var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/index.ts
import * as Babel from "@babel/standalone";

// src/compiler.ts
import { b, parse as parseJavaScript, print, x as codeRedX } from "code-red";
import { walk } from "estree-walker";
import isString from "lodash/isString";
import uniqBy from "lodash/uniqBy";

// src/native-tags.ts
import { htmlTagNames } from "html-tag-names";
import { mathmlTagNames } from "mathml-tag-names";
import { svgTagNames } from "svg-tag-names";
var outlookTagNames = ["xml", /o:.+/, /v:.+/, /w:.+/, /a:.+/];
var nativeTags = [...htmlTagNames, ...mathmlTagNames, ...svgTagNames, ...outlookTagNames];

// ../../node_modules/entities/lib/esm/generated/decode-data-html.js
var decode_data_html_default = new Uint16Array(
  // prettier-ignore
  '\u1D41<\xD5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7F\x84\x8B\x90\x95\x98\xA6\xB3\xB9\xC8\xCFlig\u803B\xC6\u40C6P\u803B&\u4026cute\u803B\xC1\u40C1reve;\u4102\u0100iyx}rc\u803B\xC2\u40C2;\u4410r;\uC000\u{1D504}rave\u803B\xC0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9D\xA1on;\u4104f;\uC000\u{1D538}plyFunction;\u6061ing\u803B\xC5\u40C5\u0100cs\xBE\xC3r;\uC000\u{1D49C}ign;\u6254ilde\u803B\xC3\u40C3ml\u803B\xC4\u40C4\u0400aceforsu\xE5\xFB\xFE\u0117\u011C\u0122\u0127\u012A\u0100cr\xEA\xF2kslash;\u6216\u0176\xF6\xF8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\u{1D505}pf;\uC000\u{1D539}eve;\u42D8c\xF2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xA9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xC7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xF2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\u{1D49E}p\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\u{1D507}\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\u{1D53B}\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xEC\u0239o\u0274\u0379\0\0\u037B\xBB\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xE5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\u{1D49F}rok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xD0\u40D0cute\u803B\xC9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xCA\u40CA;\u442Dot;\u4116r;\uC000\u{1D508}rave\u803B\xC8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\u{1D53C}silon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xCB\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\u{1D509}lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\u{1D53D}All;\u6200riertrf;\u6131c\xF2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\u{1D50A};\u62D9pf;\uC000\u{1D53E}eater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\u{1D4A2};\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xF2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xF0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xCD\u40CD\u0100iy\u0713\u0718rc\u803B\xCE\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xCC\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xF3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\u{1D540}a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xCF\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\u{1D50D}pf;\uC000\u{1D541}\u01E3\u07C7\0\u07CCr;\uC000\u{1D4A5}rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\u{1D50E}pf;\uC000\u{1D542}cr;\uC000\u{1D4A6}\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xE1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\u{1D50F}\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xE1\u03BFight\xE1\u03CAf;\uC000\u{1D543}er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xF2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\u{1D510}nusPlus;\u6213pf;\uC000\u{1D544}c\xF2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xEB\u0AD9eryThi\xEE\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xF2\u0673essLes\xF3\u0A48Line;\u400Ar;\uC000\u{1D511}\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\u{1D4A9}ilde\u803B\xD1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xD3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xD4\u40D4;\u441Eblac;\u4150r;\uC000\u{1D512}rave\u803B\xD2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\u{1D546}enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\u{1D4AA}ash\u803B\xD8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xD5\u40D5es;\u6A37ml\u803B\xD6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\u{1D513}i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xE5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\u{1D4AB};\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\u{1D514}pf;\u611Acr;\uC000\u{1D4AC}\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xAE\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xBB\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\u{1D516}ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xBB\u041EeftArrow\xBB\u089AightArrow\xBB\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\u{1D54A}\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\u{1D4AE}ar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xE1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xBB\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xDE\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\u{1D517}\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\u{1D54B}ipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\u{1D4AF}rok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xDA\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xDB\u40DB;\u4423blac;\u4170r;\uC000\u{1D518}rave\u803B\xD9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\u{1D54C}\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xE1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\u{1D4B0}ilde;\u4168ml\u803B\xDC\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\u{1D519}pf;\uC000\u{1D54D}cr;\uC000\u{1D4B1}dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\u{1D51A}pf;\uC000\u{1D54E}cr;\uC000\u{1D4B2}\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\u{1D51B};\u439Epf;\uC000\u{1D54F}cr;\uC000\u{1D4B3}\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xDD\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\u{1D51C}pf;\uC000\u{1D550}cr;\uC000\u{1D4B4}ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xE8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\u{1D4B5}\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xE1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xE2\u40E2te\u80BB\xB4\u0306;\u4430lig\u803B\xE6\u40E6\u0100;r\xB2\u15BA;\uC000\u{1D51E}rave\u803B\xE0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xE8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xBB\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xBB\xB9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\u{1D552}\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xF1\u1683ing\u803B\xE5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\u{1D4B6};\u402Amp\u0100;e\u12C1\u16AF\xF1\u0288ilde\u803B\xE3\u40E3ml\u803B\xE4\u40E4\u0100ci\u16C2\u16C8onin\xF4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xBB\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xE9\u170Cno\xF5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\u{1D51F}g\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xF0\u0760rc;\u65EFp\xBB\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xE5\u1444\xE5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\u{1D553}\u0100;t\u13CB\u1863om\xBB\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xA6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\u{1D4B7}mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xBB\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xEE\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xE7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xB8\u01ADptyv;\u69B2t\u8100\xA2;e\u1A2D\u1A2E\u40A2r\xE4\u01B2r;\uC000\u{1D520}\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xBB\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xBB\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xBB\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xC7\xC6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xEE\u1160e\u0100mx\u1AF1\u1AF6ent\xBB\u1AE9e\xF3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xF4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\u{1D554}o\xE4\u0254\u8100\xA9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\u{1D4B8}\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xE3\u1B73u\xE3\u1B75ee;\u62CEedge;\u62CFen\u803B\xA4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xBB\u1B80ight\xBB\u1BBDe\xE4\u1BDD\u0100ci\u1C01\u1C07onin\xF4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xF2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xF2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xBB\u090A\u016B\u1C61\u1C67arow;\u690Fa\xE3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xB0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\u{1D521}ar\u0100lr\u1CB3\u1CB5\xBB\u08DC\xBB\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xF7;o\u1CE7\u1CF0ntimes;\u62C7n\xF8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\u{1D555}\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xE5\xFAn\u0180adh\u112E\u1D5D\u1D67ownarrow\xF3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xF4\u1CB4igh\xF4\u1CB6\u0162\u1D7F\u1D85karo\xF7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\u{1D4B9};\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xF2\u0429a\xF2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xF4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xE9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xEA\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\u{1D522}\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xE8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xBB\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\u{1D556}\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xBB\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xBB\u1E2E\u0269\u1EF9\0\0\u1EFB\xED\u0548ant\u0100gl\u1F02\u1F06tr\xBB\u1E5Dess\xBB\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xF4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xF0\u40F0\u0100mr\u1F53\u1F57l\u803B\xEB\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xF4\u056E\u0100eo\u1F6C\u1F74ctatio\xEE\u0559nential\xE5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xF1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\u{1D523}lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\u{1D557}\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xBD\u40BD;\u6153\u803B\xBC\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xBE\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\u{1D4BB}\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xF4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\u{1D524}\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xBB\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\u{1D558}\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xF8\u209Er;\u6978q\u0100lq\u063F\u2196les\xF3\u2088i\xED\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xC5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xF2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xF0\u1484f\xBB\u2024il\xF4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xBB\u220Alip;\u6026con;\u62B9r;\uC000\u{1D525}s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\u{1D559}bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\u{1D4BD}as\xE8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xBB\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xED\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xEE\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xA1\u40A1\u0100fr\u039F\u22C9;\uC000\u{1D526}rave\u803B\xEC\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xE5\u078Ear\xF4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xF4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xF3\u1563\xE3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\u{1D55A}a;\u43B9uest\u803B\xBF\u40BF\u0100ci\u238A\u238Fr;\uC000\u{1D4BE}n\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xEF\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\u{1D527}ath;\u4237pf;\uC000\u{1D55B}\u01E3\u23EC\0\u23F1r;\uC000\u{1D4BF}rcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\u{1D528}reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\u{1D55C}cr;\uC000\u{1D4C0}\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xF2\u09C6\xF2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xEE\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xE5\u088E;\u6A85uo\u803B\xAB\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xEB\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xEC\u08B0\xE2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xE9\u24F6arpoon\u0100du\u25AF\u25B4own\xBB\u045Ap\xBB\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xF3\u0F98quigarro\xF7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xF4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xF8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xF4\u0989gt\xF2\u248C\xF4\u099Bi\xED\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\u{1D529}\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xF2\u25C1orne\xF2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xBB\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xBB\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xEB\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xE1\u09F2apsto;\u67FCight\xE1\u09FDparrow\u0100lr\u2725\u2729ef\xF4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\u{1D55D}us;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xE1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xBB\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xF2\u08A8orne\xF2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\u{1D4C1}m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xE5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xC5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xAF\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xBB\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xEE\u048Cef\xF4\u090F\xF0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xBB\u1626r;\uC000\u{1D52A}o;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xB5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xF4\u16A7ir;\u6AF0ot\u80BB\xB7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xF2\u2212\xF0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\u{1D55E}\u0100ct\u28F8\u28FDr;\uC000\u{1D4C2}pos\xBB\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xBB\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xF8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xA0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xF6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xED\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\u{1D52B}\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xF4\u0BE2i\xED\u0BEA\u0100;r\u0BB6\u2A81\xBB\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xF2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xF2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xF7\u2AC1ightarro\xF7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xF4\u0C55\u0100;s\u0C55\u2AF4\xBB\u0C36i\xED\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xE4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\u{1D55F}\u8180\xAC;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xEC\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xE5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xF1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xF2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xBB\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xE5\u0D45;\uC000\u{1D4C3}ort\u026D\u2B05\0\0\u2BD6ar\xE1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xE5\u0CF8\xE5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xF1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xEC\u0BD7lde\u803B\xF1\u40F1\xE7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xF1\u0C26ight\u0100;e\u0CCB\u2C65\xF1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xF3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xF4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\u{1D52C}\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xF2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xF2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xE5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\u{1D560}\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xF2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xBB\u2DFF\u803B\xAA\u40AA\u803B\xBA\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xF2\u2E01ash\u803B\xF8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xF5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xF6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xB6;l\u2E6D\u2E6E\u40B6le\xEC\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\u{1D52D}\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xF4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xBB\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xF6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xB1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\u{1D561}nd\u803B\xA3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xE5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xF8\u2F43urlye\xF1\u0ED9\xF1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xED\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xF0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xEF\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\u{1D4C5};\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\u{1D52E}pf;\uC000\u{1D562}rime;\u6057cr;\uC000\u{1D4C6}\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xF3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xF1\u1F19\xF4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xF2\u10B3\xF2\u03DDail;\u691Car\xF2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xE3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xE5\u0FD1uo\u803B\xBB\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xEB\u225D\xF0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xF3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xF2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xEC\u0FF2\xE2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xE5\u10BBar\xF4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\u{1D52F}\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xBB\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xE9\u30C8arpoon\u0100du\u31BB\u31BFow\xEE\u317Ep\xBB\u1092eft\u0100ah\u31CA\u31D0rrow\xF3\u0FEAarpoon\xF3\u0551ightarrows;\u61C9quigarro\xF7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xF1\u1F32\u0180ahm\u320D\u3210\u3213r\xF2\u0FEAa\xF2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xBB\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xEB\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\u{1D563}us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xF2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\u{1D4C7}\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xE5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xEF\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xE5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xED\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xEB\u2228\u0100;o\u0A36\u0A34t\u803B\xA7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xF0nu\xF3\xF1t;\u6736r\u0100;o\u3376\u2055\uC000\u{1D530}\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xE4\u1464ara\xEC\u2E6F\u803B\xAD\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xF2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xE9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\u{1D564}a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xBB\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xF1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xF1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xBB\u117Car\xF2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\u{1D4C8}tm\xEE\xF1i\xEC\u3415ar\xE6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xEE\u1EE0h\xE9\u2EAFs\xBB\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xF8\u32FAurlye\xF1\u11FE\xF1\u11F3\u0180aes\u3582\u3588\u331Bppro\xF8\u331Aq\xF1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xB9\u40B9\u803B\xB2\u40B2\u803B\xB3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xEB\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xDF\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xEB\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\u{1D531}\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xF8\u12C1im\xBB\u12ACs\xF0\u129E\u0100as\u36BA\u36AE\xF0\u12C1rn\u803B\xFE\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xD7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xE1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\u{1D565}rk;\u6ADA\xE1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xE5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xBB\u1DBBeft\u0100;e\u2800\u373E\xF1\u092E;\u625Cight\u0100;e\u32AA\u374B\xF1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\u{1D4C9};\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xF4\u1777head\u0100lr\u3797\u37A0eftarro\xF7\u084Fightarrow\xBB\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xF2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xFA\u40FA\xF2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xFB\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xF2\u13ADlac;\u4171a\xF2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\u{1D532}rave\u803B\xF9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xBB\u0957\xBB\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xBB\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xA8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\u{1D566}\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xE1\u13B3arpoon\u0100lr\u3888\u388Cef\xF4\u382Digh\xF4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xBB\u13FAon\xBB\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xBB\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\u{1D4CA}\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xBB\u1813\u0100am\u38EF\u38F2r\xF2\u38A8l\u803B\xFC\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xF2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xE8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xE1\u2415othin\xE7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xF4\u2FB5\u0100;h\u13B7\u3962\xEF\u318D\u0100iu\u3969\u396Dgm\xE1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xE1\u369Ciangle\u0100lr\u39AA\u39AFeft\xBB\u0925ight\xBB\u1051y;\u4432ash\xBB\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xF2\u1469r;\uC000\u{1D533}tr\xE9\u39AEsu\u0100bp\u39EF\u39F1\xBB\u0D1C\xBB\u0D59pf;\uC000\u{1D567}ro\xF0\u0EFBtr\xE9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\u{1D4CB}\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xBB\u397En\u0100Ee\u3992\u3A1E\xBB\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\u{1D534}pf;\uC000\u{1D568}\u0100;e\u1479\u3A66at\xE8\u1479cr;\uC000\u{1D4CC}\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xE9\u17D1r;\uC000\u{1D535}\u0100Aa\u3A94\u3A97r\xF2\u03C3r\xF2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xF2\u03B8r\xF2\u09EBa\xF0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\u{1D569}im\xE5\u17B2\u0100Aa\u3AC7\u3ACAr\xF2\u03CEr\xF2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\u{1D4CD}\u0100pt\u17D6\u3ADCr\xE9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xFD\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xA5\u40A5r;\uC000\u{1D536}cy;\u4457pf;\uC000\u{1D56A}cr;\uC000\u{1D4CE}\u0100cm\u3B26\u3B29y;\u444El\u803B\xFF\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xE6\u155Fa;\u43B6r;\uC000\u{1D537}cy;\u4436grarr;\u61DDpf;\uC000\u{1D56B}cr;\uC000\u{1D4CF}\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c) => c.charCodeAt(0))
);

// ../../node_modules/entities/lib/esm/generated/decode-data-xml.js
var decode_data_xml_default = new Uint16Array(
  // prettier-ignore
  "\u0200aglq	\x1B\u026D\0\0p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c) => c.charCodeAt(0))
);

// ../../node_modules/entities/lib/esm/decode_codepoint.js
var _a;
var decodeMap = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
var fromCodePoint = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
      codePoint -= 65536;
      output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
  }
);
function replaceCodePoint(codePoint) {
  var _a3;
  if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
    return 65533;
  }
  return (_a3 = decodeMap.get(codePoint)) !== null && _a3 !== void 0 ? _a3 : codePoint;
}

// ../../node_modules/entities/lib/esm/decode.js
var CharCodes;
(function(CharCodes4) {
  CharCodes4[CharCodes4["NUM"] = 35] = "NUM";
  CharCodes4[CharCodes4["SEMI"] = 59] = "SEMI";
  CharCodes4[CharCodes4["EQUALS"] = 61] = "EQUALS";
  CharCodes4[CharCodes4["ZERO"] = 48] = "ZERO";
  CharCodes4[CharCodes4["NINE"] = 57] = "NINE";
  CharCodes4[CharCodes4["LOWER_A"] = 97] = "LOWER_A";
  CharCodes4[CharCodes4["LOWER_F"] = 102] = "LOWER_F";
  CharCodes4[CharCodes4["LOWER_X"] = 120] = "LOWER_X";
  CharCodes4[CharCodes4["LOWER_Z"] = 122] = "LOWER_Z";
  CharCodes4[CharCodes4["UPPER_A"] = 65] = "UPPER_A";
  CharCodes4[CharCodes4["UPPER_F"] = 70] = "UPPER_F";
  CharCodes4[CharCodes4["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
var TO_LOWER_BIT = 32;
var BinTrieFlags;
(function(BinTrieFlags3) {
  BinTrieFlags3[BinTrieFlags3["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
  BinTrieFlags3[BinTrieFlags3["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
  BinTrieFlags3[BinTrieFlags3["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber(code) {
  return code >= CharCodes.ZERO && code <= CharCodes.NINE;
}
function isHexadecimalCharacter(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
}
function isAsciiAlphaNumeric(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber(code);
}
function isEntityInAttributeInvalidEnd(code) {
  return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
}
var EntityDecoderState;
(function(EntityDecoderState3) {
  EntityDecoderState3[EntityDecoderState3["EntityStart"] = 0] = "EntityStart";
  EntityDecoderState3[EntityDecoderState3["NumericStart"] = 1] = "NumericStart";
  EntityDecoderState3[EntityDecoderState3["NumericDecimal"] = 2] = "NumericDecimal";
  EntityDecoderState3[EntityDecoderState3["NumericHex"] = 3] = "NumericHex";
  EntityDecoderState3[EntityDecoderState3["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function(DecodingMode3) {
  DecodingMode3[DecodingMode3["Legacy"] = 0] = "Legacy";
  DecodingMode3[DecodingMode3["Strict"] = 1] = "Strict";
  DecodingMode3[DecodingMode3["Attribute"] = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
var EntityDecoder = class {
  constructor(decodeTree, emitCodePoint, errors) {
    this.decodeTree = decodeTree;
    this.emitCodePoint = emitCodePoint;
    this.errors = errors;
    this.state = EntityDecoderState.EntityStart;
    this.consumed = 1;
    this.result = 0;
    this.treeIndex = 0;
    this.excess = 1;
    this.decodeMode = DecodingMode.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(decodeMode) {
    this.decodeMode = decodeMode;
    this.state = EntityDecoderState.EntityStart;
    this.result = 0;
    this.treeIndex = 0;
    this.excess = 1;
    this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(str, offset) {
    switch (this.state) {
      case EntityDecoderState.EntityStart: {
        if (str.charCodeAt(offset) === CharCodes.NUM) {
          this.state = EntityDecoderState.NumericStart;
          this.consumed += 1;
          return this.stateNumericStart(str, offset + 1);
        }
        this.state = EntityDecoderState.NamedEntity;
        return this.stateNamedEntity(str, offset);
      }
      case EntityDecoderState.NumericStart: {
        return this.stateNumericStart(str, offset);
      }
      case EntityDecoderState.NumericDecimal: {
        return this.stateNumericDecimal(str, offset);
      }
      case EntityDecoderState.NumericHex: {
        return this.stateNumericHex(str, offset);
      }
      case EntityDecoderState.NamedEntity: {
        return this.stateNamedEntity(str, offset);
      }
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(str, offset) {
    if (offset >= str.length) {
      return -1;
    }
    if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
      this.state = EntityDecoderState.NumericHex;
      this.consumed += 1;
      return this.stateNumericHex(str, offset + 1);
    }
    this.state = EntityDecoderState.NumericDecimal;
    return this.stateNumericDecimal(str, offset);
  }
  addToNumericResult(str, start2, end, base) {
    if (start2 !== end) {
      const digitCount = end - start2;
      this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start2, digitCount), base);
      this.consumed += digitCount;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(str, offset) {
    const startIdx = offset;
    while (offset < str.length) {
      const char = str.charCodeAt(offset);
      if (isNumber(char) || isHexadecimalCharacter(char)) {
        offset += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset, 16);
        return this.emitNumericEntity(char, 3);
      }
    }
    this.addToNumericResult(str, startIdx, offset, 16);
    return -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(str, offset) {
    const startIdx = offset;
    while (offset < str.length) {
      const char = str.charCodeAt(offset);
      if (isNumber(char)) {
        offset += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset, 10);
        return this.emitNumericEntity(char, 2);
      }
    }
    this.addToNumericResult(str, startIdx, offset, 10);
    return -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(lastCp, expectedLength) {
    var _a3;
    if (this.consumed <= expectedLength) {
      (_a3 = this.errors) === null || _a3 === void 0 ? void 0 : _a3.absenceOfDigitsInNumericCharacterReference(this.consumed);
      return 0;
    }
    if (lastCp === CharCodes.SEMI) {
      this.consumed += 1;
    } else if (this.decodeMode === DecodingMode.Strict) {
      return 0;
    }
    this.emitCodePoint(replaceCodePoint(this.result), this.consumed);
    if (this.errors) {
      if (lastCp !== CharCodes.SEMI) {
        this.errors.missingSemicolonAfterCharacterReference();
      }
      this.errors.validateNumericCharacterReference(this.result);
    }
    return this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(str, offset) {
    const { decodeTree } = this;
    let current = decodeTree[this.treeIndex];
    let valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
    for (; offset < str.length; offset++, this.excess++) {
      const char = str.charCodeAt(offset);
      this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
      if (this.treeIndex < 0) {
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
        (valueLength === 0 || // And there should be no invalid characters.
        isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
      }
      current = decodeTree[this.treeIndex];
      valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
      if (valueLength !== 0) {
        if (char === CharCodes.SEMI) {
          return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
        }
        if (this.decodeMode !== DecodingMode.Strict) {
          this.result = this.treeIndex;
          this.consumed += this.excess;
          this.excess = 0;
        }
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var _a3;
    const { result, decodeTree } = this;
    const valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
    this.emitNamedEntityData(result, valueLength, this.consumed);
    (_a3 = this.errors) === null || _a3 === void 0 ? void 0 : _a3.missingSemicolonAfterCharacterReference();
    return this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(result, valueLength, consumed) {
    const { decodeTree } = this;
    this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
    if (valueLength === 3) {
      this.emitCodePoint(decodeTree[result + 2], consumed);
    }
    return consumed;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var _a3;
    switch (this.state) {
      case EntityDecoderState.NamedEntity: {
        return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      }
      case EntityDecoderState.NumericDecimal: {
        return this.emitNumericEntity(0, 2);
      }
      case EntityDecoderState.NumericHex: {
        return this.emitNumericEntity(0, 3);
      }
      case EntityDecoderState.NumericStart: {
        (_a3 = this.errors) === null || _a3 === void 0 ? void 0 : _a3.absenceOfDigitsInNumericCharacterReference(this.consumed);
        return 0;
      }
      case EntityDecoderState.EntityStart: {
        return 0;
      }
    }
  }
};
function getDecoder(decodeTree) {
  let ret = "";
  const decoder = new EntityDecoder(decodeTree, (str) => ret += fromCodePoint(str));
  return function decodeWithTrie(str, decodeMode) {
    let lastIndex = 0;
    let offset = 0;
    while ((offset = str.indexOf("&", offset)) >= 0) {
      ret += str.slice(lastIndex, offset);
      decoder.startEntity(decodeMode);
      const len = decoder.write(
        str,
        // Skip the "&"
        offset + 1
      );
      if (len < 0) {
        lastIndex = offset + decoder.end();
        break;
      }
      lastIndex = offset + len;
      offset = len === 0 ? lastIndex + 1 : lastIndex;
    }
    const result = ret + str.slice(lastIndex);
    ret = "";
    return result;
  };
}
function determineBranch(decodeTree, current, nodeIdx, char) {
  const branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
  const jumpOffset = current & BinTrieFlags.JUMP_TABLE;
  if (branchCount === 0) {
    return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
  }
  if (jumpOffset) {
    const value = char - jumpOffset;
    return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
  }
  let lo = nodeIdx;
  let hi = lo + branchCount - 1;
  while (lo <= hi) {
    const mid = lo + hi >>> 1;
    const midVal = decodeTree[mid];
    if (midVal < char) {
      lo = mid + 1;
    } else if (midVal > char) {
      hi = mid - 1;
    } else {
      return decodeTree[mid + branchCount];
    }
  }
  return -1;
}
var htmlDecoder = getDecoder(decode_data_html_default);
var xmlDecoder = getDecoder(decode_data_xml_default);

// ../../node_modules/htmlparser2/lib/esm/Tokenizer.js
var CharCodes2;
(function(CharCodes4) {
  CharCodes4[CharCodes4["Tab"] = 9] = "Tab";
  CharCodes4[CharCodes4["NewLine"] = 10] = "NewLine";
  CharCodes4[CharCodes4["FormFeed"] = 12] = "FormFeed";
  CharCodes4[CharCodes4["CarriageReturn"] = 13] = "CarriageReturn";
  CharCodes4[CharCodes4["Space"] = 32] = "Space";
  CharCodes4[CharCodes4["ExclamationMark"] = 33] = "ExclamationMark";
  CharCodes4[CharCodes4["Number"] = 35] = "Number";
  CharCodes4[CharCodes4["Amp"] = 38] = "Amp";
  CharCodes4[CharCodes4["SingleQuote"] = 39] = "SingleQuote";
  CharCodes4[CharCodes4["DoubleQuote"] = 34] = "DoubleQuote";
  CharCodes4[CharCodes4["Dash"] = 45] = "Dash";
  CharCodes4[CharCodes4["Slash"] = 47] = "Slash";
  CharCodes4[CharCodes4["Zero"] = 48] = "Zero";
  CharCodes4[CharCodes4["Nine"] = 57] = "Nine";
  CharCodes4[CharCodes4["Semi"] = 59] = "Semi";
  CharCodes4[CharCodes4["Lt"] = 60] = "Lt";
  CharCodes4[CharCodes4["Eq"] = 61] = "Eq";
  CharCodes4[CharCodes4["Gt"] = 62] = "Gt";
  CharCodes4[CharCodes4["Questionmark"] = 63] = "Questionmark";
  CharCodes4[CharCodes4["UpperA"] = 65] = "UpperA";
  CharCodes4[CharCodes4["LowerA"] = 97] = "LowerA";
  CharCodes4[CharCodes4["UpperF"] = 70] = "UpperF";
  CharCodes4[CharCodes4["LowerF"] = 102] = "LowerF";
  CharCodes4[CharCodes4["UpperZ"] = 90] = "UpperZ";
  CharCodes4[CharCodes4["LowerZ"] = 122] = "LowerZ";
  CharCodes4[CharCodes4["LowerX"] = 120] = "LowerX";
  CharCodes4[CharCodes4["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})(CharCodes2 || (CharCodes2 = {}));
var State;
(function(State2) {
  State2[State2["Text"] = 1] = "Text";
  State2[State2["BeforeTagName"] = 2] = "BeforeTagName";
  State2[State2["InTagName"] = 3] = "InTagName";
  State2[State2["InSelfClosingTag"] = 4] = "InSelfClosingTag";
  State2[State2["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
  State2[State2["InClosingTagName"] = 6] = "InClosingTagName";
  State2[State2["AfterClosingTagName"] = 7] = "AfterClosingTagName";
  State2[State2["BeforeAttributeName"] = 8] = "BeforeAttributeName";
  State2[State2["InAttributeName"] = 9] = "InAttributeName";
  State2[State2["AfterAttributeName"] = 10] = "AfterAttributeName";
  State2[State2["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
  State2[State2["InAttributeValueDq"] = 12] = "InAttributeValueDq";
  State2[State2["InAttributeValueSq"] = 13] = "InAttributeValueSq";
  State2[State2["InAttributeValueNq"] = 14] = "InAttributeValueNq";
  State2[State2["BeforeDeclaration"] = 15] = "BeforeDeclaration";
  State2[State2["InDeclaration"] = 16] = "InDeclaration";
  State2[State2["InProcessingInstruction"] = 17] = "InProcessingInstruction";
  State2[State2["BeforeComment"] = 18] = "BeforeComment";
  State2[State2["CDATASequence"] = 19] = "CDATASequence";
  State2[State2["InSpecialComment"] = 20] = "InSpecialComment";
  State2[State2["InCommentLike"] = 21] = "InCommentLike";
  State2[State2["BeforeSpecialS"] = 22] = "BeforeSpecialS";
  State2[State2["SpecialStartSequence"] = 23] = "SpecialStartSequence";
  State2[State2["InSpecialTag"] = 24] = "InSpecialTag";
  State2[State2["BeforeEntity"] = 25] = "BeforeEntity";
  State2[State2["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
  State2[State2["InNamedEntity"] = 27] = "InNamedEntity";
  State2[State2["InNumericEntity"] = 28] = "InNumericEntity";
  State2[State2["InHexEntity"] = 29] = "InHexEntity";
})(State || (State = {}));
function isWhitespace(c) {
  return c === CharCodes2.Space || c === CharCodes2.NewLine || c === CharCodes2.Tab || c === CharCodes2.FormFeed || c === CharCodes2.CarriageReturn;
}
function isEndOfTagSection(c) {
  return c === CharCodes2.Slash || c === CharCodes2.Gt || isWhitespace(c);
}
function isNumber2(c) {
  return c >= CharCodes2.Zero && c <= CharCodes2.Nine;
}
function isASCIIAlpha(c) {
  return c >= CharCodes2.LowerA && c <= CharCodes2.LowerZ || c >= CharCodes2.UpperA && c <= CharCodes2.UpperZ;
}
function isHexDigit(c) {
  return c >= CharCodes2.UpperA && c <= CharCodes2.UpperF || c >= CharCodes2.LowerA && c <= CharCodes2.LowerF;
}
var QuoteType;
(function(QuoteType2) {
  QuoteType2[QuoteType2["NoValue"] = 0] = "NoValue";
  QuoteType2[QuoteType2["Unquoted"] = 1] = "Unquoted";
  QuoteType2[QuoteType2["Single"] = 2] = "Single";
  QuoteType2[QuoteType2["Double"] = 3] = "Double";
})(QuoteType || (QuoteType = {}));
var Sequences = {
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  CdataEnd: new Uint8Array([93, 93, 62]),
  CommentEnd: new Uint8Array([45, 45, 62]),
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
  // `</title`
};
var Tokenizer = class {
  constructor({ xmlMode = false, decodeEntities = true }, cbs) {
    this.cbs = cbs;
    this.state = State.Text;
    this.buffer = "";
    this.sectionStart = 0;
    this.index = 0;
    this.baseState = State.Text;
    this.isSpecial = false;
    this.running = true;
    this.offset = 0;
    this.currentSequence = void 0;
    this.sequenceIndex = 0;
    this.trieIndex = 0;
    this.trieCurrent = 0;
    this.entityResult = 0;
    this.entityExcess = 0;
    this.xmlMode = xmlMode;
    this.decodeEntities = decodeEntities;
    this.entityTrie = xmlMode ? decode_data_xml_default : decode_data_html_default;
  }
  reset() {
    this.state = State.Text;
    this.buffer = "";
    this.sectionStart = 0;
    this.index = 0;
    this.baseState = State.Text;
    this.currentSequence = void 0;
    this.running = true;
    this.offset = 0;
  }
  write(chunk) {
    this.offset += this.buffer.length;
    this.buffer = chunk;
    this.parse();
  }
  end() {
    if (this.running)
      this.finish();
  }
  pause() {
    this.running = false;
  }
  resume() {
    this.running = true;
    if (this.index < this.buffer.length + this.offset) {
      this.parse();
    }
  }
  /**
   * The current index within all of the written data.
   */
  getIndex() {
    return this.index;
  }
  /**
   * The start of the current section.
   */
  getSectionStart() {
    return this.sectionStart;
  }
  stateText(c) {
    if (c === CharCodes2.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes2.Lt)) {
      if (this.index > this.sectionStart) {
        this.cbs.ontext(this.sectionStart, this.index);
      }
      this.state = State.BeforeTagName;
      this.sectionStart = this.index;
    } else if (this.decodeEntities && c === CharCodes2.Amp) {
      this.state = State.BeforeEntity;
    }
  }
  stateSpecialStartSequence(c) {
    const isEnd = this.sequenceIndex === this.currentSequence.length;
    const isMatch = isEnd ? (
      // If we are at the end of the sequence, make sure the tag name has ended
      isEndOfTagSection(c)
    ) : (
      // Otherwise, do a case-insensitive comparison
      (c | 32) === this.currentSequence[this.sequenceIndex]
    );
    if (!isMatch) {
      this.isSpecial = false;
    } else if (!isEnd) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0;
    this.state = State.InTagName;
    this.stateInTagName(c);
  }
  /** Look for an end tag. For <title> tags, also decode entities. */
  stateInSpecialTag(c) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (c === CharCodes2.Gt || isWhitespace(c)) {
        const endOfText = this.index - this.currentSequence.length;
        if (this.sectionStart < endOfText) {
          const actualIndex = this.index;
          this.index = endOfText;
          this.cbs.ontext(this.sectionStart, endOfText);
          this.index = actualIndex;
        }
        this.isSpecial = false;
        this.sectionStart = endOfText + 2;
        this.stateInClosingTagName(c);
        return;
      }
      this.sequenceIndex = 0;
    }
    if ((c | 32) === this.currentSequence[this.sequenceIndex]) {
      this.sequenceIndex += 1;
    } else if (this.sequenceIndex === 0) {
      if (this.currentSequence === Sequences.TitleEnd) {
        if (this.decodeEntities && c === CharCodes2.Amp) {
          this.state = State.BeforeEntity;
        }
      } else if (this.fastForwardTo(CharCodes2.Lt)) {
        this.sequenceIndex = 1;
      }
    } else {
      this.sequenceIndex = Number(c === CharCodes2.Lt);
    }
  }
  stateCDATASequence(c) {
    if (c === Sequences.Cdata[this.sequenceIndex]) {
      if (++this.sequenceIndex === Sequences.Cdata.length) {
        this.state = State.InCommentLike;
        this.currentSequence = Sequences.CdataEnd;
        this.sequenceIndex = 0;
        this.sectionStart = this.index + 1;
      }
    } else {
      this.sequenceIndex = 0;
      this.state = State.InDeclaration;
      this.stateInDeclaration(c);
    }
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  fastForwardTo(c) {
    while (++this.index < this.buffer.length + this.offset) {
      if (this.buffer.charCodeAt(this.index - this.offset) === c) {
        return true;
      }
    }
    this.index = this.buffer.length + this.offset - 1;
    return false;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  stateInCommentLike(c) {
    if (c === this.currentSequence[this.sequenceIndex]) {
      if (++this.sequenceIndex === this.currentSequence.length) {
        if (this.currentSequence === Sequences.CdataEnd) {
          this.cbs.oncdata(this.sectionStart, this.index, 2);
        } else {
          this.cbs.oncomment(this.sectionStart, this.index, 2);
        }
        this.sequenceIndex = 0;
        this.sectionStart = this.index + 1;
        this.state = State.Text;
      }
    } else if (this.sequenceIndex === 0) {
      if (this.fastForwardTo(this.currentSequence[0])) {
        this.sequenceIndex = 1;
      }
    } else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
      this.sequenceIndex = 0;
    }
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  isTagStartChar(c) {
    return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
  }
  startSpecial(sequence, offset) {
    this.isSpecial = true;
    this.currentSequence = sequence;
    this.sequenceIndex = offset;
    this.state = State.SpecialStartSequence;
  }
  stateBeforeTagName(c) {
    if (c === CharCodes2.ExclamationMark) {
      this.state = State.BeforeDeclaration;
      this.sectionStart = this.index + 1;
    } else if (c === CharCodes2.Questionmark) {
      this.state = State.InProcessingInstruction;
      this.sectionStart = this.index + 1;
    } else if (this.isTagStartChar(c)) {
      const lower = c | 32;
      this.sectionStart = this.index;
      if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
        this.startSpecial(Sequences.TitleEnd, 3);
      } else {
        this.state = !this.xmlMode && lower === Sequences.ScriptEnd[2] ? State.BeforeSpecialS : State.InTagName;
      }
    } else if (c === CharCodes2.Slash) {
      this.state = State.BeforeClosingTagName;
    } else {
      this.state = State.Text;
      this.stateText(c);
    }
  }
  stateInTagName(c) {
    if (isEndOfTagSection(c)) {
      this.cbs.onopentagname(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    }
  }
  stateBeforeClosingTagName(c) {
    if (isWhitespace(c)) {
    } else if (c === CharCodes2.Gt) {
      this.state = State.Text;
    } else {
      this.state = this.isTagStartChar(c) ? State.InClosingTagName : State.InSpecialComment;
      this.sectionStart = this.index;
    }
  }
  stateInClosingTagName(c) {
    if (c === CharCodes2.Gt || isWhitespace(c)) {
      this.cbs.onclosetag(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.AfterClosingTagName;
      this.stateAfterClosingTagName(c);
    }
  }
  stateAfterClosingTagName(c) {
    if (c === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.state = State.Text;
      this.baseState = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateBeforeAttributeName(c) {
    if (c === CharCodes2.Gt) {
      this.cbs.onopentagend(this.index);
      if (this.isSpecial) {
        this.state = State.InSpecialTag;
        this.sequenceIndex = 0;
      } else {
        this.state = State.Text;
      }
      this.baseState = this.state;
      this.sectionStart = this.index + 1;
    } else if (c === CharCodes2.Slash) {
      this.state = State.InSelfClosingTag;
    } else if (!isWhitespace(c)) {
      this.state = State.InAttributeName;
      this.sectionStart = this.index;
    }
  }
  stateInSelfClosingTag(c) {
    if (c === CharCodes2.Gt) {
      this.cbs.onselfclosingtag(this.index);
      this.state = State.Text;
      this.baseState = State.Text;
      this.sectionStart = this.index + 1;
      this.isSpecial = false;
    } else if (!isWhitespace(c)) {
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    }
  }
  stateInAttributeName(c) {
    if (c === CharCodes2.Eq || isEndOfTagSection(c)) {
      this.cbs.onattribname(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.AfterAttributeName;
      this.stateAfterAttributeName(c);
    }
  }
  stateAfterAttributeName(c) {
    if (c === CharCodes2.Eq) {
      this.state = State.BeforeAttributeValue;
    } else if (c === CharCodes2.Slash || c === CharCodes2.Gt) {
      this.cbs.onattribend(QuoteType.NoValue, this.index);
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    } else if (!isWhitespace(c)) {
      this.cbs.onattribend(QuoteType.NoValue, this.index);
      this.state = State.InAttributeName;
      this.sectionStart = this.index;
    }
  }
  stateBeforeAttributeValue(c) {
    if (c === CharCodes2.DoubleQuote) {
      this.state = State.InAttributeValueDq;
      this.sectionStart = this.index + 1;
    } else if (c === CharCodes2.SingleQuote) {
      this.state = State.InAttributeValueSq;
      this.sectionStart = this.index + 1;
    } else if (!isWhitespace(c)) {
      this.sectionStart = this.index;
      this.state = State.InAttributeValueNq;
      this.stateInAttributeValueNoQuotes(c);
    }
  }
  handleInAttributeValue(c, quote) {
    if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
      this.cbs.onattribdata(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.cbs.onattribend(quote === CharCodes2.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
      this.state = State.BeforeAttributeName;
    } else if (this.decodeEntities && c === CharCodes2.Amp) {
      this.baseState = this.state;
      this.state = State.BeforeEntity;
    }
  }
  stateInAttributeValueDoubleQuotes(c) {
    this.handleInAttributeValue(c, CharCodes2.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(c) {
    this.handleInAttributeValue(c, CharCodes2.SingleQuote);
  }
  stateInAttributeValueNoQuotes(c) {
    if (isWhitespace(c) || c === CharCodes2.Gt) {
      this.cbs.onattribdata(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.cbs.onattribend(QuoteType.Unquoted, this.index);
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    } else if (this.decodeEntities && c === CharCodes2.Amp) {
      this.baseState = this.state;
      this.state = State.BeforeEntity;
    }
  }
  stateBeforeDeclaration(c) {
    if (c === CharCodes2.OpeningSquareBracket) {
      this.state = State.CDATASequence;
      this.sequenceIndex = 0;
    } else {
      this.state = c === CharCodes2.Dash ? State.BeforeComment : State.InDeclaration;
    }
  }
  stateInDeclaration(c) {
    if (c === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.cbs.ondeclaration(this.sectionStart, this.index);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateInProcessingInstruction(c) {
    if (c === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.cbs.onprocessinginstruction(this.sectionStart, this.index);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateBeforeComment(c) {
    if (c === CharCodes2.Dash) {
      this.state = State.InCommentLike;
      this.currentSequence = Sequences.CommentEnd;
      this.sequenceIndex = 2;
      this.sectionStart = this.index + 1;
    } else {
      this.state = State.InDeclaration;
    }
  }
  stateInSpecialComment(c) {
    if (c === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.cbs.oncomment(this.sectionStart, this.index, 0);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateBeforeSpecialS(c) {
    const lower = c | 32;
    if (lower === Sequences.ScriptEnd[3]) {
      this.startSpecial(Sequences.ScriptEnd, 4);
    } else if (lower === Sequences.StyleEnd[3]) {
      this.startSpecial(Sequences.StyleEnd, 4);
    } else {
      this.state = State.InTagName;
      this.stateInTagName(c);
    }
  }
  stateBeforeEntity(c) {
    this.entityExcess = 1;
    this.entityResult = 0;
    if (c === CharCodes2.Number) {
      this.state = State.BeforeNumericEntity;
    } else if (c === CharCodes2.Amp) {
    } else {
      this.trieIndex = 0;
      this.trieCurrent = this.entityTrie[0];
      this.state = State.InNamedEntity;
      this.stateInNamedEntity(c);
    }
  }
  stateInNamedEntity(c) {
    this.entityExcess += 1;
    this.trieIndex = determineBranch(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
    if (this.trieIndex < 0) {
      this.emitNamedEntity();
      this.index--;
      return;
    }
    this.trieCurrent = this.entityTrie[this.trieIndex];
    const masked = this.trieCurrent & BinTrieFlags.VALUE_LENGTH;
    if (masked) {
      const valueLength = (masked >> 14) - 1;
      if (!this.allowLegacyEntity() && c !== CharCodes2.Semi) {
        this.trieIndex += valueLength;
      } else {
        const entityStart = this.index - this.entityExcess + 1;
        if (entityStart > this.sectionStart) {
          this.emitPartial(this.sectionStart, entityStart);
        }
        this.entityResult = this.trieIndex;
        this.trieIndex += valueLength;
        this.entityExcess = 0;
        this.sectionStart = this.index + 1;
        if (valueLength === 0) {
          this.emitNamedEntity();
        }
      }
    }
  }
  emitNamedEntity() {
    this.state = this.baseState;
    if (this.entityResult === 0) {
      return;
    }
    const valueLength = (this.entityTrie[this.entityResult] & BinTrieFlags.VALUE_LENGTH) >> 14;
    switch (valueLength) {
      case 1: {
        this.emitCodePoint(this.entityTrie[this.entityResult] & ~BinTrieFlags.VALUE_LENGTH);
        break;
      }
      case 2: {
        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
        break;
      }
      case 3: {
        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
        this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
      }
    }
  }
  stateBeforeNumericEntity(c) {
    if ((c | 32) === CharCodes2.LowerX) {
      this.entityExcess++;
      this.state = State.InHexEntity;
    } else {
      this.state = State.InNumericEntity;
      this.stateInNumericEntity(c);
    }
  }
  emitNumericEntity(strict) {
    const entityStart = this.index - this.entityExcess - 1;
    const numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
    if (numberStart !== this.index) {
      if (entityStart > this.sectionStart) {
        this.emitPartial(this.sectionStart, entityStart);
      }
      this.sectionStart = this.index + Number(strict);
      this.emitCodePoint(replaceCodePoint(this.entityResult));
    }
    this.state = this.baseState;
  }
  stateInNumericEntity(c) {
    if (c === CharCodes2.Semi) {
      this.emitNumericEntity(true);
    } else if (isNumber2(c)) {
      this.entityResult = this.entityResult * 10 + (c - CharCodes2.Zero);
      this.entityExcess++;
    } else {
      if (this.allowLegacyEntity()) {
        this.emitNumericEntity(false);
      } else {
        this.state = this.baseState;
      }
      this.index--;
    }
  }
  stateInHexEntity(c) {
    if (c === CharCodes2.Semi) {
      this.emitNumericEntity(true);
    } else if (isNumber2(c)) {
      this.entityResult = this.entityResult * 16 + (c - CharCodes2.Zero);
      this.entityExcess++;
    } else if (isHexDigit(c)) {
      this.entityResult = this.entityResult * 16 + ((c | 32) - CharCodes2.LowerA + 10);
      this.entityExcess++;
    } else {
      if (this.allowLegacyEntity()) {
        this.emitNumericEntity(false);
      } else {
        this.state = this.baseState;
      }
      this.index--;
    }
  }
  allowLegacyEntity() {
    return !this.xmlMode && (this.baseState === State.Text || this.baseState === State.InSpecialTag);
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    if (this.running && this.sectionStart !== this.index) {
      if (this.state === State.Text || this.state === State.InSpecialTag && this.sequenceIndex === 0) {
        this.cbs.ontext(this.sectionStart, this.index);
        this.sectionStart = this.index;
      } else if (this.state === State.InAttributeValueDq || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueNq) {
        this.cbs.onattribdata(this.sectionStart, this.index);
        this.sectionStart = this.index;
      }
    }
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    while (this.shouldContinue()) {
      const c = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case State.Text: {
          this.stateText(c);
          break;
        }
        case State.SpecialStartSequence: {
          this.stateSpecialStartSequence(c);
          break;
        }
        case State.InSpecialTag: {
          this.stateInSpecialTag(c);
          break;
        }
        case State.CDATASequence: {
          this.stateCDATASequence(c);
          break;
        }
        case State.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(c);
          break;
        }
        case State.InAttributeName: {
          this.stateInAttributeName(c);
          break;
        }
        case State.InCommentLike: {
          this.stateInCommentLike(c);
          break;
        }
        case State.InSpecialComment: {
          this.stateInSpecialComment(c);
          break;
        }
        case State.BeforeAttributeName: {
          this.stateBeforeAttributeName(c);
          break;
        }
        case State.InTagName: {
          this.stateInTagName(c);
          break;
        }
        case State.InClosingTagName: {
          this.stateInClosingTagName(c);
          break;
        }
        case State.BeforeTagName: {
          this.stateBeforeTagName(c);
          break;
        }
        case State.AfterAttributeName: {
          this.stateAfterAttributeName(c);
          break;
        }
        case State.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(c);
          break;
        }
        case State.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(c);
          break;
        }
        case State.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(c);
          break;
        }
        case State.AfterClosingTagName: {
          this.stateAfterClosingTagName(c);
          break;
        }
        case State.BeforeSpecialS: {
          this.stateBeforeSpecialS(c);
          break;
        }
        case State.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(c);
          break;
        }
        case State.InSelfClosingTag: {
          this.stateInSelfClosingTag(c);
          break;
        }
        case State.InDeclaration: {
          this.stateInDeclaration(c);
          break;
        }
        case State.BeforeDeclaration: {
          this.stateBeforeDeclaration(c);
          break;
        }
        case State.BeforeComment: {
          this.stateBeforeComment(c);
          break;
        }
        case State.InProcessingInstruction: {
          this.stateInProcessingInstruction(c);
          break;
        }
        case State.InNamedEntity: {
          this.stateInNamedEntity(c);
          break;
        }
        case State.BeforeEntity: {
          this.stateBeforeEntity(c);
          break;
        }
        case State.InHexEntity: {
          this.stateInHexEntity(c);
          break;
        }
        case State.InNumericEntity: {
          this.stateInNumericEntity(c);
          break;
        }
        default: {
          this.stateBeforeNumericEntity(c);
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    if (this.state === State.InNamedEntity) {
      this.emitNamedEntity();
    }
    if (this.sectionStart < this.index) {
      this.handleTrailingData();
    }
    this.cbs.onend();
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const endIndex = this.buffer.length + this.offset;
    if (this.state === State.InCommentLike) {
      if (this.currentSequence === Sequences.CdataEnd) {
        this.cbs.oncdata(this.sectionStart, endIndex, 0);
      } else {
        this.cbs.oncomment(this.sectionStart, endIndex, 0);
      }
    } else if (this.state === State.InNumericEntity && this.allowLegacyEntity()) {
      this.emitNumericEntity(false);
    } else if (this.state === State.InHexEntity && this.allowLegacyEntity()) {
      this.emitNumericEntity(false);
    } else if (this.state === State.InTagName || this.state === State.BeforeAttributeName || this.state === State.BeforeAttributeValue || this.state === State.AfterAttributeName || this.state === State.InAttributeName || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueDq || this.state === State.InAttributeValueNq || this.state === State.InClosingTagName) {
    } else {
      this.cbs.ontext(this.sectionStart, endIndex);
    }
  }
  emitPartial(start2, endIndex) {
    if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
      this.cbs.onattribdata(start2, endIndex);
    } else {
      this.cbs.ontext(start2, endIndex);
    }
  }
  emitCodePoint(cp) {
    if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
      this.cbs.onattribentity(cp);
    } else {
      this.cbs.ontextentity(cp);
    }
  }
};

// ../../node_modules/htmlparser2/lib/esm/Parser.js
var formTags = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]);
var pTag = /* @__PURE__ */ new Set(["p"]);
var tableSectionTags = /* @__PURE__ */ new Set(["thead", "tbody"]);
var ddtTags = /* @__PURE__ */ new Set(["dd", "dt"]);
var rtpTags = /* @__PURE__ */ new Set(["rt", "rp"]);
var openImpliesClose = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", pTag],
  ["h1", pTag],
  ["h2", pTag],
  ["h3", pTag],
  ["h4", pTag],
  ["h5", pTag],
  ["h6", pTag],
  ["select", formTags],
  ["input", formTags],
  ["output", formTags],
  ["button", formTags],
  ["datalist", formTags],
  ["textarea", formTags],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", ddtTags],
  ["dt", ddtTags],
  ["address", pTag],
  ["article", pTag],
  ["aside", pTag],
  ["blockquote", pTag],
  ["details", pTag],
  ["div", pTag],
  ["dl", pTag],
  ["fieldset", pTag],
  ["figcaption", pTag],
  ["figure", pTag],
  ["footer", pTag],
  ["form", pTag],
  ["header", pTag],
  ["hr", pTag],
  ["main", pTag],
  ["nav", pTag],
  ["ol", pTag],
  ["pre", pTag],
  ["section", pTag],
  ["table", pTag],
  ["ul", pTag],
  ["rt", rtpTags],
  ["rp", rtpTags],
  ["tbody", tableSectionTags],
  ["tfoot", tableSectionTags]
]);
var voidElements = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
var foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]);
var htmlIntegrationElements = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]);
var reNameEnd = /\s|\//;
var Parser = class {
  constructor(cbs, options = {}) {
    var _a3, _b, _c, _d, _e;
    this.options = options;
    this.startIndex = 0;
    this.endIndex = 0;
    this.openTagStart = 0;
    this.tagname = "";
    this.attribname = "";
    this.attribvalue = "";
    this.attribs = null;
    this.stack = [];
    this.foreignContext = [];
    this.buffers = [];
    this.bufferOffset = 0;
    this.writeIndex = 0;
    this.ended = false;
    this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
    this.lowerCaseTagNames = (_a3 = options.lowerCaseTags) !== null && _a3 !== void 0 ? _a3 : !options.xmlMode;
    this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
    this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer)(this.options, this);
    (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
  }
  // Tokenizer event handlers
  /** @internal */
  ontext(start2, endIndex) {
    var _a3, _b;
    const data = this.getSlice(start2, endIndex);
    this.endIndex = endIndex - 1;
    (_b = (_a3 = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a3, data);
    this.startIndex = endIndex;
  }
  /** @internal */
  ontextentity(cp) {
    var _a3, _b;
    const index = this.tokenizer.getSectionStart();
    this.endIndex = index - 1;
    (_b = (_a3 = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a3, fromCodePoint(cp));
    this.startIndex = index;
  }
  isVoidElement(name) {
    return !this.options.xmlMode && voidElements.has(name);
  }
  /** @internal */
  onopentagname(start2, endIndex) {
    this.endIndex = endIndex;
    let name = this.getSlice(start2, endIndex);
    if (this.lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    this.emitOpenTag(name);
  }
  emitOpenTag(name) {
    var _a3, _b, _c, _d;
    this.openTagStart = this.startIndex;
    this.tagname = name;
    const impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
    if (impliesClose) {
      while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
        const element = this.stack.pop();
        (_b = (_a3 = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a3, element, true);
      }
    }
    if (!this.isVoidElement(name)) {
      this.stack.push(name);
      if (foreignContextElements.has(name)) {
        this.foreignContext.push(true);
      } else if (htmlIntegrationElements.has(name)) {
        this.foreignContext.push(false);
      }
    }
    (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
    if (this.cbs.onopentag)
      this.attribs = {};
  }
  endOpenTag(isImplied) {
    var _a3, _b;
    this.startIndex = this.openTagStart;
    if (this.attribs) {
      (_b = (_a3 = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a3, this.tagname, this.attribs, isImplied);
      this.attribs = null;
    }
    if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
      this.cbs.onclosetag(this.tagname, true);
    }
    this.tagname = "";
  }
  /** @internal */
  onopentagend(endIndex) {
    this.endIndex = endIndex;
    this.endOpenTag(false);
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onclosetag(start2, endIndex) {
    var _a3, _b, _c, _d, _e, _f;
    this.endIndex = endIndex;
    let name = this.getSlice(start2, endIndex);
    if (this.lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
      this.foreignContext.pop();
    }
    if (!this.isVoidElement(name)) {
      const pos = this.stack.lastIndexOf(name);
      if (pos !== -1) {
        if (this.cbs.onclosetag) {
          let count = this.stack.length - pos;
          while (count--) {
            this.cbs.onclosetag(this.stack.pop(), count !== 0);
          }
        } else
          this.stack.length = pos;
      } else if (!this.options.xmlMode && name === "p") {
        this.emitOpenTag("p");
        this.closeCurrentTag(true);
      }
    } else if (!this.options.xmlMode && name === "br") {
      (_b = (_a3 = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a3, "br");
      (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
      (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onselfclosingtag(endIndex) {
    this.endIndex = endIndex;
    if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
      this.closeCurrentTag(false);
      this.startIndex = endIndex + 1;
    } else {
      this.onopentagend(endIndex);
    }
  }
  closeCurrentTag(isOpenImplied) {
    var _a3, _b;
    const name = this.tagname;
    this.endOpenTag(isOpenImplied);
    if (this.stack[this.stack.length - 1] === name) {
      (_b = (_a3 = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a3, name, !isOpenImplied);
      this.stack.pop();
    }
  }
  /** @internal */
  onattribname(start2, endIndex) {
    this.startIndex = start2;
    const name = this.getSlice(start2, endIndex);
    this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
  }
  /** @internal */
  onattribdata(start2, endIndex) {
    this.attribvalue += this.getSlice(start2, endIndex);
  }
  /** @internal */
  onattribentity(cp) {
    this.attribvalue += fromCodePoint(cp);
  }
  /** @internal */
  onattribend(quote, endIndex) {
    var _a3, _b;
    this.endIndex = endIndex;
    (_b = (_a3 = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a3, this.attribname, this.attribvalue, quote === QuoteType.Double ? '"' : quote === QuoteType.Single ? "'" : quote === QuoteType.NoValue ? void 0 : null);
    if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
      this.attribs[this.attribname] = this.attribvalue;
    }
    this.attribvalue = "";
  }
  getInstructionName(value) {
    const index = value.search(reNameEnd);
    let name = index < 0 ? value : value.substr(0, index);
    if (this.lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    return name;
  }
  /** @internal */
  ondeclaration(start2, endIndex) {
    this.endIndex = endIndex;
    const value = this.getSlice(start2, endIndex);
    if (this.cbs.onprocessinginstruction) {
      const name = this.getInstructionName(value);
      this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onprocessinginstruction(start2, endIndex) {
    this.endIndex = endIndex;
    const value = this.getSlice(start2, endIndex);
    if (this.cbs.onprocessinginstruction) {
      const name = this.getInstructionName(value);
      this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  oncomment(start2, endIndex, offset) {
    var _a3, _b, _c, _d;
    this.endIndex = endIndex;
    (_b = (_a3 = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a3, this.getSlice(start2, endIndex - offset));
    (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  oncdata(start2, endIndex, offset) {
    var _a3, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    this.endIndex = endIndex;
    const value = this.getSlice(start2, endIndex - offset);
    if (this.options.xmlMode || this.options.recognizeCDATA) {
      (_b = (_a3 = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a3);
      (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
      (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
    } else {
      (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, `[CDATA[${value}]]`);
      (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onend() {
    var _a3, _b;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true))
        ;
    }
    (_b = (_a3 = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a3);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var _a3, _b, _c, _d;
    (_b = (_a3 = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a3);
    this.tokenizer.reset();
    this.tagname = "";
    this.attribname = "";
    this.attribs = null;
    this.stack.length = 0;
    this.startIndex = 0;
    this.endIndex = 0;
    (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    this.buffers.length = 0;
    this.bufferOffset = 0;
    this.writeIndex = 0;
    this.ended = false;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  parseComplete(data) {
    this.reset();
    this.end(data);
  }
  getSlice(start2, end) {
    while (start2 - this.bufferOffset >= this.buffers[0].length) {
      this.shiftBuffer();
    }
    let slice = this.buffers[0].slice(start2 - this.bufferOffset, end - this.bufferOffset);
    while (end - this.bufferOffset > this.buffers[0].length) {
      this.shiftBuffer();
      slice += this.buffers[0].slice(0, end - this.bufferOffset);
    }
    return slice;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length;
    this.writeIndex--;
    this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(chunk) {
    var _a3, _b;
    if (this.ended) {
      (_b = (_a3 = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a3, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(chunk);
    if (this.tokenizer.running) {
      this.tokenizer.write(chunk);
      this.writeIndex++;
    }
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  end(chunk) {
    var _a3, _b;
    if (this.ended) {
      (_b = (_a3 = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a3, new Error(".end() after done!"));
      return;
    }
    if (chunk)
      this.write(chunk);
    this.ended = true;
    this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    this.tokenizer.resume();
    while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    }
    if (this.ended)
      this.tokenizer.end();
  }
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  parseChunk(chunk) {
    this.write(chunk);
  }
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  done(chunk) {
    this.end(chunk);
  }
};

// ../../node_modules/domelementtype/lib/esm/index.js
var esm_exports = {};
__export(esm_exports, {
  CDATA: () => CDATA,
  Comment: () => Comment,
  Directive: () => Directive,
  Doctype: () => Doctype,
  ElementType: () => ElementType,
  Root: () => Root,
  Script: () => Script,
  Style: () => Style,
  Tag: () => Tag,
  Text: () => Text,
  isTag: () => isTag
});
var ElementType;
(function(ElementType3) {
  ElementType3["Root"] = "root";
  ElementType3["Text"] = "text";
  ElementType3["Directive"] = "directive";
  ElementType3["Comment"] = "comment";
  ElementType3["Script"] = "script";
  ElementType3["Style"] = "style";
  ElementType3["Tag"] = "tag";
  ElementType3["CDATA"] = "cdata";
  ElementType3["Doctype"] = "doctype";
})(ElementType || (ElementType = {}));
function isTag(elem) {
  return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
}
var Root = ElementType.Root;
var Text = ElementType.Text;
var Directive = ElementType.Directive;
var Comment = ElementType.Comment;
var Script = ElementType.Script;
var Style = ElementType.Style;
var Tag = ElementType.Tag;
var CDATA = ElementType.CDATA;
var Doctype = ElementType.Doctype;

// ../../node_modules/domhandler/lib/esm/node.js
var Node = class {
  constructor() {
    this.parent = null;
    this.prev = null;
    this.next = null;
    this.startIndex = null;
    this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(parent) {
    this.parent = parent;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(prev) {
    this.prev = prev;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(next) {
    this.next = next;
  }
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(recursive = false) {
    return cloneNode(this, recursive);
  }
};
var DataNode = class extends Node {
  /**
   * @param data The content of the data node
   */
  constructor(data) {
    super();
    this.data = data;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(data) {
    this.data = data;
  }
};
var Text2 = class extends DataNode {
  constructor() {
    super(...arguments);
    this.type = ElementType.Text;
  }
  get nodeType() {
    return 3;
  }
};
var Comment2 = class extends DataNode {
  constructor() {
    super(...arguments);
    this.type = ElementType.Comment;
  }
  get nodeType() {
    return 8;
  }
};
var ProcessingInstruction = class extends DataNode {
  constructor(name, data) {
    super(data);
    this.name = name;
    this.type = ElementType.Directive;
  }
  get nodeType() {
    return 1;
  }
};
var NodeWithChildren = class extends Node {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(children) {
    super();
    this.children = children;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    var _a3;
    return (_a3 = this.children[0]) !== null && _a3 !== void 0 ? _a3 : null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(children) {
    this.children = children;
  }
};
var CDATA2 = class extends NodeWithChildren {
  constructor() {
    super(...arguments);
    this.type = ElementType.CDATA;
  }
  get nodeType() {
    return 4;
  }
};
var Document = class extends NodeWithChildren {
  constructor() {
    super(...arguments);
    this.type = ElementType.Root;
  }
  get nodeType() {
    return 9;
  }
};
var Element = class extends NodeWithChildren {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  constructor(name, attribs, children = [], type = name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag) {
    super(children);
    this.name = name;
    this.attribs = attribs;
    this.type = type;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(name) {
    this.name = name;
  }
  get attributes() {
    return Object.keys(this.attribs).map((name) => {
      var _a3, _b;
      return {
        name,
        value: this.attribs[name],
        namespace: (_a3 = this["x-attribsNamespace"]) === null || _a3 === void 0 ? void 0 : _a3[name],
        prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
      };
    });
  }
};
function isTag2(node) {
  return isTag(node);
}
function isCDATA(node) {
  return node.type === ElementType.CDATA;
}
function isText(node) {
  return node.type === ElementType.Text;
}
function isComment(node) {
  return node.type === ElementType.Comment;
}
function isDirective(node) {
  return node.type === ElementType.Directive;
}
function isDocument(node) {
  return node.type === ElementType.Root;
}
function hasChildren(node) {
  return Object.prototype.hasOwnProperty.call(node, "children");
}
function cloneNode(node, recursive = false) {
  let result;
  if (isText(node)) {
    result = new Text2(node.data);
  } else if (isComment(node)) {
    result = new Comment2(node.data);
  } else if (isTag2(node)) {
    const children = recursive ? cloneChildren(node.children) : [];
    const clone = new Element(node.name, { ...node.attribs }, children);
    children.forEach((child) => child.parent = clone);
    if (node.namespace != null) {
      clone.namespace = node.namespace;
    }
    if (node["x-attribsNamespace"]) {
      clone["x-attribsNamespace"] = { ...node["x-attribsNamespace"] };
    }
    if (node["x-attribsPrefix"]) {
      clone["x-attribsPrefix"] = { ...node["x-attribsPrefix"] };
    }
    result = clone;
  } else if (isCDATA(node)) {
    const children = recursive ? cloneChildren(node.children) : [];
    const clone = new CDATA2(children);
    children.forEach((child) => child.parent = clone);
    result = clone;
  } else if (isDocument(node)) {
    const children = recursive ? cloneChildren(node.children) : [];
    const clone = new Document(children);
    children.forEach((child) => child.parent = clone);
    if (node["x-mode"]) {
      clone["x-mode"] = node["x-mode"];
    }
    result = clone;
  } else if (isDirective(node)) {
    const instruction = new ProcessingInstruction(node.name, node.data);
    if (node["x-name"] != null) {
      instruction["x-name"] = node["x-name"];
      instruction["x-publicId"] = node["x-publicId"];
      instruction["x-systemId"] = node["x-systemId"];
    }
    result = instruction;
  } else {
    throw new Error(`Not implemented yet: ${node.type}`);
  }
  result.startIndex = node.startIndex;
  result.endIndex = node.endIndex;
  if (node.sourceCodeLocation != null) {
    result.sourceCodeLocation = node.sourceCodeLocation;
  }
  return result;
}
function cloneChildren(childs) {
  const children = childs.map((child) => cloneNode(child, true));
  for (let i = 1; i < children.length; i++) {
    children[i].prev = children[i - 1];
    children[i - 1].next = children[i];
  }
  return children;
}

// ../../node_modules/domhandler/lib/esm/index.js
var defaultOpts = {
  withStartIndices: false,
  withEndIndices: false,
  xmlMode: false
};
var DomHandler = class {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(callback, options, elementCB) {
    this.dom = [];
    this.root = new Document(this.dom);
    this.done = false;
    this.tagStack = [this.root];
    this.lastNode = null;
    this.parser = null;
    if (typeof options === "function") {
      elementCB = options;
      options = defaultOpts;
    }
    if (typeof callback === "object") {
      options = callback;
      callback = void 0;
    }
    this.callback = callback !== null && callback !== void 0 ? callback : null;
    this.options = options !== null && options !== void 0 ? options : defaultOpts;
    this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
  }
  onparserinit(parser) {
    this.parser = parser;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [];
    this.root = new Document(this.dom);
    this.done = false;
    this.tagStack = [this.root];
    this.lastNode = null;
    this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    if (this.done)
      return;
    this.done = true;
    this.parser = null;
    this.handleCallback(null);
  }
  onerror(error) {
    this.handleCallback(error);
  }
  onclosetag() {
    this.lastNode = null;
    const elem = this.tagStack.pop();
    if (this.options.withEndIndices) {
      elem.endIndex = this.parser.endIndex;
    }
    if (this.elementCB)
      this.elementCB(elem);
  }
  onopentag(name, attribs) {
    const type = this.options.xmlMode ? ElementType.Tag : void 0;
    const element = new Element(name, attribs, void 0, type);
    this.addNode(element);
    this.tagStack.push(element);
  }
  ontext(data) {
    const { lastNode } = this;
    if (lastNode && lastNode.type === ElementType.Text) {
      lastNode.data += data;
      if (this.options.withEndIndices) {
        lastNode.endIndex = this.parser.endIndex;
      }
    } else {
      const node = new Text2(data);
      this.addNode(node);
      this.lastNode = node;
    }
  }
  oncomment(data) {
    if (this.lastNode && this.lastNode.type === ElementType.Comment) {
      this.lastNode.data += data;
      return;
    }
    const node = new Comment2(data);
    this.addNode(node);
    this.lastNode = node;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const text = new Text2("");
    const node = new CDATA2([text]);
    this.addNode(node);
    text.parent = node;
    this.lastNode = text;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(name, data) {
    const node = new ProcessingInstruction(name, data);
    this.addNode(node);
  }
  handleCallback(error) {
    if (typeof this.callback === "function") {
      this.callback(error, this.dom);
    } else if (error) {
      throw error;
    }
  }
  addNode(node) {
    const parent = this.tagStack[this.tagStack.length - 1];
    const previousSibling = parent.children[parent.children.length - 1];
    if (this.options.withStartIndices) {
      node.startIndex = this.parser.startIndex;
    }
    if (this.options.withEndIndices) {
      node.endIndex = this.parser.endIndex;
    }
    parent.children.push(node);
    if (previousSibling) {
      node.prev = previousSibling;
      previousSibling.next = node;
    }
    node.parent = parent;
    this.lastNode = null;
  }
};

// ../../node_modules/entities/lib/esm/generated/encode-html.js
function restoreDiff(arr) {
  for (let i = 1; i < arr.length; i++) {
    arr[i][0] += arr[i - 1][0] + 1;
  }
  return arr;
}
var encode_html_default = new Map(/* @__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));

// ../../node_modules/entities/lib/esm/escape.js
var xmlCodeMap = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]);
var getCodePoint = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (str, index) => str.codePointAt(index) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (c, index) => (c.charCodeAt(index) & 64512) === 55296 ? (c.charCodeAt(index) - 55296) * 1024 + c.charCodeAt(index + 1) - 56320 + 65536 : c.charCodeAt(index)
  )
);
function getEscaper(regex, map2) {
  return function escape3(data) {
    let match;
    let lastIdx = 0;
    let result = "";
    while (match = regex.exec(data)) {
      if (lastIdx !== match.index) {
        result += data.substring(lastIdx, match.index);
      }
      result += map2.get(match[0].charCodeAt(0));
      lastIdx = match.index + 1;
    }
    return result + data.substring(lastIdx);
  };
}
var escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
var escapeAttribute = getEscaper(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
]));
var escapeText = getEscaper(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
]));

// ../../node_modules/entities/lib/esm/index.js
var EntityLevel;
(function(EntityLevel3) {
  EntityLevel3[EntityLevel3["XML"] = 0] = "XML";
  EntityLevel3[EntityLevel3["HTML"] = 1] = "HTML";
})(EntityLevel || (EntityLevel = {}));
var EncodingMode;
(function(EncodingMode3) {
  EncodingMode3[EncodingMode3["UTF8"] = 0] = "UTF8";
  EncodingMode3[EncodingMode3["ASCII"] = 1] = "ASCII";
  EncodingMode3[EncodingMode3["Extensive"] = 2] = "Extensive";
  EncodingMode3[EncodingMode3["Attribute"] = 3] = "Attribute";
  EncodingMode3[EncodingMode3["Text"] = 4] = "Text";
})(EncodingMode || (EncodingMode = {}));

// ../../node_modules/dom-serializer/lib/esm/foreignNames.js
var elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((val) => [val.toLowerCase(), val]));
var attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((val) => [val.toLowerCase(), val]));

// ../../node_modules/domutils/lib/esm/helpers.js
var DocumentPosition;
(function(DocumentPosition3) {
  DocumentPosition3[DocumentPosition3["DISCONNECTED"] = 1] = "DISCONNECTED";
  DocumentPosition3[DocumentPosition3["PRECEDING"] = 2] = "PRECEDING";
  DocumentPosition3[DocumentPosition3["FOLLOWING"] = 4] = "FOLLOWING";
  DocumentPosition3[DocumentPosition3["CONTAINS"] = 8] = "CONTAINS";
  DocumentPosition3[DocumentPosition3["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition || (DocumentPosition = {}));

// ../source-htmlparser2/dist/index.js
var __defProp2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a, prop, b2[prop]);
    }
  return a;
};
var __spreadProps = (a, b2) => __defProps(a, __getOwnPropDescs(b2));
var __export2 = (target, all) => {
  for (var name in all)
    __defProp2(target, name, { get: all[name], enumerable: true });
};
var esm_exports22 = {};
__export2(esm_exports22, {
  DocumentPosition: () => DocumentPosition2,
  append: () => append,
  appendChild: () => appendChild,
  compareDocumentPosition: () => compareDocumentPosition,
  existsOne: () => existsOne,
  filter: () => filter2,
  find: () => find,
  findAll: () => findAll,
  findOne: () => findOne2,
  findOneChild: () => findOneChild,
  getAttributeValue: () => getAttributeValue,
  getChildren: () => getChildren,
  getElementById: () => getElementById,
  getElements: () => getElements,
  getElementsByTagName: () => getElementsByTagName2,
  getElementsByTagType: () => getElementsByTagType,
  getFeed: () => getFeed2,
  getInnerHTML: () => getInnerHTML,
  getName: () => getName,
  getOuterHTML: () => getOuterHTML,
  getParent: () => getParent,
  getSiblings: () => getSiblings,
  getText: () => getText,
  hasAttrib: () => hasAttrib,
  hasChildren: () => hasChildren,
  innerText: () => innerText,
  isCDATA: () => isCDATA,
  isComment: () => isComment,
  isDocument: () => isDocument,
  isTag: () => isTag2,
  isText: () => isText,
  nextElementSibling: () => nextElementSibling,
  prepend: () => prepend,
  prependChild: () => prependChild,
  prevElementSibling: () => prevElementSibling,
  removeElement: () => removeElement,
  removeSubsets: () => removeSubsets,
  replaceElement: () => replaceElement,
  testElement: () => testElement,
  textContent: () => textContent2,
  uniqueSort: () => uniqueSort
});
var ElementType2;
(function(ElementType3) {
  ElementType3["Root"] = "root";
  ElementType3["Text"] = "text";
  ElementType3["Directive"] = "directive";
  ElementType3["Comment"] = "comment";
  ElementType3["Script"] = "script";
  ElementType3["Style"] = "style";
  ElementType3["Tag"] = "tag";
  ElementType3["CDATA"] = "cdata";
  ElementType3["Doctype"] = "doctype";
})(ElementType2 || (ElementType2 = {}));
var Root2 = ElementType2.Root;
var Text3 = ElementType2.Text;
var Directive2 = ElementType2.Directive;
var Comment3 = ElementType2.Comment;
var Script2 = ElementType2.Script;
var Style2 = ElementType2.Style;
var Tag2 = ElementType2.Tag;
var CDATA3 = ElementType2.CDATA;
var Doctype2 = ElementType2.Doctype;
var decode_data_html_default2 = new Uint16Array(
  // prettier-ignore
  '\u1D41<\xD5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7F\x84\x8B\x90\x95\x98\xA6\xB3\xB9\xC8\xCFlig\u803B\xC6\u40C6P\u803B&\u4026cute\u803B\xC1\u40C1reve;\u4102\u0100iyx}rc\u803B\xC2\u40C2;\u4410r;\uC000\u{1D504}rave\u803B\xC0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9D\xA1on;\u4104f;\uC000\u{1D538}plyFunction;\u6061ing\u803B\xC5\u40C5\u0100cs\xBE\xC3r;\uC000\u{1D49C}ign;\u6254ilde\u803B\xC3\u40C3ml\u803B\xC4\u40C4\u0400aceforsu\xE5\xFB\xFE\u0117\u011C\u0122\u0127\u012A\u0100cr\xEA\xF2kslash;\u6216\u0176\xF6\xF8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\u{1D505}pf;\uC000\u{1D539}eve;\u42D8c\xF2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xA9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xC7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xF2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\u{1D49E}p\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\u{1D507}\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\u{1D53B}\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xEC\u0239o\u0274\u0379\0\0\u037B\xBB\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xE5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\u{1D49F}rok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xD0\u40D0cute\u803B\xC9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xCA\u40CA;\u442Dot;\u4116r;\uC000\u{1D508}rave\u803B\xC8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\u{1D53C}silon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xCB\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\u{1D509}lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\u{1D53D}All;\u6200riertrf;\u6131c\xF2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\u{1D50A};\u62D9pf;\uC000\u{1D53E}eater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\u{1D4A2};\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xF2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xF0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xCD\u40CD\u0100iy\u0713\u0718rc\u803B\xCE\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xCC\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xF3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\u{1D540}a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xCF\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\u{1D50D}pf;\uC000\u{1D541}\u01E3\u07C7\0\u07CCr;\uC000\u{1D4A5}rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\u{1D50E}pf;\uC000\u{1D542}cr;\uC000\u{1D4A6}\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xE1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\u{1D50F}\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xE1\u03BFight\xE1\u03CAf;\uC000\u{1D543}er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xF2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\u{1D510}nusPlus;\u6213pf;\uC000\u{1D544}c\xF2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xEB\u0AD9eryThi\xEE\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xF2\u0673essLes\xF3\u0A48Line;\u400Ar;\uC000\u{1D511}\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\u{1D4A9}ilde\u803B\xD1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xD3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xD4\u40D4;\u441Eblac;\u4150r;\uC000\u{1D512}rave\u803B\xD2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\u{1D546}enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\u{1D4AA}ash\u803B\xD8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xD5\u40D5es;\u6A37ml\u803B\xD6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\u{1D513}i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xE5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\u{1D4AB};\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\u{1D514}pf;\u611Acr;\uC000\u{1D4AC}\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xAE\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xBB\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\u{1D516}ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xBB\u041EeftArrow\xBB\u089AightArrow\xBB\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\u{1D54A}\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\u{1D4AE}ar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xE1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xBB\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xDE\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\u{1D517}\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\u{1D54B}ipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\u{1D4AF}rok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xDA\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xDB\u40DB;\u4423blac;\u4170r;\uC000\u{1D518}rave\u803B\xD9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\u{1D54C}\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xE1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\u{1D4B0}ilde;\u4168ml\u803B\xDC\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\u{1D519}pf;\uC000\u{1D54D}cr;\uC000\u{1D4B1}dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\u{1D51A}pf;\uC000\u{1D54E}cr;\uC000\u{1D4B2}\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\u{1D51B};\u439Epf;\uC000\u{1D54F}cr;\uC000\u{1D4B3}\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xDD\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\u{1D51C}pf;\uC000\u{1D550}cr;\uC000\u{1D4B4}ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xE8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\u{1D4B5}\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xE1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xE2\u40E2te\u80BB\xB4\u0306;\u4430lig\u803B\xE6\u40E6\u0100;r\xB2\u15BA;\uC000\u{1D51E}rave\u803B\xE0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xE8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xBB\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xBB\xB9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\u{1D552}\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xF1\u1683ing\u803B\xE5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\u{1D4B6};\u402Amp\u0100;e\u12C1\u16AF\xF1\u0288ilde\u803B\xE3\u40E3ml\u803B\xE4\u40E4\u0100ci\u16C2\u16C8onin\xF4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xBB\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xE9\u170Cno\xF5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\u{1D51F}g\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xF0\u0760rc;\u65EFp\xBB\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xE5\u1444\xE5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\u{1D553}\u0100;t\u13CB\u1863om\xBB\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xA6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\u{1D4B7}mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xBB\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xEE\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xE7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xB8\u01ADptyv;\u69B2t\u8100\xA2;e\u1A2D\u1A2E\u40A2r\xE4\u01B2r;\uC000\u{1D520}\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xBB\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xBB\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xBB\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xC7\xC6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xEE\u1160e\u0100mx\u1AF1\u1AF6ent\xBB\u1AE9e\xF3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xF4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\u{1D554}o\xE4\u0254\u8100\xA9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\u{1D4B8}\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xE3\u1B73u\xE3\u1B75ee;\u62CEedge;\u62CFen\u803B\xA4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xBB\u1B80ight\xBB\u1BBDe\xE4\u1BDD\u0100ci\u1C01\u1C07onin\xF4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xF2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xF2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xBB\u090A\u016B\u1C61\u1C67arow;\u690Fa\xE3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xB0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\u{1D521}ar\u0100lr\u1CB3\u1CB5\xBB\u08DC\xBB\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xF7;o\u1CE7\u1CF0ntimes;\u62C7n\xF8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\u{1D555}\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xE5\xFAn\u0180adh\u112E\u1D5D\u1D67ownarrow\xF3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xF4\u1CB4igh\xF4\u1CB6\u0162\u1D7F\u1D85karo\xF7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\u{1D4B9};\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xF2\u0429a\xF2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xF4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xE9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xEA\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\u{1D522}\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xE8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xBB\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\u{1D556}\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xBB\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xBB\u1E2E\u0269\u1EF9\0\0\u1EFB\xED\u0548ant\u0100gl\u1F02\u1F06tr\xBB\u1E5Dess\xBB\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xF4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xF0\u40F0\u0100mr\u1F53\u1F57l\u803B\xEB\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xF4\u056E\u0100eo\u1F6C\u1F74ctatio\xEE\u0559nential\xE5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xF1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\u{1D523}lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\u{1D557}\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xBD\u40BD;\u6153\u803B\xBC\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xBE\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\u{1D4BB}\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xF4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\u{1D524}\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xBB\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\u{1D558}\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xF8\u209Er;\u6978q\u0100lq\u063F\u2196les\xF3\u2088i\xED\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xC5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xF2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xF0\u1484f\xBB\u2024il\xF4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xBB\u220Alip;\u6026con;\u62B9r;\uC000\u{1D525}s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\u{1D559}bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\u{1D4BD}as\xE8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xBB\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xED\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xEE\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xA1\u40A1\u0100fr\u039F\u22C9;\uC000\u{1D526}rave\u803B\xEC\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xE5\u078Ear\xF4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xF4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xF3\u1563\xE3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\u{1D55A}a;\u43B9uest\u803B\xBF\u40BF\u0100ci\u238A\u238Fr;\uC000\u{1D4BE}n\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xEF\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\u{1D527}ath;\u4237pf;\uC000\u{1D55B}\u01E3\u23EC\0\u23F1r;\uC000\u{1D4BF}rcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\u{1D528}reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\u{1D55C}cr;\uC000\u{1D4C0}\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xF2\u09C6\xF2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xEE\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xE5\u088E;\u6A85uo\u803B\xAB\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xEB\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xEC\u08B0\xE2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xE9\u24F6arpoon\u0100du\u25AF\u25B4own\xBB\u045Ap\xBB\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xF3\u0F98quigarro\xF7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xF4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xF8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xF4\u0989gt\xF2\u248C\xF4\u099Bi\xED\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\u{1D529}\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xF2\u25C1orne\xF2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xBB\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xBB\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xEB\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xE1\u09F2apsto;\u67FCight\xE1\u09FDparrow\u0100lr\u2725\u2729ef\xF4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\u{1D55D}us;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xE1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xBB\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xF2\u08A8orne\xF2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\u{1D4C1}m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xE5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xC5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xAF\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xBB\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xEE\u048Cef\xF4\u090F\xF0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xBB\u1626r;\uC000\u{1D52A}o;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xB5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xF4\u16A7ir;\u6AF0ot\u80BB\xB7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xF2\u2212\xF0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\u{1D55E}\u0100ct\u28F8\u28FDr;\uC000\u{1D4C2}pos\xBB\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xBB\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xF8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xA0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xF6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xED\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\u{1D52B}\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xF4\u0BE2i\xED\u0BEA\u0100;r\u0BB6\u2A81\xBB\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xF2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xF2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xF7\u2AC1ightarro\xF7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xF4\u0C55\u0100;s\u0C55\u2AF4\xBB\u0C36i\xED\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xE4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\u{1D55F}\u8180\xAC;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xEC\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xE5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xF1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xF2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xBB\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xE5\u0D45;\uC000\u{1D4C3}ort\u026D\u2B05\0\0\u2BD6ar\xE1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xE5\u0CF8\xE5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xF1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xEC\u0BD7lde\u803B\xF1\u40F1\xE7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xF1\u0C26ight\u0100;e\u0CCB\u2C65\xF1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xF3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xF4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\u{1D52C}\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xF2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xF2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xE5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\u{1D560}\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xF2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xBB\u2DFF\u803B\xAA\u40AA\u803B\xBA\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xF2\u2E01ash\u803B\xF8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xF5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xF6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xB6;l\u2E6D\u2E6E\u40B6le\xEC\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\u{1D52D}\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xF4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xBB\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xF6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xB1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\u{1D561}nd\u803B\xA3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xE5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xF8\u2F43urlye\xF1\u0ED9\xF1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xED\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xF0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xEF\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\u{1D4C5};\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\u{1D52E}pf;\uC000\u{1D562}rime;\u6057cr;\uC000\u{1D4C6}\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xF3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xF1\u1F19\xF4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xF2\u10B3\xF2\u03DDail;\u691Car\xF2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xE3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xE5\u0FD1uo\u803B\xBB\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xEB\u225D\xF0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xF3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xF2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xEC\u0FF2\xE2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xE5\u10BBar\xF4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\u{1D52F}\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xBB\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xE9\u30C8arpoon\u0100du\u31BB\u31BFow\xEE\u317Ep\xBB\u1092eft\u0100ah\u31CA\u31D0rrow\xF3\u0FEAarpoon\xF3\u0551ightarrows;\u61C9quigarro\xF7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xF1\u1F32\u0180ahm\u320D\u3210\u3213r\xF2\u0FEAa\xF2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xBB\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xEB\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\u{1D563}us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xF2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\u{1D4C7}\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xE5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xEF\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xE5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xED\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xEB\u2228\u0100;o\u0A36\u0A34t\u803B\xA7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xF0nu\xF3\xF1t;\u6736r\u0100;o\u3376\u2055\uC000\u{1D530}\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xE4\u1464ara\xEC\u2E6F\u803B\xAD\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xF2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xE9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\u{1D564}a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xBB\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xF1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xF1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xBB\u117Car\xF2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\u{1D4C8}tm\xEE\xF1i\xEC\u3415ar\xE6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xEE\u1EE0h\xE9\u2EAFs\xBB\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xF8\u32FAurlye\xF1\u11FE\xF1\u11F3\u0180aes\u3582\u3588\u331Bppro\xF8\u331Aq\xF1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xB9\u40B9\u803B\xB2\u40B2\u803B\xB3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xEB\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xDF\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xEB\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\u{1D531}\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xF8\u12C1im\xBB\u12ACs\xF0\u129E\u0100as\u36BA\u36AE\xF0\u12C1rn\u803B\xFE\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xD7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xE1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\u{1D565}rk;\u6ADA\xE1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xE5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xBB\u1DBBeft\u0100;e\u2800\u373E\xF1\u092E;\u625Cight\u0100;e\u32AA\u374B\xF1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\u{1D4C9};\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xF4\u1777head\u0100lr\u3797\u37A0eftarro\xF7\u084Fightarrow\xBB\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xF2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xFA\u40FA\xF2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xFB\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xF2\u13ADlac;\u4171a\xF2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\u{1D532}rave\u803B\xF9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xBB\u0957\xBB\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xBB\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xA8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\u{1D566}\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xE1\u13B3arpoon\u0100lr\u3888\u388Cef\xF4\u382Digh\xF4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xBB\u13FAon\xBB\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xBB\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\u{1D4CA}\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xBB\u1813\u0100am\u38EF\u38F2r\xF2\u38A8l\u803B\xFC\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xF2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xE8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xE1\u2415othin\xE7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xF4\u2FB5\u0100;h\u13B7\u3962\xEF\u318D\u0100iu\u3969\u396Dgm\xE1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xE1\u369Ciangle\u0100lr\u39AA\u39AFeft\xBB\u0925ight\xBB\u1051y;\u4432ash\xBB\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xF2\u1469r;\uC000\u{1D533}tr\xE9\u39AEsu\u0100bp\u39EF\u39F1\xBB\u0D1C\xBB\u0D59pf;\uC000\u{1D567}ro\xF0\u0EFBtr\xE9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\u{1D4CB}\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xBB\u397En\u0100Ee\u3992\u3A1E\xBB\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\u{1D534}pf;\uC000\u{1D568}\u0100;e\u1479\u3A66at\xE8\u1479cr;\uC000\u{1D4CC}\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xE9\u17D1r;\uC000\u{1D535}\u0100Aa\u3A94\u3A97r\xF2\u03C3r\xF2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xF2\u03B8r\xF2\u09EBa\xF0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\u{1D569}im\xE5\u17B2\u0100Aa\u3AC7\u3ACAr\xF2\u03CEr\xF2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\u{1D4CD}\u0100pt\u17D6\u3ADCr\xE9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xFD\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xA5\u40A5r;\uC000\u{1D536}cy;\u4457pf;\uC000\u{1D56A}cr;\uC000\u{1D4CE}\u0100cm\u3B26\u3B29y;\u444El\u803B\xFF\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xE6\u155Fa;\u43B6r;\uC000\u{1D537}cy;\u4436grarr;\u61DDpf;\uC000\u{1D56B}cr;\uC000\u{1D4CF}\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c) => c.charCodeAt(0))
);
var decode_data_xml_default2 = new Uint16Array(
  // prettier-ignore
  "\u0200aglq	\x1B\u026D\0\0p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c) => c.charCodeAt(0))
);
var _a2;
var decodeMap2 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
var fromCodePoint2 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (_a2 = String.fromCodePoint) !== null && _a2 !== void 0 ? _a2 : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
      codePoint -= 65536;
      output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
  }
);
function replaceCodePoint2(codePoint) {
  var _a22;
  if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
    return 65533;
  }
  return (_a22 = decodeMap2.get(codePoint)) !== null && _a22 !== void 0 ? _a22 : codePoint;
}
var CharCodes3;
(function(CharCodes22) {
  CharCodes22[CharCodes22["NUM"] = 35] = "NUM";
  CharCodes22[CharCodes22["SEMI"] = 59] = "SEMI";
  CharCodes22[CharCodes22["EQUALS"] = 61] = "EQUALS";
  CharCodes22[CharCodes22["ZERO"] = 48] = "ZERO";
  CharCodes22[CharCodes22["NINE"] = 57] = "NINE";
  CharCodes22[CharCodes22["LOWER_A"] = 97] = "LOWER_A";
  CharCodes22[CharCodes22["LOWER_F"] = 102] = "LOWER_F";
  CharCodes22[CharCodes22["LOWER_X"] = 120] = "LOWER_X";
  CharCodes22[CharCodes22["LOWER_Z"] = 122] = "LOWER_Z";
  CharCodes22[CharCodes22["UPPER_A"] = 65] = "UPPER_A";
  CharCodes22[CharCodes22["UPPER_F"] = 70] = "UPPER_F";
  CharCodes22[CharCodes22["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes3 || (CharCodes3 = {}));
var TO_LOWER_BIT2 = 32;
var BinTrieFlags2;
(function(BinTrieFlags22) {
  BinTrieFlags22[BinTrieFlags22["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
  BinTrieFlags22[BinTrieFlags22["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
  BinTrieFlags22[BinTrieFlags22["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags2 || (BinTrieFlags2 = {}));
function isNumber3(code) {
  return code >= CharCodes3.ZERO && code <= CharCodes3.NINE;
}
function isHexadecimalCharacter2(code) {
  return code >= CharCodes3.UPPER_A && code <= CharCodes3.UPPER_F || code >= CharCodes3.LOWER_A && code <= CharCodes3.LOWER_F;
}
function isAsciiAlphaNumeric2(code) {
  return code >= CharCodes3.UPPER_A && code <= CharCodes3.UPPER_Z || code >= CharCodes3.LOWER_A && code <= CharCodes3.LOWER_Z || isNumber3(code);
}
function isEntityInAttributeInvalidEnd2(code) {
  return code === CharCodes3.EQUALS || isAsciiAlphaNumeric2(code);
}
var EntityDecoderState2;
(function(EntityDecoderState22) {
  EntityDecoderState22[EntityDecoderState22["EntityStart"] = 0] = "EntityStart";
  EntityDecoderState22[EntityDecoderState22["NumericStart"] = 1] = "NumericStart";
  EntityDecoderState22[EntityDecoderState22["NumericDecimal"] = 2] = "NumericDecimal";
  EntityDecoderState22[EntityDecoderState22["NumericHex"] = 3] = "NumericHex";
  EntityDecoderState22[EntityDecoderState22["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState2 || (EntityDecoderState2 = {}));
var DecodingMode2;
(function(DecodingMode22) {
  DecodingMode22[DecodingMode22["Legacy"] = 0] = "Legacy";
  DecodingMode22[DecodingMode22["Strict"] = 1] = "Strict";
  DecodingMode22[DecodingMode22["Attribute"] = 2] = "Attribute";
})(DecodingMode2 || (DecodingMode2 = {}));
var EntityDecoder2 = class {
  constructor(decodeTree, emitCodePoint, errors) {
    this.decodeTree = decodeTree;
    this.emitCodePoint = emitCodePoint;
    this.errors = errors;
    this.state = EntityDecoderState2.EntityStart;
    this.consumed = 1;
    this.result = 0;
    this.treeIndex = 0;
    this.excess = 1;
    this.decodeMode = DecodingMode2.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(decodeMode) {
    this.decodeMode = decodeMode;
    this.state = EntityDecoderState2.EntityStart;
    this.result = 0;
    this.treeIndex = 0;
    this.excess = 1;
    this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(str, offset) {
    switch (this.state) {
      case EntityDecoderState2.EntityStart: {
        if (str.charCodeAt(offset) === CharCodes3.NUM) {
          this.state = EntityDecoderState2.NumericStart;
          this.consumed += 1;
          return this.stateNumericStart(str, offset + 1);
        }
        this.state = EntityDecoderState2.NamedEntity;
        return this.stateNamedEntity(str, offset);
      }
      case EntityDecoderState2.NumericStart: {
        return this.stateNumericStart(str, offset);
      }
      case EntityDecoderState2.NumericDecimal: {
        return this.stateNumericDecimal(str, offset);
      }
      case EntityDecoderState2.NumericHex: {
        return this.stateNumericHex(str, offset);
      }
      case EntityDecoderState2.NamedEntity: {
        return this.stateNamedEntity(str, offset);
      }
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(str, offset) {
    if (offset >= str.length) {
      return -1;
    }
    if ((str.charCodeAt(offset) | TO_LOWER_BIT2) === CharCodes3.LOWER_X) {
      this.state = EntityDecoderState2.NumericHex;
      this.consumed += 1;
      return this.stateNumericHex(str, offset + 1);
    }
    this.state = EntityDecoderState2.NumericDecimal;
    return this.stateNumericDecimal(str, offset);
  }
  addToNumericResult(str, start2, end, base) {
    if (start2 !== end) {
      const digitCount = end - start2;
      this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start2, digitCount), base);
      this.consumed += digitCount;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(str, offset) {
    const startIdx = offset;
    while (offset < str.length) {
      const char = str.charCodeAt(offset);
      if (isNumber3(char) || isHexadecimalCharacter2(char)) {
        offset += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset, 16);
        return this.emitNumericEntity(char, 3);
      }
    }
    this.addToNumericResult(str, startIdx, offset, 16);
    return -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(str, offset) {
    const startIdx = offset;
    while (offset < str.length) {
      const char = str.charCodeAt(offset);
      if (isNumber3(char)) {
        offset += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset, 10);
        return this.emitNumericEntity(char, 2);
      }
    }
    this.addToNumericResult(str, startIdx, offset, 10);
    return -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(lastCp, expectedLength) {
    var _a22;
    if (this.consumed <= expectedLength) {
      (_a22 = this.errors) === null || _a22 === void 0 ? void 0 : _a22.absenceOfDigitsInNumericCharacterReference(this.consumed);
      return 0;
    }
    if (lastCp === CharCodes3.SEMI) {
      this.consumed += 1;
    } else if (this.decodeMode === DecodingMode2.Strict) {
      return 0;
    }
    this.emitCodePoint(replaceCodePoint2(this.result), this.consumed);
    if (this.errors) {
      if (lastCp !== CharCodes3.SEMI) {
        this.errors.missingSemicolonAfterCharacterReference();
      }
      this.errors.validateNumericCharacterReference(this.result);
    }
    return this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(str, offset) {
    const { decodeTree } = this;
    let current = decodeTree[this.treeIndex];
    let valueLength = (current & BinTrieFlags2.VALUE_LENGTH) >> 14;
    for (; offset < str.length; offset++, this.excess++) {
      const char = str.charCodeAt(offset);
      this.treeIndex = determineBranch2(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
      if (this.treeIndex < 0) {
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === DecodingMode2.Attribute && // We shouldn't have consumed any characters after the entity,
        (valueLength === 0 || // And there should be no invalid characters.
        isEntityInAttributeInvalidEnd2(char)) ? 0 : this.emitNotTerminatedNamedEntity();
      }
      current = decodeTree[this.treeIndex];
      valueLength = (current & BinTrieFlags2.VALUE_LENGTH) >> 14;
      if (valueLength !== 0) {
        if (char === CharCodes3.SEMI) {
          return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
        }
        if (this.decodeMode !== DecodingMode2.Strict) {
          this.result = this.treeIndex;
          this.consumed += this.excess;
          this.excess = 0;
        }
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var _a22;
    const { result, decodeTree } = this;
    const valueLength = (decodeTree[result] & BinTrieFlags2.VALUE_LENGTH) >> 14;
    this.emitNamedEntityData(result, valueLength, this.consumed);
    (_a22 = this.errors) === null || _a22 === void 0 ? void 0 : _a22.missingSemicolonAfterCharacterReference();
    return this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(result, valueLength, consumed) {
    const { decodeTree } = this;
    this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags2.VALUE_LENGTH : decodeTree[result + 1], consumed);
    if (valueLength === 3) {
      this.emitCodePoint(decodeTree[result + 2], consumed);
    }
    return consumed;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var _a22;
    switch (this.state) {
      case EntityDecoderState2.NamedEntity: {
        return this.result !== 0 && (this.decodeMode !== DecodingMode2.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      }
      case EntityDecoderState2.NumericDecimal: {
        return this.emitNumericEntity(0, 2);
      }
      case EntityDecoderState2.NumericHex: {
        return this.emitNumericEntity(0, 3);
      }
      case EntityDecoderState2.NumericStart: {
        (_a22 = this.errors) === null || _a22 === void 0 ? void 0 : _a22.absenceOfDigitsInNumericCharacterReference(this.consumed);
        return 0;
      }
      case EntityDecoderState2.EntityStart: {
        return 0;
      }
    }
  }
};
function getDecoder2(decodeTree) {
  let ret = "";
  const decoder = new EntityDecoder2(decodeTree, (str) => ret += fromCodePoint2(str));
  return function decodeWithTrie(str, decodeMode) {
    let lastIndex = 0;
    let offset = 0;
    while ((offset = str.indexOf("&", offset)) >= 0) {
      ret += str.slice(lastIndex, offset);
      decoder.startEntity(decodeMode);
      const len = decoder.write(
        str,
        // Skip the "&"
        offset + 1
      );
      if (len < 0) {
        lastIndex = offset + decoder.end();
        break;
      }
      lastIndex = offset + len;
      offset = len === 0 ? lastIndex + 1 : lastIndex;
    }
    const result = ret + str.slice(lastIndex);
    ret = "";
    return result;
  };
}
function determineBranch2(decodeTree, current, nodeIdx, char) {
  const branchCount = (current & BinTrieFlags2.BRANCH_LENGTH) >> 7;
  const jumpOffset = current & BinTrieFlags2.JUMP_TABLE;
  if (branchCount === 0) {
    return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
  }
  if (jumpOffset) {
    const value = char - jumpOffset;
    return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
  }
  let lo = nodeIdx;
  let hi = lo + branchCount - 1;
  while (lo <= hi) {
    const mid = lo + hi >>> 1;
    const midVal = decodeTree[mid];
    if (midVal < char) {
      lo = mid + 1;
    } else if (midVal > char) {
      hi = mid - 1;
    } else {
      return decodeTree[mid + branchCount];
    }
  }
  return -1;
}
var htmlDecoder2 = getDecoder2(decode_data_html_default2);
var xmlDecoder2 = getDecoder2(decode_data_xml_default2);
function restoreDiff2(arr) {
  for (let i = 1; i < arr.length; i++) {
    arr[i][0] += arr[i - 1][0] + 1;
  }
  return arr;
}
var encode_html_default2 = new Map(/* @__PURE__ */ restoreDiff2([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ restoreDiff2([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ restoreDiff2([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ restoreDiff2([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var xmlReplacer2 = /["&'<>$\x80-\uFFFF]/g;
var xmlCodeMap2 = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]);
var getCodePoint2 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (str, index) => str.codePointAt(index) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (c, index) => (c.charCodeAt(index) & 64512) === 55296 ? (c.charCodeAt(index) - 55296) * 1024 + c.charCodeAt(index + 1) - 56320 + 65536 : c.charCodeAt(index)
  )
);
function encodeXML2(str) {
  let ret = "";
  let lastIdx = 0;
  let match;
  while ((match = xmlReplacer2.exec(str)) !== null) {
    const i = match.index;
    const char = str.charCodeAt(i);
    const next = xmlCodeMap2.get(char);
    if (next !== void 0) {
      ret += str.substring(lastIdx, i) + next;
      lastIdx = i + 1;
    } else {
      ret += `${str.substring(lastIdx, i)}&#x${getCodePoint2(str, i).toString(16)};`;
      lastIdx = xmlReplacer2.lastIndex += Number((char & 64512) === 55296);
    }
  }
  return ret + str.substr(lastIdx);
}
function getEscaper2(regex, map2) {
  return function escape22(data) {
    let match;
    let lastIdx = 0;
    let result = "";
    while (match = regex.exec(data)) {
      if (lastIdx !== match.index) {
        result += data.substring(lastIdx, match.index);
      }
      result += map2.get(match[0].charCodeAt(0));
      lastIdx = match.index + 1;
    }
    return result + data.substring(lastIdx);
  };
}
var escapeUTF82 = getEscaper2(/[&<>'"]/g, xmlCodeMap2);
var escapeAttribute2 = getEscaper2(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
]));
var escapeText2 = getEscaper2(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
]));
var EntityLevel2;
(function(EntityLevel22) {
  EntityLevel22[EntityLevel22["XML"] = 0] = "XML";
  EntityLevel22[EntityLevel22["HTML"] = 1] = "HTML";
})(EntityLevel2 || (EntityLevel2 = {}));
var EncodingMode2;
(function(EncodingMode22) {
  EncodingMode22[EncodingMode22["UTF8"] = 0] = "UTF8";
  EncodingMode22[EncodingMode22["ASCII"] = 1] = "ASCII";
  EncodingMode22[EncodingMode22["Extensive"] = 2] = "Extensive";
  EncodingMode22[EncodingMode22["Attribute"] = 3] = "Attribute";
  EncodingMode22[EncodingMode22["Text"] = 4] = "Text";
})(EncodingMode2 || (EncodingMode2 = {}));
var elementNames2 = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((val) => [val.toLowerCase(), val]));
var attributeNames2 = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((val) => [val.toLowerCase(), val]));
var unencodedElements = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function replaceQuotes(value) {
  return value.replace(/"/g, "&quot;");
}
function formatAttributes(attributes, opts) {
  var _a22;
  if (!attributes)
    return;
  const encode = ((_a22 = opts.encodeEntities) !== null && _a22 !== void 0 ? _a22 : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? encodeXML2 : escapeAttribute2;
  return Object.keys(attributes).map((key) => {
    var _a3, _b;
    const value = (_a3 = attributes[key]) !== null && _a3 !== void 0 ? _a3 : "";
    if (opts.xmlMode === "foreign") {
      key = (_b = attributeNames2.get(key)) !== null && _b !== void 0 ? _b : key;
    }
    if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
      return key;
    }
    return `${key}="${encode(value)}"`;
  }).join(" ");
}
var singleTag = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function render(node, options = {}) {
  const nodes = "length" in node ? node : [node];
  let output = "";
  for (let i = 0; i < nodes.length; i++) {
    output += renderNode(nodes[i], options);
  }
  return output;
}
var esm_default2 = render;
function renderNode(node, options) {
  switch (node.type) {
    case Root2:
      return render(node.children, options);
    case Doctype2:
    case Directive2:
      return renderDirective(node);
    case Comment3:
      return renderComment(node);
    case CDATA3:
      return renderCdata(node);
    case Script2:
    case Style2:
    case Tag2:
      return renderTag(node, options);
    case Text3:
      return renderText(node, options);
  }
}
var foreignModeIntegrationPoints = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]);
var foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
function renderTag(elem, opts) {
  var _a22;
  if (opts.xmlMode === "foreign") {
    elem.name = (_a22 = elementNames2.get(elem.name)) !== null && _a22 !== void 0 ? _a22 : elem.name;
    if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
      opts = __spreadProps(__spreadValues({}, opts), { xmlMode: false });
    }
  }
  if (!opts.xmlMode && foreignElements.has(elem.name)) {
    opts = __spreadProps(__spreadValues({}, opts), { xmlMode: "foreign" });
  }
  let tag = `<${elem.name}`;
  const attribs = formatAttributes(elem.attribs, opts);
  if (attribs) {
    tag += ` ${attribs}`;
  }
  if (elem.children.length === 0 && (opts.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    opts.selfClosingTags !== false
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    opts.selfClosingTags && singleTag.has(elem.name)
  ))) {
    if (!opts.xmlMode)
      tag += " ";
    tag += "/>";
  } else {
    tag += ">";
    if (elem.children.length > 0) {
      tag += render(elem.children, opts);
    }
    if (opts.xmlMode || !singleTag.has(elem.name)) {
      tag += `</${elem.name}>`;
    }
  }
  return tag;
}
function renderDirective(elem) {
  return `<${elem.data}>`;
}
function renderText(elem, opts) {
  var _a22;
  let data = elem.data || "";
  if (((_a22 = opts.encodeEntities) !== null && _a22 !== void 0 ? _a22 : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
    data = opts.xmlMode || opts.encodeEntities !== "utf8" ? encodeXML2(data) : escapeText2(data);
  }
  return data;
}
function renderCdata(elem) {
  return `<![CDATA[${elem.children[0].data}]]>`;
}
function renderComment(elem) {
  return `<!--${elem.data}-->`;
}
function getOuterHTML(node, options) {
  return esm_default2(node, options);
}
function getInnerHTML(node, options) {
  return hasChildren(node) ? node.children.map((node2) => getOuterHTML(node2, options)).join("") : "";
}
function getText(node) {
  if (Array.isArray(node))
    return node.map(getText).join("");
  if (isTag2(node))
    return node.name === "br" ? "\n" : getText(node.children);
  if (isCDATA(node))
    return getText(node.children);
  if (isText(node))
    return node.data;
  return "";
}
function textContent2(node) {
  if (Array.isArray(node))
    return node.map(textContent2).join("");
  if (hasChildren(node) && !isComment(node)) {
    return textContent2(node.children);
  }
  if (isText(node))
    return node.data;
  return "";
}
function innerText(node) {
  if (Array.isArray(node))
    return node.map(innerText).join("");
  if (hasChildren(node) && (node.type === ElementType2.Tag || isCDATA(node))) {
    return innerText(node.children);
  }
  if (isText(node))
    return node.data;
  return "";
}
function getChildren(elem) {
  return hasChildren(elem) ? elem.children : [];
}
function getParent(elem) {
  return elem.parent || null;
}
function getSiblings(elem) {
  const parent = getParent(elem);
  if (parent != null)
    return getChildren(parent);
  const siblings = [elem];
  let { prev, next } = elem;
  while (prev != null) {
    siblings.unshift(prev);
    ({ prev } = prev);
  }
  while (next != null) {
    siblings.push(next);
    ({ next } = next);
  }
  return siblings;
}
function getAttributeValue(elem, name) {
  var _a22;
  return (_a22 = elem.attribs) === null || _a22 === void 0 ? void 0 : _a22[name];
}
function hasAttrib(elem, name) {
  return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function getName(elem) {
  return elem.name;
}
function nextElementSibling(elem) {
  let { next } = elem;
  while (next !== null && !isTag2(next))
    ({ next } = next);
  return next;
}
function prevElementSibling(elem) {
  let { prev } = elem;
  while (prev !== null && !isTag2(prev))
    ({ prev } = prev);
  return prev;
}
function removeElement(elem) {
  if (elem.prev)
    elem.prev.next = elem.next;
  if (elem.next)
    elem.next.prev = elem.prev;
  if (elem.parent) {
    const childs = elem.parent.children;
    childs.splice(childs.lastIndexOf(elem), 1);
  }
}
function replaceElement(elem, replacement) {
  const prev = replacement.prev = elem.prev;
  if (prev) {
    prev.next = replacement;
  }
  const next = replacement.next = elem.next;
  if (next) {
    next.prev = replacement;
  }
  const parent = replacement.parent = elem.parent;
  if (parent) {
    const childs = parent.children;
    childs[childs.lastIndexOf(elem)] = replacement;
    elem.parent = null;
  }
}
function appendChild(elem, child) {
  removeElement(child);
  child.next = null;
  child.parent = elem;
  if (elem.children.push(child) > 1) {
    const sibling = elem.children[elem.children.length - 2];
    sibling.next = child;
    child.prev = sibling;
  } else {
    child.prev = null;
  }
}
function append(elem, next) {
  removeElement(next);
  const { parent } = elem;
  const currNext = elem.next;
  next.next = currNext;
  next.prev = elem;
  elem.next = next;
  next.parent = parent;
  if (currNext) {
    currNext.prev = next;
    if (parent) {
      const childs = parent.children;
      childs.splice(childs.lastIndexOf(currNext), 0, next);
    }
  } else if (parent) {
    parent.children.push(next);
  }
}
function prependChild(elem, child) {
  removeElement(child);
  child.parent = elem;
  child.prev = null;
  if (elem.children.unshift(child) !== 1) {
    const sibling = elem.children[1];
    sibling.prev = child;
    child.next = sibling;
  } else {
    child.next = null;
  }
}
function prepend(elem, prev) {
  removeElement(prev);
  const { parent } = elem;
  if (parent) {
    const childs = parent.children;
    childs.splice(childs.indexOf(elem), 0, prev);
  }
  if (elem.prev) {
    elem.prev.next = prev;
  }
  prev.parent = parent;
  prev.prev = elem.prev;
  prev.next = elem;
  elem.prev = prev;
}
function filter2(test, node, recurse = true, limit = Infinity) {
  if (!Array.isArray(node))
    node = [node];
  return find(test, node, recurse, limit);
}
function find(test, nodes, recurse, limit) {
  const result = [];
  for (const elem of nodes) {
    if (test(elem)) {
      result.push(elem);
      if (--limit <= 0)
        break;
    }
    if (recurse && hasChildren(elem) && elem.children.length > 0) {
      const children = find(test, elem.children, recurse, limit);
      result.push(...children);
      limit -= children.length;
      if (limit <= 0)
        break;
    }
  }
  return result;
}
function findOneChild(test, nodes) {
  return nodes.find(test);
}
function findOne2(test, nodes, recurse = true) {
  let elem = null;
  for (let i = 0; i < nodes.length && !elem; i++) {
    const checked = nodes[i];
    if (!isTag2(checked)) {
      continue;
    } else if (test(checked)) {
      elem = checked;
    } else if (recurse && checked.children.length > 0) {
      elem = findOne2(test, checked.children, true);
    }
  }
  return elem;
}
function existsOne(test, nodes) {
  return nodes.some((checked) => isTag2(checked) && (test(checked) || checked.children.length > 0 && existsOne(test, checked.children)));
}
function findAll(test, nodes) {
  var _a22;
  const result = [];
  const stack = nodes.filter(isTag2);
  let elem;
  while (elem = stack.shift()) {
    const children = (_a22 = elem.children) === null || _a22 === void 0 ? void 0 : _a22.filter(isTag2);
    if (children && children.length > 0) {
      stack.unshift(...children);
    }
    if (test(elem))
      result.push(elem);
  }
  return result;
}
var Checks = {
  tag_name(name) {
    if (typeof name === "function") {
      return (elem) => isTag2(elem) && name(elem.name);
    } else if (name === "*") {
      return isTag2;
    }
    return (elem) => isTag2(elem) && elem.name === name;
  },
  tag_type(type) {
    if (typeof type === "function") {
      return (elem) => type(elem.type);
    }
    return (elem) => elem.type === type;
  },
  tag_contains(data) {
    if (typeof data === "function") {
      return (elem) => isText(elem) && data(elem.data);
    }
    return (elem) => isText(elem) && elem.data === data;
  }
};
function getAttribCheck(attrib, value) {
  if (typeof value === "function") {
    return (elem) => isTag2(elem) && value(elem.attribs[attrib]);
  }
  return (elem) => isTag2(elem) && elem.attribs[attrib] === value;
}
function combineFuncs(a, b2) {
  return (elem) => a(elem) || b2(elem);
}
function compileTest(options) {
  const funcs = Object.keys(options).map((key) => {
    const value = options[key];
    return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
  });
  return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
function testElement(options, node) {
  const test = compileTest(options);
  return test ? test(node) : true;
}
function getElements(options, nodes, recurse, limit = Infinity) {
  const test = compileTest(options);
  return test ? filter2(test, nodes, recurse, limit) : [];
}
function getElementById(id, nodes, recurse = true) {
  if (!Array.isArray(nodes))
    nodes = [nodes];
  return findOne2(getAttribCheck("id", id), nodes, recurse);
}
function getElementsByTagName2(tagName, nodes, recurse = true, limit = Infinity) {
  return filter2(Checks["tag_name"](tagName), nodes, recurse, limit);
}
function getElementsByTagType(type, nodes, recurse = true, limit = Infinity) {
  return filter2(Checks["tag_type"](type), nodes, recurse, limit);
}
function removeSubsets(nodes) {
  let idx = nodes.length;
  while (--idx >= 0) {
    const node = nodes[idx];
    if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
      nodes.splice(idx, 1);
      continue;
    }
    for (let ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
      if (nodes.includes(ancestor)) {
        nodes.splice(idx, 1);
        break;
      }
    }
  }
  return nodes;
}
var DocumentPosition2;
(function(DocumentPosition22) {
  DocumentPosition22[DocumentPosition22["DISCONNECTED"] = 1] = "DISCONNECTED";
  DocumentPosition22[DocumentPosition22["PRECEDING"] = 2] = "PRECEDING";
  DocumentPosition22[DocumentPosition22["FOLLOWING"] = 4] = "FOLLOWING";
  DocumentPosition22[DocumentPosition22["CONTAINS"] = 8] = "CONTAINS";
  DocumentPosition22[DocumentPosition22["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition2 || (DocumentPosition2 = {}));
function compareDocumentPosition(nodeA, nodeB) {
  const aParents = [];
  const bParents = [];
  if (nodeA === nodeB) {
    return 0;
  }
  let current = hasChildren(nodeA) ? nodeA : nodeA.parent;
  while (current) {
    aParents.unshift(current);
    current = current.parent;
  }
  current = hasChildren(nodeB) ? nodeB : nodeB.parent;
  while (current) {
    bParents.unshift(current);
    current = current.parent;
  }
  const maxIdx = Math.min(aParents.length, bParents.length);
  let idx = 0;
  while (idx < maxIdx && aParents[idx] === bParents[idx]) {
    idx++;
  }
  if (idx === 0) {
    return DocumentPosition2.DISCONNECTED;
  }
  const sharedParent = aParents[idx - 1];
  const siblings = sharedParent.children;
  const aSibling = aParents[idx];
  const bSibling = bParents[idx];
  if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
    if (sharedParent === nodeB) {
      return DocumentPosition2.FOLLOWING | DocumentPosition2.CONTAINED_BY;
    }
    return DocumentPosition2.FOLLOWING;
  }
  if (sharedParent === nodeA) {
    return DocumentPosition2.PRECEDING | DocumentPosition2.CONTAINS;
  }
  return DocumentPosition2.PRECEDING;
}
function uniqueSort(nodes) {
  nodes = nodes.filter((node, i, arr) => !arr.includes(node, i + 1));
  nodes.sort((a, b2) => {
    const relative = compareDocumentPosition(a, b2);
    if (relative & DocumentPosition2.PRECEDING) {
      return -1;
    } else if (relative & DocumentPosition2.FOLLOWING) {
      return 1;
    }
    return 0;
  });
  return nodes;
}
function getFeed2(doc) {
  const feedRoot = getOneElement(isValidFeed, doc);
  return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
}
function getAtomFeed(feedRoot) {
  var _a22;
  const childs = feedRoot.children;
  const feed = {
    type: "atom",
    items: getElementsByTagName2("entry", childs).map((item) => {
      var _a3;
      const { children } = item;
      const entry = { media: getMediaElements(children) };
      addConditionally(entry, "id", "id", children);
      addConditionally(entry, "title", "title", children);
      const href2 = (_a3 = getOneElement("link", children)) === null || _a3 === void 0 ? void 0 : _a3.attribs["href"];
      if (href2) {
        entry.link = href2;
      }
      const description = fetch("summary", children) || fetch("content", children);
      if (description) {
        entry.description = description;
      }
      const pubDate = fetch("updated", children);
      if (pubDate) {
        entry.pubDate = new Date(pubDate);
      }
      return entry;
    })
  };
  addConditionally(feed, "id", "id", childs);
  addConditionally(feed, "title", "title", childs);
  const href = (_a22 = getOneElement("link", childs)) === null || _a22 === void 0 ? void 0 : _a22.attribs["href"];
  if (href) {
    feed.link = href;
  }
  addConditionally(feed, "description", "subtitle", childs);
  const updated = fetch("updated", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "email", childs, true);
  return feed;
}
function getRssFeed(feedRoot) {
  var _a22, _b;
  const childs = (_b = (_a22 = getOneElement("channel", feedRoot.children)) === null || _a22 === void 0 ? void 0 : _a22.children) !== null && _b !== void 0 ? _b : [];
  const feed = {
    type: feedRoot.name.substr(0, 3),
    id: "",
    items: getElementsByTagName2("item", feedRoot.children).map((item) => {
      const { children } = item;
      const entry = { media: getMediaElements(children) };
      addConditionally(entry, "id", "guid", children);
      addConditionally(entry, "title", "title", children);
      addConditionally(entry, "link", "link", children);
      addConditionally(entry, "description", "description", children);
      const pubDate = fetch("pubDate", children);
      if (pubDate)
        entry.pubDate = new Date(pubDate);
      return entry;
    })
  };
  addConditionally(feed, "title", "title", childs);
  addConditionally(feed, "link", "link", childs);
  addConditionally(feed, "description", "description", childs);
  const updated = fetch("lastBuildDate", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "managingEditor", childs, true);
  return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function getMediaElements(where) {
  return getElementsByTagName2("media:content", where).map((elem) => {
    const { attribs } = elem;
    const media = {
      medium: attribs["medium"],
      isDefault: !!attribs["isDefault"]
    };
    for (const attrib of MEDIA_KEYS_STRING) {
      if (attribs[attrib]) {
        media[attrib] = attribs[attrib];
      }
    }
    for (const attrib of MEDIA_KEYS_INT) {
      if (attribs[attrib]) {
        media[attrib] = parseInt(attribs[attrib], 10);
      }
    }
    if (attribs["expression"]) {
      media.expression = attribs["expression"];
    }
    return media;
  });
}
function getOneElement(tagName, node) {
  return getElementsByTagName2(tagName, node, true, 1)[0];
}
function fetch(tagName, where, recurse = false) {
  return textContent2(getElementsByTagName2(tagName, where, recurse, 1)).trim();
}
function addConditionally(obj, prop, tagName, where, recurse = false) {
  const val = fetch(tagName, where, recurse);
  if (val)
    obj[prop] = val;
}
function isValidFeed(value) {
  return value === "rss" || value === "feed" || value === "rdf:RDF";
}
function isCDATA4(node) {
  return isCDATA(node);
}
function isComment4(node) {
  return isComment(node);
}
function isDirective2(node) {
  return isDirective(node);
}
function isDoctype(node) {
  return node.type === esm_exports.Doctype;
}
function isDocument3(node) {
  return isDocument(node);
}
function isTag7(node) {
  return isTag2(node) && !!node.source;
}
function isText5(node) {
  return isText(node);
}
var SourceDomHandler = class extends DomHandler {
  constructor() {
    super(...arguments);
    this.extendedParser = null;
  }
  onparserinit(parser) {
    super.onparserinit(parser);
    this.extendedParser = parser;
  }
  /**
   * Make the tag stack public
   */
  get publicTagStack() {
    return this.tagStack;
  }
  addNode(node) {
    var _a22;
    if ((node.type === esm_exports.Tag || node.type === esm_exports.Script || node.type === esm_exports.Style) && ((_a22 = this.extendedParser) == null ? void 0 : _a22.openTag)) {
      node.source = {
        openTag: this.extendedParser.openTag,
        closeTag: null,
        attributes: this.extendedParser.attributes
      };
    }
    super.addNode(node);
  }
  onclosetag() {
    var _a22, _b, _c;
    if (this.tagStack.length > 0 && ((_a22 = this.tagStack[this.tagStack.length - 1]) == null ? void 0 : _a22.source) && ((_b = this.extendedParser) == null ? void 0 : _b.closeTag)) {
      if (this.extendedParser.closeTag.name === this.tagStack[this.tagStack.length - 1].source.openTag.name) {
        this.tagStack[this.tagStack.length - 1].source.closeTag = (_c = this.extendedParser) == null ? void 0 : _c.closeTag;
        this.extendedParser.closeTag = null;
      }
    }
    super.onclosetag();
  }
};
var SourceParser = class extends Parser {
  constructor(handler, options) {
    super(handler, options);
    this.attributeSource = null;
    this.openTag = null;
    this.closeTag = null;
    this.attributes = null;
    this.source = "";
    this.handler = handler;
  }
  /**
   * Get the open tag
   *
   * 1. onopentagname is called with the start index of the tag name
   * 2. onopentagend is called with the end index of the tag
   */
  onopentagname(start2, endIndex) {
    const fullStartIndex = start2 - 1;
    this.openTag = {
      startIndex: fullStartIndex,
      endIndex: fullStartIndex,
      data: "",
      name: this.slice(start2, endIndex),
      isSelfClosing: false
    };
    this.attributes = [];
    super.onopentagname(start2, endIndex);
  }
  onopentagend(endIndex) {
    this.openTag = __spreadProps(__spreadValues({}, this.openTag), {
      endIndex,
      data: this.slice(this.openTag.startIndex, endIndex + 1),
      // if the second to last character is a /, then it's self closing
      isSelfClosing: this.source[endIndex - 1] === "/" || this.isVoidElement(this.openTag.name)
    });
    super.onopentagend(endIndex);
  }
  /**
   * Get the close tag
   *
   * 1. onclosetag is called with the start index and end index of the tag
   * 2. onselfclosingtag is called with the end index of the tag
   */
  onclosetag(start2, endIndex) {
    let trueStartIndex = start2;
    while (this.slice(trueStartIndex, trueStartIndex + 1) !== "<") {
      trueStartIndex -= 1;
    }
    let trueEndIndex = endIndex;
    while (this.slice(trueEndIndex - 1, trueEndIndex) !== ">") {
      trueEndIndex += 1;
    }
    this.closeTag = {
      startIndex: trueStartIndex,
      endIndex: trueEndIndex,
      data: this.slice(trueStartIndex, trueEndIndex),
      name: this.slice(start2, endIndex)
    };
    if (this.handler.publicTagStack.length > 0) {
      const lastTag = this.handler.publicTagStack[this.handler.publicTagStack.length - 1];
      if (lastTag.type === esm_exports.Tag && this.closeTag.name !== lastTag.name || lastTag.type === esm_exports.Root) {
        this.handler.ontext(this.closeTag.data);
      }
    } else {
      this.handler.ontext(this.closeTag.data);
    }
    super.onclosetag(start2, endIndex);
    this.startIndex = trueEndIndex;
  }
  onselfclosingtag(endIndex) {
    this.openTag = __spreadProps(__spreadValues({}, this.openTag), {
      endIndex,
      data: this.slice(this.openTag.startIndex, endIndex + 1),
      isSelfClosing: true
    });
    this.closeTag = null;
    super.onselfclosingtag(endIndex);
  }
  /**
   * Get the attributes
   *
   * 1. onattribname - Grab start and end indexes of the attribute name
   * 2. onattribdata - Grab start and end indexes of the attribute value. If it already has a value, then extend the end index.
   * 3. onattribentity - If the attribute already has a value range, then extend the end index
   * 4. onattribend - Get the end index for the full source and attribute value, and store the type of quote used with the attribute
   *
   */
  onattribname(start2, endIndex) {
    const name = this.slice(start2, endIndex);
    this.attributeSource = {
      name: {
        startIndex: start2,
        endIndex: endIndex - 1,
        data: name
      },
      value: null,
      quote: void 0,
      source: {
        startIndex: start2,
        endIndex: endIndex - 1,
        data: name
      }
    };
    super.onattribname(start2, endIndex);
  }
  onattribdata(start2, endIndex) {
    var _a22;
    if (this.attributeSource) {
      if (!((_a22 = this.attributeSource) == null ? void 0 : _a22.value)) {
        const value = this.slice(start2, endIndex);
        this.attributeSource.value = {
          startIndex: start2,
          endIndex: endIndex - 1,
          data: value
        };
      } else {
        const value = this.slice(this.attributeSource.value.startIndex, endIndex);
        this.attributeSource.value.endIndex = endIndex - 1;
        this.attributeSource.value.data = value;
      }
      this.attributeSource.source.endIndex = endIndex - 1;
    }
    super.onattribdata(start2, endIndex);
  }
  /**
   * TODO: verify this is correct and we don't need to handle
   * it being called as the first part of the value
   */
  onattribentity(cp) {
    if (this.attributeSource) {
      const value = this.attribvalue;
      if (this.attributeSource.value) {
        this.attributeSource.value.endIndex += 1;
        this.attributeSource.value.data = value;
        this.attributeSource.source.endIndex += 1;
      }
    }
    super.onattribentity(cp);
  }
  onattribend(quote, endIndex) {
    const endIndexWithQuote = endIndex - 1 + (quote === 3 || quote === 2 ? 1 : 0);
    if (this.attributeSource) {
      this.attributeSource.source = __spreadProps(__spreadValues({}, this.attributeSource.source), {
        endIndex: endIndexWithQuote,
        data: this.slice(this.attributeSource.source.startIndex, endIndexWithQuote + 1)
      });
      this.attributeSource.quote = quote === 3 ? '"' : quote === 2 ? "'" : quote === 0 ? void 0 : null;
      this.attributes.push(this.attributeSource);
    }
    this.attributeSource = null;
    super.onattribend(quote, endIndex);
  }
  slice(startIndex, endIndex) {
    return this.source.slice(startIndex, endIndex);
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(chunk) {
    this.source += chunk;
    super.write(chunk);
  }
};
function parseDocument(data, options) {
  var _a22;
  options = options || {};
  options = __spreadValues({
    withStartIndices: true,
    withEndIndices: true
  }, options);
  const handler = new SourceDomHandler(void 0, options);
  new SourceParser(handler, options).end(data);
  const { root } = handler;
  const stack = [root];
  while (stack.length > 0) {
    const node = stack.pop();
    if (isTag7(node) && node.source.closeTag === null && !node.source.openTag.isSelfClosing) {
      let parent = isTag7(node.parent) ? node.parent : void 0;
      while ((parent == null ? void 0 : parent.source.closeTag) === null && (parent == null ? void 0 : parent.parent) && isTag7(parent == null ? void 0 : parent.parent) && ((_a22 = parent == null ? void 0 : parent.parent) == null ? void 0 : _a22.endIndex) === node.endIndex) {
        parent = parent.parent;
      }
      if (parent && isTag7(parent) && parent.source.closeTag) {
        node.endIndex = parent.source.closeTag.startIndex - 1;
      }
    }
    if (node.type === esm_exports.Root || isTag7(node)) {
      stack.push(...node.children);
    }
  }
  return handler.root;
}
function nodeToString(node) {
  var _a22, _b;
  if (isDocument3(node)) {
    return node.children.map((node2) => nodeToString(node2)).join("");
  }
  if (isDirective2(node) || isDoctype(node)) {
    return `<${node.data}>`;
  }
  if (isText5(node)) {
    return node.data;
  }
  if (isCDATA4(node)) {
    return "";
  }
  if (isComment4(node)) {
    return `<!--${node.data}-->`;
  }
  if (isTag7(node)) {
    return node.source.openTag.data + node.children.map(nodeToString).join("") + ((_b = (_a22 = node.source.closeTag) == null ? void 0 : _a22.data) != null ? _b : "");
  }
  return "";
}

// src/parser/style.ts
import has from "lodash/has";
function parseStyle(styleNodes) {
  const styleValue = [];
  while (styleNodes.length) {
    const styleNode = styleNodes.shift();
    if (has(styleNode, "attribs.#if")) {
      const rootIfNode = {
        type: "if",
        test: styleNode.attribs["#if"],
        consequent: [parseStyleNode(styleNode)],
        alternate: void 0
      };
      styleValue.push(rootIfNode);
      let latestIfNode = rootIfNode;
      while (styleNodes.length && has(styleNodes[0], "attribs.#else-if")) {
        const elseIfNode = {
          type: "if",
          test: styleNodes[0].attribs["#else-if"],
          consequent: [parseStyleNode(styleNodes.shift())],
          alternate: void 0
        };
        latestIfNode.alternate = [elseIfNode];
        latestIfNode = elseIfNode;
      }
      if (styleNodes.length && has(styleNodes[0], "attribs.#else")) {
        latestIfNode.alternate = [parseStyleNode(styleNodes.shift())];
      }
    } else {
      styleValue.push(parseStyleNode(styleNode));
    }
  }
  return {
    value: styleValue
  };
}
function parseStyleNode(styleNode) {
  const css = styleNode.children.map(nodeToString).join("");
  const setFunctionRanges = getSetFunctionRanges(css);
  const children = [];
  let lastIndex = 0;
  for (const range of setFunctionRanges) {
    const [start2, end] = range;
    const value2 = css.slice(lastIndex, start2);
    if (value2) {
      children.push({
        type: "raw",
        value: value2
      });
    }
    const variablePath = css.slice(start2, end).replace(/set\(\s*['"]?/, "").replace(/['"]?\s*\)/, "");
    children.push({
      type: "expression",
      value: `__CARTA_RUNTIME.escapeCss(${variablePath})`
    });
    lastIndex = end;
  }
  const value = css.slice(lastIndex);
  if (value) {
    children.push({
      type: "raw",
      value
    });
  }
  const styleElementNode = {
    type: "style",
    props: {
      discrete: has(styleNode.attribs, "discrete") ? "true" : "false"
    },
    children
  };
  return styleElementNode;
}
function getSetFunctionRanges(css) {
  const ranges = [];
  let rangeStart = null;
  let inDeclarationValue = false;
  let inSetFunction = false;
  let inString = false;
  let stringQuote = "";
  for (let i = 0; i < css.length; i++) {
    const char = css[i];
    if (char === ":" && !inDeclarationValue) {
      inDeclarationValue = true;
      continue;
    }
    if (char === ";" && inDeclarationValue) {
      inDeclarationValue = false;
      continue;
    }
    if (!inSetFunction) {
      if (char === "s" && css[i + 1] === "e" && css[i + 2] === "t" && css[i + 3] === "(") {
        if (!inDeclarationValue) {
          throw new Error("set() functions can only be used in declaration values");
        }
        rangeStart = i;
        inSetFunction = true;
        i += 3;
        while (/\s/.test(css[i + 1])) {
          i++;
        }
        if (css[i + 1] === '"' || css[i + 1] === "'") {
          stringQuote = css[i + 1];
          inString = true;
          i += 1;
        }
      }
      continue;
    }
    if (char === "\\" && inString && css[i + 1] === stringQuote) {
      i++;
      continue;
    }
    if (inString && char === stringQuote) {
      while (/\s/.test(css[i + 1])) {
        i++;
      }
      if (css[i + 1] === ")") {
        ranges.push([rangeStart, i + 2]);
        inSetFunction = false;
        inString = false;
        stringQuote = "";
        rangeStart = null;
        i += 1;
        continue;
      } else {
        throw new Error("Error closing set() function. Expected ')' after quote.");
      }
    }
    if (char === ")" && !inString) {
      ranges.push([rangeStart, i + 1]);
      inSetFunction = false;
      inString = false;
      stringQuote = "";
      rangeStart = null;
      continue;
    }
  }
  if (rangeStart !== null) {
    throw new Error("Unclosed set() function");
  }
  return ranges;
}

// src/parser/template.ts
import { postprocess } from "@customerio/process-conditional-comments";
import cloneDeep from "lodash/cloneDeep";
import compact from "lodash/compact";
import flatten from "lodash/flatten";
import has2 from "lodash/has";
import last from "lodash/last";
function parseTemplate(templateNode, options) {
  const nodes = parseTemplateNodeChildren(templateNode, options);
  while (nodes.length && nodes[0].type === "raw" && !nodes[0].value.trim()) {
    nodes.shift();
  }
  while (nodes.length && last(nodes).type === "raw" && last(nodes).value.trim() === "") {
    nodes.pop();
  }
  return nodes;
}
function parseTemplateNodeChildren(templateNode, options) {
  const results = [];
  const children = [...templateNode.children];
  while (children.length) {
    const node = children.shift();
    results.push(...parseTemplateNode(node, children, options));
  }
  return buildPersonalizationBlocks(mergeRawNodes(flatten(results)), options);
}
function parseTemplateNode(node, next, options) {
  if (isText5(node)) {
    return parseTextNode(node, options);
  } else if (isComment4(node)) {
    return parseCommentNode(node);
  } else if (isTag7(node)) {
    return parseTagNode(node, next, options);
  }
  return [
    {
      type: "raw",
      value: nodeToString(node)
    }
  ];
}
function parseTextNode(node, options) {
  const expressionResults = parseExpressions(node.data);
  const textTokenizer = options?.personalizationLanguage?.textTokenizer;
  if (!textTokenizer) {
    return expressionResults;
  }
  const resultsWithPersonalizationLanguage = [];
  for (const result of expressionResults) {
    if (result.type === "expression") {
      resultsWithPersonalizationLanguage.push(result);
      continue;
    }
    const text = result.value;
    const personalizationLanguageRanges = getPersonalizationLanguageRanges(text, textTokenizer);
    let lastIndex = 0;
    for (const range of personalizationLanguageRanges) {
      const [start2, end] = range;
      const leadingText = text.slice(lastIndex, start2);
      const value = text.slice(start2, end);
      const type = textTokenizer.match(value);
      if (type === null) {
        resultsWithPersonalizationLanguage.push(...parseExpressions(leadingText + value));
        continue;
      }
      if (leadingText) {
        resultsWithPersonalizationLanguage.push(...parseExpressions(leadingText));
      }
      if (type === "expression") {
        resultsWithPersonalizationLanguage.push({
          type: "personalization-expression",
          value
        });
      } else {
        resultsWithPersonalizationLanguage.push({
          type: `personalization-block-${type}`,
          value
        });
      }
      lastIndex = end;
    }
    const remainingText = text.slice(lastIndex);
    if (remainingText) {
      resultsWithPersonalizationLanguage.push({
        type: "raw",
        value: remainingText
      });
    }
  }
  return resultsWithPersonalizationLanguage;
}
function getPersonalizationLanguageRanges(str, textTokenizer) {
  const ranges = [];
  let rangeStart = null;
  let inPersonalizationLanguage = false;
  let currentPattern = null;
  let inString = false;
  let stringQuote = "";
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (!inPersonalizationLanguage) {
      const pattern = textTokenizer.patterns.find((pattern2) => {
        const [startString] = pattern2;
        return str.slice(i).startsWith(startString);
      });
      if (pattern) {
        inPersonalizationLanguage = true;
        rangeStart = i;
        currentPattern = pattern;
        i++;
      }
      continue;
    }
    if (char === "\\" && inString) {
      i++;
      continue;
    }
    if (char === '"' || char === "'" || char === "`") {
      if (inString) {
        if (char === stringQuote) {
          inString = false;
        }
      } else {
        inString = true;
        stringQuote = char;
      }
    }
    if (!inString && inPersonalizationLanguage) {
      if (str.slice(i).startsWith(currentPattern[1])) {
        ranges.push([rangeStart, i + currentPattern[1].length]);
        inPersonalizationLanguage = false;
        i += currentPattern[1].length;
        currentPattern = null;
        rangeStart = null;
      }
    }
  }
  if (inPersonalizationLanguage) {
    throw new Error(`Unexpected end of string while parsing personalization language`);
  }
  return ranges;
}
function parseExpressions(str) {
  const expressionRanges = getExpressionRanges(str);
  const results = [];
  let lastIndex = 0;
  for (const range of expressionRanges) {
    const [start2, end] = range;
    const value2 = str.slice(lastIndex, start2);
    if (value2) {
      results.push({
        type: "raw",
        value: value2
      });
    }
    results.push({
      type: "expression",
      value: `__CARTA_RUNTIME.escapeHtml(${str.slice(start2 + 2, end - 1)})`
      // remove the ${ and }
    });
    lastIndex = end;
  }
  const value = str.slice(lastIndex);
  if (value) {
    results.push({
      type: "raw",
      value
    });
  }
  return results;
}
function parseCommentNode(node) {
  return [
    {
      type: "raw",
      value: postprocess(nodeToString(node))
    }
  ];
}
function parseTagNode(node, next, options) {
  if (node.name === "slot") {
    return [
      {
        type: "slot",
        name: node.attribs.name ?? "default",
        children: parseTemplateNodeChildren(node, options)
      }
    ];
  }
  if (has2(node, "attribs.#if")) {
    const cleanedNode = removeDirectiveFromAttributes(node, "#if");
    const rootIfNode = {
      type: "if",
      test: node.attribs["#if"],
      consequent: buildPersonalizationBlocks(parseTemplateNode(cleanedNode, next, options), options),
      alternate: void 0
    };
    let latestIfNode = rootIfNode;
    while (next.length) {
      if (isText5(next[0]) && next[0].data.trim() === "") {
        next.shift();
        continue;
      }
      if (!isTag7(next[0])) {
        break;
      }
      if (!has2(next, "0.attribs.#else-if")) {
        break;
      }
      const nextNode = next.shift();
      const cleanedNextNode = removeDirectiveFromAttributes(nextNode, "#else-if");
      latestIfNode.alternate = [
        {
          type: "if",
          test: nextNode.attribs["#else-if"],
          consequent: buildPersonalizationBlocks(parseTemplateNode(cleanedNextNode, next, options), options),
          alternate: void 0
        }
      ];
      latestIfNode = latestIfNode.alternate[0];
    }
    while (next.length) {
      if (isText5(next[0]) && next[0].data.trim() === "") {
        next.shift();
        continue;
      }
      if (!isTag7(next[0])) {
        break;
      }
      if (!has2(next, "0.attribs.#else")) {
        break;
      }
      const nextNode = next.shift();
      const cleanedNextNode = removeDirectiveFromAttributes(nextNode, "#else");
      latestIfNode.alternate = buildPersonalizationBlocks(parseTemplateNode(cleanedNextNode, next, options), options);
    }
    return [rootIfNode];
  }
  if (has2(node, "attribs.#each")) {
    const cleanedNode = removeDirectiveFromAttributes(node, "#each");
    const [left, right] = node.attribs["#each"].split(" in ");
    const leftParts = left.startsWith("(") && left.endsWith(")") ? left.slice(1, -1).split(",") : [left];
    return [
      {
        type: "each",
        target: right.trim(),
        values: compact([
          leftParts?.[0].trim(),
          leftParts?.[1]?.trim(),
          leftParts?.[2]?.trim()
        ]),
        consequent: buildPersonalizationBlocks(parseTemplateNode(cleanedNode, next, options), options)
      }
    ];
  }
  const { name, props, openTag, closeTag, isRaw, html, slot } = parseElementTags(node);
  const children = html !== null ? [
    {
      type: "expression",
      value: html
    }
  ] : isRaw === true ? [
    {
      type: "raw",
      value: node.children.map(nodeToString).join("")
    }
  ] : parseTemplateNodeChildren(node, options);
  const slots = {};
  for (const child of children) {
    if (child.type === "element" && child.slot !== null) {
      slots[child.slot] = [...slots[child.slot] ?? [], child];
    } else {
      if (child.type === "raw" && child.value.trim() === "") {
        continue;
      }
      slots.default = [...slots.default ?? [], child];
    }
  }
  return [
    {
      // Shared
      type: "element",
      slot,
      children,
      // 1. Element
      openTag,
      closeTag,
      // 2. Component
      name,
      props
    }
  ];
}
function removeDirectiveFromAttributes(node, directive) {
  const cleanedNode = cloneDeep(node);
  Object.keys(node.attribs).forEach((key) => {
    if (key === directive) {
      delete cleanedNode.attribs[key];
    }
  });
  return cleanedNode;
}
function parseElementTags(node) {
  let name;
  let props = [];
  let openTagNodes = [];
  let closeTagNodes = [];
  let isRaw = false;
  let slot = null;
  let html = null;
  const isDirective3 = node.source.attributes.find((attribute) => {
    return ["#is", "#set:is", ":is"].includes(attribute.name.data);
  });
  if (isDirective3 && isDirective3.name.data === "#is" && isDirective3.value) {
    name = {
      type: "raw",
      value: isDirective3.value.data
    };
    openTagNodes.push({
      type: "raw",
      value: `<${isDirective3.value.data}`
    });
    if (node.source.closeTag) {
      closeTagNodes.push({
        type: "raw",
        value: `</${isDirective3.value.data}>`
        // TODO: respect spacing in the future
      });
    }
  } else if (isDirective3 && ["#set:is", ":is"].includes(isDirective3.name.data) && isDirective3.value) {
    name = {
      type: "expression",
      value: isDirective3.value.data
    };
    openTagNodes.push(
      {
        type: "raw",
        value: "<"
      },
      {
        type: "expression",
        value: `__CARTA_RUNTIME.escapeAttributeValue(${isDirective3.value.data})`
        // TODO: is this the right escape function?
      }
    );
    if (node.source.closeTag) {
      closeTagNodes.push(
        {
          type: "raw",
          value: `</`
        },
        {
          type: "expression",
          value: `__CARTA_RUNTIME.escapeAttributeValue(${isDirective3.value.data})`
          // TODO: is this the right escape function?
        },
        {
          type: "raw",
          value: ">"
        }
      );
    }
  } else {
    name = {
      type: "raw",
      value: node.name
    };
    openTagNodes.push({
      type: "raw",
      value: node.source.openTag.data.slice(0, node.name.length + 1)
      // +1 for the `<`
    });
    closeTagNodes.push({
      type: "raw",
      value: node.source.closeTag?.data ?? ""
    });
  }
  const addProp = (key, value) => {
    props = [value ? [key, value] : key, ...props];
  };
  let previousEndIndex = node.name.length + 1;
  let attributes = [...node.source.attributes];
  let processedClass = false;
  let processedStyle = false;
  while (attributes.length) {
    const attribute = attributes.shift();
    const leadingWhitespace = node.source.openTag.data.slice(
      previousEndIndex,
      attribute.source.startIndex - node.source.openTag.startIndex
    );
    if (attribute.name.data === "#slot") {
      slot = attribute.value?.data ?? null;
    } else if (attribute.name.data === "#is:raw") {
      isRaw = true;
    } else if (["#is", "#set:is", ":is"].includes(attribute.name.data)) {
    } else if (["#if", "#else-if", "#else", "#each"].includes(attribute.name.data)) {
    } else if (["#set:html", ":html"].includes(attribute.name.data) && html === null) {
      html = attribute.value?.data ?? "";
    } else if (isClassRelatedAttribute(attribute.name.data) && !processedClass) {
      processedClass = true;
      const classRelatedAttributes = [
        attribute,
        ...attributes.filter((attribute2) => isClassRelatedAttribute(attribute2.name.data))
      ];
      if (classRelatedAttributes.length === 1 && attribute.name.data === "class") {
        openTagNodes.push({
          type: "raw",
          value: leadingWhitespace + attribute.source.data
        });
        addProp(attribute.name.data, `"${attribute.value?.data ?? ""}"`);
      } else {
        let value = "__CARTA_RUNTIME.renderClass([";
        let handledNativeClassAttribute = false;
        classRelatedAttributes.forEach((attribute2) => {
          if (attribute2.name.data === "class") {
            if (!handledNativeClassAttribute) {
              handledNativeClassAttribute = true;
              value += attribute2.value?.data ? `"${attribute2.value?.data}",` : "";
            }
          } else if (attribute2.name.data === "#set:class" || attribute2.name.data === ":class") {
            value += attribute2.value?.data ? `${attribute2.value?.data},` : "";
          } else if (attribute2.name.data.startsWith("#class:")) {
            const className2 = attribute2.name.data.replace("#class:", "");
            value += `"${className2}",`;
          } else if (attribute2.name.data.startsWith("#set:class:") || attribute2.name.data.startsWith(":class:")) {
            const className2 = attribute2.name.data.replace("#set:class:", "").replace(":class:", "");
            const condition = attribute2.value?.data ?? "true";
            value += `{"${className2}": ${condition} },`;
          } else {
            throw new Error(`Unknown class-related attribute: ${attribute2.name.data}`);
          }
        });
        value += "])";
        openTagNodes.push({
          type: "raw",
          value: `${leadingWhitespace}class=${attribute.quote}` ?? '"'
        });
        openTagNodes.push({
          type: "expression",
          value
        });
        openTagNodes.push({
          type: "raw",
          value: attribute.quote ?? '"'
        });
      }
    } else if (isStyleRelatedAttribute(attribute.name.data) && !processedStyle) {
      processedStyle = true;
      const styleRelatedAttributes = [
        attribute,
        ...attributes.filter((attribute2) => isStyleRelatedAttribute(attribute2.name.data))
      ];
      if (styleRelatedAttributes.length === 1 && attribute.name.data === "style") {
        openTagNodes.push({
          type: "raw",
          value: leadingWhitespace + attribute.source.data
        });
        addProp(attribute.name.data, `"${attribute.value?.data ?? ""}"`);
      } else {
        let value = "__CARTA_RUNTIME.renderStyle([";
        let handledNativeStyleAttribute = false;
        styleRelatedAttributes.forEach((attribute2) => {
          if (attribute2.name.data === "style") {
            if (!handledNativeStyleAttribute) {
              handledNativeStyleAttribute = true;
              value += attribute2.value?.data ? `"${attribute2.value?.data}",` : "";
            }
          }
          if (attribute2.name.data === "#set:style" || attribute2.name.data === ":style") {
            value += attribute2.value?.data ? `${attribute2.value?.data},` : "";
          } else if (attribute2.name.data.startsWith("#style:")) {
            const styleName = attribute2.name.data.replace("#style:", "");
            const styleValue = attribute2.value?.data ?? "";
            value += `{"${styleName}": "${styleValue}"},`;
          } else if (attribute2.name.data.startsWith("#set:style:") || attribute2.name.data.startsWith(":style:")) {
            const styleName = attribute2.name.data.replace("#set:style:", "").replace(":style:", "");
            const styleValue = attribute2.value?.data ?? "false";
            value += `{"${styleName}": ${styleValue}},`;
          }
        });
        value += "])";
        openTagNodes.push({
          type: "raw",
          value: `${leadingWhitespace}style=${attribute.quote}` ?? '"'
        });
        openTagNodes.push({
          type: "expression",
          value
        });
        openTagNodes.push({
          type: "raw",
          value: attribute.quote ?? '"'
        });
      }
    } else if (attribute.name.data.startsWith("#set:") || attribute.name.data.startsWith(":")) {
      const key = attribute.name.data.replace(/^#set:/, "").replace(/^:/, "");
      openTagNodes.push({
        type: "raw",
        value: leadingWhitespace
      });
      openTagNodes.push({
        type: "expression",
        value: `__CARTA_RUNTIME.renderAttribute("${key}", ${attribute.value?.data ?? "undefined"}, ${`\`${attribute.quote}\`` ?? "undefined"})`
      });
      addProp(key, attribute.value?.data ?? "true");
    } else if (attribute.name.data === "#set") {
      openTagNodes.push({
        type: "raw",
        value: leadingWhitespace
      });
      openTagNodes.push({
        type: "expression",
        value: `__CARTA_RUNTIME.renderAttributes(${attribute.value?.data ?? ""})`
      });
      addProp(attribute.value?.data ?? "{}");
    } else if (attribute.name.data === "#root") {
      openTagNodes.push({
        type: "raw",
        value: leadingWhitespace
      });
      openTagNodes.push({
        type: "expression",
        value: `__CARTA_RUNTIME.renderRootDirectiveAttributes({ env: __CARTA_INPUT.__internals.env, depth:__CARTA_CURRENT_DEPTH })`
      });
      addProp("#root", "");
    } else if (!attribute.name.data.startsWith("#") && !attribute.name.data.startsWith(":")) {
      openTagNodes.push({
        type: "raw",
        value: leadingWhitespace + attribute.source.data
      });
      addProp(attribute.name.data, `"${attribute.value?.data ?? ""}"`);
    } else {
      throw new Error(`Unknown attribute directive: ${attribute.name.data} on ${node.name}`);
    }
    previousEndIndex = attribute.source.endIndex - node.source.openTag.startIndex + 1;
  }
  const trailingRaw = node.source.openTag.data.slice(previousEndIndex);
  openTagNodes.push({
    type: "raw",
    value: trailingRaw
  });
  return {
    name,
    openTag: mergeRawNodes(openTagNodes),
    closeTag: mergeRawNodes(closeTagNodes),
    props,
    isRaw,
    slot,
    html
  };
}
function mergeRawNodes(nodes) {
  const mergedNodes = [];
  for (const node of nodes) {
    const lastMergedNode = last(mergedNodes);
    if (node.type === "raw" && lastMergedNode?.type === "raw") {
      lastMergedNode.value += node.value;
    } else {
      mergedNodes.push(node);
    }
  }
  return mergedNodes;
}
function isClassRelatedAttribute(attr) {
  return attr === "class" || "#set:class" === attr || ":class" === attr || attr.startsWith("#class:") || attr.startsWith("#set:class:") || attr.startsWith(":class:*");
}
function isStyleRelatedAttribute(attr) {
  return attr === "style" || "#set:style" === attr || ":style" === attr || attr.startsWith("#style:") || attr.startsWith("#set:style:") || attr.startsWith(":style:*");
}
function getExpressionRanges(str) {
  const ranges = [];
  let rangeStart = null;
  let inExpression = false;
  let inString = false;
  let stringQuote = "";
  let curlyCount = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (!inExpression) {
      if (char === "$" && str[i + 1] === "{") {
        inExpression = true;
        rangeStart = i;
        i++;
      }
      continue;
    }
    if (char === "\\" && inString) {
      i++;
      continue;
    }
    if (char === '"' || char === "'" || char === "`") {
      if (inString) {
        if (char === stringQuote) {
          inString = false;
        }
      } else {
        inString = true;
        stringQuote = char;
      }
    }
    if (char === "{" && !inString) {
      curlyCount++;
      continue;
    }
    if (char === "}" && !inString) {
      if (curlyCount > 0) {
        curlyCount--;
        continue;
      }
      ranges.push([rangeStart, i + 1]);
      inExpression = false;
      inString = false;
      stringQuote = "";
      curlyCount = 0;
    }
  }
  if (inExpression) {
    throw new Error("Unclosed expression");
  }
  return ranges;
}
function buildPersonalizationBlocks(nodes, options) {
  const results = [];
  const children = [...nodes];
  while (children.length) {
    const node = children.shift();
    switch (node.type) {
      case "personalization-block-open": {
        const block = buildPersonalizationBlock(node, children, options);
        results.push(block);
        break;
      }
      case "personalization-block-divider": {
        throw new Error(`Found a personalization block divider tag without an open tag`);
      }
      case "personalization-block-close": {
        throw new Error(`Found a personalization block close tag without an open tag`);
      }
      default: {
        results.push(node);
      }
    }
  }
  return results;
}
function buildPersonalizationBlock(openNode, next, options) {
  const parts = [openNode];
  const { textTokenizer } = options.personalizationLanguage;
  while (next.length) {
    const node = next.shift();
    switch (node.type) {
      case "personalization-block-open": {
        const block = buildPersonalizationBlock(node, next, options);
        parts.push(block);
        break;
      }
      case "personalization-block-divider": {
        parts.push(node);
        break;
      }
      case "personalization-block-close": {
        parts.push(node);
        if (!textTokenizer.matchOpenClose(openNode.value, node.value)) {
          throw new Error(`Found a personalization block close tag that doesn't match the open tag`);
        }
        return {
          type: "personalization-block",
          parts
        };
      }
      default: {
        parts.push(node);
      }
    }
  }
  throw new Error(`Unclosed personalization block`);
}

// src/parser/index.ts
import { preprocess } from "@customerio/process-conditional-comments";
function parse(source, options) {
  const dom = parseDocument(preprocess(source), { recognizeSelfClosing: true });
  const templateNodes = dom.children.filter((child) => {
    return isTag7(child) && child.name === "template";
  });
  if (templateNodes.length === 0) {
    templateNodes.push({
      type: "tag",
      children: dom.children,
      attribs: {}
    });
    dom.children = [];
  }
  const scriptNode = dom.children.find((child) => {
    return isTag7(child) && child.name === "script";
  });
  const script = scriptNode ? {
    value: (scriptNode?.children || []).map(nodeToString).join("")
  } : { value: "" };
  const styleNodes = dom.children.filter((child) => {
    return isTag7(child) && child.name === "style";
  });
  const style3 = parseStyle(styleNodes);
  const templates = templateNodes.map((templateNode) => ({
    value: parseTemplate(templateNode, options),
    format: templateNode.attribs.format ?? null
  }));
  return {
    script,
    style: style3,
    templates
  };
}

// src/compiler.ts
function compile(source, options = {}) {
  options.nativeTags = options.nativeTags || nativeTags;
  const { script, style: style3, templates } = parse(source, options);
  const { config, props, slots, imports, result: compiledScript } = compileScript(script, options);
  const compiledStyles = b`
    const __CARTA_STYLES = [];
    ${b`${style3.value.map(compileStyle)}`}
  `;
  const formatTemplates = uniqBy(
    templates.filter((template) => template.format !== null),
    "format"
  );
  const defaultTemplate = templates.find((template) => template.format === null);
  const compiledTemplates = b`
  const __CARTA_RESULT = ${compileTemplates(
    [...formatTemplates, ...defaultTemplate ? [defaultTemplate] : []],
    options
  )}`;
  const { code, map: map2 } = print(
    codeRedX`
  ${b`
  import { __CARTA_RUNTIME as __CARTA_RUNTIME } from 'carta/internals';
  
  ${imports}

  ${config}
  ${props}
  ${slots}

  ${props ? b`const __PROP_DEFINITION = props;` : ""}
  ${slots ? b`const __SLOT_DEFINITION = slots;` : ""}
  
  export default async function(__CARTA_INPUT) {
    if (typeof process === 'undefined') var process = {};
    process.env = process.env || {};
    process.env.CARTA_ENV = __CARTA_INPUT.__internals.env;
    ${props ? b`const props = __PROP_DEFINITION.schema.parse(__CARTA_INPUT.props);` : ""}
    ${slots ? b`const slots = __SLOT_DEFINITION.schema.parse(__CARTA_INPUT.slots);` : ""}

    const __CARTA_CURRENT_DEPTH = __CARTA_INPUT.__internals.track.depth;
    const __CONTEXT = __CARTA_INPUT.context;

    ${compiledScript}
    ${compiledStyles}
    ${compiledTemplates}

    return {
      result: __CARTA_RESULT,
      styles: __CARTA_STYLES,
    }
  }
  `}`
  );
  return { code, map: map2, config: extractStaticExport(config) };
}
function compileScript(script, _options) {
  const ast = parseJavaScript(script.value, {
    sourceType: "module",
    allowAwaitOutsideFunction: true
  });
  let props = null;
  let slots = null;
  let config = null;
  let imports = [];
  walk(ast, {
    enter(node) {
      if (node.type === "ImportDeclaration") {
        imports.push(node);
        this.remove();
      }
      if (node.type === "CallExpression") {
        const { callee } = node;
        if (callee.type === "Identifier") {
          if (callee.name === "getContext") {
            node.callee = codeRedX`__CARTA_RUNTIME.getContext`;
            node.arguments = [codeRedX`__CARTA_INPUT`, ...node.arguments];
          }
        }
      }
      if (node.type === "CallExpression") {
        const { callee } = node;
        if (callee.type === "Identifier") {
          if (callee.name === "setContext") {
            node.callee = codeRedX`__CARTA_RUNTIME.setContext`;
            node.arguments = [codeRedX`__CARTA_INPUT`, ...node.arguments];
          }
        }
      }
      if (node.type === "ExportNamedDeclaration") {
        if (node?.declaration?.type === "VariableDeclaration") {
          for (const decl of node.declaration.declarations) {
            if (decl.id.type !== "Identifier") {
              throw new Error("Unexpected export");
            }
            if (decl.id.name === "config") {
              config = node;
              this.remove();
            } else if (decl.id.name === "props") {
              props = node;
              this.remove();
            } else if (decl.id.name === "slots") {
              slots = node;
              this.remove();
            } else {
              throw new Error("Unexpected export");
            }
          }
        }
      }
    }
  });
  return {
    result: ast.body,
    props: compileProps(props),
    slots: compileSlots(slots),
    config,
    imports
  };
}
function extractStaticExport(staticExport) {
  const result = {};
  if (!staticExport) {
    return result;
  }
  if (staticExport.type !== "ExportNamedDeclaration") {
    throw new Error("Failed to extract statically exported object");
  }
  const { declaration } = staticExport;
  if (declaration?.type !== "VariableDeclaration") {
    throw new Error("Failed to extract statically exported object");
  }
  const [variable] = declaration.declarations;
  if (!variable?.init) {
    throw new Error("Failed to extract statically exported object");
  }
  if (variable?.init?.type !== "ObjectExpression") {
    throw new Error("Failed to extract statically exported object");
  }
  return extractStaticValue(variable.init);
}
function extractStaticValue(node) {
  if (node.type === "Literal") {
    return node.value;
  }
  if (node.type === "ObjectExpression") {
    let result = {};
    node.properties.every((prop) => {
      if (prop.type === "SpreadElement") {
        throw new Error("Failed to extract statically exported object");
      }
      if (prop.key.type !== "Identifier") {
        throw new Error("Failed to extract statically exported object");
      }
      result[prop.key.name] = extractStaticValue(prop.value);
    });
    return result;
  }
  if (node.type === "ArrayExpression") {
    let result = [];
    return node.elements.every((element) => {
      if (element.type === "SpreadElement") {
        return false;
      }
      result.push(extractStaticValue(element));
    });
  }
  throw new Error("Failed to extract statically exported object");
}
function compileProps(props) {
  if (!props) {
    return null;
  }
  if (props.type !== "ExportNamedDeclaration") {
    throw new Error("props must be a statically exported");
  }
  const { declaration } = props;
  if (declaration?.type !== "VariableDeclaration") {
    throw new Error("props must be a statically exported");
  }
  if (declaration.declarations.length !== 1) {
    throw new Error("props must be a statically exported");
  }
  const [variable] = declaration.declarations;
  if (!variable?.init) {
    throw new Error("props must be a statically exported");
  }
  if (variable?.init?.type !== "CallExpression") {
    throw new Error("props must be a statically exported");
  }
  const call = variable.init;
  if (call.callee.type !== "Identifier") {
    throw new Error("props must be a statically exported");
  }
  if (call.callee.name !== "defineProps") {
    throw new Error("props must be a statically exported");
  }
  if (call.arguments.length !== 1) {
    throw new Error("props must be a statically exported");
  }
  if (call.arguments[0].type !== "ArrayExpression" && call.arguments[0].type !== "ObjectExpression") {
    throw new Error("props must be a statically exported");
  }
  walk(props, {
    enter(node) {
      if (node.type === "CallExpression") {
        const { callee } = node;
        if (callee.type === "Identifier") {
          if (callee.name === "defineProps") {
            node.callee = codeRedX`__CARTA_RUNTIME.defineProps`;
          }
        }
      }
      if (node.type === "MemberExpression") {
        if (node.object.type === "Identifier") {
          if (node.object.name === "PropTypes") {
            node.object = codeRedX`__CARTA_RUNTIME.PropTypes`;
            this.skip();
          }
        }
      }
    }
  });
  return props;
}
function compileSlots(slots) {
  if (!slots) {
    return null;
  }
  if (slots.type !== "ExportNamedDeclaration") {
    throw new Error("slots must be a statically exported");
  }
  const { declaration } = slots;
  if (declaration?.type !== "VariableDeclaration") {
    throw new Error("slots must be a statically exported");
  }
  if (declaration.declarations.length !== 1) {
    throw new Error("slots must be a statically exported");
  }
  const [variable] = declaration.declarations;
  if (!variable?.init) {
    throw new Error("slots must be a statically exported");
  }
  if (variable?.init?.type !== "CallExpression") {
    throw new Error("slots must be a statically exported");
  }
  const call = variable.init;
  if (call.callee.type !== "Identifier") {
    throw new Error("slots must be a statically exported");
  }
  if (call.callee.name !== "defineSlots") {
    throw new Error("slots must be a statically exported");
  }
  if (call.arguments.length !== 1) {
    throw new Error("slots must be a statically exported");
  }
  if (call.arguments[0].type === "ArrayExpression") {
    for (const element of call.arguments[0].elements) {
      if (element == null || element.type !== "Literal") {
        throw new Error("slots must be a statically exported");
      }
    }
    walk(slots, {
      enter(node) {
        if (node.type === "CallExpression") {
          const { callee } = node;
          if (callee.type === "Identifier") {
            if (callee.name === "defineSlots") {
              node.callee = codeRedX`__CARTA_RUNTIME.defineSlots`;
            }
          }
        }
      }
    });
    return slots;
  }
  if (call.arguments[0].type !== "ObjectExpression") {
    throw new Error("slots must be a statically exported");
  }
  walk(slots, {
    enter(node) {
      if (node.type === "CallExpression") {
        const { callee } = node;
        if (callee.type === "Identifier") {
          if (callee.name === "defineSlots") {
            node.callee = codeRedX`__CARTA_RUNTIME.defineSlots`;
          }
        }
      }
      if (node.type === "MemberExpression") {
        if (node.object.type === "Identifier") {
          if (node.object.name === "SlotTypes") {
            node.object = codeRedX`__CARTA_RUNTIME.SlotTypes`;
            this.skip();
          }
        }
      }
    }
  });
  return slots;
}
function compileStyle(style3) {
  if (style3.type === "if") {
    return b`if (${style3.test}) {
      ${style3.consequent.map(compileStyle)} else {
        ${style3.alternate ? style3.alternate.map(compileStyle) : ""}
      }`;
  }
  return b`__CARTA_STYLES.push({
    value: ${templateNodesToJavaScript(style3.children, {})},
    discrete: ${style3.props.discrete}
  })`;
}
function compileTemplates(templates, options) {
  const template = templates.shift();
  if (!template) {
    return x`''`;
  }
  if (template.format === null) {
    return templateNodesToJavaScript(template.value, options);
  }
  return x`__CARTA_INPUT.__internals.format === "${template.format}" ? ${templateNodesToJavaScript(
    template.value,
    options
  )} : ${compileTemplates(templates, options)}`;
}
function templateNodesToJavaScript(templateNodes, options) {
  const nodes = mergeAdjacentStringNodes(
    templateNodes.map((templateNode) => {
      return templateNodeToJavaScript(templateNode, options);
    })
  );
  if (nodes.length === 0) {
    return x`''`;
  }
  if (nodes.length === 1) {
    return nodes[0];
  }
  return x`[${nodes}].join("")`;
}
function mergeAdjacentStringNodes(nodes) {
  const mergedNodes = [];
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if (isStringLiteral(node) && mergedNodes.length) {
      const lastNode = mergedNodes[mergedNodes.length - 1];
      if (isStringLiteral(lastNode)) {
        lastNode.value += node.value;
        continue;
      }
    }
    mergedNodes.push(node);
  }
  return mergedNodes;
}
function isStringLiteral(node) {
  return node.type === "Literal" && typeof node.value === "string";
}
function templateNodeToJavaScript(templateNode, options) {
  switch (templateNode.type) {
    case "if":
      return x`${templateNode.test} ?
        ${templateNodesToJavaScript(templateNode.consequent, options)}
       : ${templateNode.alternate?.length ? templateNodesToJavaScript(templateNode.alternate, options) : "''"}
      `;
    case "each":
      return x`__CARTA_RUNTIME.map(${templateNode.target}, function (
        ${templateNode.values.join(", ")},
      ) {
        return ${templateNodesToJavaScript(templateNode.consequent, options)}
      })`;
    case "element":
      const hasRootDirective = templateNode.props.find((prop) => prop === "#root");
      templateNode.props = hasRootDirective ? templateNode.props.filter((prop) => prop !== "#root") : templateNode.props;
      if ((templateNode.name.type === "raw" && options?.nativeTags?.includes(templateNode.name.value) || options.nativeTags?.filter((tag) => typeof tag !== "string").some((regex) => {
        return regex.test(templateNode.name.value);
      })) && // force native tags with the #root directive to be rendered via renderElement
      // this ensures that when in dev mode, the data attribute can be added
      !hasRootDirective) {
        return templateNodesToJavaScript(
          [...templateNode.openTag, ...templateNode.children, ...templateNode.closeTag],
          options
        );
      }
      const componentName = templateNodeToJavaScript(templateNode.name, options);
      const props = x`{
        ${templateNode.props.map((prop) => {
        return isString(prop) ? `...${prop}` : `"${escapeQuotes(prop[0])}": ${prop[1].replaceAll("\n", "\\n")}`;
      }).join(",")}}`;
      return x`await (async (__CONTEXT) => {
            return await __CARTA_RUNTIME.renderElement(
            ${componentName},
            ${props},
            __CONTEXT,
            async () => [${templateNode.children.map((child) => {
        if (child.type !== "element") {
          return templateNodeToJavaScript(child, options);
        }
        if (child.slot === "default" || child.slot === null) {
          return templateNodeToJavaScript(child, options);
        }
        return x`{
                slot: "${child.slot}",
                value: ${templateNodeToJavaScript(child, options)}
              }`;
      })}],
            Object.assign(
              {},
              __CARTA_INPUT.__internals,
              { 
                track: Object.assign(
                  {}, 
                  __CARTA_INPUT.__internals.track, 
                  { depth: __CARTA_CURRENT_DEPTH + 1 }
                ),
              },
            ),
            {
              openTag: ${templateNodesToJavaScript(templateNode.openTag, options)},
              closeTag: ${templateNodesToJavaScript(templateNode.closeTag, options)}
            }
          )
        })({...__CONTEXT})`;
    case "expression":
      return x`${templateNode.value}`;
    case "raw":
      return x`${{
        type: "Literal",
        value: templateNode.value ?? ""
      }}`;
    case "slot":
      return x`await __CARTA_RUNTIME.renderSlot(__CARTA_INPUT,${{
        type: "Literal",
        value: templateNode.name
      }}, ${templateNodesToJavaScript(templateNode.children, options)})`;
    case "personalization-block":
      return x`${templateNode.parts.map((part) => {
        switch (part.type) {
          case "personalization-block-open":
          case "personalization-block-divider":
          case "personalization-block-close":
            return x`__CARTA_RUNTIME.renderPersonalization(__CARTA_INPUT,${{
              type: "Literal",
              value: part.value
            }}, ${{
              type: "Literal",
              value: part.type.replace("personalization-block-", "")
            }})`;
          default: {
            return templateNodeToJavaScript(part, options);
          }
        }
      })}`;
    case "personalization-expression":
      return x`__CARTA_RUNTIME.renderPersonalization(__CARTA_INPUT,${{
        type: "Literal",
        value: templateNode.value
      }}, 'expression')`;
    default:
      const never = templateNode;
      throw new Error(`Unknown template node type: ${never}`);
  }
}
function escapeQuotes(string) {
  return string.replace(/"/g, '\\"').replace(/'/g, "\\'");
}
function x(parts, ...substitutions) {
  let result = "";
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    const substitution = substitutions[i] ?? "";
    if (typeof substitution === "object") {
      if ("type" in substitution && "value" in substitution && substitution.type === "Literal") {
        result += `${part}${literalToString(substitution)}`;
        continue;
      }
      if ("type" in substitution && "value" in substitution && substitution.type === "Identifier") {
        result += `${parts[i]}${substitution.value}`;
        continue;
      }
      if (Array.isArray(substitution)) {
        let currentString = void 0;
        result += part;
        let mergedSubstitution = [];
        for (const part2 of substitution) {
          if (typeof part2 === "string" && /^"(.*)"$/g.test(part2)) {
            currentString = `${currentString ?? ""}${part2.slice(1, -1)}`;
          } else {
            if (currentString != null) {
              mergedSubstitution.push(`"${currentString}"`);
              currentString = void 0;
            }
            mergedSubstitution.push(part2);
          }
        }
        if (currentString != null) {
          mergedSubstitution.push(`"${currentString}"`);
        }
        result += mergedSubstitution.join(",");
        continue;
      }
      throw new Error(`Unknown object type: ${typeof substitution} ${substitution}`);
    } else {
      result += part + substitution;
    }
  }
  return result;
}
function literalToString(literal) {
  if (literal.value.includes("\n")) {
    return `\`${escapeQuotes(literal.value)}\``;
  }
  return `"${escapeQuotes(literal.value)}"`;
}

// src/internals/index.ts
var internals_exports = {};
__export(internals_exports, {
  __CARTA_RUNTIME: () => __CARTA_RUNTIME
});

// src/internals/css-properties.ts
var unitless = {
  animationIterationCount: true,
  basePalette: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  fontSizeAdjust: true,
  fontWeight: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  WebkitLineClamp: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var isUnitlessProperty = (propertyName) => {
  return propertyName in unitless;
};
function addUnitIfNeeded(name, value) {
  if (value == null || typeof value === "boolean" || value === "") {
    return "";
  }
  if (typeof value === "number" && value !== 0 && !isUnitlessProperty(name)) {
    return `${value}px`;
  }
  return String(value).trim();
}

// src/internals/production.ts
import clsx from "clsx";
import cssesc from "cssesc";
import escape2 from "escape-html";
import _map from "lodash/map";
import omit from "lodash/omit";
import compact2 from "lodash/compact";
import isUndefined from "lodash/isUndefined";
import isPlainObject from "lodash/isPlainObject";
import isArray from "lodash/isArray";
import * as zod from "zod";
import { camelCase } from "lodash";
function addUnitIfNeeded2(key, value) {
  return addUnitIfNeeded(camelCase(key), value);
}
function renderAttributes(attributes) {
  return _map(attributes, (value, key) => {
    if (value === true) {
      return key;
    } else if (value === false) {
      return "";
    } else {
      return `${key}="${escapeAttributeValue(value)}"`;
    }
  }).join(" ");
}
function renderAttribute(key, value, quote) {
  if (value === true) {
    return key;
  } else if (value === false) {
    return "";
  } else if (value === void 0) {
    return "";
  } else {
    return `${key}=${quote ?? ""}${escapeAttributeValue(value)}${quote ?? ""}`;
  }
}
function renderStyle(styles) {
  let output = "";
  for (const style3 of styles) {
    if (typeof style3 === "string") {
      output += style3;
    } else if (Array.isArray(style3)) {
      output += renderStyle(style3);
    } else {
      output += compact2(
        _map(style3, (value, key) => {
          if (value === false || value === void 0 || value === null) {
            return null;
          }
          return `${key}: ${addUnitIfNeeded2(key, value)};`;
        })
      ).join(" ");
    }
  }
  return output;
}
function renderClass(classes) {
  return clsx(classes);
}
async function renderElement(component, props, context, children, __internals, tags) {
  if (typeof component === "string" && __internals.components[component]) {
    component = __internals.components[component];
  }
  if (typeof component === "function") {
    let slots;
    const { result, styles } = await component({
      props,
      slots: async () => {
        if (slots) {
          return slots;
        }
        slots = { default: "" };
        for (const child of await children()) {
          if (typeof child === "string") {
            slots.default += child;
          } else {
            slots[child.slot] = slots[child.slot] ?? "";
            slots[child.slot] += child.value;
          }
        }
        return slots;
      },
      context,
      __internals
    });
    __internals.styles.unshift(...styles);
    return result;
  }
  return Promise.resolve(
    tags.openTag + (await children()).map((child) => {
      if (typeof child === "string") {
        return child;
      } else {
        return child.value;
      }
    }).join("") + tags.closeTag
  );
}
async function renderSlot(__CARTA_INPUT, name, defaultContent) {
  const slotContent = (await __CARTA_INPUT.slots())[name];
  return slotContent.trim() ? slotContent : defaultContent;
}
function renderPersonalization(__CARTA_INPUT, value, type) {
  return value ?? "";
}
function escapeHtml(value) {
  if (isUndefined(value)) {
    return "";
  }
  return escape2(value);
}
function escapeAttributeValue(value) {
  if (isUndefined(value)) {
    return "";
  }
  return escapeHtml(value);
}
function escapeCss(value) {
  return cssesc(value, {
    isIdentifier: true
  });
}
function map(items, iterator) {
  let iterable;
  if (typeof items === "number") {
    iterable = Array.from({ length: items }).map((_, index2) => index2);
  } else if (typeof items === "string") {
    iterable = items.split("");
  } else if (isArray(items)) {
    iterable = items;
  } else if (isPlainObject(items)) {
    iterable = items;
  } else {
    throw new Error(
      `Unable to iterate over the given value. ${typeof items === "object" ? `The given value is of type ${items.constructor.name}` : `The given value is of type ${typeof items}`}. The value must be a number, string, array, or object.`
    );
  }
  let index = 0;
  return _map(iterable, (value, key) => {
    const output = iterator(...isPlainObject(iterable) ? [value, key, index] : [value, index]);
    index += 1;
    return output;
  }).join("");
}
var PropTypes = zod;
function defineProps(definition) {
  const metadata = {};
  let definitionObject = {};
  if (Array.isArray(definition)) {
    for (const propName of definition) {
      definitionObject[propName] = zod.any().optional();
    }
  } else {
    definitionObject = definition;
  }
  const definitionSchema = {};
  for (const [propName, propDefinition] of Object.entries(definitionObject)) {
    if ("schema" in propDefinition) {
      metadata[propName] = omit(propDefinition, ["schema"]);
      definitionSchema[propName] = propDefinition.schema;
    } else {
      metadata[propName] = {};
      definitionSchema[propName] = propDefinition;
    }
  }
  return {
    schema: zod.object(definitionSchema),
    metadata
  };
}
var SlotTypes = {
  /**
   * Specify a list of allowed children
   */
  children(tagNames) {
    return {
      _def: {
        type: "SlotChildren",
        tagNames
      }
    };
  },
  /**
   * Specify the slot may contain only text and marks
   */
  text() {
    return {
      _def: {
        type: "SlotText"
      }
    };
  },
  /**
   * Specify the slot may contain any content
   */
  any() {
    return {
      _def: {
        type: "SlotAny"
      }
    };
  }
};
function defineSlots(definition) {
  const shape = {};
  const metadata = {};
  if (Array.isArray(definition)) {
    const slotNames = definition;
    definition = {};
    for (const slotName of slotNames) {
      definition[slotName] = SlotTypes.any();
    }
  }
  for (const [slotName, slotDefinition] of Object.entries(definition)) {
    if ("schema" in slotDefinition) {
      metadata[slotName] = omit(slotDefinition, ["schema"]);
      shape[slotName] = slotDefinition.schema;
    } else {
      metadata[slotName] = {};
      shape[slotName] = slotDefinition;
    }
  }
  const parse2 = (slots) => slots;
  return {
    schema: { shape, parse: parse2 },
    metadata
  };
}
function getContext(__CARTA_INPUT, key) {
  if (key) {
    return __CARTA_INPUT.context[key];
  }
  return __CARTA_INPUT.context;
}
function setContext(__CARTA_INPUT, key, value) {
  __CARTA_INPUT.context[key] = value;
}
function renderRootDirectiveAttributes(_input) {
  return "";
}
var __PROD_CARTA_RUNTIME = {
  renderAttributes,
  renderAttribute,
  renderStyle,
  renderClass,
  renderElement,
  renderSlot,
  renderPersonalization,
  escapeHtml,
  escapeAttributeValue,
  escapeCss,
  map,
  PropTypes,
  defineProps,
  SlotTypes,
  defineSlots,
  getContext,
  setContext,
  renderRootDirectiveAttributes
};

// src/internals/development.ts
var __DEV_CARTA_RUNTIME = {
  // wrap renderElement to add markers
  renderElement: async function renderElement2(component, props, context, children, __internals, tags) {
    const tagName = getTagName(tags.openTag);
    if (tagName == null) {
      throw new Error("cannot render element with invalid tag name");
    }
    const isCalledFromTopLevelComponent = __internals.track.depth === 1;
    let index;
    if (isCalledFromTopLevelComponent) {
      __internals.track.components[tagName] = (__internals.track.components[tagName] ?? 0) + 1;
      index = __internals.track.components[tagName] - 1;
    }
    let result;
    if (__internals.components[tagName] == null) {
      result = await __PROD_CARTA_RUNTIME.renderElement(component, props, context, children, __internals, tags);
    } else {
      result = await __PROD_CARTA_RUNTIME.renderElement(component, props, context, children, __internals, tags);
    }
    if (isCalledFromTopLevelComponent && result && tagName !== "fragment") {
      if (result.includes('data-carta-marker="1"')) {
        return result.replace('data-carta-marker="1"', `data-carta-marker="${tagName}:${index}"`).replace(/data-carta-marker="\d+"/g, "");
      } else {
        return `<!--CARTA:COMPONENT:${tagName}:${index}:START-->${result.replace(
          /data-carta-marker="\d+"/g,
          ""
        )}<!--CARTA:COMPONENT:${tagName}:${index}:END-->`;
      }
    }
    return result;
  },
  // wrap renderSlot to add markers
  renderSlot: async (...args) => {
    const [__CARTA_INPUT] = args;
    const result = await __PROD_CARTA_RUNTIME.renderSlot(...args);
    const [, slotName] = args;
    const isCalledFromTopLevelComponent = __CARTA_INPUT.__internals.track.depth <= 1;
    if (!isCalledFromTopLevelComponent) {
      return result;
    }
    if (typeof result === "string") {
      return `<!--CARTA:SLOT:${slotName}:START-->${result}<!--CARTA:SLOT:${slotName}:END-->`;
    }
    return result;
  },
  // wrap renderPersonalization to add markers
  renderPersonalization: (__CARTA_INPUT, value, type) => {
    const isCalledFromTopLevelComponent = __CARTA_INPUT.__internals.track.depth <= 1;
    if (!isCalledFromTopLevelComponent) {
      return "";
    }
    if (type === "expression") {
      const result = __PROD_CARTA_RUNTIME.renderPersonalization(__CARTA_INPUT, value, type);
      return `<!--CARTA:PERSONALIZATION:${type.toUpperCase()}:START-->${result}<!--CARTA:PERSONALIZATION:${type.toUpperCase()}:END-->`;
    }
    if (type === "open") {
      return `<!--CARTA:PERSONALIZATION:BLOCK:${value}:START-->`;
    }
    if (type === "divider") {
      return `<!--CARTA:PERSONALIZATION:BLOCK:${value}:DIVIDER-->`;
    }
    if (type === "close") {
      return `<!--CARTA:PERSONALIZATION:BLOCK:${value}:END-->`;
    }
    return "";
  },
  /**
   * Render the root attributes for the root element of a component
   */
  renderRootDirectiveAttributes({ depth }) {
    return `data-carta-marker="${depth}"`;
  }
};
function getTagName(tag) {
  return tag.match(/<([^\s>]+)/)?.[1];
}

// src/internals/index.ts
var __CARTA_RUNTIME = {
  ...__PROD_CARTA_RUNTIME,
  renderElement: async function renderElement3(component, props, context, children, __internals, tags) {
    if (__internals.env === "development") {
      return __DEV_CARTA_RUNTIME.renderElement(component, props, context, children, __internals, tags);
    }
    return __PROD_CARTA_RUNTIME.renderElement(component, props, context, children, __internals, tags);
  },
  renderSlot: async (__CARTA_INPUT, name, defaultContent) => {
    if (__CARTA_INPUT.__internals.env === "development") {
      return __DEV_CARTA_RUNTIME.renderSlot(__CARTA_INPUT, name, defaultContent);
    }
    return __PROD_CARTA_RUNTIME.renderSlot(__CARTA_INPUT, name, defaultContent);
  },
  renderPersonalization(__CARTA_INPUT, value, type) {
    if (__CARTA_INPUT.__internals.env === "development") {
      return __DEV_CARTA_RUNTIME.renderPersonalization(__CARTA_INPUT, value, type);
    }
    return __PROD_CARTA_RUNTIME.renderPersonalization(__CARTA_INPUT, value, type);
  },
  renderRootDirectiveAttributes: ({
    env,
    depth
  }) => {
    if (env === "development") {
      return __DEV_CARTA_RUNTIME.renderRootDirectiveAttributes({ env, depth });
    }
    return __PROD_CARTA_RUNTIME.renderRootDirectiveAttributes({ env, depth });
  }
};

// src/runtime-utilities/props.ts
var props_exports = {};
__export(props_exports, {
  commonGroups: () => commonGroups,
  commonProps: () => commonProps,
  expandShorthand: () => expand,
  fonts: () => fonts
});

// src/runtime-utilities/google-fonts.ts
var googleFonts = {
  axisRegistry: [
    {
      tag: "YELA",
      displayName: "Vertical Element Alignment",
      min: -100,
      defaultValue: 0,
      max: 100,
      precision: 0,
      description: "Align glyphs from their default position (0%), usually the baseline, to an upper (100%) or lower (-100%) position.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "BNCE",
      displayName: "Bounce",
      min: -100,
      defaultValue: 0,
      max: 100,
      precision: 0,
      description: "Shift glyphs up and down in the Y dimension, resulting in an uneven, bouncy baseline.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "CASL",
      displayName: "Casual",
      min: 0,
      defaultValue: 0,
      max: 1,
      precision: -2,
      description: "Adjust stroke curvature, contrast, and terminals from a sturdy, rational Linear style to a friendly, energetic Casual style.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/casual_445408692.svg",
      fallbacks: [
        {
          name: "Linear",
          value: 0,
          displayName: ""
        },
        {
          name: "Casual",
          value: 1,
          displayName: ""
        }
      ]
    },
    {
      tag: "CRSV",
      displayName: "Cursive",
      min: 0,
      defaultValue: 0.5,
      max: 1,
      precision: -1,
      description: "Control the substitution of cursive forms along the Slant axis. 'Off' (0) maintains Roman letterforms such as a double-storey a and g, 'Auto' (0.5) allows for Cursive substitution, and 'On' (1) asserts cursive forms even in upright text with a Slant of 0.",
      fallbackOnly: true,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/cursive_445408692.svg",
      fallbacks: [
        {
          name: "Roman",
          value: 0,
          displayName: "Off"
        },
        {
          name: "Auto",
          value: 0.5,
          displayName: ""
        },
        {
          name: "Cursive",
          value: 1,
          displayName: "On"
        }
      ]
    },
    {
      tag: "EDPT",
      displayName: "Extrusion Depth",
      min: 0,
      defaultValue: 100,
      max: 1e3,
      precision: 0,
      description: "Controls the 3D depth on contours.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 100,
          displayName: ""
        }
      ]
    },
    {
      tag: "EHLT",
      displayName: "Edge Highlight",
      min: 0,
      defaultValue: 12,
      max: 1e3,
      precision: 0,
      description: "Controls thickness of edge highlight details.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 12,
          displayName: ""
        }
      ]
    },
    {
      tag: "ELGR",
      displayName: "Element Grid",
      min: 1,
      defaultValue: 1,
      max: 2,
      precision: -1,
      description: "In modular fonts, where glyphs are composed using multiple copies of the same element, this axis controls how many elements are used per one grid unit.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 1,
          displayName: ""
        }
      ]
    },
    {
      tag: "ELSH",
      displayName: "Element Shape",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: -1,
      description: "In modular fonts, where glyphs are composed using multiple copies of the same element, this axis controls the shape of the element",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "FILL",
      displayName: "Fill",
      min: 0,
      defaultValue: 0,
      max: 1,
      precision: -2,
      description: "Fill in transparent forms with opaque ones. Sometimes interior opaque forms become transparent, to maintain contrasting shapes. This can be useful in animation or interaction to convey a state transition. Ranges from 0 (no treatment) to 1 (completely filled).",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/fill_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 0,
          displayName: ""
        },
        {
          name: "Filled",
          value: 1,
          displayName: ""
        }
      ]
    },
    {
      tag: "FLAR",
      displayName: "Flare",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: 0,
      description: "As the flare axis grows, the stem terminals go from straight (0%) to develop a swelling (100%).",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "GRAD",
      displayName: "Grade",
      min: -1e3,
      defaultValue: 0,
      max: 1e3,
      precision: 0,
      description: "Finesse the style from lighter to bolder in typographic color, without any changes overall width, line breaks or page layout. Negative grade makes the style lighter, while positive grade makes it bolder. The units are the same as in the Weight axis.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/grade_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "HEXP",
      displayName: "Hyper Expansion",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: -1,
      description: "Expansion of inner and outer space of glyphs.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "INFM",
      displayName: "Informality",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: 0,
      description: "Adjusts overall design from formal and traditional (0%) to informal and unconventional (up to 100%).",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "MONO",
      displayName: "Monospace",
      min: 0,
      defaultValue: 0,
      max: 1,
      precision: -2,
      description: "Adjust the style from Proportional (natural widths, default) to Monospace (fixed width). With proportional spacing, each glyph takes up a unique amount of space on a line, while monospace is when all glyphs have the same total character width.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/monospace_445408692.svg",
      fallbacks: [
        {
          name: "Proportional",
          value: 0,
          displayName: ""
        },
        {
          name: "Monospace",
          value: 1,
          displayName: ""
        }
      ]
    },
    {
      tag: "MORF",
      displayName: "Morph",
      min: 0,
      defaultValue: 0,
      max: 60,
      precision: 0,
      description: "Letterforms morph: Changing in unconventional ways, that don't alter other attributes, like width or weight. The range from 0 to 60 can be understood as seconds.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "ROND",
      displayName: "Roundness",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: 0,
      description: "Adjust shapes from angular defaults (0%) to become increasingly rounded (up to 100%).",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "SHRP",
      displayName: "Sharpness",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: 0,
      description: "Adjust shapes from angular or blunt default shapes (0%) to become increasingly sharped forms (up to 100%).",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "SOFT",
      displayName: "Softness",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: -1,
      description: "Adjust letterforms to become more and more soft and rounded.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/softness_445408692.svg",
      fallbacks: [
        {
          name: "Sharp",
          value: 0,
          displayName: ""
        },
        {
          name: "Soft",
          value: 50,
          displayName: ""
        },
        {
          name: "SuperSoft",
          value: 100,
          displayName: ""
        }
      ]
    },
    {
      tag: "SPAC",
      displayName: "Spacing",
      min: -100,
      defaultValue: 0,
      max: 100,
      precision: -1,
      description: "Adjusts the overall letter spacing of a font. The range is a relative percentage change from the family\u2019s default spacing, so the default value is 0.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "VOLM",
      displayName: "Volume",
      min: 0,
      defaultValue: 0,
      max: 100,
      precision: 0,
      description: "Expands and exaggerates details of a typeface to emphasize the personality. Understood in a percentage amount, it goes from a neutral state (0%) to a maximum level (100%).",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "WONK",
      displayName: "Wonky",
      min: 0,
      defaultValue: 0,
      max: 1,
      precision: 0,
      description: "Toggle the substitution of wonky forms. 'Off' (0) maintains more conventional letterforms, while 'On' (1) maintains wonky letterforms, such as leaning stems in roman, or flagged ascenders in italic. These forms are also controlled by Optical Size.",
      fallbackOnly: true,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/wonky_445408692.svg",
      fallbacks: [
        {
          name: "NonWonky",
          value: 0,
          displayName: ""
        },
        {
          name: "Wonky",
          value: 1,
          displayName: ""
        }
      ]
    },
    {
      tag: "XOPQ",
      displayName: "Thick Stroke",
      min: -1e3,
      defaultValue: 88,
      max: 2e3,
      precision: 0,
      description: "A parametric axis for varying thick stroke weights, such as stems.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/x_opaque_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 88,
          displayName: ""
        }
      ]
    },
    {
      tag: "XROT",
      displayName: "Rotation in X",
      min: -180,
      defaultValue: 0,
      max: 180,
      precision: 0,
      description: "Glyphs rotate left and right, negative values to the left and positive values to the right, in the X dimension.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "XTRA",
      displayName: "Counter Width",
      min: -1e3,
      defaultValue: 400,
      max: 2e3,
      precision: 0,
      description: "A parametric axis for varying counter widths in the X dimension.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/x_transparent_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 400,
          displayName: ""
        }
      ]
    },
    {
      tag: "YEAR",
      displayName: "Year",
      min: -4e3,
      defaultValue: 2e3,
      max: 4e3,
      precision: 0,
      description: "Axis that shows in a metaphoric way the effect of time on a chosen topic.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 2e3,
          displayName: ""
        }
      ]
    },
    {
      tag: "YOPQ",
      displayName: "Thin Stroke",
      min: -1e3,
      defaultValue: 116,
      max: 2e3,
      precision: 0,
      description: "A parametric axis for varying thin stroke weights, such as bars and hairlines.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/y_opaque_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 116,
          displayName: ""
        }
      ]
    },
    {
      tag: "YROT",
      displayName: "Rotation in Y",
      min: -180,
      defaultValue: 0,
      max: 180,
      precision: 0,
      description: "Glyphs rotate up and down, negative values tilt down and positive values tilt up, in the Y dimension.",
      fallbackOnly: false,
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "YTAS",
      displayName: "Ascender Height",
      min: 0,
      defaultValue: 750,
      max: 1e3,
      precision: 0,
      description: "A parametric axis for varying the height of lowercase ascenders.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/y_transparent_ascender_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 750,
          displayName: ""
        }
      ]
    },
    {
      tag: "YTDE",
      displayName: "Descender Depth",
      min: -1e3,
      defaultValue: -250,
      max: 0,
      precision: 0,
      description: "A parametric axis for varying the depth of lowercase descenders.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/y_transparent_descender_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: -250,
          displayName: ""
        }
      ]
    },
    {
      tag: "YTFI",
      displayName: "Figure Height",
      min: -1e3,
      defaultValue: 600,
      max: 2e3,
      precision: 0,
      description: "A parametric axis for varying the height of figures.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/y_transparent_figures_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 600,
          displayName: ""
        }
      ]
    },
    {
      tag: "YTLC",
      displayName: "Lowercase Height",
      min: 0,
      defaultValue: 500,
      max: 1e3,
      precision: 0,
      description: "A parametric axis for varying the height of the lowercase.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/y_transparent_lowercase_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 500,
          displayName: ""
        }
      ]
    },
    {
      tag: "YTUC",
      displayName: "Uppercase Height",
      min: 0,
      defaultValue: 725,
      max: 1e3,
      precision: 0,
      description: "A parametric axis for varying the heights of uppercase letterforms.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/y_transparent_uppercase_445408692.svg",
      fallbacks: [
        {
          name: "Normal",
          value: 725,
          displayName: ""
        }
      ]
    },
    {
      tag: "ital",
      displayName: "Italic",
      min: 0,
      defaultValue: 0,
      max: 1,
      precision: 0,
      description: "Adjust the style from roman to italic. This can be provided as a continuous range within a single font file, like most axes, or as a toggle between two roman and italic files that form a family as a pair.",
      fallbackOnly: true,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/italic_445408692.svg",
      fallbacks: [
        {
          name: "Roman",
          value: 0,
          displayName: ""
        },
        {
          name: "Italic",
          value: 1,
          displayName: ""
        }
      ]
    },
    {
      tag: "opsz",
      displayName: "Optical Size",
      min: 5,
      defaultValue: 14,
      max: 1200,
      precision: -1,
      description: "Adapt the style to specific text sizes. At smaller sizes, letters typically become optimized for more legibility. At larger sizes, optimized for headlines, with more extreme weights and widths. In CSS this axis is activated automatically when it is available.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/optical_size_445408692.svg",
      fallbacks: [
        {
          name: "6pt",
          value: 6,
          displayName: ""
        },
        {
          name: "7pt",
          value: 7,
          displayName: ""
        },
        {
          name: "8pt",
          value: 8,
          displayName: ""
        },
        {
          name: "9pt",
          value: 9,
          displayName: ""
        },
        {
          name: "10pt",
          value: 10,
          displayName: ""
        },
        {
          name: "11pt",
          value: 11,
          displayName: ""
        },
        {
          name: "12pt",
          value: 12,
          displayName: ""
        },
        {
          name: "14pt",
          value: 14,
          displayName: ""
        },
        {
          name: "16pt",
          value: 16,
          displayName: ""
        },
        {
          name: "17pt",
          value: 17,
          displayName: ""
        },
        {
          name: "18pt",
          value: 18,
          displayName: ""
        },
        {
          name: "20pt",
          value: 20,
          displayName: ""
        },
        {
          name: "24pt",
          value: 24,
          displayName: ""
        },
        {
          name: "28pt",
          value: 28,
          displayName: ""
        },
        {
          name: "36pt",
          value: 36,
          displayName: ""
        },
        {
          name: "48pt",
          value: 48,
          displayName: ""
        },
        {
          name: "60pt",
          value: 60,
          displayName: ""
        },
        {
          name: "72pt",
          value: 72,
          displayName: ""
        },
        {
          name: "96pt",
          value: 96,
          displayName: ""
        },
        {
          name: "120pt",
          value: 120,
          displayName: ""
        },
        {
          name: "144pt",
          value: 144,
          displayName: ""
        }
      ]
    },
    {
      tag: "slnt",
      displayName: "Slant",
      min: -90,
      defaultValue: 0,
      max: 90,
      precision: 0,
      description: "Adjust the style from upright to slanted, also known to typographers as an 'oblique' style. Rarely, slant can work in the other direction, called a 'backslanted' or 'reverse oblique' style.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/slant_445408692.svg",
      fallbacks: [
        {
          name: "Default",
          value: 0,
          displayName: ""
        }
      ]
    },
    {
      tag: "wdth",
      displayName: "Width",
      min: 25,
      defaultValue: 100,
      max: 200,
      precision: -1,
      description: "Adjust the style from narrower to wider, by varying the proportions of counters, strokes, spacing and kerning, and other aspects of the type. This typically changes the typographic color in a subtle way, and so may be used in conjunction with Weight and Grade axes.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/width_440161844.svg",
      fallbacks: [
        {
          name: "SuperCondensed",
          value: 25,
          displayName: ""
        },
        {
          name: "UltraCondensed",
          value: 50,
          displayName: ""
        },
        {
          name: "ExtraCondensed",
          value: 62.5,
          displayName: ""
        },
        {
          name: "Condensed",
          value: 75,
          displayName: ""
        },
        {
          name: "SemiCondensed",
          value: 87.5,
          displayName: ""
        },
        {
          name: "Normal",
          value: 100,
          displayName: ""
        },
        {
          name: "SemiExpanded",
          value: 112.5,
          displayName: ""
        },
        {
          name: "Expanded",
          value: 125,
          displayName: ""
        },
        {
          name: "ExtraExpanded",
          value: 150,
          displayName: ""
        },
        {
          name: "UltraExpanded",
          value: 200,
          displayName: ""
        }
      ]
    },
    {
      tag: "wght",
      displayName: "Weight",
      min: 1,
      defaultValue: 400,
      max: 1e3,
      precision: 0,
      description: "Adjust the style from lighter to bolder in typographic color, by varying stroke weights, spacing and kerning, and other aspects of the type. This typically changes overall width, and so may be used in conjunction with Width and Grade axes.",
      fallbackOnly: false,
      illustrationUrl: "https://fonts.gstatic.com/s/img/axisregistry/weight_445408692.svg",
      fallbacks: [
        {
          name: "Thin",
          value: 100,
          displayName: ""
        },
        {
          name: "ExtraLight",
          value: 200,
          displayName: ""
        },
        {
          name: "Light",
          value: 300,
          displayName: ""
        },
        {
          name: "Regular",
          value: 400,
          displayName: ""
        },
        {
          name: "Medium",
          value: 500,
          displayName: ""
        },
        {
          name: "SemiBold",
          value: 600,
          displayName: ""
        },
        {
          name: "Bold",
          value: 700,
          displayName: ""
        },
        {
          name: "ExtraBold",
          value: 800,
          displayName: ""
        },
        {
          name: "Black",
          value: 900,
          displayName: ""
        }
      ]
    }
  ],
  familyMetadataList: [
    {
      family: "ABeeZee",
      displayName: null,
      category: "Sans Serif",
      size: 46514,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.182
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.182
        }
      },
      axes: [],
      designers: ["Anja Meiners"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-30",
      popularity: 163,
      trending: 1368,
      defaultSort: 157,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Abel",
      displayName: null,
      category: "Sans Serif",
      size: 35220,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 2,
          lineHeight: 1.2744140625
        }
      },
      axes: [],
      designers: ["MADType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-03",
      popularity: 73,
      trending: 1045,
      defaultSort: 69,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Abhaya Libre",
      displayName: null,
      category: "Serif",
      size: 536189,
      subsets: ["menu", "latin", "latin-ext", "sinhala"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1796875
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1796875
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1796875
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1796875
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1796875
        }
      },
      axes: [],
      designers: ["Mooniak"],
      lastModified: "2023-05-02",
      dateAdded: "2016-08-30",
      popularity: 296,
      trending: 366,
      defaultSort: 310,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aboreto",
      displayName: null,
      category: "Display",
      size: 48356,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.16
        }
      },
      axes: [],
      designers: ["Dominik J\xE1ger"],
      lastModified: "2022-09-21",
      dateAdded: "2022-05-26",
      popularity: 794,
      trending: 1481,
      defaultSort: 796,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Abril Fatface",
      displayName: null,
      category: "Display",
      size: 29201,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.349
        }
      },
      axes: [],
      designers: ["TypeTogether"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-31",
      popularity: 103,
      trending: 1212,
      defaultSort: 98,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Abyssinica SIL",
      displayName: null,
      category: "Serif",
      size: 312804,
      subsets: ["menu", "ethiopic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.326171875
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2022-12-07",
      dateAdded: "2016-01-20",
      popularity: 678,
      trending: 29,
      defaultSort: 316,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Ethi",
      primaryLanguage: ""
    },
    {
      family: "Aclonica",
      displayName: null,
      category: "Sans Serif",
      size: 68732,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.13330078125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-27",
      popularity: 407,
      trending: 857,
      defaultSort: 429,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Acme",
      displayName: null,
      category: "Sans Serif",
      size: 23292,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.266
        }
      },
      axes: [],
      designers: ["Juan Pablo del Peral", "Huerta Tipogr\xE1fica"],
      lastModified: "2022-12-07",
      dateAdded: "2011-12-19",
      popularity: 138,
      trending: 670,
      defaultSort: 131,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Actor",
      displayName: null,
      category: "Sans Serif",
      size: 32863,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.203
        }
      },
      axes: [],
      designers: ["Thomas Junold"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-03",
      popularity: 391,
      trending: 870,
      defaultSort: 411,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Adamina",
      displayName: null,
      category: "Serif",
      size: 114460,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-20",
      dateAdded: "2011-09-07",
      popularity: 312,
      trending: 1228,
      defaultSort: 328,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Advent Pro",
      displayName: null,
      category: "Sans Serif",
      size: 254866,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 6,
          lineHeight: 1.196
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "200": {
          thickness: 2,
          slant: 1,
          width: 6,
          lineHeight: 1.196
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.196
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.196
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "500": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.196
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.196
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.196
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 100,
          max: 200,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Andreas Kalpakidis"],
      lastModified: "2023-03-21",
      dateAdded: "2012-02-29",
      popularity: 241,
      trending: 1259,
      defaultSort: 254,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Agdasima",
      displayName: null,
      category: "Sans Serif",
      size: 23082,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18408203125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197265625
        }
      },
      axes: [],
      designers: ["The DocRepair Project", "Patric King"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 904,
      trending: 4,
      defaultSort: 7,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aguafina Script",
      displayName: null,
      category: "Handwriting",
      size: 22551,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 8,
          width: 5,
          lineHeight: 1.547
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-30",
      popularity: 792,
      trending: 1220,
      defaultSort: 794,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Akatab",
      displayName: null,
      category: "Sans Serif",
      size: 105286,
      subsets: ["menu", "latin", "latin-ext", "tifinagh"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.369140625
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.369140625
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.369140625
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.369140625
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.369140625
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.369140625
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 833,
      trending: 3,
      defaultSort: 4,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Tfng",
      primaryLanguage: ""
    },
    {
      family: "Akaya Kanadaka",
      displayName: null,
      category: "Display",
      size: 341876,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        }
      },
      axes: [],
      designers: ["Vaishnavi Murthy", "Juan Luis Blanco"],
      lastModified: "2022-09-21",
      dateAdded: "2021-01-14",
      popularity: 1147,
      trending: 1340,
      defaultSort: 1120,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Akaya Telivigala",
      displayName: null,
      category: "Display",
      size: 561640,
      subsets: ["menu", "latin", "latin-ext", "telugu"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.196
        }
      },
      axes: [],
      designers: ["Vaishnavi Murthy", "Juan Luis Blanco"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 975,
      trending: 267,
      defaultSort: 957,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Akronim",
      displayName: null,
      category: "Display",
      size: 109592,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 5,
          width: 5,
          lineHeight: 1.142
        }
      },
      axes: [],
      designers: ["Grzegorz Klimczewski"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-23",
      popularity: 1021,
      trending: 720,
      defaultSort: 1002,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Akshar",
      displayName: null,
      category: "Sans Serif",
      size: 246008,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tall Chai"],
      lastModified: "2023-03-21",
      dateAdded: "2022-03-21",
      popularity: 817,
      trending: 1667,
      defaultSort: 819,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aladin",
      displayName: null,
      category: "Handwriting",
      size: 42180,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 5,
          lineHeight: 1.226
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-30",
      popularity: 573,
      trending: 1408,
      defaultSort: 589,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alata",
      displayName: null,
      category: "Sans Serif",
      size: 103312,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        }
      },
      axes: [],
      designers: ["Spyros Zevelakis", "Eben Sorkin"],
      lastModified: "2022-09-21",
      dateAdded: "2019-11-08",
      popularity: 172,
      trending: 469,
      defaultSort: 173,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alatsi",
      displayName: null,
      category: "Sans Serif",
      size: 139444,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        }
      },
      axes: [],
      designers: ["Spyros Zevelakis", "Eben Sorkin"],
      lastModified: "2023-05-02",
      dateAdded: "2019-11-07",
      popularity: 489,
      trending: 1679,
      defaultSort: 509,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Albert Sans",
      displayName: null,
      category: "Sans Serif",
      size: 135578,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Andreas Rasmussen"],
      lastModified: "2022-09-21",
      dateAdded: "2022-06-08",
      popularity: 356,
      trending: 1718,
      defaultSort: 373,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aldrich",
      displayName: null,
      category: "Sans Serif",
      size: 56548,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 0.97802734375
        }
      },
      axes: [],
      designers: ["MADType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-17",
      popularity: 499,
      trending: 797,
      defaultSort: 516,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alef",
      displayName: null,
      category: "Sans Serif",
      size: 91654,
      subsets: ["menu", "hebrew", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.36181640625
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.36181640625
        }
      },
      axes: [],
      designers: ["Hagilda", "Mushon Zer-Aviv"],
      lastModified: "2022-09-21",
      dateAdded: "2013-05-21",
      popularity: 378,
      trending: 1285,
      defaultSort: 398,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alegreya",
      displayName: null,
      category: "Serif",
      size: 425570,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.361
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 6,
          lineHeight: 1.361
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.361
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 6,
          lineHeight: 1.361
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.361
        },
        "900i": {
          thickness: 8,
          slant: 4,
          width: 6,
          lineHeight: 1.361
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Juan Pablo del Peral", "Huerta Tipogr\xE1fica"],
      lastModified: "2023-03-21",
      dateAdded: "2011-12-19",
      popularity: 156,
      trending: 278,
      defaultSort: 150,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alegreya SC",
      displayName: null,
      category: "Serif",
      size: 381295,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.361
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.361
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.361
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.361
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.361
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.361
        },
        "900i": {
          thickness: 8,
          slant: 3,
          width: 7,
          lineHeight: 1.361
        }
      },
      axes: [],
      designers: ["Juan Pablo del Peral", "Huerta Tipogr\xE1fica"],
      lastModified: "2022-12-07",
      dateAdded: "2011-12-19",
      popularity: 585,
      trending: 679,
      defaultSort: 601,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alegreya Sans",
      displayName: null,
      category: "Sans Serif",
      size: 267803,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "100i": {
          thickness: 1,
          slant: 4,
          width: 5,
          lineHeight: 1.2
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "300i": {
          thickness: 3,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "500i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "800i": {
          thickness: 7,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "900i": {
          thickness: 8,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Juan Pablo del Peral", "Huerta Tipogr\xE1fica"],
      lastModified: "2022-12-07",
      dateAdded: "2013-12-04",
      popularity: 148,
      trending: 723,
      defaultSort: 141,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alegreya Sans SC",
      displayName: null,
      category: "Sans Serif",
      size: 270500,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "100i": {
          thickness: 1,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "300i": {
          thickness: 3,
          slant: 3,
          width: 6,
          lineHeight: 1.2
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "400i": {
          thickness: 4,
          slant: 3,
          width: 6,
          lineHeight: 1.2
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "500i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.2
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "800i": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.2
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "900i": {
          thickness: 8,
          slant: 3,
          width: 7,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Juan Pablo del Peral", "Huerta Tipogr\xE1fica"],
      lastModified: "2022-12-07",
      dateAdded: "2013-12-04",
      popularity: 243,
      trending: 1672,
      defaultSort: 256,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aleo",
      displayName: null,
      category: "Serif",
      size: 151930,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Alessio Laiso"],
      lastModified: "2023-06-22",
      dateAdded: "2018-12-11",
      popularity: 246,
      trending: 159,
      defaultSort: 258,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alex Brush",
      displayName: null,
      category: "Handwriting",
      size: 116244,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 9,
          width: 5,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 323,
      trending: 783,
      defaultSort: 342,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alexandria",
      displayName: null,
      category: "Sans Serif",
      size: 332488,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Mohamed Gaber", "Julieta Ulanovsky"],
      lastModified: "2023-03-21",
      dateAdded: "2022-11-03",
      popularity: 517,
      trending: 88,
      defaultSort: 533,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Alfa Slab One",
      displayName: null,
      category: "Display",
      size: 97376,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.369
        }
      },
      axes: [],
      designers: ["JM Sol\xE9"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 164,
      trending: 1697,
      defaultSort: 158,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alice",
      displayName: null,
      category: "Serif",
      size: 129200,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.143
        }
      },
      axes: [],
      designers: ["Ksenya Erulevich", "Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-10",
      popularity: 206,
      trending: 396,
      defaultSort: 209,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alike",
      displayName: null,
      category: "Serif",
      size: 97452,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.254
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-20",
      dateAdded: "2011-08-24",
      popularity: 439,
      trending: 182,
      defaultSort: 461,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alike Angular",
      displayName: null,
      category: "Serif",
      size: 122512,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.254
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-20",
      dateAdded: "2011-09-28",
      popularity: 681,
      trending: 561,
      defaultSort: 687,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alkalami",
      displayName: null,
      category: "Serif",
      size: 145540,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.892
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-02",
      dateAdded: "2022-06-09",
      popularity: 1121,
      trending: 422,
      defaultSort: 1100,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Alkatra",
      displayName: null,
      category: "Display",
      size: 949464,
      subsets: ["menu", "bengali", "devanagari", "latin", "latin-ext", "oriya"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Suman Bhandary"],
      lastModified: "2023-03-21",
      dateAdded: "2023-03-14",
      popularity: 1212,
      trending: 1769,
      defaultSort: 543,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Allan",
      displayName: null,
      category: "Display",
      size: 85912,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 5,
          width: 5,
          lineHeight: 1.142578125
        },
        "700": {
          thickness: 6,
          slant: 5,
          width: 5,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Anton Koovit"],
      lastModified: "2023-05-02",
      dateAdded: "2010-12-15",
      popularity: 762,
      trending: 1693,
      defaultSort: 763,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Allerta",
      displayName: null,
      category: "Sans Serif",
      size: 12255,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.2783203125
        }
      },
      axes: [],
      designers: ["Matt McInerney"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-30",
      popularity: 518,
      trending: 1372,
      defaultSort: 534,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Allerta Stencil",
      displayName: null,
      category: "Sans Serif",
      size: 13012,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.2783203125
        }
      },
      axes: [],
      designers: ["Matt McInerney"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-30",
      popularity: 504,
      trending: 125,
      defaultSort: 520,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Allison",
      displayName: null,
      category: "Handwriting",
      size: 143700,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.27
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-07-02",
      popularity: 696,
      trending: 904,
      defaultSort: 703,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Allura",
      displayName: null,
      category: "Handwriting",
      size: 246632,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 7,
          width: 5,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-01-18",
      dateAdded: "2012-02-08",
      popularity: 275,
      trending: 606,
      defaultSort: 287,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Almarai",
      displayName: null,
      category: "Sans Serif",
      size: 156817,
      subsets: ["menu", "arabic"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.116
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.116
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.116
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.116
        }
      },
      axes: [],
      designers: ["Boutros Fonts"],
      lastModified: "2022-09-21",
      dateAdded: "2019-06-04",
      popularity: 144,
      trending: 1335,
      defaultSort: 137,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Almendra",
      displayName: null,
      category: "Serif",
      size: 43976,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.296
        },
        "400i": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.296
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.296
        },
        "700i": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.296
        }
      },
      axes: [],
      designers: ["Ana Sanfelippo"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 694,
      trending: 1513,
      defaultSort: 700,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Almendra Display",
      displayName: null,
      category: "Display",
      size: 39264,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 1,
          slant: 1,
          width: 6,
          lineHeight: 1.296
        }
      },
      axes: [],
      designers: ["Ana Sanfelippo"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-12",
      popularity: 1319,
      trending: 1411,
      defaultSort: 1270,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Almendra SC",
      displayName: null,
      category: "Serif",
      size: 35988,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.19
        }
      },
      axes: [],
      designers: ["Ana Sanfelippo"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1289,
      trending: 1339,
      defaultSort: 1246,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alumni Sans",
      displayName: null,
      category: "Sans Serif",
      size: 138102,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Robert Leuschke"],
      lastModified: "2023-03-21",
      dateAdded: "2021-06-19",
      popularity: 617,
      trending: 1474,
      defaultSort: 629,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alumni Sans Collegiate One",
      displayName: null,
      category: "Sans Serif",
      size: 168620,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-04-09",
      popularity: 1454,
      trending: 149,
      defaultSort: 1372,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alumni Sans Inline One",
      displayName: null,
      category: "Display",
      size: 133842,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-24",
      popularity: 1361,
      trending: 468,
      defaultSort: 1304,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Alumni Sans Pinstripe",
      displayName: null,
      category: "Sans Serif",
      size: 107670,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2022-06-08",
      popularity: 1444,
      trending: 376,
      defaultSort: 1345,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Amarante",
      displayName: null,
      category: "Display",
      size: 55376,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Karolina Lach"],
      lastModified: "2023-05-02",
      dateAdded: "2012-07-10",
      popularity: 800,
      trending: 1190,
      defaultSort: 802,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Amaranth",
      displayName: null,
      category: "Sans Serif",
      size: 88842,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.212
        },
        "400i": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1.212
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.212
        },
        "700i": {
          thickness: 7,
          slant: 5,
          width: 7,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Gesine Todt"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-04",
      popularity: 293,
      trending: 1427,
      defaultSort: 307,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Amatic SC",
      displayName: null,
      category: "Handwriting",
      size: 153902,
      subsets: ["menu", "cyrillic", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 4,
          lineHeight: 1.261
        },
        "700": {
          thickness: 3,
          slant: 1,
          width: 2,
          lineHeight: 1.261
        }
      },
      axes: [],
      designers: ["Vernon Adams", "Ben Nathan", "Thomas Jockin", "Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 155,
      trending: 934,
      defaultSort: 149,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Amethysta",
      displayName: null,
      category: "Serif",
      size: 66348,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.26220703125
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-20",
      dateAdded: "2012-01-18",
      popularity: 601,
      trending: 1359,
      defaultSort: 616,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Amiko",
      displayName: null,
      category: "Sans Serif",
      size: 193692,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.334
        },
        "600": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.334
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.334
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2016-03-01",
      popularity: 600,
      trending: 762,
      defaultSort: 615,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Amiri",
      displayName: null,
      category: "Serif",
      size: 439402,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.758
        },
        "400i": {
          thickness: 3,
          slant: 5,
          width: 4,
          lineHeight: 1.758
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.758
        },
        "700i": {
          thickness: 5,
          slant: 5,
          width: 4,
          lineHeight: 1.758
        }
      },
      axes: [],
      designers: ["Khaled Hosny", "Sebastian Kosch"],
      lastModified: "2023-01-10",
      dateAdded: "2012-07-30",
      popularity: 170,
      trending: 871,
      defaultSort: 171,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Amiri Quran",
      displayName: null,
      category: "Serif",
      size: 205188,
      subsets: ["menu", "arabic", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.449
        }
      },
      axes: [],
      designers: ["Khaled Hosny", "Sebastian Kosch"],
      lastModified: "2022-09-14",
      dateAdded: "2022-08-10",
      popularity: 1236,
      trending: 68,
      defaultSort: 1158,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV0"],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Amita",
      displayName: null,
      category: "Handwriting",
      size: 218394,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 2,
          width: 4,
          lineHeight: 1.942
        },
        "700": {
          thickness: 3,
          slant: 2,
          width: 4,
          lineHeight: 1.942
        }
      },
      axes: [],
      designers: ["Eduardo Tunni", "Brian Bonislawsky"],
      lastModified: "2022-09-21",
      dateAdded: "2015-05-20",
      popularity: 460,
      trending: 881,
      defaultSort: 477,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anaheim",
      displayName: null,
      category: "Sans Serif",
      size: 34740,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2890625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 790,
      trending: 102,
      defaultSort: 791,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Andada Pro",
      displayName: null,
      category: "Serif",
      size: 270086,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.177
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 840,
          defaultValue: 400
        }
      ],
      designers: ["Huerta Tipogr\xE1fica", "Carolina Giovagnoli"],
      lastModified: "2023-03-21",
      dateAdded: "2021-05-19",
      popularity: 823,
      trending: 133,
      defaultSort: 826,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Andika",
      displayName: null,
      category: "Sans Serif",
      size: 690265,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.611328125
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.611328125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.611328125
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.611328125
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-31",
      dateAdded: "2011-08-10",
      popularity: 713,
      trending: 481,
      defaultSort: 718,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Bangla",
      displayName: null,
      category: "Sans Serif",
      size: 1344456,
      subsets: ["menu", "bengali", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.866
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-01-06",
      dateAdded: "2022-02-08",
      popularity: 1086,
      trending: 1535,
      defaultSort: 1069,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Devanagari",
      displayName: null,
      category: "Sans Serif",
      size: 2190532,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7055
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-03-21",
      dateAdded: "2022-02-08",
      popularity: 1166,
      trending: 56,
      defaultSort: 905,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Gujarati",
      displayName: null,
      category: "Sans Serif",
      size: 1621452,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5195
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2022-02-08",
      popularity: 1242,
      trending: 1736,
      defaultSort: 1202,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Gurmukhi",
      displayName: null,
      category: "Sans Serif",
      size: 357420,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-03-09",
      dateAdded: "2022-02-15",
      popularity: 1396,
      trending: 340,
      defaultSort: 1333,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Kannada",
      displayName: null,
      category: "Sans Serif",
      size: 1346860,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.67
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-01-06",
      dateAdded: "2022-02-15",
      popularity: 1439,
      trending: 750,
      defaultSort: 1364,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Latin",
      displayName: null,
      category: "Sans Serif",
      size: 404880,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-01-06",
      dateAdded: "2022-02-15",
      popularity: 1122,
      trending: 430,
      defaultSort: 1101,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Malayalam",
      displayName: null,
      category: "Sans Serif",
      size: 668244,
      subsets: ["menu", "latin", "latin-ext", "malayalam"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4325
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2022-02-15",
      popularity: 734,
      trending: 540,
      defaultSort: 739,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Odia",
      displayName: null,
      category: "Sans Serif",
      size: 858180,
      subsets: ["menu", "latin", "latin-ext", "oriya"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.68
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2022-02-08",
      popularity: 1403,
      trending: 176,
      defaultSort: 1339,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Tamil",
      displayName: null,
      category: "Sans Serif",
      size: 899668,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.408
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2022-02-08",
      popularity: 1025,
      trending: 1031,
      defaultSort: 1011,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anek Telugu",
      displayName: null,
      category: "Sans Serif",
      size: 1806540,
      subsets: ["menu", "latin", "latin-ext", "telugu"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-03-21",
      dateAdded: "2022-02-15",
      popularity: 979,
      trending: 1224,
      defaultSort: 961,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Angkor",
      displayName: null,
      category: "Display",
      size: 79720,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-20",
      dateAdded: "2011-03-02",
      popularity: 818,
      trending: 1808,
      defaultSort: 820,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Annie Use Your Telescope",
      displayName: null,
      category: "Handwriting",
      size: 51068,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.43359375
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-14",
      popularity: 538,
      trending: 1495,
      defaultSort: 556,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anonymous Pro",
      displayName: null,
      category: "Monospace",
      size: 149516,
      subsets: ["menu", "cyrillic", "greek", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 8,
          lineHeight: 1
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1
        },
        "700i": {
          thickness: 5,
          slant: 5,
          width: 8,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Mark Simonson"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-15",
      popularity: 350,
      trending: 165,
      defaultSort: 367,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Antic",
      displayName: null,
      category: "Sans Serif",
      size: 39240,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.191
        }
      },
      axes: [],
      designers: ["Santiago Orozco"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-31",
      popularity: 382,
      trending: 545,
      defaultSort: 403,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Antic Didone",
      displayName: null,
      category: "Serif",
      size: 39668,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.19
        }
      },
      axes: [],
      designers: ["Santiago Orozco"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 761,
      trending: 1160,
      defaultSort: 762,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Antic Slab",
      displayName: null,
      category: "Serif",
      size: 36948,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.19
        }
      },
      axes: [],
      designers: ["Santiago Orozco"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 237,
      trending: 814,
      defaultSort: 249,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anton",
      displayName: null,
      category: "Sans Serif",
      size: 170812,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.50537109375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-02-23",
      popularity: 72,
      trending: 1123,
      defaultSort: 68,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Antonio",
      displayName: null,
      category: "Sans Serif",
      size: 74104,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2939453125
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2939453125
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2939453125
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2939453125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2939453125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2939453125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2939453125
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2013-03-05",
      popularity: 303,
      trending: 1746,
      defaultSort: 319,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Anuphan",
      displayName: null,
      category: "Sans Serif",
      size: 232008,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Cadson Demak"],
      lastModified: "2023-04-27",
      dateAdded: "2023-03-31",
      popularity: 972,
      trending: 1801,
      defaultSort: 440,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Thai",
      primaryLanguage: ""
    },
    {
      family: "Anybody",
      displayName: null,
      category: "Display",
      size: 205226,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.035
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 50,
          max: 150,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck"],
      lastModified: "2023-04-04",
      dateAdded: "2022-03-02",
      popularity: 1291,
      trending: 1621,
      defaultSort: 1248,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aoboshi One",
      displayName: null,
      category: "Serif",
      size: 117976,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Natsumi Matsuba"],
      lastModified: "2023-05-23",
      dateAdded: "2023-05-23",
      popularity: 1336,
      trending: 82,
      defaultSort: 237,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Arapey",
      displayName: null,
      category: "Serif",
      size: 14833,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.096
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.096
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-02",
      popularity: 434,
      trending: 1305,
      defaultSort: 456,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Arbutus",
      displayName: null,
      category: "Display",
      size: 80964,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 9,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Karolina Lach"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 1240,
      trending: 645,
      defaultSort: 1200,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Arbutus Slab",
      displayName: null,
      category: "Serif",
      size: 69268,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Karolina Lach"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-18",
      popularity: 385,
      trending: 477,
      defaultSort: 405,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Architects Daughter",
      displayName: null,
      category: "Handwriting",
      size: 43352,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.3896484375
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-09",
      popularity: 225,
      trending: 1405,
      defaultSort: 232,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Archivo",
      displayName: null,
      category: "Sans Serif",
      size: 699982,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.088
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-03",
      popularity: 99,
      trending: 607,
      defaultSort: 94,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Archivo Black",
      displayName: null,
      category: "Sans Serif",
      size: 90988,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.088
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-18",
      popularity: 159,
      trending: 307,
      defaultSort: 153,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Archivo Narrow",
      displayName: null,
      category: "Sans Serif",
      size: 95880,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.347
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 6,
          lineHeight: 1.347
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.347
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.347
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.347
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.347
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.347
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 6,
          lineHeight: 1.347
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2012-09-18",
      popularity: 151,
      trending: 391,
      defaultSort: 145,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Are You Serious",
      displayName: null,
      category: "Handwriting",
      size: 150788,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-08-27",
      popularity: 1495,
      trending: 810,
      defaultSort: 1397,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aref Ruqaa",
      displayName: null,
      category: "Serif",
      size: 117274,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.563
        },
        "700": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.563
        }
      },
      axes: [],
      designers: ["Abdullah Aref", "Khaled Hosny", "Hermann Zapf"],
      lastModified: "2022-12-07",
      dateAdded: "2016-06-20",
      popularity: 687,
      trending: 1262,
      defaultSort: 693,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Aref Ruqaa Ink",
      displayName: null,
      category: "Serif",
      size: 599536,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.563
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.563
        }
      },
      axes: [],
      designers: ["Abdullah Aref", "Khaled Hosny", "Hermann Zapf"],
      lastModified: "2023-05-31",
      dateAdded: "2022-02-26",
      popularity: 1458,
      trending: 1683,
      defaultSort: 1375,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV1", "OTSVG"],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Arima",
      displayName: null,
      category: "Display",
      size: 348480,
      subsets: ["menu", "greek", "greek-ext", "latin", "latin-ext", "malayalam", "tamil", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.633
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.633
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.633
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.633
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.633
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.633
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.633
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Natanael Gama", "Joana Correia", "Rosalie Wagner"],
      lastModified: "2023-04-04",
      dateAdded: "2022-05-24",
      popularity: 1158,
      trending: 1382,
      defaultSort: 1129,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Arimo",
      displayName: null,
      category: "Sans Serif",
      size: 519822,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.14990234375
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.14990234375
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.14990234375
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.14990234375
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.14990234375
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.14990234375
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.14990234375
        },
        "700i": {
          thickness: 7,
          slant: 4,
          width: 7,
          lineHeight: 1.14990234375
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Steve Matteson"],
      lastModified: "2023-05-02",
      dateAdded: "2010-11-18",
      popularity: 57,
      trending: 795,
      defaultSort: 56,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Arizonia",
      displayName: null,
      category: "Handwriting",
      size: 126276,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 9,
          width: 6,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 494,
      trending: 1063,
      defaultSort: 512,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Armata",
      displayName: null,
      category: "Sans Serif",
      size: 89724,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Viktoriya Grabowska"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 435,
      trending: 1724,
      defaultSort: 457,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Arsenal",
      displayName: null,
      category: "Sans Serif",
      size: 195348,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.254
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.254
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.254
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.254
        }
      },
      axes: [],
      designers: ["Andrij Shevchenko"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-06",
      popularity: 218,
      trending: 266,
      defaultSort: 225,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Artifika",
      displayName: null,
      category: "Serif",
      size: 54136,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.216796875
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2023-01-10",
      dateAdded: "2011-06-01",
      popularity: 926,
      trending: 553,
      defaultSort: 915,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Arvo",
      displayName: null,
      category: "Serif",
      size: 37115,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.23486328125
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 8,
          lineHeight: 1.23486328125
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.23486328125
        },
        "700i": {
          thickness: 7,
          slant: 4,
          width: 8,
          lineHeight: 1.23486328125
        }
      },
      axes: [],
      designers: ["Anton Koovit"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-17",
      popularity: 95,
      trending: 1207,
      defaultSort: 90,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Arya",
      displayName: null,
      category: "Sans Serif",
      size: 184268,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 1.809
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 3,
          lineHeight: 1.809
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2015-05-20",
      popularity: 604,
      trending: 466,
      defaultSort: 619,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Asap",
      displayName: null,
      category: "Sans Serif",
      size: 476880,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.146
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.146
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.146
        },
        "700i": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.146
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-06-07",
      dateAdded: "2012-01-25",
      popularity: 101,
      trending: 1578,
      defaultSort: 96,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Asap Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 114349,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.146
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2017-07-31",
      popularity: 118,
      trending: 1337,
      defaultSort: 112,
      androidFragment: "name=Asap&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Asar",
      displayName: null,
      category: "Serif",
      size: 669032,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.753
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-17",
      popularity: 957,
      trending: 588,
      defaultSort: 943,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Asset",
      displayName: null,
      category: "Display",
      size: 50616,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 10,
          slant: 1,
          width: 10,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Riccardo De Franceschi"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-29",
      popularity: 1313,
      trending: 1584,
      defaultSort: 1264,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Assistant",
      displayName: null,
      category: "Sans Serif",
      size: 99496,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 4,
          lineHeight: 1.308
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.308
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.308
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.308
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.308
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.308
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.308
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Adobe Systems Inc.", "Ben Nathan"],
      lastModified: "2022-09-21",
      dateAdded: "2016-03-31",
      popularity: 79,
      trending: 209,
      defaultSort: 75,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Astloch",
      displayName: null,
      category: "Display",
      size: 63444,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 5,
          lineHeight: 1.23388671875
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.23388671875
        }
      },
      axes: [],
      designers: ["Dan Rhatigan"],
      lastModified: "2022-04-20",
      dateAdded: "2011-02-16",
      popularity: 1347,
      trending: 1743,
      defaultSort: 1293,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Asul",
      displayName: null,
      category: "Sans Serif",
      size: 33432,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.213
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.213
        }
      },
      axes: [],
      designers: ["Mariela Monsalve"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 865,
      trending: 1629,
      defaultSort: 863,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Athiti",
      displayName: null,
      category: "Sans Serif",
      size: 174908,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 354,
      trending: 555,
      defaultSort: 371,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Atkinson Hyperlegible",
      displayName: null,
      category: "Sans Serif",
      size: 54946,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        }
      },
      axes: [],
      designers: [
        "Braille Institute",
        "Applied Design Works",
        "Elliott Scott",
        "Megan Eiswerth",
        "Linus Boman",
        "Theodore Petrosky"
      ],
      lastModified: "2023-05-02",
      dateAdded: "2021-04-30",
      popularity: 472,
      trending: 506,
      defaultSort: 491,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Atma",
      displayName: null,
      category: "Display",
      size: 219289,
      subsets: ["menu", "bengali", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.619
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.619
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.619
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.619
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.619
        }
      },
      axes: [],
      designers: ["Black Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 891,
      trending: 1566,
      defaultSort: 884,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Atomic Age",
      displayName: null,
      category: "Display",
      size: 62592,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.34130859375
        }
      },
      axes: [],
      designers: ["James Grieshaber"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-26",
      popularity: 1206,
      trending: 1635,
      defaultSort: 1170,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Aubrey",
      displayName: null,
      category: "Display",
      size: 45628,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.042
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-27",
      popularity: 1339,
      trending: 1674,
      defaultSort: 1285,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Audiowide",
      displayName: null,
      category: "Display",
      size: 69916,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.27490234375
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-04-04",
      popularity: 351,
      trending: 1078,
      defaultSort: 368,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Autour One",
      displayName: null,
      category: "Display",
      size: 87060,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-05-15",
      popularity: 1209,
      trending: 1551,
      defaultSort: 1173,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Average",
      displayName: null,
      category: "Serif",
      size: 73640,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.216
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-11-09",
      dateAdded: "2012-03-14",
      popularity: 592,
      trending: 447,
      defaultSort: 607,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Average Sans",
      displayName: null,
      category: "Sans Serif",
      size: 43824,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.296
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-26",
      popularity: 507,
      trending: 614,
      defaultSort: 523,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Averia Gruesa Libre",
      displayName: null,
      category: "Display",
      size: 111584,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.193359375
        }
      },
      axes: [],
      designers: ["Dan Sayers"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 965,
      trending: 1802,
      defaultSort: 950,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Averia Libre",
      displayName: null,
      category: "Display",
      size: 121133,
      subsets: ["menu", "latin"],
      fonts: {
        "300": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.193359375
        },
        "300i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.193359375
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.193359375
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.193359375
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.193359375
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.193359375
        }
      },
      axes: [],
      designers: ["Dan Sayers"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 552,
      trending: 1227,
      defaultSort: 570,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Averia Sans Libre",
      displayName: null,
      category: "Display",
      size: 121324,
      subsets: ["menu", "latin"],
      fonts: {
        "300": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2373046875
        },
        "300i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.2373046875
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2373046875
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.2373046875
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2373046875
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.2373046875
        }
      },
      axes: [],
      designers: ["Dan Sayers"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 813,
      trending: 775,
      defaultSort: 814,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Averia Serif Libre",
      displayName: null,
      category: "Display",
      size: 123154,
      subsets: ["menu", "latin"],
      fonts: {
        "300": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.20703125
        },
        "300i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.2392578125
        },
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.20947265625
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.2353515625
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.21240234375
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.23046875
        }
      },
      axes: [],
      designers: ["Dan Sayers"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 497,
      trending: 649,
      defaultSort: 514,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Azeret Mono",
      displayName: null,
      category: "Monospace",
      size: 109188,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Displaay", "Martin V\xE1cha"],
      lastModified: "2023-05-02",
      dateAdded: "2021-06-08",
      popularity: 732,
      trending: 297,
      defaultSort: 737,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "B612",
      displayName: null,
      category: "Sans Serif",
      size: 117356,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        }
      },
      axes: [],
      designers: ["PolarSys", "Nicolas Chauveau", "Thomas Paillot", "Jonathan Favre-Lamarine", "Jean-Luc Vinot"],
      lastModified: "2022-09-21",
      dateAdded: "2018-12-11",
      popularity: 571,
      trending: 519,
      defaultSort: 587,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "B612 Mono",
      displayName: null,
      category: "Monospace",
      size: 131870,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        }
      },
      axes: [],
      designers: ["PolarSys", "Nicolas Chauveau", "Thomas Paillot", "Jonathan Favre-Lamarine", "Jean-Luc Vinot"],
      lastModified: "2022-09-21",
      dateAdded: "2018-12-11",
      popularity: 551,
      trending: 111,
      defaultSort: 569,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "BIZ UDGothic",
      displayName: null,
      category: "Sans Serif",
      size: 4652752,
      subsets: ["menu", "cyrillic", "greek-ext", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Type Bank Co.", "Morisawa Inc."],
      lastModified: "2023-05-02",
      dateAdded: "2022-03-16",
      popularity: 1059,
      trending: 928,
      defaultSort: 1044,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "BIZ UDMincho",
      displayName: null,
      category: "Serif",
      size: 6630482,
      subsets: ["menu", "cyrillic", "greek-ext", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Type Bank Co.", "Morisawa Inc."],
      lastModified: "2023-01-18",
      dateAdded: "2022-03-16",
      popularity: 1272,
      trending: 1633,
      defaultSort: 1230,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "BIZ UDPGothic",
      displayName: null,
      category: "Sans Serif",
      size: 4655140,
      subsets: ["menu", "cyrillic", "greek-ext", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Type Bank Co.", "Morisawa Inc."],
      lastModified: "2023-05-02",
      dateAdded: "2022-03-16",
      popularity: 409,
      trending: 312,
      defaultSort: 434,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "BIZ UDPMincho",
      displayName: null,
      category: "Serif",
      size: 6632938,
      subsets: ["menu", "cyrillic", "greek-ext", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Type Bank Co.", "Morisawa Inc."],
      lastModified: "2023-01-18",
      dateAdded: "2022-03-16",
      popularity: 902,
      trending: 1229,
      defaultSort: 894,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Babylonica",
      displayName: null,
      category: "Handwriting",
      size: 498620,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-23",
      popularity: 1384,
      trending: 1756,
      defaultSort: 1324,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bacasime Antique",
      displayName: null,
      category: "Serif",
      size: 30848,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["The DocRepair Project", "Claus Eggers S\xF8rensen"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 946,
      trending: 5,
      defaultSort: 11,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bad Script",
      displayName: null,
      category: "Handwriting",
      size: 37312,
      subsets: ["menu", "cyrillic", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 5,
          width: 6,
          lineHeight: 1.97119140625
        }
      },
      axes: [],
      designers: ["Gaslight"],
      lastModified: "2022-04-20",
      dateAdded: "2011-12-13",
      popularity: 329,
      trending: 695,
      defaultSort: 348,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bagel Fat One",
      displayName: null,
      category: "Display",
      size: 1585984,
      subsets: ["menu", "korean", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Kyungwon Kim", "JAMO"],
      lastModified: "2023-06-07",
      dateAdded: "2023-06-05",
      popularity: 1373,
      trending: 1805,
      defaultSort: 159,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Kore",
      primaryLanguage: ""
    },
    {
      family: "Bahiana",
      displayName: null,
      category: "Display",
      size: 85984,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-02",
      popularity: 1231,
      trending: 592,
      defaultSort: 1192,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bahianita",
      displayName: null,
      category: "Display",
      size: 142668,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2019-06-11",
      popularity: 1286,
      trending: 1311,
      defaultSort: 1243,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bai Jamjuree",
      displayName: null,
      category: "Sans Serif",
      size: 84860,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 264,
      trending: 1489,
      defaultSort: 277,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bakbak One",
      displayName: null,
      category: "Display",
      size: 263136,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4
        }
      },
      axes: [],
      designers: ["Saumya Kishore", "Sanchit Sawaria"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-09",
      popularity: 702,
      trending: 445,
      defaultSort: 709,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ballet",
      displayName: null,
      category: "Handwriting",
      size: 134e3,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.9
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 16,
          max: 72,
          defaultValue: 16
        }
      ],
      designers: ["Omnibus-Type", "Maximiliano Sproviero"],
      lastModified: "2023-03-09",
      dateAdded: "2020-09-23",
      popularity: 1355,
      trending: 1255,
      defaultSort: 1300,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Baloo 2",
      displayName: null,
      category: "Display",
      size: 683200,
      subsets: ["menu", "devanagari", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.602
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.602
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.602
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.602
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.602
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2016-01-20",
      popularity: 187,
      trending: 1030,
      defaultSort: 188,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "Baloo Bhai 2",
      displayName: null,
      category: "Display",
      size: 710488,
      subsets: ["menu", "gujarati", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2016-01-20",
      popularity: 988,
      trending: 863,
      defaultSort: 969,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Gujr",
      primaryLanguage: ""
    },
    {
      family: "Baloo Bhaijaan 2",
      displayName: null,
      category: "Display",
      size: 285508,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.712
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.712
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.712
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.712
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.712
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2021-10-29",
      popularity: 971,
      trending: 218,
      defaultSort: 954,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Baloo Bhaina 2",
      displayName: null,
      category: "Display",
      size: 473060,
      subsets: ["menu", "latin", "latin-ext", "oriya", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.012
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.012
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.012
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.012
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.012
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2016-01-20",
      popularity: 903,
      trending: 1373,
      defaultSort: 895,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Orya",
      primaryLanguage: ""
    },
    {
      family: "Baloo Chettan 2",
      displayName: null,
      category: "Display",
      size: 339860,
      subsets: ["menu", "latin", "latin-ext", "malayalam", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.47
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.47
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.47
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.47
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.47
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2016-01-20",
      popularity: 765,
      trending: 612,
      defaultSort: 766,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Mlym",
      primaryLanguage: ""
    },
    {
      family: "Baloo Da 2",
      displayName: null,
      category: "Display",
      size: 451504,
      subsets: ["menu", "bengali", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.684
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2016-01-20",
      popularity: 661,
      trending: 1490,
      defaultSort: 668,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Beng",
      primaryLanguage: ""
    },
    {
      family: "Baloo Paaji 2",
      displayName: null,
      category: "Display",
      size: 243180,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.771
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.771
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.771
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.771
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.771
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2016-01-20",
      popularity: 698,
      trending: 629,
      defaultSort: 705,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Guru",
      primaryLanguage: ""
    },
    {
      family: "Baloo Tamma 2",
      displayName: null,
      category: "Display",
      size: 475932,
      subsets: ["menu", "kannada", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.751
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.751
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.751
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.751
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.751
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2016-01-20",
      popularity: 714,
      trending: 1787,
      defaultSort: 719,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Knda",
      primaryLanguage: ""
    },
    {
      family: "Baloo Tammudu 2",
      displayName: null,
      category: "Display",
      size: 669816,
      subsets: ["menu", "latin", "latin-ext", "telugu", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.296
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.296
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.296
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.296
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.296
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2016-01-20",
      popularity: 1029,
      trending: 1508,
      defaultSort: 1016,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Telu",
      primaryLanguage: ""
    },
    {
      family: "Baloo Thambi 2",
      displayName: null,
      category: "Display",
      size: 307136,
      subsets: ["menu", "latin", "latin-ext", "tamil", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.564
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.564
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.564
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.564
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.564
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Ek Type"],
      lastModified: "2022-11-09",
      dateAdded: "2016-01-20",
      popularity: 682,
      trending: 694,
      defaultSort: 688,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Taml",
      primaryLanguage: ""
    },
    {
      family: "Balsamiq Sans",
      displayName: null,
      category: "Display",
      size: 377154,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Michael Angeles"],
      lastModified: "2023-05-23",
      dateAdded: "2020-04-09",
      popularity: 519,
      trending: 1634,
      defaultSort: 535,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Balthazar",
      displayName: null,
      category: "Serif",
      size: 15754,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.018
        }
      },
      axes: [],
      designers: ["Dario Manuel Muhafara"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 877,
      trending: 712,
      defaultSort: 873,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bangers",
      displayName: null,
      category: "Display",
      size: 100928,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 4,
          width: 6,
          lineHeight: 1.064
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2011-02-09",
      popularity: 282,
      trending: 1309,
      defaultSort: 295,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Barlow",
      displayName: null,
      category: "Sans Serif",
      size: 108188,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Jeremy Tribby"],
      lastModified: "2022-09-21",
      dateAdded: "2017-10-26",
      popularity: 40,
      trending: 841,
      defaultSort: 39,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Barlow Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 107974,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Jeremy Tribby"],
      lastModified: "2022-09-21",
      dateAdded: "2017-10-26",
      popularity: 70,
      trending: 229,
      defaultSort: 66,
      androidFragment: "name=Barlow&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Barlow Semi Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 110106,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Jeremy Tribby"],
      lastModified: "2023-05-02",
      dateAdded: "2017-10-26",
      popularity: 127,
      trending: 660,
      defaultSort: 121,
      androidFragment: "name=Barlow&width=87.5",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Barriecito",
      displayName: null,
      category: "Display",
      size: 278448,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2019-06-11",
      popularity: 1306,
      trending: 1204,
      defaultSort: 1261,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Barrio",
      displayName: null,
      category: "Display",
      size: 225524,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.127
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-02",
      popularity: 1035,
      trending: 408,
      defaultSort: 1022,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Basic",
      displayName: null,
      category: "Sans Serif",
      size: 19647,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.25830078125
        }
      },
      axes: [],
      designers: ["Magnus Gaarde"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-15",
      popularity: 463,
      trending: 1370,
      defaultSort: 480,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Baskervville",
      displayName: null,
      category: "Serif",
      size: 94600,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.293
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.293
        }
      },
      axes: [],
      designers: ["ANRT"],
      lastModified: "2023-01-18",
      dateAdded: "2019-10-04",
      popularity: 383,
      trending: 1759,
      defaultSort: 404,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Battambang",
      displayName: null,
      category: "Display",
      size: 106306,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-20",
      dateAdded: "2011-03-02",
      popularity: 778,
      trending: 1725,
      defaultSort: 779,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Baumans",
      displayName: null,
      category: "Display",
      size: 52076,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.182
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-20",
      dateAdded: "2011-12-07",
      popularity: 835,
      trending: 1700,
      defaultSort: 836,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bayon",
      displayName: null,
      category: "Sans Serif",
      size: 55132,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-20",
      dateAdded: "2011-03-02",
      popularity: 1024,
      trending: 1547,
      defaultSort: 1010,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Be Vietnam Pro",
      displayName: null,
      category: "Sans Serif",
      size: 136123,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.265
        }
      },
      axes: [],
      designers: ["L\xE2m B\u1EA3o", "Tony Le", "Vi\u1EC7tAnh Nguy\u1EC5n"],
      lastModified: "2023-06-07",
      dateAdded: "2021-06-13",
      popularity: 230,
      trending: 1766,
      defaultSort: 242,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Beau Rivage",
      displayName: null,
      category: "Handwriting",
      size: 238824,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-16",
      popularity: 1246,
      trending: 634,
      defaultSort: 1206,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bebas Neue",
      displayName: null,
      category: "Sans Serif",
      size: 61400,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Ryoichi Tsunekawa"],
      lastModified: "2023-05-09",
      dateAdded: "2019-10-16",
      popularity: 64,
      trending: 688,
      defaultSort: 60,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Belanosima",
      displayName: null,
      category: "Sans Serif",
      size: 38777,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.09912109375
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12890625
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.23779296875
        }
      },
      axes: [],
      designers: ["The DocRepair Project", "Santiago Orozco"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 1037,
      trending: 7,
      defaultSort: 19,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Belgrano",
      displayName: null,
      category: "Serif",
      size: 29048,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.268
        }
      },
      axes: [],
      designers: ["LatinoType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 940,
      trending: 1691,
      defaultSort: 930,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bellefair",
      displayName: null,
      category: "Serif",
      size: 65432,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.146
        }
      },
      axes: [],
      designers: ["Nick Shinn", "Liron Lavi Turkenic"],
      lastModified: "2022-09-21",
      dateAdded: "2017-06-28",
      popularity: 505,
      trending: 333,
      defaultSort: 521,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Belleza",
      displayName: null,
      category: "Sans Serif",
      size: 55696,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.152
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-29",
      popularity: 526,
      trending: 1514,
      defaultSort: 544,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bellota",
      displayName: null,
      category: "Display",
      size: 198025,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        }
      },
      axes: [],
      designers: ["Kemie Guaida"],
      lastModified: "2022-09-21",
      dateAdded: "2020-01-16",
      popularity: 886,
      trending: 1198,
      defaultSort: 881,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bellota Text",
      displayName: null,
      category: "Display",
      size: 196294,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.258
        }
      },
      axes: [],
      designers: ["Kemie Guaida"],
      lastModified: "2022-09-21",
      dateAdded: "2020-01-16",
      popularity: 704,
      trending: 729,
      defaultSort: 710,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "BenchNine",
      displayName: null,
      category: "Sans Serif",
      size: 56994,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 3,
          slant: 1,
          width: 1,
          lineHeight: 1.337890625
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 2,
          lineHeight: 1.337890625
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.337890625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-24",
      popularity: 338,
      trending: 1023,
      defaultSort: 356,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Benne",
      displayName: null,
      category: "Serif",
      size: 230896,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["John Harrington"],
      lastModified: "2022-09-21",
      dateAdded: "2016-03-01",
      popularity: 1249,
      trending: 268,
      defaultSort: 1208,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bentham",
      displayName: null,
      category: "Serif",
      size: 55468,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2021484375
        }
      },
      axes: [],
      designers: ["Ben Weiner"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-30",
      popularity: 679,
      trending: 1054,
      defaultSort: 685,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Berkshire Swash",
      displayName: null,
      category: "Handwriting",
      size: 58400,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.2421875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 422,
      trending: 1744,
      defaultSort: 445,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Besley",
      displayName: null,
      category: "Serif",
      size: 110716,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.675
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Owen Earl"],
      lastModified: "2023-03-21",
      dateAdded: "2021-01-05",
      popularity: 911,
      trending: 1719,
      defaultSort: 903,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Beth Ellen",
      displayName: null,
      category: "Handwriting",
      size: 116988,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.22
        }
      },
      axes: [],
      designers: ["Rob Jelinski", "Alyson Fraser Diaz"],
      lastModified: "2022-04-20",
      dateAdded: "2019-05-09",
      popularity: 1097,
      trending: 310,
      defaultSort: 1079,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bevan",
      displayName: null,
      category: "Display",
      size: 118472,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.60693359375
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.60693359375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2011-02-23",
      popularity: 496,
      trending: 1349,
      defaultSort: 513,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "BhuTuka Expanded One",
      displayName: null,
      category: "Display",
      size: 138740,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.008
        }
      },
      axes: [],
      designers: ["Erin McLaughlin"],
      lastModified: "2023-05-02",
      dateAdded: "2022-01-21",
      popularity: 722,
      trending: 597,
      defaultSort: 727,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Big Shoulders Display",
      displayName: null,
      category: "Display",
      size: 219532,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Patric King"],
      lastModified: "2023-03-21",
      dateAdded: "2019-09-11",
      popularity: 488,
      trending: 725,
      defaultSort: 508,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Big Shoulders Inline Display",
      displayName: null,
      category: "Display",
      size: 420084,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Patric King"],
      lastModified: "2023-03-09",
      dateAdded: "2020-10-12",
      popularity: 1432,
      trending: 868,
      defaultSort: 1360,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Big Shoulders Inline Text",
      displayName: null,
      category: "Display",
      size: 414916,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Patric King"],
      lastModified: "2023-03-09",
      dateAdded: "2020-10-12",
      popularity: 1413,
      trending: 1556,
      defaultSort: 1348,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Big Shoulders Stencil Display",
      displayName: null,
      category: "Display",
      size: 226508,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Patric King"],
      lastModified: "2023-05-02",
      dateAdded: "2020-10-12",
      popularity: 1320,
      trending: 435,
      defaultSort: 1271,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Big Shoulders Stencil Text",
      displayName: null,
      category: "Display",
      size: 225152,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Patric King"],
      lastModified: "2022-09-21",
      dateAdded: "2020-10-12",
      popularity: 1284,
      trending: 211,
      defaultSort: 1241,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Big Shoulders Text",
      displayName: null,
      category: "Display",
      size: 218416,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.197
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Patric King"],
      lastModified: "2023-03-21",
      dateAdded: "2019-09-11",
      popularity: 649,
      trending: 595,
      defaultSort: 657,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bigelow Rules",
      displayName: null,
      category: "Display",
      size: 59476,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 2,
          lineHeight: 1.15869140625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-02",
      popularity: 1189,
      trending: 1483,
      defaultSort: 1155,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bigshot One",
      displayName: null,
      category: "Display",
      size: 44836,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.048
        }
      },
      axes: [],
      designers: ["Gesine Todt"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-04",
      popularity: 892,
      trending: 1469,
      defaultSort: 885,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bilbo",
      displayName: null,
      category: "Handwriting",
      size: 100216,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 6,
          width: 2,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 1152,
      trending: 367,
      defaultSort: 1125,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bilbo Swash Caps",
      displayName: null,
      category: "Handwriting",
      size: 58072,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 6,
          width: 2,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["TypeSETit"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 831,
      trending: 1142,
      defaultSort: 833,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "BioRhyme",
      displayName: null,
      category: "Serif",
      size: 95912,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 5,
          lineHeight: 1.549
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 5,
          lineHeight: 1.549
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.549
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.549
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 5,
          lineHeight: 1.549
        }
      },
      axes: [],
      designers: ["Aoife Mooney"],
      lastModified: "2023-05-02",
      dateAdded: "2016-03-01",
      popularity: 530,
      trending: 761,
      defaultSort: 548,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "BioRhyme Expanded",
      displayName: null,
      category: "Serif",
      size: 93088,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 9,
          lineHeight: 1.549
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 9,
          lineHeight: 1.549
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 9,
          lineHeight: 1.549
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 9,
          lineHeight: 1.549
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 9,
          lineHeight: 1.549
        }
      },
      axes: [],
      designers: ["Aoife Mooney"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 1277,
      trending: 283,
      defaultSort: 1234,
      androidFragment: "name=BioRhyme&width=125.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Birthstone",
      displayName: null,
      category: "Handwriting",
      size: 381092,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-08-06",
      popularity: 929,
      trending: 1076,
      defaultSort: 918,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Birthstone Bounce",
      displayName: null,
      category: "Handwriting",
      size: 324558,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-02",
      popularity: 1226,
      trending: 1101,
      defaultSort: 1187,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Biryani",
      displayName: null,
      category: "Sans Serif",
      size: 179017,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 5,
          lineHeight: 1.765
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 5,
          lineHeight: 1.765
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.765
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.765
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 5,
          lineHeight: 1.765
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 5,
          lineHeight: 1.765
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 5,
          lineHeight: 1.765
        }
      },
      axes: [],
      designers: ["Dan Reynolds", "Mathieu R\xE9guer"],
      lastModified: "2022-09-21",
      dateAdded: "2015-04-22",
      popularity: 501,
      trending: 742,
      defaultSort: 518,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bitter",
      displayName: null,
      category: "Serif",
      size: 293992,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Sol Matas"],
      lastModified: "2022-12-07",
      dateAdded: "2011-12-19",
      popularity: 67,
      trending: 1331,
      defaultSort: 63,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Black And White Picture",
      displayName: null,
      category: "Sans Serif",
      size: 9606352,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["AsiaSoft Inc."],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-27",
      popularity: 1151,
      trending: 1434,
      defaultSort: 1124,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Black Han Sans",
      displayName: null,
      category: "Sans Serif",
      size: 984288,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Zess Type"],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-23",
      popularity: 375,
      trending: 777,
      defaultSort: 395,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Black Ops One",
      displayName: null,
      category: "Display",
      size: 166532,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["James Grieshaber", "Eben Sorkin"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-27",
      popularity: 368,
      trending: 549,
      defaultSort: 388,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Blaka",
      displayName: null,
      category: "Display",
      size: 57684,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        }
      },
      axes: [],
      designers: ["Mohamed Gaber"],
      lastModified: "2022-12-07",
      dateAdded: "2022-04-25",
      popularity: 1428,
      trending: 1388,
      defaultSort: 1358,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Blaka Hollow",
      displayName: null,
      category: "Display",
      size: 73248,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        }
      },
      axes: [],
      designers: ["Mohamed Gaber"],
      lastModified: "2022-12-07",
      dateAdded: "2022-04-25",
      popularity: 1498,
      trending: 196,
      defaultSort: 1394,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Blaka Ink",
      displayName: null,
      category: "Display",
      size: 387400,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.167
        }
      },
      axes: [],
      designers: ["Mohamed Gaber"],
      lastModified: "2023-05-31",
      dateAdded: "2022-02-26",
      popularity: 1570,
      trending: 1509,
      defaultSort: 1425,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV1", "OTSVG"],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Blinker",
      displayName: null,
      category: "Sans Serif",
      size: 77402,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Juergen Huber"],
      lastModified: "2023-05-02",
      dateAdded: "2019-06-23",
      popularity: 315,
      trending: 486,
      defaultSort: 332,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bodoni Moda",
      displayName: null,
      category: "Serif",
      size: 163920,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.525
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 6,
          max: 96,
          defaultValue: 11
        },
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Owen Earl"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-25",
      popularity: 201,
      trending: 604,
      defaultSort: 203,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bokor",
      displayName: null,
      category: "Display",
      size: 124128,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-21",
      dateAdded: "2011-03-02",
      popularity: 1301,
      trending: 157,
      defaultSort: 1258,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bona Nova",
      displayName: null,
      category: "Serif",
      size: 409220,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Capitalics", "Mateusz Machalski", "Andrzej Heidrich"],
      lastModified: "2022-09-21",
      dateAdded: "2021-04-13",
      popularity: 1092,
      trending: 216,
      defaultSort: 1074,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bonbon",
      displayName: null,
      category: "Handwriting",
      size: 81772,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 2,
          width: 8,
          lineHeight: 1.175
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-21",
      dateAdded: "2011-12-07",
      popularity: 1421,
      trending: 850,
      defaultSort: 1354,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bonheur Royale",
      displayName: null,
      category: "Handwriting",
      size: 133728,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.16
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-08-06",
      popularity: 1343,
      trending: 305,
      defaultSort: 1289,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Boogaloo",
      displayName: null,
      category: "Display",
      size: 33960,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.189
        }
      },
      axes: [],
      designers: ["John Vargas Beltr\xE1n"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 479,
      trending: 1410,
      defaultSort: 498,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bowlby One",
      displayName: null,
      category: "Display",
      size: 59856,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.56640625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-13",
      popularity: 622,
      trending: 190,
      defaultSort: 634,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bowlby One SC",
      displayName: null,
      category: "Display",
      size: 39440,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.525390625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2011-07-06",
      popularity: 527,
      trending: 162,
      defaultSort: 545,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Braah One",
      displayName: null,
      category: "Sans Serif",
      size: 124592,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4
        }
      },
      axes: [],
      designers: ["Ashish Kumar"],
      lastModified: "2023-06-07",
      dateAdded: "2023-03-23",
      popularity: 1311,
      trending: 467,
      defaultSort: 536,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Guru",
      primaryLanguage: ""
    },
    {
      family: "Brawler",
      displayName: null,
      category: "Serif",
      size: 53220,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.219
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-18",
      popularity: 693,
      trending: 1e3,
      defaultSort: 699,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bree Serif",
      displayName: null,
      category: "Serif",
      size: 46572,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.358
        }
      },
      axes: [],
      designers: ["TypeTogether"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 150,
      trending: 1093,
      defaultSort: 144,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bruno Ace",
      displayName: null,
      category: "Display",
      size: 56748,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.206
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-04-20",
      dateAdded: "2023-04-19",
      popularity: 1455,
      trending: 1721,
      defaultSort: 433,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bruno Ace SC",
      displayName: null,
      category: "Display",
      size: 55520,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.206
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-04-20",
      dateAdded: "2023-04-19",
      popularity: 1237,
      trending: 1549,
      defaultSort: 431,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Brygada 1918",
      displayName: null,
      category: "Serif",
      size: 242986,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Capitalics", "Mateusz Machalski", "Borys Kosmynka", "Ania Wielu\u0144ska", "Przemys\u0142aw Hoffer"],
      lastModified: "2023-01-06",
      dateAdded: "2021-01-27",
      popularity: 630,
      trending: 1462,
      defaultSort: 641,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bubblegum Sans",
      displayName: null,
      category: "Display",
      size: 20678,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.163
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 596,
      trending: 1162,
      defaultSort: 611,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bubbler One",
      displayName: null,
      category: "Sans Serif",
      size: 31008,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.163
        }
      },
      axes: [],
      designers: ["Brenda Gallo"],
      lastModified: "2022-09-21",
      dateAdded: "2012-05-09",
      popularity: 1111,
      trending: 1294,
      defaultSort: 1091,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Buda",
      displayName: null,
      category: "Display",
      size: 106012,
      subsets: ["menu", "latin"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Ad\xE8le Antignac"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-20",
      popularity: 1182,
      trending: 643,
      defaultSort: 1149,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Buenard",
      displayName: null,
      category: "Serif",
      size: 59520,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.301
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.301
        }
      },
      axes: [],
      designers: ["FontFuror"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 756,
      trending: 1222,
      defaultSort: 757,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bungee",
      displayName: null,
      category: "Display",
      size: 126736,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["David Jonathan Ross"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 286,
      trending: 1307,
      defaultSort: 300,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bungee Hairline",
      displayName: null,
      category: "Display",
      size: 115760,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["David Jonathan Ross"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 1304,
      trending: 794,
      defaultSort: 1260,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bungee Inline",
      displayName: null,
      category: "Display",
      size: 176392,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["David Jonathan Ross"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 524,
      trending: 1389,
      defaultSort: 541,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bungee Outline",
      displayName: null,
      category: "Display",
      size: 238148,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["David Jonathan Ross"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 1259,
      trending: 448,
      defaultSort: 1218,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bungee Shade",
      displayName: null,
      category: "Display",
      size: 416840,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["David Jonathan Ross"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 706,
      trending: 502,
      defaultSort: 711,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Bungee Spice",
      displayName: null,
      category: "Display",
      size: 503072,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["David Jonathan Ross"],
      lastModified: "2023-05-31",
      dateAdded: "2021-12-07",
      popularity: 1473,
      trending: 1576,
      defaultSort: 1387,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV1", "OTSVG"],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Butcherman",
      displayName: null,
      category: "Display",
      size: 66100,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.93505859375
        }
      },
      axes: [],
      designers: ["Typomondo"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1367,
      trending: 1703,
      defaultSort: 1309,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Butterfly Kids",
      displayName: null,
      category: "Handwriting",
      size: 202848,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 4,
          width: 5,
          lineHeight: 1.1923828125
        }
      },
      axes: [],
      designers: ["Tart Workshop"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-15",
      popularity: 1325,
      trending: 1044,
      defaultSort: 1275,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cabin",
      displayName: null,
      category: "Sans Serif",
      size: 160440,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.215
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.215
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.215
        },
        "500i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.215
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.215
        },
        "600i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.215
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.215
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.215
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type", "Rodrigo Fuenzalida"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 66,
      trending: 1148,
      defaultSort: 62,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cabin Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 98711,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.215
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.215
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.215
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.215
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-30",
      popularity: 347,
      trending: 1354,
      defaultSort: 365,
      androidFragment: "name=Cabin&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cabin Sketch",
      displayName: null,
      category: "Display",
      size: 213622,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.171
        },
        "700": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.171
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-16",
      popularity: 399,
      trending: 1225,
      defaultSort: 421,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Caesar Dressing",
      displayName: null,
      category: "Display",
      size: 40370,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2138671875
        }
      },
      axes: [],
      designers: ["Open Window"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1137,
      trending: 94,
      defaultSort: 1112,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cagliostro",
      displayName: null,
      category: "Sans Serif",
      size: 20763,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.353
        }
      },
      axes: [],
      designers: ["MADType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-30",
      popularity: 1145,
      trending: 1518,
      defaultSort: 1118,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cairo",
      displayName: null,
      category: "Sans Serif",
      size: 599548,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        }
      },
      axes: [
        {
          tag: "slnt",
          min: -11,
          max: 11,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 200,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Mohamed Gaber", "Accademia di Belle Arti di Urbino"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 65,
      trending: 1502,
      defaultSort: 61,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Cairo Play",
      displayName: null,
      category: "Sans Serif",
      size: 608152,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.874
        }
      },
      axes: [
        {
          tag: "slnt",
          min: -11,
          max: 11,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 200,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Mohamed Gaber", "Accademia di Belle Arti di Urbino"],
      lastModified: "2023-04-27",
      dateAdded: "2022-08-05",
      popularity: 1452,
      trending: 856,
      defaultSort: 1250,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV0"],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Caladea",
      displayName: null,
      category: "Serif",
      size: 83307,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Andr\xE9s Torresi", "Carolina Giovanolli"],
      lastModified: "2022-09-21",
      dateAdded: "2020-02-11",
      popularity: 266,
      trending: 74,
      defaultSort: 279,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Calistoga",
      displayName: null,
      category: "Display",
      size: 209540,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Yvonne Sch\xFCttler", "Sorkin Type", "Eben Sorkin"],
      lastModified: "2022-12-07",
      dateAdded: "2019-11-04",
      popularity: 337,
      trending: 231,
      defaultSort: 355,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Calligraffitti",
      displayName: null,
      category: "Handwriting",
      size: 59860,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 6,
          width: 6,
          lineHeight: 1.5693359375
        }
      },
      axes: [],
      designers: ["Open Window"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 642,
      trending: 1169,
      defaultSort: 650,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cambay",
      displayName: null,
      category: "Sans Serif",
      size: 233689,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.62875
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.62875
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.62875
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1.62875
        }
      },
      axes: [],
      designers: ["Pooja Saxena"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-28",
      popularity: 625,
      trending: 353,
      defaultSort: 636,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cambo",
      displayName: null,
      category: "Serif",
      size: 29104,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.122
        }
      },
      axes: [],
      designers: ["Huerta Tipogr\xE1fica"],
      lastModified: "2022-12-07",
      dateAdded: "2011-12-19",
      popularity: 733,
      trending: 1601,
      defaultSort: 738,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Candal",
      displayName: null,
      category: "Sans Serif",
      size: 19847,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.2978515625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-09",
      popularity: 487,
      trending: 1051,
      defaultSort: 506,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cantarell",
      displayName: null,
      category: "Sans Serif",
      size: 45417,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.416015625
        },
        "400i": {
          thickness: 4,
          slant: 6,
          width: 7,
          lineHeight: 1.416015625
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.416015625
        },
        "700i": {
          thickness: 6,
          slant: 6,
          width: 8,
          lineHeight: 1.416015625
        }
      },
      axes: [],
      designers: ["Dave Crossland"],
      lastModified: "2022-11-09",
      dateAdded: "2010-05-10",
      popularity: 185,
      trending: 200,
      defaultSort: 187,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cantata One",
      displayName: null,
      category: "Serif",
      size: 96828,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.26953125
        }
      },
      axes: [],
      designers: ["Joana Correia"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 464,
      trending: 1452,
      defaultSort: 481,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cantora One",
      displayName: null,
      category: "Sans Serif",
      size: 159328,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-11-09",
      dateAdded: "2012-07-30",
      popularity: 1031,
      trending: 1301,
      defaultSort: 1018,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Caprasimo",
      displayName: null,
      category: "Display",
      size: 41660,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.14697265625
        }
      },
      axes: [],
      designers: ["The DocRepair Project", "Phaedra Charles", "Flavia Zimbardi"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 922,
      trending: 6,
      defaultSort: 13,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Capriola",
      displayName: null,
      category: "Sans Serif",
      size: 47884,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Viktoriya Grabowska"],
      lastModified: "2023-05-02",
      dateAdded: "2012-07-10",
      popularity: 448,
      trending: 651,
      defaultSort: 469,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Caramel",
      displayName: null,
      category: "Handwriting",
      size: 204044,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-08-06",
      popularity: 1348,
      trending: 1533,
      defaultSort: 1294,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Carattere",
      displayName: null,
      category: "Handwriting",
      size: 124884,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-08-26",
      popularity: 1186,
      trending: 192,
      defaultSort: 1153,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cardo",
      displayName: null,
      category: "Serif",
      size: 224897,
      subsets: ["menu", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.35400390625
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.35400390625
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.35400390625
        }
      },
      axes: [],
      designers: ["David Perry"],
      lastModified: "2022-09-21",
      dateAdded: "2011-09-07",
      popularity: 145,
      trending: 757,
      defaultSort: 138,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Carlito",
      displayName: null,
      category: "Sans Serif",
      size: 683561,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.220703125
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.220703125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.220703125
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.220703125
        }
      },
      axes: [],
      designers: ["\u0141ukasz Dziedzic"],
      lastModified: "2023-05-02",
      dateAdded: "2023-04-19",
      popularity: 1374,
      trending: 780,
      defaultSort: 339,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Carme",
      displayName: null,
      category: "Sans Serif",
      size: 26098,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.20068359375
        }
      },
      axes: [],
      designers: ["Rub\xE9n Prol"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-27",
      popularity: 769,
      trending: 751,
      defaultSort: 771,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Carrois Gothic",
      displayName: null,
      category: "Sans Serif",
      size: 41724,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.192
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-30",
      popularity: 466,
      trending: 844,
      defaultSort: 485,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Carrois Gothic SC",
      displayName: null,
      category: "Sans Serif",
      size: 40356,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.192
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-30",
      popularity: 977,
      trending: 1005,
      defaultSort: 959,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Carter One",
      displayName: null,
      category: "Display",
      size: 40519,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.5400390625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-04",
      popularity: 219,
      trending: 714,
      defaultSort: 226,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Castoro",
      displayName: null,
      category: "Serif",
      size: 127312,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Paul Hanslow", "Kaja S\u0142ojewska"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-03",
      popularity: 322,
      trending: 1498,
      defaultSort: 341,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Castoro Titling",
      displayName: null,
      category: "Display",
      size: 56184,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson"],
      lastModified: "2023-05-02",
      dateAdded: "2023-04-19",
      popularity: 1330,
      trending: 96,
      defaultSort: 432,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Catamaran",
      displayName: null,
      category: "Sans Serif",
      size: 184276,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "200": {
          thickness: 2,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        },
        "900": {
          thickness: 9,
          slant: 1,
          width: 4,
          lineHeight: 1.64
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Pria Ravichandran"],
      lastModified: "2023-05-02",
      dateAdded: "2015-07-08",
      popularity: 107,
      trending: 44,
      defaultSort: 102,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Caudex",
      displayName: null,
      category: "Serif",
      size: 188237,
      subsets: ["menu", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2890625
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.2890625
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2890625
        },
        "700i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.2890625
        }
      },
      axes: [],
      designers: ["Nidud"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-18",
      popularity: 593,
      trending: 623,
      defaultSort: 608,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Caveat",
      displayName: null,
      category: "Handwriting",
      size: 403648,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 6,
          width: 3,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: 4,
          slant: 6,
          width: 3,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2015-09-23",
      popularity: 100,
      trending: 1189,
      defaultSort: 95,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Caveat Brush",
      displayName: null,
      category: "Handwriting",
      size: 140755,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 3,
          lineHeight: 1.26
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2015-09-23",
      popularity: 470,
      trending: 1108,
      defaultSort: 489,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cedarville Cursive",
      displayName: null,
      category: "Handwriting",
      size: 38590,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 6,
          width: 7,
          lineHeight: 1.896484375
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-08",
      popularity: 542,
      trending: 1292,
      defaultSort: 560,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ceviche One",
      displayName: null,
      category: "Display",
      size: 36940,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 5,
          width: 6,
          lineHeight: 1.043
        }
      },
      axes: [],
      designers: ["Miguel Hernandez"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 689,
      trending: 202,
      defaultSort: 695,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chakra Petch",
      displayName: null,
      category: "Sans Serif",
      size: 79780,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 126,
      trending: 847,
      defaultSort: 120,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Changa",
      displayName: null,
      category: "Sans Serif",
      size: 132140,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 4,
          lineHeight: 1.84
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.84
        },
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.84
        },
        "500": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.84
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.84
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.84
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.84
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 174,
      trending: 1600,
      defaultSort: 175,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Changa One",
      displayName: null,
      category: "Display",
      size: 13542,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.062
        },
        "400i": {
          thickness: 8,
          slant: 4,
          width: 7,
          lineHeight: 1.062
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-30",
      popularity: 426,
      trending: 117,
      defaultSort: 449,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chango",
      displayName: null,
      category: "Display",
      size: 20879,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 10,
          slant: 1,
          width: 9,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Fontstage"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-13",
      popularity: 766,
      trending: 54,
      defaultSort: 767,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Charis SIL",
      displayName: null,
      category: "Serif",
      size: 767411,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6357421875
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6357421875
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6357421875
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6357421875
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-04-27",
      dateAdded: "2022-05-12",
      popularity: 1346,
      trending: 1638,
      defaultSort: 1292,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Charm",
      displayName: null,
      category: "Handwriting",
      size: 138632,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.549
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.549
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2018-12-11",
      popularity: 450,
      trending: 1040,
      defaultSort: 471,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Charmonman",
      displayName: null,
      category: "Handwriting",
      size: 117514,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.9
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.9
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 873,
      trending: 475,
      defaultSort: 870,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chathura",
      displayName: null,
      category: "Sans Serif",
      size: 336350,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.622
        }
      },
      axes: [],
      designers: ["Appaji Ambarisha Darbha"],
      lastModified: "2022-04-21",
      dateAdded: "2016-06-15",
      popularity: 1174,
      trending: 63,
      defaultSort: 1062,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chau Philomene One",
      displayName: null,
      category: "Sans Serif",
      size: 42184,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.367
        },
        "400i": {
          thickness: 6,
          slant: 3,
          width: 6,
          lineHeight: 1.367
        }
      },
      axes: [],
      designers: ["Vicente Lam\xF3naca"],
      lastModified: "2022-09-21",
      dateAdded: "2012-04-04",
      popularity: 841,
      trending: 247,
      defaultSort: 842,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chela One",
      displayName: null,
      category: "Display",
      size: 35744,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 6,
          lineHeight: 1.177
        }
      },
      axes: [],
      designers: ["Miguel Hernandez"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-05",
      popularity: 887,
      trending: 28,
      defaultSort: 296,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chelsea Market",
      displayName: null,
      category: "Display",
      size: 82147,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.2724609375
        }
      },
      axes: [],
      designers: ["Tart Workshop"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-04",
      popularity: 764,
      trending: 1471,
      defaultSort: 765,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chenla",
      displayName: null,
      category: "Display",
      size: 293316,
      subsets: ["menu", "khmer"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.83935546875
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-02",
      popularity: 1372,
      trending: 800,
      defaultSort: 1314,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cherish",
      displayName: null,
      category: "Handwriting",
      size: 202240,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.17
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-08-13",
      popularity: 1535,
      trending: 1281,
      defaultSort: 1421,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cherry Bomb One",
      displayName: null,
      category: "Display",
      size: 214940,
      subsets: ["menu", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Satsuyako"],
      lastModified: "2023-05-23",
      dateAdded: "2023-05-23",
      popularity: 1392,
      trending: 1768,
      defaultSort: 223,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Cherry Cream Soda",
      displayName: null,
      category: "Display",
      size: 50256,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.251953125
        }
      },
      axes: [],
      designers: ["Font Diner"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 963,
      trending: 1557,
      defaultSort: 948,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cherry Swash",
      displayName: null,
      category: "Display",
      size: 14596,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.326
        },
        "700": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.326
        }
      },
      axes: [],
      designers: ["Nataliya Kasatkina"],
      lastModified: "2022-04-21",
      dateAdded: "2012-10-24",
      popularity: 966,
      trending: 1402,
      defaultSort: 951,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chewy",
      displayName: null,
      category: "Display",
      size: 41248,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.306640625
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 438,
      trending: 1665,
      defaultSort: 460,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chicle",
      displayName: null,
      category: "Display",
      size: 21180,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.209
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-30",
      popularity: 1044,
      trending: 459,
      defaultSort: 1029,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chilanka",
      displayName: null,
      category: "Handwriting",
      size: 352832,
      subsets: ["menu", "latin", "latin-ext", "malayalam"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.0986328125
        }
      },
      axes: [],
      designers: ["SMC", "Santhosh Thottingal"],
      lastModified: "2023-05-02",
      dateAdded: "2016-05-10",
      popularity: 1217,
      trending: 257,
      defaultSort: 1178,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chivo",
      displayName: null,
      category: "Sans Serif",
      size: 169244,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.19
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.19
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.19
        },
        "900i": {
          thickness: 8,
          slant: 3,
          width: 7,
          lineHeight: 1.19
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2022-11-17",
      dateAdded: "2011-12-07",
      popularity: 212,
      trending: 661,
      defaultSort: 216,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chivo Mono",
      displayName: null,
      category: "Monospace",
      size: 127924,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2022-11-02",
      popularity: 787,
      trending: 1384,
      defaultSort: 788,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Chokokutai",
      displayName: null,
      category: "Display",
      size: 165580,
      subsets: ["menu", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Font Zone 108"],
      lastModified: "2023-05-23",
      dateAdded: "2023-05-23",
      popularity: 1453,
      trending: 1784,
      defaultSort: 224,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Chonburi",
      displayName: null,
      category: "Display",
      size: 72060,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2015-07-08",
      popularity: 513,
      trending: 177,
      defaultSort: 529,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cinzel",
      displayName: null,
      category: "Serif",
      size: 125468,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.348
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.348
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.348
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.348
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.348
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.348
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Natanael Gama"],
      lastModified: "2023-03-21",
      dateAdded: "2012-10-24",
      popularity: 158,
      trending: 781,
      defaultSort: 152,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cinzel Decorative",
      displayName: null,
      category: "Display",
      size: 61800,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 8,
          lineHeight: 1.348
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.348
        },
        "900": {
          thickness: 6,
          slant: 1,
          width: 9,
          lineHeight: 1.348
        }
      },
      axes: [],
      designers: ["Natanael Gama"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-24",
      popularity: 477,
      trending: 1261,
      defaultSort: 496,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Clicker Script",
      displayName: null,
      category: "Handwriting",
      size: 35215,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 2,
          width: 5,
          lineHeight: 1.32080078125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-11",
      popularity: 858,
      trending: 1232,
      defaultSort: 857,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Climate Crisis",
      displayName: null,
      category: "Display",
      size: 168852,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        }
      },
      axes: [
        {
          tag: "YEAR",
          min: 1979,
          max: 2050,
          defaultValue: 1979
        }
      ],
      designers: ["Daniel Coull", "Eino Korkala"],
      lastModified: "2023-05-31",
      dateAdded: "2022-09-30",
      popularity: 1430,
      trending: 1437,
      defaultSort: 1193,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Coda",
      displayName: null,
      category: "Display",
      size: 88788,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.419921875
        },
        "800": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.419921875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-07",
      popularity: 482,
      trending: 1446,
      defaultSort: 501,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Codystar",
      displayName: null,
      category: "Display",
      size: 55871,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 1,
          slant: 9,
          width: 8,
          lineHeight: 1.1796875
        },
        "400": {
          thickness: 1,
          slant: 1,
          width: 8,
          lineHeight: 1.1796875
        }
      },
      axes: [],
      designers: ["Neapolitan"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 852,
      trending: 256,
      defaultSort: 851,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Coiny",
      displayName: null,
      category: "Display",
      size: 156520,
      subsets: ["menu", "latin", "latin-ext", "tamil", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        }
      },
      axes: [],
      designers: ["Marcelo Magalh\xE3es"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-20",
      popularity: 917,
      trending: 1199,
      defaultSort: 910,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Combo",
      displayName: null,
      category: "Display",
      size: 49028,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.176
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-23",
      popularity: 1269,
      trending: 375,
      defaultSort: 1226,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Comfortaa",
      displayName: null,
      category: "Display",
      size: 201756,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.115
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.115
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.115
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.115
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.115
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Johan Aakerlund"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-10",
      popularity: 94,
      trending: 1522,
      defaultSort: 89,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Comforter",
      displayName: null,
      category: "Handwriting",
      size: 279684,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.41
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-28",
      popularity: 1084,
      trending: 1815,
      defaultSort: 1067,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Comforter Brush",
      displayName: null,
      category: "Handwriting",
      size: 807248,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.41
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-16",
      popularity: 982,
      trending: 1456,
      defaultSort: 964,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Comic Neue",
      displayName: null,
      category: "Handwriting",
      size: 55536,
      subsets: ["menu", "latin"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Craig Rozynski", "Hrant Papazian"],
      lastModified: "2022-09-21",
      dateAdded: "2020-03-12",
      popularity: 359,
      trending: 647,
      defaultSort: 378,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Coming Soon",
      displayName: null,
      category: "Handwriting",
      size: 53256,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.53515625
        }
      },
      axes: [],
      designers: ["Open Window"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 564,
      trending: 1029,
      defaultSort: 582,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Comme",
      displayName: null,
      category: "Sans Serif",
      size: 91652,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams"],
      lastModified: "2023-04-27",
      dateAdded: "2023-04-26",
      popularity: 1477,
      trending: 1752,
      defaultSort: 331,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Commissioner",
      displayName: null,
      category: "Sans Serif",
      size: 742232,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.223
        }
      },
      axes: [
        {
          tag: "FLAR",
          min: 0,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "VOLM",
          min: 0,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "slnt",
          min: -12,
          max: 0,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Kostas Bartsokas"],
      lastModified: "2023-05-02",
      dateAdded: "2020-07-20",
      popularity: 236,
      trending: 666,
      defaultSort: 248,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Concert One",
      displayName: null,
      category: "Display",
      size: 71072,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.17919921875
        }
      },
      axes: [],
      designers: ["Johan Kallas", "Mihkel Virkus"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 226,
      trending: 1345,
      defaultSort: 233,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Condiment",
      displayName: null,
      category: "Handwriting",
      size: 23826,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 9,
          width: 6,
          lineHeight: 1.523
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-25",
      popularity: 1140,
      trending: 1583,
      defaultSort: 1115,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Content",
      displayName: null,
      category: "Display",
      size: 64158,
      subsets: ["menu", "khmer"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.83935546875
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.83935546875
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-02",
      popularity: 1139,
      trending: 1182,
      defaultSort: 1114,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Contrail One",
      displayName: null,
      category: "Display",
      size: 16400,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 3,
          width: 6,
          lineHeight: 1.251953125
        }
      },
      axes: [],
      designers: ["Riccardo De Franceschi"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-26",
      popularity: 545,
      trending: 1325,
      defaultSort: 563,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Convergence",
      displayName: null,
      category: "Sans Serif",
      size: 30220,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.173
        }
      },
      axes: [],
      designers: ["Nicol\xE1s Silva", "John Vargas Beltr\xE1n"],
      lastModified: "2022-04-21",
      dateAdded: "2011-11-09",
      popularity: 768,
      trending: 1117,
      defaultSort: 770,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cookie",
      displayName: null,
      category: "Handwriting",
      size: 21573,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.109
        }
      },
      axes: [],
      designers: ["Ania Kruk"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 239,
      trending: 1644,
      defaultSort: 251,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Copse",
      displayName: null,
      category: "Serif",
      size: 35077,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.23583984375
        }
      },
      axes: [],
      designers: ["Dan Rhatigan"],
      lastModified: "2022-04-21",
      dateAdded: "2010-12-15",
      popularity: 695,
      trending: 1219,
      defaultSort: 701,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Corben",
      displayName: null,
      category: "Display",
      size: 80580,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.85302734375
        },
        "700": {
          thickness: 9,
          slant: 1,
          width: 9,
          lineHeight: 1.85302734375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-20",
      popularity: 480,
      trending: 487,
      defaultSort: 499,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Corinthia",
      displayName: null,
      category: "Handwriting",
      size: 218854,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-08-26",
      popularity: 953,
      trending: 1052,
      defaultSort: 939,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cormorant",
      displayName: null,
      category: "Serif",
      size: 461494,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Christian Thalmann"],
      lastModified: "2023-03-21",
      dateAdded: "2016-06-15",
      popularity: 178,
      trending: 1217,
      defaultSort: 179,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cormorant Garamond",
      displayName: null,
      category: "Serif",
      size: 631164,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Christian Thalmann"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 105,
      trending: 1081,
      defaultSort: 100,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cormorant Infant",
      displayName: null,
      category: "Serif",
      size: 622257,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Christian Thalmann"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 523,
      trending: 914,
      defaultSort: 540,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cormorant SC",
      displayName: null,
      category: "Serif",
      size: 763366,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Christian Thalmann"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 620,
      trending: 892,
      defaultSort: 632,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cormorant Unicase",
      displayName: null,
      category: "Serif",
      size: 763615,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Christian Thalmann"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 890,
      trending: 386,
      defaultSort: 883,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cormorant Upright",
      displayName: null,
      category: "Serif",
      size: 223316,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Christian Thalmann"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 588,
      trending: 455,
      defaultSort: 604,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Courgette",
      displayName: null,
      category: "Handwriting",
      size: 55174,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 6,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Karolina Lach"],
      lastModified: "2022-09-21",
      dateAdded: "2012-07-10",
      popularity: 160,
      trending: 406,
      defaultSort: 154,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Courier Prime",
      displayName: null,
      category: "Monospace",
      size: 76224,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.123046875
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.123046875
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.123046875
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.123046875
        }
      },
      axes: [],
      designers: ["Alan Dague-Greene"],
      lastModified: "2022-09-21",
      dateAdded: "2019-12-05",
      popularity: 333,
      trending: 530,
      defaultSort: 351,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cousine",
      displayName: null,
      category: "Monospace",
      size: 286881,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.1328125
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 8,
          lineHeight: 1.1328125
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.1328125
        },
        "700i": {
          thickness: 7,
          slant: 4,
          width: 8,
          lineHeight: 1.1328125
        }
      },
      axes: [],
      designers: ["Steve Matteson"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-18",
      popularity: 326,
      trending: 1036,
      defaultSort: 345,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Coustard",
      displayName: null,
      category: "Serif",
      size: 80866,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.404296875
        },
        "900": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.404296875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-10",
      popularity: 541,
      trending: 837,
      defaultSort: 559,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Covered By Your Grace",
      displayName: null,
      category: "Handwriting",
      size: 29017,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.3466796875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-07",
      popularity: 430,
      trending: 853,
      defaultSort: 452,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Crafty Girls",
      displayName: null,
      category: "Handwriting",
      size: 75336,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 8,
          lineHeight: 1.4482421875
        }
      },
      axes: [],
      designers: ["Tart Workshop"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 949,
      trending: 1506,
      defaultSort: 936,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Creepster",
      displayName: null,
      category: "Display",
      size: 37836,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.1689453125
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 506,
      trending: 1762,
      defaultSort: 522,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Crete Round",
      displayName: null,
      category: "Serif",
      size: 24652,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.276
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.275
        }
      },
      axes: [],
      designers: ["TypeTogether"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 191,
      trending: 1038,
      defaultSort: 192,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Crimson Pro",
      displayName: null,
      category: "Serif",
      size: 249750,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.111328125
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2018-12-04",
      popularity: 258,
      trending: 1009,
      defaultSort: 270,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Crimson Text",
      displayName: null,
      category: "Serif",
      size: 111436,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2998046875
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.2998046875
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2998046875
        },
        "600i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.2998046875
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2998046875
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.2998046875
        }
      },
      axes: [],
      designers: ["Sebastian Kosch"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-26",
      popularity: 86,
      trending: 1039,
      defaultSort: 83,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Croissant One",
      displayName: null,
      category: "Display",
      size: 22909,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.415
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-12",
      popularity: 1233,
      trending: 790,
      defaultSort: 1195,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Crushed",
      displayName: null,
      category: "Display",
      size: 57792,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.1494140625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 1110,
      trending: 764,
      defaultSort: 1090,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cuprum",
      displayName: null,
      category: "Sans Serif",
      size: 84342,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.155
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.155
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.155
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.155
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.155
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.155
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.155
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 6,
          lineHeight: 1.155
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Jovanny Lemonad"],
      lastModified: "2023-05-02",
      dateAdded: "2012-04-04",
      popularity: 254,
      trending: 1431,
      defaultSort: 267,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cute Font",
      displayName: null,
      category: "Display",
      size: 1027936,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["TypoDesign Lab. Inc"],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-23",
      popularity: 981,
      trending: 508,
      defaultSort: 963,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cutive",
      displayName: null,
      category: "Serif",
      size: 43435,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.09765625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 720,
      trending: 1494,
      defaultSort: 725,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Cutive Mono",
      displayName: null,
      category: "Monospace",
      size: 78984,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.10107421875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2012-10-26",
      popularity: 429,
      trending: 657,
      defaultSort: 451,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "DM Mono",
      displayName: null,
      category: "Monospace",
      size: 50926,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        }
      },
      axes: [],
      designers: ["Colophon Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2020-04-15",
      popularity: 419,
      trending: 1208,
      defaultSort: 442,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "DM Sans",
      displayName: null,
      category: "Sans Serif",
      size: 74182,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.302
        }
      },
      axes: [],
      designers: ["Colophon Foundry", "Jonny Pinhorn", "Indian Type Foundry"],
      lastModified: "2023-06-22",
      dateAdded: "2019-06-11",
      popularity: 42,
      trending: 632,
      defaultSort: 41,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "DM Serif Display",
      displayName: null,
      category: "Serif",
      size: 73894,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        }
      },
      axes: [],
      designers: ["Colophon Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2019-06-11",
      popularity: 153,
      trending: 1167,
      defaultSort: 147,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "DM Serif Text",
      displayName: null,
      category: "Serif",
      size: 74766,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        }
      },
      axes: [],
      designers: ["Colophon Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2019-06-11",
      popularity: 284,
      trending: 1047,
      defaultSort: 298,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Damion",
      displayName: null,
      category: "Handwriting",
      size: 30578,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 8,
          width: 6,
          lineHeight: 1.3740234375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-27",
      popularity: 374,
      trending: 1358,
      defaultSort: 394,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dancing Script",
      displayName: null,
      category: "Handwriting",
      size: 133636,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 7,
          width: 6,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: 4,
          slant: 7,
          width: 6,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-18",
      popularity: 71,
      trending: 836,
      defaultSort: 67,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dangrek",
      displayName: null,
      category: "Display",
      size: 62464,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-21",
      dateAdded: "2011-03-02",
      popularity: 1288,
      trending: 1604,
      defaultSort: 1245,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Darker Grotesque",
      displayName: null,
      category: "Sans Serif",
      size: 91516,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Gabriel Lam", "Vi\u1EC7tAnh Nguy\u1EC5n"],
      lastModified: "2023-05-31",
      dateAdded: "2019-06-19",
      popularity: 539,
      trending: 1711,
      defaultSort: 557,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Darumadrop One",
      displayName: null,
      category: "Display",
      size: 359120,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Maniackers Design"],
      lastModified: "2023-05-02",
      dateAdded: "2023-04-26",
      popularity: 1433,
      trending: 1423,
      defaultSort: 376,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "David Libre",
      displayName: null,
      category: "Serif",
      size: 112136,
      subsets: ["menu", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.96533203125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.96533203125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.96533203125
        }
      },
      axes: [],
      designers: ["Monotype Imaging Inc.", "SIL International", "Meir Sadan"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 613,
      trending: 1701,
      defaultSort: 626,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hebr",
      primaryLanguage: ""
    },
    {
      family: "Dawning of a New Day",
      displayName: null,
      category: "Handwriting",
      size: 30075,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 5,
          width: 6,
          lineHeight: 1.6123046875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-14",
      popularity: 658,
      trending: 1486,
      defaultSort: 665,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Days One",
      displayName: null,
      category: "Sans Serif",
      size: 30757,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.27294921875
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-17",
      popularity: 417,
      trending: 1443,
      defaultSort: 439,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dekko",
      displayName: null,
      category: "Handwriting",
      size: 135576,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 3,
          lineHeight: 1.63232421875
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-28",
      popularity: 1080,
      trending: 1739,
      defaultSort: 1063,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dela Gothic One",
      displayName: null,
      category: "Display",
      size: 2508848,
      subsets: ["menu", "cyrillic", "greek", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["artakana"],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-13",
      popularity: 710,
      trending: 428,
      defaultSort: 715,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Delicious Handrawn",
      displayName: null,
      category: "Handwriting",
      size: 74692,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Agung Rohmat"],
      lastModified: "2023-04-27",
      dateAdded: "2023-01-05",
      popularity: 919,
      trending: 80,
      defaultSort: 899,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Delius",
      displayName: null,
      category: "Handwriting",
      size: 37237,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.256
        }
      },
      axes: [],
      designers: ["Natalia Raices"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-27",
      popularity: 607,
      trending: 1572,
      defaultSort: 622,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Delius Swash Caps",
      displayName: null,
      category: "Handwriting",
      size: 30652,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.256
        }
      },
      axes: [],
      designers: ["Natalia Raices"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-03",
      popularity: 879,
      trending: 260,
      defaultSort: 875,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Delius Unicase",
      displayName: null,
      category: "Handwriting",
      size: 16510,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.252
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 9,
          lineHeight: 1.283
        }
      },
      axes: [],
      designers: ["Natalia Raices"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 934,
      trending: 1144,
      defaultSort: 923,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Della Respira",
      displayName: null,
      category: "Serif",
      size: 27795,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.36865234375
        }
      },
      axes: [],
      designers: ["Nathan Willis"],
      lastModified: "2022-09-21",
      dateAdded: "2012-04-04",
      popularity: 690,
      trending: 1140,
      defaultSort: 696,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Denk One",
      displayName: null,
      category: "Sans Serif",
      size: 304360,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2023-04-04",
      dateAdded: "2012-12-13",
      popularity: 1012,
      trending: 1364,
      defaultSort: 993,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Devonshire",
      displayName: null,
      category: "Handwriting",
      size: 30667,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 3,
          width: 5,
          lineHeight: 1.414
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-16",
      popularity: 1262,
      trending: 1245,
      defaultSort: 1221,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dhurjati",
      displayName: null,
      category: "Sans Serif",
      size: 112310,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.8505747126436782
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-04-21",
      dateAdded: "2014-12-10",
      popularity: 1377,
      trending: 362,
      defaultSort: 1317,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Didact Gothic",
      displayName: null,
      category: "Sans Serif",
      size: 194200,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.311
        }
      },
      axes: [],
      designers: ["Daniel Johnson", "Cyreal"],
      lastModified: "2023-05-02",
      dateAdded: "2011-05-04",
      popularity: 147,
      trending: 1146,
      defaultSort: 140,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Diphylleia",
      displayName: null,
      category: "Serif",
      size: 1947768,
      subsets: ["menu", "korean", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Minha Hyung", "JAMO"],
      lastModified: "2023-06-07",
      dateAdded: "2023-06-05",
      popularity: 1422,
      trending: 1819,
      defaultSort: 161,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Kore",
      primaryLanguage: ""
    },
    {
      family: "Diplomata",
      displayName: null,
      category: "Display",
      size: 89556,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 10,
          lineHeight: 1.217
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-05-02",
      dateAdded: "2012-01-25",
      popularity: 1168,
      trending: 1230,
      defaultSort: 1137,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Diplomata SC",
      displayName: null,
      category: "Display",
      size: 87544,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 10,
          lineHeight: 1.217
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-05-02",
      dateAdded: "2012-01-25",
      popularity: 1283,
      trending: 865,
      defaultSort: 1240,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Do Hyeon",
      displayName: null,
      category: "Sans Serif",
      size: 864520,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Woowahan Brothers"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-24",
      popularity: 521,
      trending: 1383,
      defaultSort: 538,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dokdo",
      displayName: null,
      category: "Handwriting",
      size: 2150860,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["FONTRIX"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-23",
      popularity: 780,
      trending: 538,
      defaultSort: 781,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Domine",
      displayName: null,
      category: "Serif",
      size: 101904,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.14
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.14
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.14
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.14
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-30",
      popularity: 130,
      trending: 1021,
      defaultSort: 124,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Donegal One",
      displayName: null,
      category: "Serif",
      size: 34745,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Gary Lonergan"],
      lastModified: "2023-05-02",
      dateAdded: "2012-12-13",
      popularity: 1064,
      trending: 405,
      defaultSort: 1048,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dongle",
      displayName: null,
      category: "Sans Serif",
      size: 4441398,
      subsets: ["menu", "korean", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yanghee Ryu"],
      lastModified: "2023-05-02",
      dateAdded: "2021-06-14",
      popularity: 954,
      trending: 1764,
      defaultSort: 940,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Doppio One",
      displayName: null,
      category: "Sans Serif",
      size: 31619,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Szymon Celej"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-22",
      popularity: 832,
      trending: 1119,
      defaultSort: 834,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dorsa",
      displayName: null,
      category: "Sans Serif",
      size: 10949,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 1,
          lineHeight: 1.057
        }
      },
      axes: [],
      designers: ["Santiago Orozco"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-31",
      popularity: 1020,
      trending: 169,
      defaultSort: 1001,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dosis",
      displayName: null,
      category: "Sans Serif",
      size: 117280,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 6,
          lineHeight: 1.264
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.264
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.264
        },
        "500": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.264
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.264
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.264
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.264
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-20",
      popularity: 60,
      trending: 746,
      defaultSort: 57,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "DotGothic16",
      displayName: null,
      category: "Sans Serif",
      size: 2069236,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Fontworks Inc."],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-15",
      popularity: 798,
      trending: 1053,
      defaultSort: 800,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dr Sugiyama",
      displayName: null,
      category: "Handwriting",
      size: 21575,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.459
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-30",
      popularity: 1235,
      trending: 332,
      defaultSort: 1196,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Duru Sans",
      displayName: null,
      category: "Sans Serif",
      size: 21388,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Onur Yaz\u0131c\u0131gil"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 770,
      trending: 577,
      defaultSort: 772,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "DynaPuff",
      displayName: null,
      category: "Display",
      size: 212600,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Toshi Omagari", "Jennifer Daniel"],
      lastModified: "2023-05-02",
      dateAdded: "2022-05-18",
      popularity: 1228,
      trending: 779,
      defaultSort: 1189,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Dynalight",
      displayName: null,
      category: "Display",
      size: 28233,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 7,
          width: 5,
          lineHeight: 1.21337890625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 927,
      trending: 1235,
      defaultSort: 916,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "EB Garamond",
      displayName: null,
      category: "Serif",
      size: 906308,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.305
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.305
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Georg Duffner", "Octavio Pardo"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 68,
      trending: 1238,
      defaultSort: 64,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Eagle Lake",
      displayName: null,
      category: "Handwriting",
      size: 46135,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.63330078125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-07-11",
      popularity: 1170,
      trending: 1258,
      defaultSort: 1139,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "East Sea Dokdo",
      displayName: null,
      category: "Handwriting",
      size: 3178684,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["YoonDesign Inc"],
      lastModified: "2022-09-27",
      dateAdded: "2018-03-12",
      popularity: 1034,
      trending: 1156,
      defaultSort: 1021,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Eater",
      displayName: null,
      category: "Display",
      size: 56242,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.86376953125
        }
      },
      axes: [],
      designers: ["Typomondo"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 830,
      trending: 642,
      defaultSort: 832,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Economica",
      displayName: null,
      category: "Sans Serif",
      size: 15255,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.149
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 5,
          lineHeight: 1.149
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.149
        },
        "700i": {
          thickness: 5,
          slant: 4,
          width: 5,
          lineHeight: 1.149
        }
      },
      axes: [],
      designers: ["Vicente Lam\xF3naca"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 358,
      trending: 1147,
      defaultSort: 375,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Eczar",
      displayName: null,
      category: "Serif",
      size: 407304,
      subsets: ["menu", "devanagari", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 3,
          lineHeight: 1.777
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 3,
          lineHeight: 1.777
        },
        "600": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 1.777
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 1.777
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 3,
          lineHeight: 1.777
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Rosetta", "Vaibhav Singh"],
      lastModified: "2023-05-02",
      dateAdded: "2015-06-03",
      popularity: 363,
      trending: 1737,
      defaultSort: 383,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Edu NSW ACT Foundation",
      displayName: null,
      category: "Handwriting",
      size: 55116,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tina Anderson", "Corey Anderson"],
      lastModified: "2023-01-06",
      dateAdded: "2022-06-09",
      popularity: 1407,
      trending: 1689,
      defaultSort: 1346,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Edu QLD Beginner",
      displayName: null,
      category: "Handwriting",
      size: 46888,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tina Anderson", "Corey Anderson"],
      lastModified: "2023-03-09",
      dateAdded: "2022-06-21",
      popularity: 1485,
      trending: 232,
      defaultSort: 1355,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Edu SA Beginner",
      displayName: null,
      category: "Handwriting",
      size: 33724,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tina Anderson", "Corey Anderson"],
      lastModified: "2023-03-09",
      dateAdded: "2022-06-09",
      popularity: 1474,
      trending: 1460,
      defaultSort: 1363,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Edu TAS Beginner",
      displayName: null,
      category: "Handwriting",
      size: 34068,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tina Anderson", "Corey Anderson"],
      lastModified: "2023-03-09",
      dateAdded: "2022-06-09",
      popularity: 1390,
      trending: 776,
      defaultSort: 1328,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Edu VIC WA NT Beginner",
      displayName: null,
      category: "Handwriting",
      size: 34552,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tina Anderson", "Corey Anderson"],
      lastModified: "2023-03-09",
      dateAdded: "2022-06-09",
      popularity: 1457,
      trending: 888,
      defaultSort: 1362,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "El Messiri",
      displayName: null,
      category: "Sans Serif",
      size: 138664,
      subsets: ["menu", "arabic", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.563
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.563
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.563
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.563
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Mohamed Gaber", "Jovanny Lemonad"],
      lastModified: "2023-03-21",
      dateAdded: "2016-05-31",
      popularity: 211,
      trending: 1121,
      defaultSort: 214,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Electrolize",
      displayName: null,
      category: "Sans Serif",
      size: 24536,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.186
        }
      },
      axes: [],
      designers: ["Gaslight"],
      lastModified: "2022-04-21",
      dateAdded: "2011-12-07",
      popularity: 352,
      trending: 446,
      defaultSort: 369,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Elsie",
      displayName: null,
      category: "Display",
      size: 40576,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.152
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.152
        }
      },
      axes: [],
      designers: ["Alejandro Inler"],
      lastModified: "2023-05-02",
      dateAdded: "2012-12-13",
      popularity: 796,
      trending: 640,
      defaultSort: 798,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Elsie Swash Caps",
      displayName: null,
      category: "Display",
      size: 38568,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.152
        },
        "900": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.152
        }
      },
      axes: [],
      designers: ["Alejandro Inler"],
      lastModified: "2022-09-21",
      dateAdded: "2012-12-13",
      popularity: 1229,
      trending: 1611,
      defaultSort: 1190,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Emblema One",
      displayName: null,
      category: "Display",
      size: 28852,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 3,
          width: 8,
          lineHeight: 1.193359375
        }
      },
      axes: [],
      designers: ["Riccardo De Franceschi"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 1279,
      trending: 1092,
      defaultSort: 1236,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Emilys Candy",
      displayName: null,
      category: "Display",
      size: 114841,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.251953125
        }
      },
      axes: [],
      designers: ["Neapolitan"],
      lastModified: "2023-05-02",
      dateAdded: "2012-02-29",
      popularity: 819,
      trending: 1266,
      defaultSort: 821,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Encode Sans",
      displayName: null,
      category: "Sans Serif",
      size: 285792,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type", "Andres Torresi", "Jacques Le Bailly"],
      lastModified: "2023-03-21",
      dateAdded: "2017-02-08",
      popularity: 189,
      trending: 587,
      defaultSort: 190,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Encode Sans Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 167694,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type", "Andres Torresi", "Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2017-02-08",
      popularity: 262,
      trending: 135,
      defaultSort: 274,
      androidFragment: "name=Encode Sans&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Encode Sans Expanded",
      displayName: null,
      category: "Sans Serif",
      size: 167897,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type", "Andres Torresi", "Jacques Le Bailly"],
      lastModified: "2023-05-02",
      dateAdded: "2017-02-08",
      popularity: 726,
      trending: 738,
      defaultSort: 731,
      androidFragment: "name=Encode Sans&width=125.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Encode Sans SC",
      displayName: null,
      category: "Sans Serif",
      size: 217392,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type", "Andres Torresi", "Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2020-06-24",
      popularity: 1199,
      trending: 1705,
      defaultSort: 1165,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Encode Sans Semi Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 168269,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type", "Andres Torresi", "Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2017-02-08",
      popularity: 606,
      trending: 1095,
      defaultSort: 621,
      androidFragment: "name=Encode Sans&width=87.5",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Encode Sans Semi Expanded",
      displayName: null,
      category: "Sans Serif",
      size: 168725,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type", "Andres Torresi", "Jacques Le Bailly"],
      lastModified: "2023-05-02",
      dateAdded: "2017-02-08",
      popularity: 935,
      trending: 1658,
      defaultSort: 924,
      androidFragment: "name=Encode Sans&width=112.5",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Engagement",
      displayName: null,
      category: "Handwriting",
      size: 39511,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 2,
          width: 1,
          lineHeight: 1.23388671875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 1076,
      trending: 429,
      defaultSort: 1060,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Englebert",
      displayName: null,
      category: "Sans Serif",
      size: 30984,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 0.61767578125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-02",
      popularity: 1215,
      trending: 1477,
      defaultSort: 1177,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Enriqueta",
      displayName: null,
      category: "Serif",
      size: 74400,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.338
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.338
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.338
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.338
        }
      },
      axes: [],
      designers: ["FontFuror"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 558,
      trending: 1663,
      defaultSort: 576,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ephesis",
      displayName: null,
      category: "Handwriting",
      size: 142188,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-08-06",
      popularity: 906,
      trending: 462,
      defaultSort: 897,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Epilogue",
      displayName: null,
      category: "Sans Serif",
      size: 206150,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.025
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck", "ETC"],
      lastModified: "2023-03-21",
      dateAdded: "2020-06-26",
      popularity: 366,
      trending: 1577,
      defaultSort: 386,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Erica One",
      displayName: null,
      category: "Display",
      size: 26244,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 10,
          slant: 1,
          width: 8,
          lineHeight: 1.492
        }
      },
      axes: [],
      designers: ["Miguel Hernandez"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 1287,
      trending: 1742,
      defaultSort: 1244,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Esteban",
      displayName: null,
      category: "Serif",
      size: 23463,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.274
        }
      },
      axes: [],
      designers: ["Ang\xE9lica D\xEDaz"],
      lastModified: "2023-05-02",
      dateAdded: "2012-01-11",
      popularity: 730,
      trending: 1661,
      defaultSort: 735,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Estonia",
      displayName: null,
      category: "Handwriting",
      size: 1470272,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-08-26",
      popularity: 1472,
      trending: 46,
      defaultSort: 679,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Euphoria Script",
      displayName: null,
      category: "Handwriting",
      size: 20795,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 4,
          width: 5,
          lineHeight: 1.1648
        }
      },
      axes: [],
      designers: ["Sabrina Mariela Lopez"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-08",
      popularity: 844,
      trending: 1438,
      defaultSort: 844,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ewert",
      displayName: null,
      category: "Display",
      size: 70752,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 3,
          width: 9,
          lineHeight: 1.243
        }
      },
      axes: [],
      designers: ["Johan Kallas", "Mihkel Virkus"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-08",
      popularity: 1265,
      trending: 801,
      defaultSort: 1224,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Exo",
      displayName: null,
      category: "Sans Serif",
      size: 178500,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "100i": {
          thickness: 1,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        },
        "200": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "200i": {
          thickness: 3,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "300i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "500i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "600i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.329
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "800i": {
          thickness: 7,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.329
        },
        "900i": {
          thickness: 8,
          slant: 4,
          width: 7,
          lineHeight: 1.329
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Natanael Gama", "Robin Mientjes"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-08",
      popularity: 149,
      trending: 1068,
      defaultSort: 142,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Exo 2",
      displayName: null,
      category: "Sans Serif",
      size: 287194,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "100i": {
          thickness: 1,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "200": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "200i": {
          thickness: 3,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "300i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "500i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "600i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "700i": {
          thickness: 7,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "800i": {
          thickness: 8,
          slant: 4,
          width: 7,
          lineHeight: 1.2
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.2
        },
        "900i": {
          thickness: 8,
          slant: 4,
          width: 8,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Natanael Gama"],
      lastModified: "2022-09-21",
      dateAdded: "2013-12-04",
      popularity: 80,
      trending: 511,
      defaultSort: 76,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Expletus Sans",
      displayName: null,
      category: "Display",
      size: 39486,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.339
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.339
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.339
        },
        "500i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.339
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.339
        },
        "600i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.339
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.339
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.339
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Designtown"],
      lastModified: "2023-01-06",
      dateAdded: "2011-05-04",
      popularity: 797,
      trending: 1216,
      defaultSort: 799,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Explora",
      displayName: null,
      category: "Handwriting",
      size: 164680,
      subsets: ["menu", "cherokee", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-08-10",
      popularity: 1528,
      trending: 1418,
      defaultSort: 1418,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fahkwang",
      displayName: null,
      category: "Sans Serif",
      size: 89621,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 660,
      trending: 1569,
      defaultSort: 667,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Familjen Grotesk",
      displayName: null,
      category: "Sans Serif",
      size: 92160,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Familjen STHLM AB"],
      lastModified: "2023-03-21",
      dateAdded: "2022-03-02",
      popularity: 783,
      trending: 1803,
      defaultSort: 784,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fanwood Text",
      displayName: null,
      category: "Serif",
      size: 63489,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.31103515625
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.31103515625
        }
      },
      axes: [],
      designers: ["Barry Schwartz"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-31",
      popularity: 749,
      trending: 1203,
      defaultSort: 751,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Farro",
      displayName: null,
      category: "Sans Serif",
      size: 68443,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Grayscale"],
      lastModified: "2022-09-21",
      dateAdded: "2019-07-16",
      popularity: 711,
      trending: 175,
      defaultSort: 716,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Farsan",
      displayName: null,
      category: "Display",
      size: 243932,
      subsets: ["menu", "gujarati", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 3,
          width: 3,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Pooja Saxena"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-20",
      popularity: 1014,
      trending: 728,
      defaultSort: 995,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fascinate",
      displayName: null,
      category: "Display",
      size: 25808,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.326171875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 1136,
      trending: 390,
      defaultSort: 1111,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fascinate Inline",
      displayName: null,
      category: "Display",
      size: 29942,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.326171875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 1043,
      trending: 242,
      defaultSort: 1028,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Faster One",
      displayName: null,
      category: "Display",
      size: 94044,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 4,
          width: 8,
          lineHeight: 1.063
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2012-10-26",
      popularity: 875,
      trending: 1296,
      defaultSort: 872,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fasthand",
      displayName: null,
      category: "Display",
      size: 213852,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-21",
      dateAdded: "2012-05-24",
      popularity: 705,
      trending: 10,
      defaultSort: 38,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fauna One",
      displayName: null,
      category: "Serif",
      size: 58804,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.23
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2013-06-05",
      popularity: 624,
      trending: 1236,
      defaultSort: 635,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Faustina",
      displayName: null,
      category: "Serif",
      size: 119606,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-03-21",
      dateAdded: "2017-07-31",
      popularity: 302,
      trending: 1806,
      defaultSort: 317,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Federant",
      displayName: null,
      category: "Display",
      size: 45588,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.226
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-21",
      dateAdded: "2011-10-05",
      popularity: 1324,
      trending: 180,
      defaultSort: 1274,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Federo",
      displayName: null,
      category: "Sans Serif",
      size: 69453,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.17822265625
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-21",
      dateAdded: "2011-07-27",
      popularity: 767,
      trending: 1441,
      defaultSort: 768,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Felipa",
      displayName: null,
      category: "Handwriting",
      size: 21605,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 4,
          width: 6,
          lineHeight: 1.285
        }
      },
      axes: [],
      designers: ["Fontstage"],
      lastModified: "2023-05-02",
      dateAdded: "2012-02-08",
      popularity: 1102,
      trending: 351,
      defaultSort: 1083,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fenix",
      displayName: null,
      category: "Serif",
      size: 17214,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.117
        }
      },
      axes: [],
      designers: ["Fernando D\xEDaz"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-24",
      popularity: 1149,
      trending: 97,
      defaultSort: 1122,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Festive",
      displayName: null,
      category: "Handwriting",
      size: 1326792,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.69
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-04-23",
      popularity: 1243,
      trending: 204,
      defaultSort: 1203,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Figtree",
      displayName: null,
      category: "Sans Serif",
      size: 61608,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Erik Kennedy"],
      lastModified: "2023-03-21",
      dateAdded: "2022-07-21",
      popularity: 198,
      trending: 1659,
      defaultSort: 200,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Finger Paint",
      displayName: null,
      category: "Display",
      size: 107440,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.474
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-30",
      popularity: 855,
      trending: 1454,
      defaultSort: 854,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Finlandica",
      displayName: null,
      category: "Sans Serif",
      size: 147950,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Helsinki Type Studio", "Niklas Ekholm", "Juho Hiilivirta", "Jaakko Suomalainen"],
      lastModified: "2023-03-09",
      dateAdded: "2022-05-13",
      popularity: 1276,
      trending: 636,
      defaultSort: 1233,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fira Code",
      displayName: null,
      category: "Monospace",
      size: 260364,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.312
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.312
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.312
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.312
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.312
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["The Mozilla Foundation", "Telefonica S.A.", "Nikita Prokopov"],
      lastModified: "2022-09-21",
      dateAdded: "2019-03-24",
      popularity: 442,
      trending: 214,
      defaultSort: 464,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fira Mono",
      displayName: null,
      category: "Monospace",
      size: 184837,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2014-06-18",
      popularity: 346,
      trending: 547,
      defaultSort: 364,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fira Sans",
      displayName: null,
      category: "Sans Serif",
      size: 480177,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: 4,
          slant: 3,
          width: 7,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2023-05-02",
      dateAdded: "2014-06-18",
      popularity: 35,
      trending: 1025,
      defaultSort: 36,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fira Sans Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 480660,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-07",
      popularity: 111,
      trending: 1075,
      defaultSort: 107,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fira Sans Extra Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 479881,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-07",
      popularity: 240,
      trending: 206,
      defaultSort: 253,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fjalla One",
      displayName: null,
      category: "Sans Serif",
      size: 209052,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.2568359375
        }
      },
      axes: [],
      designers: ["Sorkin Type", "Irina Smirnova"],
      lastModified: "2023-04-04",
      dateAdded: "2012-10-27",
      popularity: 90,
      trending: 789,
      defaultSort: 86,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fjord One",
      displayName: null,
      category: "Serif",
      size: 26548,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Viktoriya Grabowska"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-02",
      popularity: 508,
      trending: 490,
      defaultSort: 524,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Flamenco",
      displayName: null,
      category: "Display",
      size: 35588,
      subsets: ["menu", "latin"],
      fonts: {
        "300": {
          thickness: 1,
          slant: 1,
          width: 6,
          lineHeight: 1.032
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.031
        }
      },
      axes: [],
      designers: ["LatinoType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 727,
      trending: 444,
      defaultSort: 732,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Flavors",
      displayName: null,
      category: "Display",
      size: 184784,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.27734375
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1318,
      trending: 1414,
      defaultSort: 1269,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fleur De Leah",
      displayName: null,
      category: "Handwriting",
      size: 231608,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.37
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-02",
      popularity: 1419,
      trending: 471,
      defaultSort: 1352,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Flow Block",
      displayName: null,
      category: "Display",
      size: 38928,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Dan Ross"],
      lastModified: "2023-01-06",
      dateAdded: "2021-10-21",
      popularity: 1488,
      trending: 609,
      defaultSort: 1392,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Flow Circular",
      displayName: null,
      category: "Display",
      size: 45788,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Dan Ross"],
      lastModified: "2023-01-06",
      dateAdded: "2021-10-21",
      popularity: 913,
      trending: 61,
      defaultSort: 906,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Flow Rounded",
      displayName: null,
      category: "Display",
      size: 43800,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Dan Ross"],
      lastModified: "2023-01-06",
      dateAdded: "2021-10-21",
      popularity: 1551,
      trending: 698,
      defaultSort: 1429,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Foldit",
      displayName: null,
      category: "Display",
      size: 520484,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Sophia Tai"],
      lastModified: "2023-04-27",
      dateAdded: "2023-04-26",
      popularity: 1435,
      trending: 1704,
      defaultSort: 318,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV1"],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fondamento",
      displayName: null,
      category: "Handwriting",
      size: 44342,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.3837890625
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.3837890625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-16",
      popularity: 721,
      trending: 1515,
      defaultSort: 726,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fontdiner Swanky",
      displayName: null,
      category: "Display",
      size: 45524,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.5400390625
        }
      },
      axes: [],
      designers: ["Font Diner"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 1088,
      trending: 1755,
      defaultSort: 1071,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Forum",
      displayName: null,
      category: "Display",
      size: 131858,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.104
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-06",
      popularity: 364,
      trending: 126,
      defaultSort: 384,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fragment Mono",
      displayName: null,
      category: "Monospace",
      size: 126710,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Wei Huang", "URW Design Studio"],
      lastModified: "2022-11-09",
      dateAdded: "2022-10-23",
      popularity: 1125,
      trending: 1650,
      defaultSort: 1103,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Francois One",
      displayName: null,
      category: "Sans Serif",
      size: 79356,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.418
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2011-05-04",
      popularity: 227,
      trending: 1401,
      defaultSort: 234,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Frank Ruhl Libre",
      displayName: null,
      category: "Serif",
      size: 178108,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Yanek Iontef"],
      lastModified: "2023-06-22",
      dateAdded: "2016-06-20",
      popularity: 136,
      trending: 423,
      defaultSort: 130,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fraunces",
      displayName: null,
      category: "Serif",
      size: 387672,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.233
        }
      },
      axes: [
        {
          tag: "SOFT",
          min: 0,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "WONK",
          min: 0,
          max: 1,
          defaultValue: 0
        },
        {
          tag: "opsz",
          min: 9,
          max: 144,
          defaultValue: 14
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Undercase Type", "Phaedra Charles", "Flavia Zimbardi"],
      lastModified: "2023-05-02",
      dateAdded: "2020-07-23",
      popularity: 427,
      trending: 357,
      defaultSort: 450,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Freckle Face",
      displayName: null,
      category: "Display",
      size: 68140,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.22900390625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-26",
      popularity: 864,
      trending: 1312,
      defaultSort: 862,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fredericka the Great",
      displayName: null,
      category: "Display",
      size: 486016,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2255859375
        }
      },
      axes: [],
      designers: ["Tart Workshop"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 445,
      trending: 677,
      defaultSort: 467,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fredoka",
      displayName: null,
      category: "Sans Serif",
      size: 159184,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.21
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.21
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.21
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.21
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.21
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Milena Brand\xE3o", "Hafontia"],
      lastModified: "2023-04-04",
      dateAdded: "2021-12-15",
      popularity: 546,
      trending: 134,
      defaultSort: 564,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Freehand",
      displayName: null,
      category: "Display",
      size: 235540,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-21",
      dateAdded: "2011-03-02",
      popularity: 691,
      trending: 15,
      defaultSort: 82,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fresca",
      displayName: null,
      category: "Sans Serif",
      size: 18537,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.154
        }
      },
      axes: [],
      designers: ["Fontstage"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 898,
      trending: 1772,
      defaultSort: 889,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Frijole",
      displayName: null,
      category: "Display",
      size: 122166,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 9,
          lineHeight: 1.37890625
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 866,
      trending: 571,
      defaultSort: 864,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fruktur",
      displayName: null,
      category: "Display",
      size: 210982,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Viktoriya Grabowska", "Eben Sorkin"],
      lastModified: "2023-04-27",
      dateAdded: "2013-01-16",
      popularity: 1387,
      trending: 1329,
      defaultSort: 1327,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fugaz One",
      displayName: null,
      category: "Display",
      size: 16808,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 4,
          width: 8,
          lineHeight: 1.468
        }
      },
      axes: [],
      designers: ["LatinoType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 405,
      trending: 1435,
      defaultSort: 427,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fuggles",
      displayName: null,
      category: "Handwriting",
      size: 734252,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.201
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-04-29",
      popularity: 1362,
      trending: 1439,
      defaultSort: 1305,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Fuzzy Bubbles",
      displayName: null,
      category: "Handwriting",
      size: 144420,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-02",
      popularity: 1131,
      trending: 132,
      defaultSort: 1109,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "GFS Didot",
      displayName: null,
      category: "Serif",
      size: 79456,
      subsets: ["menu", "greek"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.249
        }
      },
      axes: [],
      designers: ["Greek Font Society"],
      lastModified: "2022-09-21",
      dateAdded: "2010-09-21",
      popularity: 469,
      trending: 656,
      defaultSort: 488,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "GFS Neohellenic",
      displayName: null,
      category: "Sans Serif",
      size: 152310,
      subsets: ["menu", "greek"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.142
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.143
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.157
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1.159
        }
      },
      axes: [],
      designers: ["Greek Font Society"],
      lastModified: "2022-09-21",
      dateAdded: "2010-09-21",
      popularity: 1334,
      trending: 1374,
      defaultSort: 1283,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gabriela",
      displayName: null,
      category: "Serif",
      size: 70984,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.281
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-05-02",
      dateAdded: "2013-03-06",
      popularity: 629,
      trending: 1145,
      defaultSort: 640,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gaegu",
      displayName: null,
      category: "Handwriting",
      size: 3113828,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["JIKJI SOFT"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-28",
      popularity: 920,
      trending: 1015,
      defaultSort: 911,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gafata",
      displayName: null,
      category: "Sans Serif",
      size: 14318,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.123
        }
      },
      axes: [],
      designers: ["Lautaro Hourcade"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 1007,
      trending: 1346,
      defaultSort: 986,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gajraj One",
      displayName: null,
      category: "Display",
      size: 149784,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.465
        }
      },
      axes: [],
      designers: ["Saurabh Sharma"],
      lastModified: "2023-04-27",
      dateAdded: "2023-01-22",
      popularity: 1515,
      trending: 496,
      defaultSort: 823,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "Galada",
      displayName: null,
      category: "Display",
      size: 187776,
      subsets: ["menu", "bengali", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 4,
          width: 4,
          lineHeight: 1.627
        }
      },
      axes: [],
      designers: ["Black Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-20",
      popularity: 845,
      trending: 1214,
      defaultSort: 845,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Galdeano",
      displayName: null,
      category: "Sans Serif",
      size: 14389,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.05
        }
      },
      axes: [],
      designers: ["Dario Manuel Muhafara"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 1238,
      trending: 1192,
      defaultSort: 1197,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Galindo",
      displayName: null,
      category: "Display",
      size: 33936,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.41455078125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-13",
      popularity: 1310,
      trending: 1562,
      defaultSort: 1262,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gamja Flower",
      displayName: null,
      category: "Handwriting",
      size: 12615444,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["YoonDesign Inc"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-23",
      popularity: 885,
      trending: 1058,
      defaultSort: 880,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gantari",
      displayName: null,
      category: "Sans Serif",
      size: 128108,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Lafontype"],
      lastModified: "2022-09-21",
      dateAdded: "2022-05-25",
      popularity: 912,
      trending: 1442,
      defaultSort: 904,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gasoek One",
      displayName: null,
      category: "Sans Serif",
      size: 1061372,
      subsets: ["menu", "korean", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Jiashuo Zhang", "JAMO"],
      lastModified: "2023-06-07",
      dateAdded: "2023-06-05",
      popularity: 1436,
      trending: 1820,
      defaultSort: 163,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Kore",
      primaryLanguage: ""
    },
    {
      family: "Gayathri",
      displayName: null,
      category: "Sans Serif",
      size: 163513,
      subsets: ["menu", "latin", "malayalam"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.220703125
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.220703125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.220703125
        }
      },
      axes: [],
      designers: ["SMC", "Binoy Dominic"],
      lastModified: "2022-09-21",
      dateAdded: "2019-06-10",
      popularity: 939,
      trending: 1231,
      defaultSort: 929,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gelasio",
      displayName: null,
      category: "Serif",
      size: 127403,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        }
      },
      axes: [],
      designers: ["Eben Sorkin"],
      lastModified: "2022-09-21",
      dateAdded: "2019-12-03",
      popularity: 238,
      trending: 1291,
      defaultSort: 250,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gemunu Libre",
      displayName: null,
      category: "Sans Serif",
      size: 256512,
      subsets: ["menu", "latin", "latin-ext", "sinhala"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.084
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.084
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.084
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.084
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.084
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.084
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.084
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Mooniak"],
      lastModified: "2023-03-21",
      dateAdded: "2017-05-29",
      popularity: 878,
      trending: 1420,
      defaultSort: 874,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Genos",
      displayName: null,
      category: "Sans Serif",
      size: 139784,
      subsets: ["menu", "cherokee", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Robert Leuschke"],
      lastModified: "2023-03-21",
      dateAdded: "2021-10-07",
      popularity: 1177,
      trending: 478,
      defaultSort: 1145,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gentium Book Plus",
      displayName: null,
      category: "Serif",
      size: 857030,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2022-09-21",
      dateAdded: "2022-05-18",
      popularity: 1427,
      trending: 1319,
      defaultSort: 1335,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gentium Plus",
      displayName: null,
      category: "Serif",
      size: 852956,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-04-27",
      dateAdded: "2022-05-13",
      popularity: 1225,
      trending: 160,
      defaultSort: 1186,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Geo",
      displayName: null,
      category: "Sans Serif",
      size: 16882,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.111328125
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.111328125
        }
      },
      axes: [],
      designers: ["Ben Weiner"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-30",
      popularity: 867,
      trending: 1173,
      defaultSort: 865,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Geologica",
      displayName: null,
      category: "Sans Serif",
      size: 348640,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "CRSV",
          min: 0,
          max: 1,
          defaultValue: 0
        },
        {
          tag: "SHRP",
          min: 0,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "slnt",
          min: -12,
          max: 0,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Monokrom", "Sindre Bremnes", "Frode Helland"],
      lastModified: "2023-05-31",
      dateAdded: "2023-05-29",
      popularity: 1089,
      trending: 1794,
      defaultSort: 118,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Georama",
      displayName: null,
      category: "Sans Serif",
      size: 449838,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 150,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Production Type"],
      lastModified: "2022-09-21",
      dateAdded: "2020-07-01",
      popularity: 610,
      trending: 1103,
      defaultSort: 624,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Geostar",
      displayName: null,
      category: "Display",
      size: 21536,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 9,
          lineHeight: 1.148
        }
      },
      axes: [],
      designers: ["Joe Prince"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-10",
      popularity: 1398,
      trending: 903,
      defaultSort: 1334,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Geostar Fill",
      displayName: null,
      category: "Display",
      size: 20292,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 9,
          lineHeight: 1.148
        }
      },
      axes: [],
      designers: ["Joe Prince"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-10",
      popularity: 1353,
      trending: 382,
      defaultSort: 1298,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Germania One",
      displayName: null,
      category: "Display",
      size: 15842,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.161
        }
      },
      axes: [],
      designers: ["John Vargas Beltr\xE1n"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 758,
      trending: 1062,
      defaultSort: 759,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gideon Roman",
      displayName: null,
      category: "Display",
      size: 109484,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-08-26",
      popularity: 1383,
      trending: 457,
      defaultSort: 1323,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gidugu",
      displayName: null,
      category: "Sans Serif",
      size: 164648,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.8540925266903914
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-09-21",
      dateAdded: "2014-12-10",
      popularity: 1239,
      trending: 172,
      defaultSort: 1198,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gilda Display",
      displayName: null,
      category: "Serif",
      size: 68020,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.177
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-02-16",
      dateAdded: "2012-10-31",
      popularity: 403,
      trending: 718,
      defaultSort: 425,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Girassol",
      displayName: null,
      category: "Display",
      size: 37644,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.194
        }
      },
      axes: [],
      designers: ["Liam Spradlin"],
      lastModified: "2023-05-02",
      dateAdded: "2019-12-05",
      popularity: 1054,
      trending: 79,
      defaultSort: 1038,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Give You Glory",
      displayName: null,
      category: "Handwriting",
      size: 26317,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.6064453125
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-13",
      popularity: 812,
      trending: 424,
      defaultSort: 813,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Glass Antiqua",
      displayName: null,
      category: "Display",
      size: 26654,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.035
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-22",
      popularity: 1253,
      trending: 675,
      defaultSort: 1211,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Glegoo",
      displayName: null,
      category: "Serif",
      size: 15296,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.793
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.793
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-25",
      popularity: 400,
      trending: 460,
      defaultSort: 422,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gloock",
      displayName: null,
      category: "Serif",
      size: 98096,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Duarte Pinto"],
      lastModified: "2023-05-02",
      dateAdded: "2023-01-05",
      popularity: 827,
      trending: 23,
      defaultSort: 197,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gloria Hallelujah",
      displayName: null,
      category: "Handwriting",
      size: 33223,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.982421875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-27",
      popularity: 224,
      trending: 1049,
      defaultSort: 231,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Glory",
      displayName: null,
      category: "Sans Serif",
      size: 88242,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.12
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Robert Leuschke"],
      lastModified: "2023-03-21",
      dateAdded: "2021-06-17",
      popularity: 759,
      trending: 879,
      defaultSort: 760,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gluten",
      displayName: null,
      category: "Display",
      size: 349672,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.8825
        }
      },
      axes: [
        {
          tag: "slnt",
          min: -13,
          max: 13,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck", "ETC"],
      lastModified: "2023-05-02",
      dateAdded: "2021-09-02",
      popularity: 1257,
      trending: 1749,
      defaultSort: 1216,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Goblin One",
      displayName: null,
      category: "Display",
      size: 18847,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 9,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-29",
      popularity: 789,
      trending: 1300,
      defaultSort: 790,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gochi Hand",
      displayName: null,
      category: "Handwriting",
      size: 37352,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.1787109375
        }
      },
      axes: [],
      designers: ["Huerta Tipogr\xE1fica"],
      lastModified: "2022-12-07",
      dateAdded: "2011-10-05",
      popularity: 413,
      trending: 197,
      defaultSort: 436,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Goldman",
      displayName: null,
      category: "Display",
      size: 77968,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Jaikishan Patel"],
      lastModified: "2023-05-02",
      dateAdded: "2020-07-21",
      popularity: 829,
      trending: 1165,
      defaultSort: 831,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Golos Text",
      displayName: null,
      category: "Sans Serif",
      size: 184292,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Alexandra Korolkova", "Vitaly Kuzmin"],
      lastModified: "2023-03-21",
      dateAdded: "2023-01-05",
      popularity: 557,
      trending: 36,
      defaultSort: 465,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gorditas",
      displayName: null,
      category: "Display",
      size: 62156,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.213
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.213
        }
      },
      axes: [],
      designers: ["Gustavo Dipre"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 1106,
      trending: 1320,
      defaultSort: 1087,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gothic A1",
      displayName: null,
      category: "Sans Serif",
      size: 2289616,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["HanYang I&C Co"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-24",
      popularity: 228,
      trending: 829,
      defaultSort: 235,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gotu",
      displayName: null,
      category: "Sans Serif",
      size: 697792,
      subsets: ["menu", "devanagari", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.66
        }
      },
      axes: [],
      designers: ["Ek Type"],
      lastModified: "2022-09-21",
      dateAdded: "2020-01-09",
      popularity: 1e3,
      trending: 138,
      defaultSort: 980,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Goudy Bookletter 1911",
      displayName: null,
      category: "Serif",
      size: 42809,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.3603515625
        }
      },
      axes: [],
      designers: ["Barry Schwartz"],
      lastModified: "2022-09-21",
      dateAdded: "2011-02-09",
      popularity: 669,
      trending: 611,
      defaultSort: 675,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gowun Batang",
      displayName: null,
      category: "Serif",
      size: 8306004,
      subsets: ["menu", "korean", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yanghee Ryu"],
      lastModified: "2022-09-27",
      dateAdded: "2021-06-10",
      popularity: 1051,
      trending: 237,
      defaultSort: 1036,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gowun Dodum",
      displayName: null,
      category: "Sans Serif",
      size: 7229088,
      subsets: ["menu", "korean", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yanghee Ryu"],
      lastModified: "2022-09-27",
      dateAdded: "2021-06-10",
      popularity: 1082,
      trending: 1606,
      defaultSort: 1065,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Graduate",
      displayName: null,
      category: "Display",
      size: 11170,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.139
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 560,
      trending: 1336,
      defaultSort: 578,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Grand Hotel",
      displayName: null,
      category: "Handwriting",
      size: 30641,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.3583984375
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-30",
      popularity: 578,
      trending: 500,
      defaultSort: 594,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Grandiflora One",
      displayName: null,
      category: "Serif",
      size: 2342680,
      subsets: ["menu", "korean", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Haesung Cho", "JAMO"],
      lastModified: "2023-06-07",
      dateAdded: "2023-06-05",
      popularity: 1459,
      trending: 1821,
      defaultSort: 164,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Kore",
      primaryLanguage: ""
    },
    {
      family: "Grandstander",
      displayName: null,
      category: "Display",
      size: 184074,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9975
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck", "ETC"],
      lastModified: "2023-03-21",
      dateAdded: "2020-07-23",
      popularity: 565,
      trending: 1069,
      defaultSort: 583,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Grape Nuts",
      displayName: null,
      category: "Handwriting",
      size: 122812,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-17",
      popularity: 1077,
      trending: 222,
      defaultSort: 1061,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gravitas One",
      displayName: null,
      category: "Display",
      size: 19700,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 9,
          lineHeight: 1.27197265625
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-29",
      popularity: 659,
      trending: 150,
      defaultSort: 666,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Great Vibes",
      displayName: null,
      category: "Handwriting",
      size: 156124,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 8,
          width: 5,
          lineHeight: 1.252
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2012-03-29",
      popularity: 171,
      trending: 1246,
      defaultSort: 172,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Grechen Fuemen",
      displayName: null,
      category: "Handwriting",
      size: 136992,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-02",
      popularity: 1464,
      trending: 373,
      defaultSort: 1380,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Grenze",
      displayName: null,
      category: "Serif",
      size: 101833,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2018-09-18",
      popularity: 1245,
      trending: 356,
      defaultSort: 1205,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Grenze Gotisch",
      displayName: null,
      category: "Display",
      size: 193492,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.48
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-03-21",
      dateAdded: "2020-05-17",
      popularity: 619,
      trending: 1392,
      defaultSort: 631,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Grey Qo",
      displayName: null,
      category: "Handwriting",
      size: 111544,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-02",
      popularity: 1514,
      trending: 512,
      defaultSort: 1410,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Griffy",
      displayName: null,
      category: "Display",
      size: 97366,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.3505859375
        }
      },
      axes: [],
      designers: ["Neapolitan"],
      lastModified: "2023-05-02",
      dateAdded: "2012-09-06",
      popularity: 1188,
      trending: 1233,
      defaultSort: 1154,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gruppo",
      displayName: null,
      category: "Sans Serif",
      size: 76204,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 0.96630859375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-23",
      dateAdded: "2010-12-20",
      popularity: 193,
      trending: 1091,
      defaultSort: 194,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gudea",
      displayName: null,
      category: "Sans Serif",
      size: 14187,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.236
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 6,
          lineHeight: 1.236
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.236
        }
      },
      axes: [],
      designers: ["Agustina Mingote"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 292,
      trending: 1293,
      defaultSort: 306,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gugi",
      displayName: null,
      category: "Display",
      size: 990856,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["TAE System & Typefaces Co."],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-23",
      popularity: 805,
      trending: 1187,
      defaultSort: 807,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gulzar",
      displayName: null,
      category: "Serif",
      size: 963496,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.7
        }
      },
      axes: [],
      designers: ["Borna Izadpanah", "Fiona Ross", "Alice Savoie", "Simon Cozens"],
      lastModified: "2023-05-31",
      dateAdded: "2022-05-13",
      popularity: 1201,
      trending: 1686,
      defaultSort: 1166,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Gupter",
      displayName: null,
      category: "Serif",
      size: 52564,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Octavio Pardo"],
      lastModified: "2022-09-21",
      dateAdded: "2019-11-13",
      popularity: 1341,
      trending: 1493,
      defaultSort: 1287,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gurajada",
      displayName: null,
      category: "Serif",
      size: 166688,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.966355140186916
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-08",
      popularity: 709,
      trending: 1361,
      defaultSort: 714,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Gwendolyn",
      displayName: null,
      category: "Handwriting",
      size: 163988,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-02",
      popularity: 1401,
      trending: 1753,
      defaultSort: 1337,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Habibi",
      displayName: null,
      category: "Serif",
      size: 21968,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Magnus Gaarde"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1039,
      trending: 1520,
      defaultSort: 1025,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hachi Maru Pop",
      displayName: null,
      category: "Handwriting",
      size: 4385624,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Nonty"],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-14",
      popularity: 942,
      trending: 648,
      defaultSort: 931,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hahmlet",
      displayName: null,
      category: "Serif",
      size: 3559144,
      subsets: ["menu", "korean", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Hypertype"],
      lastModified: "2023-03-21",
      dateAdded: "2021-05-13",
      popularity: 673,
      trending: 384,
      defaultSort: 680,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Halant",
      displayName: null,
      category: "Serif",
      size: 294952,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.575
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.575
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.575
        },
        "600": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.575
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.575
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2014-08-27",
      popularity: 599,
      trending: 1105,
      defaultSort: 614,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hammersmith One",
      displayName: null,
      category: "Sans Serif",
      size: 102884,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Nicole Fally"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-29",
      popularity: 311,
      trending: 1365,
      defaultSort: 327,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hanalei",
      displayName: null,
      category: "Display",
      size: 89124,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.30126953125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-26",
      popularity: 1417,
      trending: 1473,
      defaultSort: 1351,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hanalei Fill",
      displayName: null,
      category: "Display",
      size: 38904,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.30126953125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-26",
      popularity: 1274,
      trending: 107,
      defaultSort: 1231,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Handlee",
      displayName: null,
      category: "Handwriting",
      size: 22842,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.335
        }
      },
      axes: [],
      designers: ["Joe Prince"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 220,
      trending: 112,
      defaultSort: 227,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hanken Grotesk",
      displayName: null,
      category: "Sans Serif",
      size: 136140,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Alfredo Marco Pradil", "Hanken Design Co."],
      lastModified: "2023-05-02",
      dateAdded: "2022-11-16",
      popularity: 591,
      trending: 32,
      defaultSort: 380,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hanuman",
      displayName: null,
      category: "Serif",
      size: 104915,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.46484375
        },
        "700": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.46484375
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46484375
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-21",
      dateAdded: "2010-09-21",
      popularity: 537,
      trending: 521,
      defaultSort: 555,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Happy Monkey",
      displayName: null,
      category: "Display",
      size: 40103,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.205
        }
      },
      axes: [],
      designers: ["Brenda Gallo"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 836,
      trending: 1193,
      defaultSort: 837,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Harmattan",
      displayName: null,
      category: "Sans Serif",
      size: 565835,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.70361328125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.70361328125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.70361328125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.70361328125
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-23",
      dateAdded: "2020-07-02",
      popularity: 821,
      trending: 805,
      defaultSort: 824,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Headland One",
      displayName: null,
      category: "Serif",
      size: 26762,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25244140625
        }
      },
      axes: [],
      designers: ["Gary Lonergan"],
      lastModified: "2023-05-02",
      dateAdded: "2012-05-09",
      popularity: 525,
      trending: 246,
      defaultSort: 542,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Heebo",
      displayName: null,
      category: "Sans Serif",
      size: 98800,
      subsets: ["menu", "hebrew", "latin"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 4,
          lineHeight: 1.46875
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46875
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.46875
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.46875
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.46875
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46875
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.46875
        },
        "800": {
          thickness: 9,
          slant: 1,
          width: 4,
          lineHeight: 1.46875
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 4,
          lineHeight: 1.46875
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Oded Ezer"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 44,
      trending: 313,
      defaultSort: 43,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Henny Penny",
      displayName: null,
      category: "Display",
      size: 59697,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.77197265625
        }
      },
      axes: [],
      designers: ["Brownfox"],
      lastModified: "2022-04-26",
      dateAdded: "2012-02-22",
      popularity: 583,
      trending: 1298,
      defaultSort: 599,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hepta Slab",
      displayName: null,
      category: "Serif",
      size: 555236,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.251
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Mike LaGattuta"],
      lastModified: "2023-03-21",
      dateAdded: "2018-09-19",
      popularity: 602,
      trending: 1181,
      defaultSort: 617,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Herr Von Muellerhoff",
      displayName: null,
      category: "Handwriting",
      size: 25280,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 9,
          width: 4,
          lineHeight: 1.422
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-30",
      popularity: 484,
      trending: 1079,
      defaultSort: 503,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hi Melody",
      displayName: null,
      category: "Handwriting",
      size: 12623412,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["YoonDesign Inc"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-23",
      popularity: 791,
      trending: 1400,
      defaultSort: 792,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hina Mincho",
      displayName: null,
      category: "Serif",
      size: 6451924,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Satsuyako"],
      lastModified: "2023-05-02",
      dateAdded: "2021-04-14",
      popularity: 1003,
      trending: 137,
      defaultSort: 982,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hind",
      displayName: null,
      category: "Sans Serif",
      size: 286572,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.601
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.601
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.601
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.601
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.601
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2014-06-25",
      popularity: 76,
      trending: 674,
      defaultSort: 73,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hind Guntur",
      displayName: null,
      category: "Sans Serif",
      size: 323773,
      subsets: ["menu", "latin", "latin-ext", "telugu"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.888
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.888
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.888
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.888
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.888
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 437,
      trending: 745,
      defaultSort: 459,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hind Madurai",
      displayName: null,
      category: "Sans Serif",
      size: 136848,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 102,
      trending: 1436,
      defaultSort: 97,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hind Siliguri",
      displayName: null,
      category: "Sans Serif",
      size: 267262,
      subsets: ["menu", "bengali", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.617
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.617
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.617
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.617
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.617
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 52,
      trending: 1263,
      defaultSort: 52,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hind Vadodara",
      displayName: null,
      category: "Sans Serif",
      size: 245245,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.498
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.498
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.498
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.498
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.498
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 299,
      trending: 1070,
      defaultSort: 314,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Holtwood One SC",
      displayName: null,
      category: "Serif",
      size: 19536,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 9,
          lineHeight: 1.62744140625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-04",
      popularity: 392,
      trending: 498,
      defaultSort: 412,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Homemade Apple",
      displayName: null,
      category: "Handwriting",
      size: 110004,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 6,
          width: 8,
          lineHeight: 2.1591796875
        }
      },
      axes: [],
      designers: ["Font Diner"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 304,
      trending: 336,
      defaultSort: 320,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Homenaje",
      displayName: null,
      category: "Sans Serif",
      size: 36436,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.096
        }
      },
      axes: [],
      designers: ["Constanza Artigas Preller", "Agustina Mingote"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 561,
      trending: 395,
      defaultSort: 579,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hubballi",
      displayName: null,
      category: "Display",
      size: 187464,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.956
        }
      },
      axes: [],
      designers: ["Erin McLaughlin"],
      lastModified: "2022-09-21",
      dateAdded: "2021-12-16",
      popularity: 1394,
      trending: 1017,
      defaultSort: 1331,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Hurricane",
      displayName: null,
      category: "Handwriting",
      size: 377368,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-07",
      popularity: 811,
      trending: 848,
      defaultSort: 812,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Mono",
      displayName: null,
      category: "Monospace",
      size: 140956,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-04-27",
      dateAdded: "2018-03-12",
      popularity: 106,
      trending: 1019,
      defaultSort: 101,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans",
      displayName: null,
      category: "Sans Serif",
      size: 185965,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-05-02",
      dateAdded: "2018-03-11",
      popularity: 50,
      trending: 1637,
      defaultSort: 50,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans Arabic",
      displayName: null,
      category: "Sans Serif",
      size: 241138,
      subsets: ["menu", "arabic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-05-02",
      dateAdded: "2021-06-17",
      popularity: 122,
      trending: 1205,
      defaultSort: 116,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 114858,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-04-27",
      dateAdded: "2018-03-12",
      popularity: 231,
      trending: 261,
      defaultSort: 243,
      androidFragment: "name=IBM Plex Sans&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans Devanagari",
      displayName: null,
      category: "Sans Serif",
      size: 355786,
      subsets: ["menu", "cyrillic-ext", "devanagari", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.53
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.53
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.53
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.53
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.53
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.53
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.53
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-05-02",
      dateAdded: "2021-06-18",
      popularity: 1050,
      trending: 831,
      defaultSort: 1035,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans Hebrew",
      displayName: null,
      category: "Sans Serif",
      size: 97738,
      subsets: ["menu", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-04-27",
      dateAdded: "2021-06-18",
      popularity: 1329,
      trending: 796,
      defaultSort: 1279,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hebr",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans JP",
      displayName: null,
      category: "Sans Serif",
      size: 2400371,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-04-27",
      dateAdded: "2022-09-11",
      popularity: 1091,
      trending: 495,
      defaultSort: 1073,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans KR",
      displayName: null,
      category: "Sans Serif",
      size: 2796901,
      subsets: ["menu", "korean", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-04-27",
      dateAdded: "2021-06-18",
      popularity: 676,
      trending: 900,
      defaultSort: 683,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Kore",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans Thai",
      displayName: null,
      category: "Sans Serif",
      size: 117789,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "thai"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-04-27",
      dateAdded: "2021-06-18",
      popularity: 481,
      trending: 398,
      defaultSort: 500,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Thai",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Sans Thai Looped",
      displayName: null,
      category: "Sans Serif",
      size: 126189,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "thai"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-05-02",
      dateAdded: "2021-06-18",
      popularity: 1071,
      trending: 741,
      defaultSort: 1055,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Thai",
      primaryLanguage: ""
    },
    {
      family: "IBM Plex Serif",
      displayName: null,
      category: "Serif",
      size: 167765,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Mike Abbink", "Bold Monday"],
      lastModified: "2023-04-27",
      dateAdded: "2018-03-11",
      popularity: 143,
      trending: 1139,
      defaultSort: 136,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell DW Pica",
      displayName: null,
      category: "Serif",
      size: 124462,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.25
        },
        "400i": {
          thickness: 4,
          slant: 7,
          width: 6,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 675,
      trending: 1126,
      defaultSort: 682,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell DW Pica SC",
      displayName: null,
      category: "Serif",
      size: 112595,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 1247,
      trending: 72,
      defaultSort: 1207,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell Double Pica",
      displayName: null,
      category: "Serif",
      size: 120725,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.25341796875
        },
        "400i": {
          thickness: 5,
          slant: 6,
          width: 6,
          lineHeight: 1.25341796875
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 771,
      trending: 1449,
      defaultSort: 773,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell Double Pica SC",
      displayName: null,
      category: "Serif",
      size: 111273,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25341796875
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 1371,
      trending: 1619,
      defaultSort: 1313,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell English",
      displayName: null,
      category: "Serif",
      size: 118208,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2685546875
        },
        "400i": {
          thickness: 5,
          slant: 6,
          width: 6,
          lineHeight: 1.2685546875
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 654,
      trending: 1129,
      defaultSort: 661,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell English SC",
      displayName: null,
      category: "Serif",
      size: 110116,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2685546875
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 637,
      trending: 1444,
      defaultSort: 648,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell French Canon",
      displayName: null,
      category: "Serif",
      size: 85439,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.1708984375
        },
        "400i": {
          thickness: 5,
          slant: 7,
          width: 6,
          lineHeight: 1.1708984375
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 1036,
      trending: 1571,
      defaultSort: 1023,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell French Canon SC",
      displayName: null,
      category: "Serif",
      size: 78513,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.1708984375
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 1285,
      trending: 578,
      defaultSort: 1242,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell Great Primer",
      displayName: null,
      category: "Serif",
      size: 124052,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 2,
          width: 6,
          lineHeight: 1.22265625
        },
        "400i": {
          thickness: 5,
          slant: 6,
          width: 6,
          lineHeight: 1.22265625
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 1065,
      trending: 225,
      defaultSort: 1049,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "IM Fell Great Primer SC",
      displayName: null,
      category: "Serif",
      size: 115605,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.22265625
        }
      },
      axes: [],
      designers: ["Igino Marini"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 1271,
      trending: 271,
      defaultSort: 1229,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ibarra Real Nova",
      displayName: null,
      category: "Serif",
      size: 117214,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Jos\xE9 Mar\xEDa Ribagorda", "Octavio Pardo"],
      lastModified: "2023-05-02",
      dateAdded: "2019-11-04",
      popularity: 725,
      trending: 281,
      defaultSort: 730,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Iceberg",
      displayName: null,
      category: "Display",
      size: 19655,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-26",
      dateAdded: "2012-01-25",
      popularity: 1083,
      trending: 690,
      defaultSort: 1066,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Iceland",
      displayName: null,
      category: "Display",
      size: 19403,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 0.97
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-26",
      dateAdded: "2011-11-23",
      popularity: 997,
      trending: 1197,
      defaultSort: 978,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Imbue",
      displayName: null,
      category: "Serif",
      size: 220012,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 10,
          max: 100,
          defaultValue: 10
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck", "ETC"],
      lastModified: "2022-09-21",
      dateAdded: "2020-12-02",
      popularity: 1264,
      trending: 1668,
      defaultSort: 1223,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Imperial Script",
      displayName: null,
      category: "Handwriting",
      size: 154824,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.21
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-18",
      popularity: 1378,
      trending: 1690,
      defaultSort: 1318,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Imprima",
      displayName: null,
      category: "Sans Serif",
      size: 55692,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.158
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2012-03-14",
      popularity: 916,
      trending: 778,
      defaultSort: 909,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inconsolata",
      displayName: null,
      category: "Monospace",
      size: 347180,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.049
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.049
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.049
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.049
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.049
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.049
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.049
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.049
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 50,
          max: 200,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Raph Levien"],
      lastModified: "2022-09-21",
      dateAdded: "2010-02-19",
      popularity: 46,
      trending: 740,
      defaultSort: 45,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inder",
      displayName: null,
      category: "Sans Serif",
      size: 20318,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 697,
      trending: 501,
      defaultSort: 704,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Indie Flower",
      displayName: null,
      category: "Handwriting",
      size: 33416,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.458984375
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-09",
      popularity: 123,
      trending: 1257,
      defaultSort: 117,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ingrid Darling",
      displayName: null,
      category: "Handwriting",
      size: 159820,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-11",
      popularity: 1556,
      trending: 1085,
      defaultSort: 1420,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inika",
      displayName: null,
      category: "Serif",
      size: 21019,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.303
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.303
        }
      },
      axes: [],
      designers: ["Constanza Artigas"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 1165,
      trending: 747,
      defaultSort: 1134,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inknut Antiqua",
      displayName: null,
      category: "Serif",
      size: 397792,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 2.579
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 2.579
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 2.579
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 2.579
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 2.579
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 2.579
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 9,
          lineHeight: 2.579
        }
      },
      axes: [],
      designers: ["Claus Eggers S\xF8rensen"],
      lastModified: "2022-09-21",
      dateAdded: "2015-05-20",
      popularity: 820,
      trending: 1110,
      defaultSort: 822,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inria Sans",
      displayName: null,
      category: "Sans Serif",
      size: 85028,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        }
      },
      axes: [],
      designers: ["Gr\xE9gori Vincens", "J\xE9r\xE9mie Hornus"],
      lastModified: "2022-09-21",
      dateAdded: "2019-12-05",
      popularity: 884,
      trending: 288,
      defaultSort: 878,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inria Serif",
      displayName: null,
      category: "Serif",
      size: 100073,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.199
        }
      },
      axes: [],
      designers: ["Gr\xE9gori Vincens", "J\xE9r\xE9mie Hornus"],
      lastModified: "2022-09-21",
      dateAdded: "2019-12-05",
      popularity: 945,
      trending: 1120,
      defaultSort: 933,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inspiration",
      displayName: null,
      category: "Handwriting",
      size: 162296,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.27
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-26",
      popularity: 1321,
      trending: 1791,
      defaultSort: 1272,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Instrument Sans",
      displayName: null,
      category: "Sans Serif",
      size: 198232,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Rodrigo Fuenzalida", "Jordan Egstad"],
      lastModified: "2023-05-09",
      dateAdded: "2023-05-08",
      popularity: 1203,
      trending: 217,
      defaultSort: 276,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Instrument Serif",
      displayName: null,
      category: "Serif",
      size: 70802,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Rodrigo Fuenzalida", "Jordan Egstad"],
      lastModified: "2023-05-23",
      dateAdded: "2023-03-21",
      popularity: 1135,
      trending: 1708,
      defaultSort: 568,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inter",
      displayName: null,
      category: "Sans Serif",
      size: 805528,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2102272727272727
        }
      },
      axes: [
        {
          tag: "slnt",
          min: -10,
          max: 0,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Rasmus Andersson"],
      lastModified: "2022-09-21",
      dateAdded: "2020-01-24",
      popularity: 14,
      trending: 1022,
      defaultSort: 14,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Inter Tight",
      displayName: null,
      category: "Sans Serif",
      size: 587716,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2099609375
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Rasmus Andersson"],
      lastModified: "2023-05-02",
      dateAdded: "2022-07-22",
      popularity: 353,
      trending: 1428,
      defaultSort: 370,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Irish Grover",
      displayName: null,
      category: "Display",
      size: 52648,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.208984375
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-16",
      popularity: 569,
      trending: 1178,
      defaultSort: 585,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Island Moments",
      displayName: null,
      category: "Handwriting",
      size: 615340,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-18",
      popularity: 1441,
      trending: 131,
      defaultSort: 1365,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Istok Web",
      displayName: null,
      category: "Sans Serif",
      size: 114423,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.439453125
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.439453125
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.439453125
        },
        "700i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.439453125
        }
      },
      axes: [],
      designers: ["Andrey V. Panov"],
      lastModified: "2023-05-02",
      dateAdded: "2011-07-13",
      popularity: 313,
      trending: 568,
      defaultSort: 329,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Italiana",
      displayName: null,
      category: "Serif",
      size: 15007,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.178
        }
      },
      axes: [],
      designers: ["Santiago Orozco"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 667,
      trending: 807,
      defaultSort: 673,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Italianno",
      displayName: null,
      category: "Handwriting",
      size: 223708,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 8,
          width: 4,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 370,
      trending: 1026,
      defaultSort: 390,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Itim",
      displayName: null,
      category: "Handwriting",
      size: 143147,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2015-07-01",
      popularity: 319,
      trending: 1426,
      defaultSort: 336,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jacques Francois",
      displayName: null,
      category: "Serif",
      size: 36901,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.31884765625
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-26",
      dateAdded: "2012-09-07",
      popularity: 1223,
      trending: 1523,
      defaultSort: 1184,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jacques Francois Shadow",
      displayName: null,
      category: "Display",
      size: 54277,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.31884765625
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-26",
      dateAdded: "2012-09-07",
      popularity: 1193,
      trending: 602,
      defaultSort: 1159,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jaldi",
      displayName: null,
      category: "Sans Serif",
      size: 175808,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.68994140625
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 4,
          lineHeight: 1.68994140625
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2015-04-22",
      popularity: 355,
      trending: 319,
      defaultSort: 372,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "JetBrains Mono",
      displayName: null,
      category: "Monospace",
      size: 189382,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["JetBrains", "Philipp Nurullin", "Konstantin Bulenkov"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-18",
      popularity: 446,
      trending: 1242,
      defaultSort: 468,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jim Nightshade",
      displayName: null,
      category: "Handwriting",
      size: 83742,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 4,
          width: 5,
          lineHeight: 1.4169921875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-04",
      popularity: 1254,
      trending: 1404,
      defaultSort: 1212,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Joan",
      displayName: null,
      category: "Serif",
      size: 460452,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.292
        }
      },
      axes: [],
      designers: ["Paolo Biagini"],
      lastModified: "2023-05-02",
      dateAdded: "2022-04-28",
      popularity: 1205,
      trending: 1781,
      defaultSort: 1169,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jockey One",
      displayName: null,
      category: "Sans Serif",
      size: 22480,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.398
        }
      },
      axes: [],
      designers: ["TypeTogether"],
      lastModified: "2023-05-02",
      dateAdded: "2011-10-26",
      popularity: 647,
      trending: 1478,
      defaultSort: 655,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jolly Lodger",
      displayName: null,
      category: "Display",
      size: 24196,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 2,
          lineHeight: 1.2158203125
        }
      },
      axes: [],
      designers: ["Font Diner"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 1115,
      trending: 472,
      defaultSort: 1094,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jomhuria",
      displayName: null,
      category: "Display",
      size: 171488,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 3,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["KB Studio"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 815,
      trending: 1396,
      defaultSort: 816,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jomolhari",
      displayName: null,
      category: "Serif",
      size: 2260860,
      subsets: ["menu", "latin", "tibetan"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6015625
        }
      },
      axes: [],
      designers: ["Christopher J. Fynn"],
      lastModified: "2022-09-21",
      dateAdded: "2019-09-10",
      popularity: 994,
      trending: 548,
      defaultSort: 975,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Josefin Sans",
      displayName: null,
      category: "Sans Serif",
      size: 124786,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 6,
          lineHeight: 1
        },
        "100i": {
          thickness: 1,
          slant: 4,
          width: 6,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1
        },
        "300i": {
          thickness: 3,
          slant: 3,
          width: 6,
          lineHeight: 1
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1
        },
        "400i": {
          thickness: 4,
          slant: 3,
          width: 6,
          lineHeight: 1
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1
        },
        "600i": {
          thickness: 5,
          slant: 3,
          width: 6,
          lineHeight: 1
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 6,
          lineHeight: 1
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Santiago Orozco"],
      lastModified: "2023-05-02",
      dateAdded: "2010-11-17",
      popularity: 55,
      trending: 1157,
      defaultSort: 55,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Josefin Slab",
      displayName: null,
      category: "Serif",
      size: 38448,
      subsets: ["menu", "latin"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "100i": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "300": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "300i": {
          thickness: 1,
          slant: 4,
          width: 7,
          lineHeight: 1
        },
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "400i": {
          thickness: 3,
          slant: 3,
          width: 7,
          lineHeight: 1
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "600": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "600i": {
          thickness: 4,
          slant: 3,
          width: 7,
          lineHeight: 1
        },
        "700": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "700i": {
          thickness: 4,
          slant: 3,
          width: 7,
          lineHeight: 1
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Santiago Orozco"],
      lastModified: "2023-03-21",
      dateAdded: "2010-11-17",
      popularity: 234,
      trending: 1028,
      defaultSort: 246,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jost",
      displayName: null,
      category: "Sans Serif",
      size: 139692,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Owen Earl"],
      lastModified: "2022-09-21",
      dateAdded: "2020-02-11",
      popularity: 83,
      trending: 1012,
      defaultSort: 79,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Joti One",
      displayName: null,
      category: "Display",
      size: 58384,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.334
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-04-04",
      dateAdded: "2012-10-31",
      popularity: 1196,
      trending: 1158,
      defaultSort: 1162,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jua",
      displayName: null,
      category: "Sans Serif",
      size: 2106004,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Woowahan Brothers"],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-24",
      popularity: 468,
      trending: 766,
      defaultSort: 487,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Judson",
      displayName: null,
      category: "Serif",
      size: 100370,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.15
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.172
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.163
        }
      },
      axes: [],
      designers: ["Daniel Johnson"],
      lastModified: "2023-05-02",
      dateAdded: "2011-05-04",
      popularity: 580,
      trending: 1386,
      defaultSort: 596,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Julee",
      displayName: null,
      category: "Handwriting",
      size: 66776,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.178
        }
      },
      axes: [],
      designers: ["Juli\xE1n Tunni"],
      lastModified: "2023-04-27",
      dateAdded: "2011-09-07",
      popularity: 467,
      trending: 873,
      defaultSort: 486,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Julius Sans One",
      displayName: null,
      category: "Sans Serif",
      size: 22892,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 8,
          lineHeight: 1.091
        }
      },
      axes: [],
      designers: ["Luciano Vergara"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-05",
      popularity: 373,
      trending: 1542,
      defaultSort: 393,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Junge",
      displayName: null,
      category: "Serif",
      size: 39575,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.21533203125
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-26",
      dateAdded: "2012-01-18",
      popularity: 1213,
      trending: 497,
      defaultSort: 1175,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Jura",
      displayName: null,
      category: "Sans Serif",
      size: 258404,
      subsets: [
        "menu",
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "kayah-li",
        "latin",
        "latin-ext",
        "vietnamese"
      ],
      fonts: {
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.183
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.183
        },
        "500": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.183
        },
        "600": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.183
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.183
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Daniel Johnson", "Cyreal"],
      lastModified: "2023-05-02",
      dateAdded: "2011-05-18",
      popularity: 360,
      trending: 664,
      defaultSort: 379,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Just Another Hand",
      displayName: null,
      category: "Handwriting",
      size: 191076,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 1,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-20",
      popularity: 424,
      trending: 59,
      defaultSort: 447,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Just Me Again Down Here",
      displayName: null,
      category: "Handwriting",
      size: 36244,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.498
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-07",
      popularity: 846,
      trending: 205,
      defaultSort: 846,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "K2D",
      displayName: null,
      category: "Sans Serif",
      size: 98513,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 452,
      trending: 311,
      defaultSort: 473,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kablammo",
      displayName: null,
      category: "Display",
      size: 2209224,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.292
        }
      },
      axes: [
        {
          tag: "MORF",
          min: 0,
          max: 60,
          defaultValue: 0
        }
      ],
      designers: ["Vectro Type Foundry", "Travis Kochel", "Lizy Gershenzon", "Daria Cohen", "Ethan Cohen"],
      lastModified: "2023-06-08",
      dateAdded: "2023-06-06",
      popularity: 1303,
      trending: 1812,
      defaultSort: 133,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kadwa",
      displayName: null,
      category: "Serif",
      size: 96645,
      subsets: ["menu", "devanagari", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 5,
          lineHeight: 2.0078125
        },
        "700": {
          thickness: 9,
          slant: 1,
          width: 5,
          lineHeight: 2.0078125
        }
      },
      axes: [],
      designers: ["Sol Matas"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-17",
      popularity: 724,
      trending: 1288,
      defaultSort: 729,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kaisei Decol",
      displayName: null,
      category: "Serif",
      size: 4362606,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Font-Kai"],
      lastModified: "2022-09-27",
      dateAdded: "2021-05-21",
      popularity: 779,
      trending: 163,
      defaultSort: 780,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kaisei HarunoUmi",
      displayName: null,
      category: "Serif",
      size: 4430161,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Font-Kai"],
      lastModified: "2022-09-27",
      dateAdded: "2021-05-21",
      popularity: 1087,
      trending: 75,
      defaultSort: 1070,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kaisei Opti",
      displayName: null,
      category: "Serif",
      size: 4362830,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Font-Kai"],
      lastModified: "2022-09-27",
      dateAdded: "2021-05-21",
      popularity: 1008,
      trending: 726,
      defaultSort: 987,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kaisei Tokumin",
      displayName: null,
      category: "Serif",
      size: 4469844,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Font-Kai"],
      lastModified: "2022-09-27",
      dateAdded: "2021-05-21",
      popularity: 894,
      trending: 721,
      defaultSort: 887,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kalam",
      displayName: null,
      category: "Handwriting",
      size: 191146,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 5,
          width: 7,
          lineHeight: 1.594
        },
        "400": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.594
        },
        "700": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1.594
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2014-10-17",
      popularity: 154,
      trending: 304,
      defaultSort: 148,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kameron",
      displayName: null,
      category: "Serif",
      size: 41226,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.18701171875
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.2705078125
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-08",
      popularity: 543,
      trending: 573,
      defaultSort: 561,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kanit",
      displayName: null,
      category: "Sans Serif",
      size: 174512,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "100i": {
          thickness: 1,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "200": {
          thickness: 2,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "200i": {
          thickness: 2,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "300i": {
          thickness: 3,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "500i": {
          thickness: 5,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "600i": {
          thickness: 6,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "700i": {
          thickness: 7,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "800i": {
          thickness: 8,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        },
        "900": {
          thickness: 9,
          slant: 1,
          width: 4,
          lineHeight: 1.495
        },
        "900i": {
          thickness: 9,
          slant: 5,
          width: 4,
          lineHeight: 1.495
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2015-12-07",
      popularity: 30,
      trending: 1154,
      defaultSort: 31,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kantumruy Pro",
      displayName: null,
      category: "Sans Serif",
      size: 210094,
      subsets: ["menu", "khmer", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.18
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tep Sovichet", "Wei Huang"],
      lastModified: "2023-03-21",
      dateAdded: "2022-05-12",
      popularity: 1227,
      trending: 280,
      defaultSort: 1188,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Karantina",
      displayName: null,
      category: "Display",
      size: 50662,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.012
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.012
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.012
        }
      },
      axes: [],
      designers: ["Rony Koch"],
      lastModified: "2022-09-21",
      dateAdded: "2021-03-11",
      popularity: 1046,
      trending: 753,
      defaultSort: 1031,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Karla",
      displayName: null,
      category: "Sans Serif",
      size: 90874,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.169
        },
        "400i": {
          thickness: 4,
          slant: 2,
          width: 6,
          lineHeight: 1.169
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.169
        },
        "700i": {
          thickness: 6,
          slant: 2,
          width: 7,
          lineHeight: 1.169
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.169
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Jonny Pinhorn"],
      lastModified: "2023-05-09",
      dateAdded: "2012-03-14",
      popularity: 51,
      trending: 931,
      defaultSort: 51,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Karma",
      displayName: null,
      category: "Serif",
      size: 334681,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.419
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.453
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.493
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.544
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.628
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2014-06-25",
      popularity: 441,
      trending: 1581,
      defaultSort: 463,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Katibeh",
      displayName: null,
      category: "Display",
      size: 188360,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 3,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["KB Studio"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 921,
      trending: 315,
      defaultSort: 912,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kaushan Script",
      displayName: null,
      category: "Handwriting",
      size: 79314,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 7,
          width: 6,
          lineHeight: 1.451
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-25",
      popularity: 203,
      trending: 1104,
      defaultSort: 205,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kavivanar",
      displayName: null,
      category: "Handwriting",
      size: 66324,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 3,
          lineHeight: 1.482
        }
      },
      axes: [],
      designers: ["Tharique Azeez"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-20",
      popularity: 1148,
      trending: 1529,
      defaultSort: 1121,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kavoon",
      displayName: null,
      category: "Display",
      size: 71476,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Viktoriya Grabowska"],
      lastModified: "2022-09-21",
      dateAdded: "2013-01-23",
      popularity: 1032,
      trending: 431,
      defaultSort: 1019,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kdam Thmor Pro",
      displayName: null,
      category: "Sans Serif",
      size: 85760,
      subsets: ["menu", "khmer", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.546
        }
      },
      axes: [],
      designers: ["Tep Sovichet", "Hak Longdey"],
      lastModified: "2022-09-21",
      dateAdded: "2022-05-11",
      popularity: 1323,
      trending: 1810,
      defaultSort: 1273,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Keania One",
      displayName: null,
      category: "Display",
      size: 20748,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.217
        }
      },
      axes: [],
      designers: ["Julia Petretta"],
      lastModified: "2023-05-02",
      dateAdded: "2012-10-31",
      popularity: 1178,
      trending: 806,
      defaultSort: 1146,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kelly Slab",
      displayName: null,
      category: "Display",
      size: 37844,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.212
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-27",
      popularity: 744,
      trending: 1010,
      defaultSort: 747,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kenia",
      displayName: null,
      category: "Display",
      size: 33989,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Julia Petretta"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-15",
      popularity: 1385,
      trending: 1166,
      defaultSort: 1325,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Khand",
      displayName: null,
      category: "Sans Serif",
      size: 332096,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.529
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.529
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.529
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.529
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.529
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-12-07",
      dateAdded: "2014-07-14",
      popularity: 207,
      trending: 569,
      defaultSort: 210,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Khmer",
      displayName: null,
      category: "Display",
      size: 74869,
      subsets: ["menu", "khmer"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.708984375
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-26",
      dateAdded: "2011-03-02",
      popularity: 1049,
      trending: 1403,
      defaultSort: 1034,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Khula",
      displayName: null,
      category: "Sans Serif",
      size: 158814,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.6056622851365014
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.6056622851365014
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6056622851365014
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.6056622851365014
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.6056622851365014
        }
      },
      axes: [],
      designers: ["Erin McLaughlin"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-28",
      popularity: 362,
      trending: 1265,
      defaultSort: 382,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kings",
      displayName: null,
      category: "Handwriting",
      size: 270704,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-21",
      popularity: 1529,
      trending: 1517,
      defaultSort: 1419,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kirang Haerang",
      displayName: null,
      category: "Display",
      size: 5979324,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Woowahan Brothers"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-24",
      popularity: 1184,
      trending: 927,
      defaultSort: 1151,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kite One",
      displayName: null,
      category: "Sans Serif",
      size: 67692,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.445
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2012-10-26",
      popularity: 849,
      trending: 1573,
      defaultSort: 849,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kiwi Maru",
      displayName: null,
      category: "Serif",
      size: 5057289,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Hiroki-Chan"],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-14",
      popularity: 475,
      trending: 377,
      defaultSort: 494,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Klee One",
      displayName: null,
      category: "Handwriting",
      size: 8814666,
      subsets: ["menu", "cyrillic", "greek-ext", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Fontworks Inc."],
      lastModified: "2022-09-27",
      dateAdded: "2021-06-08",
      popularity: 605,
      trending: 374,
      defaultSort: 620,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Knewave",
      displayName: null,
      category: "Display",
      size: 21718,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 7,
          width: 7,
          lineHeight: 1.554
        }
      },
      axes: [],
      designers: ["Tyler Finck"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 514,
      trending: 1008,
      defaultSort: 530,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "KoHo",
      displayName: null,
      category: "Sans Serif",
      size: 97959,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 699,
      trending: 1064,
      defaultSort: 706,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kodchasan",
      displayName: null,
      category: "Sans Serif",
      size: 103138,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2018-09-10",
      popularity: 683,
      trending: 1585,
      defaultSort: 689,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Koh Santepheap",
      displayName: null,
      category: "Display",
      size: 162697,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26953125
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-26",
      dateAdded: "2021-06-10",
      popularity: 1395,
      trending: 1239,
      defaultSort: 1332,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kolker Brush",
      displayName: null,
      category: "Handwriting",
      size: 268272,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-26",
      popularity: 1494,
      trending: 1715,
      defaultSort: 1396,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Konkhmer Sleokchher",
      displayName: null,
      category: "Display",
      size: 1834832,
      subsets: ["menu", "khmer", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Suon May Sophanith"],
      lastModified: "2023-04-27",
      dateAdded: "2023-04-26",
      popularity: 1492,
      trending: 335,
      defaultSort: 377,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Khmr",
      primaryLanguage: ""
    },
    {
      family: "Kosugi",
      displayName: null,
      category: "Sans Serif",
      size: 2288848,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["MOTOYA"],
      lastModified: "2023-05-02",
      dateAdded: "2016-01-21",
      popularity: 556,
      trending: 1528,
      defaultSort: 575,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kosugi Maru",
      displayName: null,
      category: "Sans Serif",
      size: 3565716,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["MOTOYA"],
      lastModified: "2022-09-27",
      dateAdded: "2016-01-21",
      popularity: 277,
      trending: 582,
      defaultSort: 289,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kotta One",
      displayName: null,
      category: "Serif",
      size: 17086,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 3,
          width: 7,
          lineHeight: 1.203
        }
      },
      axes: [],
      designers: ["Ania Kruk"],
      lastModified: "2022-04-26",
      dateAdded: "2012-01-25",
      popularity: 959,
      trending: 1211,
      defaultSort: 944,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Koulen",
      displayName: null,
      category: "Display",
      size: 56324,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-26",
      dateAdded: "2011-03-02",
      popularity: 394,
      trending: 591,
      defaultSort: 414,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kranky",
      displayName: null,
      category: "Display",
      size: 199284,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.2685546875
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 962,
      trending: 1534,
      defaultSort: 947,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kreon",
      displayName: null,
      category: "Serif",
      size: 79176,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.26
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Julia Petretta"],
      lastModified: "2023-03-21",
      dateAdded: "2011-02-02",
      popularity: 423,
      trending: 654,
      defaultSort: 446,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kristi",
      displayName: null,
      category: "Handwriting",
      size: 47440,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 7,
          width: 1,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Birgit Pulk"],
      lastModified: "2022-04-26",
      dateAdded: "2010-12-20",
      popularity: 536,
      trending: 1342,
      defaultSort: 554,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Krona One",
      displayName: null,
      category: "Sans Serif",
      size: 20960,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 9,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Yvonne Sch\xFCttler"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-22",
      popularity: 535,
      trending: 1415,
      defaultSort: 553,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Krub",
      displayName: null,
      category: "Sans Serif",
      size: 91507,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 404,
      trending: 752,
      defaultSort: 426,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kufam",
      displayName: null,
      category: "Sans Serif",
      size: 433056,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Original Type", "Wael Morcos", "Artur Schmal"],
      lastModified: "2022-09-21",
      dateAdded: "2020-07-14",
      popularity: 668,
      trending: 1272,
      defaultSort: 674,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kulim Park",
      displayName: null,
      category: "Sans Serif",
      size: 61847,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.135
        }
      },
      axes: [],
      designers: ["Dale Sattler"],
      lastModified: "2022-09-21",
      dateAdded: "2019-09-25",
      popularity: 1022,
      trending: 1485,
      defaultSort: 1003,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kumar One",
      displayName: null,
      category: "Display",
      size: 95320,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.779
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 1258,
      trending: 1786,
      defaultSort: 1217,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kumar One Outline",
      displayName: null,
      category: "Display",
      size: 128948,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.779
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 1315,
      trending: 1450,
      defaultSort: 1266,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kumbh Sans",
      displayName: null,
      category: "Sans Serif",
      size: 164284,
      subsets: ["menu", "latin", "latin-ext", "math"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.240234375
        }
      },
      axes: [
        {
          tag: "YOPQ",
          min: 40,
          max: 300,
          defaultValue: 300
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Saurabh Sharma"],
      lastModified: "2023-03-21",
      dateAdded: "2020-07-22",
      popularity: 341,
      trending: 210,
      defaultSort: 359,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Kurale",
      displayName: null,
      category: "Serif",
      size: 250224,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 1.478
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2015-05-14",
      popularity: 589,
      trending: 589,
      defaultSort: 605,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "La Belle Aurore",
      displayName: null,
      category: "Handwriting",
      size: 31611,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 8,
          width: 7,
          lineHeight: 1.8525390625
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-08",
      popularity: 458,
      trending: 296,
      defaultSort: 475,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Labrada",
      displayName: null,
      category: "Serif",
      size: 170442,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.445
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Mercedes J\xE1uregui", "Omnibus-Type"],
      lastModified: "2023-03-09",
      dateAdded: "2023-01-18",
      popularity: 1307,
      trending: 170,
      defaultSort: 697,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lacquer",
      displayName: null,
      category: "Display",
      size: 294060,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Niki Polyocan", "Eli Block"],
      lastModified: "2022-09-21",
      dateAdded: "2019-07-03",
      popularity: 1368,
      trending: 354,
      defaultSort: 1310,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Laila",
      displayName: null,
      category: "Sans Serif",
      size: 349949,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.55
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.55
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.55
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.55
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.55
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2014-08-27",
      popularity: 343,
      trending: 1457,
      defaultSort: 361,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lakki Reddy",
      displayName: null,
      category: "Handwriting",
      size: 220826,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.6630859375
        }
      },
      axes: [],
      designers: ["Appaji Ambarisha Darbha"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-12",
      popularity: 1219,
      trending: 630,
      defaultSort: 1180,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lalezar",
      displayName: null,
      category: "Display",
      size: 292656,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.567
        }
      },
      axes: [],
      designers: ["Borna Izadpanah"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 334,
      trending: 524,
      defaultSort: 352,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lancelot",
      displayName: null,
      category: "Display",
      size: 31944,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.10498046875
        }
      },
      axes: [],
      designers: ["Marion Kadi"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-02",
      popularity: 1252,
      trending: 179,
      defaultSort: 1210,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Langar",
      displayName: null,
      category: "Display",
      size: 192308,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.394
        }
      },
      axes: [],
      designers: ["Typeland", "Alessia Mazzarella"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 1333,
      trending: 631,
      defaultSort: 1282,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lateef",
      displayName: null,
      category: "Serif",
      size: 195161,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.44580078125
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.44580078125
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.44580078125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.44580078125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.44580078125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.44580078125
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.44580078125
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-23",
      dateAdded: "2015-03-03",
      popularity: 628,
      trending: 1716,
      defaultSort: 639,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Lato",
      displayName: null,
      category: "Sans Serif",
      size: 51318,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 6,
          lineHeight: 1.2
        },
        "100i": {
          thickness: 1,
          slant: 6,
          width: 6,
          lineHeight: 1.2
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "300i": {
          thickness: 3,
          slant: 4,
          width: 6,
          lineHeight: 1.2
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 6,
          lineHeight: 1.2
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.2
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.2
        },
        "900i": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["\u0141ukasz Dziedzic"],
      lastModified: "2023-05-02",
      dateAdded: "2010-12-15",
      popularity: 8,
      trending: 838,
      defaultSort: 9,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lavishly Yours",
      displayName: null,
      category: "Handwriting",
      size: 150132,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-11",
      popularity: 1328,
      trending: 114,
      defaultSort: 1278,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "League Gothic",
      displayName: null,
      category: "Sans Serif",
      size: 65972,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 100,
          defaultValue: 100
        }
      ],
      designers: ["Tyler Finck", "Caroline Hadilaksono", "Micah Rich"],
      lastModified: "2022-09-21",
      dateAdded: "2021-12-09",
      popularity: 631,
      trending: 628,
      defaultSort: 642,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "League Script",
      displayName: null,
      category: "Handwriting",
      size: 69292,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 1,
          slant: 8,
          width: 7,
          lineHeight: 1.1067708333333333
        }
      },
      axes: [],
      designers: ["Haley Fiege"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-09",
      popularity: 961,
      trending: 1267,
      defaultSort: 946,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "League Spartan",
      displayName: null,
      category: "Sans Serif",
      size: 95116,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.92
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Matt Bailey", "Tyler Finck"],
      lastModified: "2023-05-02",
      dateAdded: "2021-12-17",
      popularity: 294,
      trending: 1196,
      defaultSort: 308,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Leckerli One",
      displayName: null,
      category: "Handwriting",
      size: 25643,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 4,
          width: 7,
          lineHeight: 1.345
        }
      },
      axes: [],
      designers: ["Gesine Todt"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-20",
      popularity: 386,
      trending: 713,
      defaultSort: 406,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ledger",
      displayName: null,
      category: "Serif",
      size: 62148,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.391
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-22",
      popularity: 804,
      trending: 1525,
      defaultSort: 806,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lekton",
      displayName: null,
      category: "Sans Serif",
      size: 87405,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["ISIA Urbino"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-20",
      popularity: 869,
      trending: 786,
      defaultSort: 867,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lemon",
      displayName: null,
      category: "Display",
      size: 77180,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 4,
          width: 8,
          lineHeight: 1.306
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-04-04",
      dateAdded: "2011-11-30",
      popularity: 814,
      trending: 1395,
      defaultSort: 815,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lemonada",
      displayName: null,
      category: "Display",
      size: 189204,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.998
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.998
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.998
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.998
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.998
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Mohamed Gaber", "Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2016-06-15",
      popularity: 433,
      trending: 1343,
      defaultSort: 455,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Lexend",
      displayName: null,
      category: "Sans Serif",
      size: 175756,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-05-02",
      dateAdded: "2021-03-08",
      popularity: 177,
      trending: 542,
      defaultSort: 178,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lexend Deca",
      displayName: null,
      category: "Sans Serif",
      size: 175928,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-03-21",
      dateAdded: "2019-08-01",
      popularity: 233,
      trending: 1699,
      defaultSort: 245,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lexend Exa",
      displayName: null,
      category: "Sans Serif",
      size: 189908,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-05-02",
      dateAdded: "2019-08-01",
      popularity: 914,
      trending: 1480,
      defaultSort: 907,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lexend Giga",
      displayName: null,
      category: "Sans Serif",
      size: 192100,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-01-06",
      dateAdded: "2019-08-01",
      popularity: 991,
      trending: 1479,
      defaultSort: 972,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lexend Mega",
      displayName: null,
      category: "Sans Serif",
      size: 192116,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-01-06",
      dateAdded: "2019-08-01",
      popularity: 1104,
      trending: 1610,
      defaultSort: 1085,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lexend Peta",
      displayName: null,
      category: "Sans Serif",
      size: 192228,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-03-09",
      dateAdded: "2019-08-01",
      popularity: 843,
      trending: 19,
      defaultSort: 129,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lexend Tera",
      displayName: null,
      category: "Sans Serif",
      size: 192544,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-03-09",
      dateAdded: "2019-08-01",
      popularity: 1352,
      trending: 1516,
      defaultSort: 1297,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lexend Zetta",
      displayName: null,
      category: "Sans Serif",
      size: 192720,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bonnie Shaver-Troup", "Thomas Jockin", "Santiago Orozco", "H\xE9ctor G\xF3mez", "Superunion"],
      lastModified: "2023-03-21",
      dateAdded: "2019-08-01",
      popularity: 708,
      trending: 1151,
      defaultSort: 713,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Barcode 128",
      displayName: null,
      category: "Display",
      size: 22380,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Lasse Fister"],
      lastModified: "2022-04-26",
      dateAdded: "2017-07-31",
      popularity: 774,
      trending: 70,
      defaultSort: 775,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Barcode 128 Text",
      displayName: null,
      category: "Display",
      size: 48056,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Lasse Fister"],
      lastModified: "2022-04-26",
      dateAdded: "2017-07-31",
      popularity: 1157,
      trending: 1565,
      defaultSort: 1128,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Barcode 39",
      displayName: null,
      category: "Display",
      size: 14800,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Lasse Fister"],
      lastModified: "2022-04-26",
      dateAdded: "2017-07-31",
      popularity: 462,
      trending: 816,
      defaultSort: 479,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Barcode 39 Extended",
      displayName: null,
      category: "Display",
      size: 17396,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Lasse Fister"],
      lastModified: "2022-04-26",
      dateAdded: "2017-08-21",
      popularity: 1314,
      trending: 121,
      defaultSort: 1265,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Barcode 39 Extended Text",
      displayName: null,
      category: "Display",
      size: 35280,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Lasse Fister"],
      lastModified: "2022-04-26",
      dateAdded: "2017-08-21",
      popularity: 947,
      trending: 129,
      defaultSort: 934,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Barcode 39 Text",
      displayName: null,
      category: "Display",
      size: 22984,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Lasse Fister"],
      lastModified: "2022-04-26",
      dateAdded: "2017-07-31",
      popularity: 951,
      trending: 95,
      defaultSort: 937,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Barcode EAN13 Text",
      displayName: null,
      category: "Display",
      size: 72692,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.9375
        }
      },
      axes: [],
      designers: ["Lasse Fister"],
      lastModified: "2022-04-26",
      dateAdded: "2020-10-25",
      popularity: 1414,
      trending: 852,
      defaultSort: 1349,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Baskerville",
      displayName: null,
      category: "Serif",
      size: 165649,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.24
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.24
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.24
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-30",
      popularity: 61,
      trending: 1327,
      defaultSort: 58,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Bodoni",
      displayName: null,
      category: "Serif",
      size: 106136,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Pablo Impallari", "Rodrigo Fuenzalida"],
      lastModified: "2023-03-21",
      dateAdded: "2022-04-13",
      popularity: 549,
      trending: 139,
      defaultSort: 566,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Caslon Display",
      displayName: null,
      category: "Serif",
      size: 101384,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.236
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2017-11-29",
      popularity: 868,
      trending: 1202,
      defaultSort: 866,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Caslon Text",
      displayName: null,
      category: "Serif",
      size: 97869,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.23
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.23
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.23
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2023-05-02",
      dateAdded: "2013-03-14",
      popularity: 290,
      trending: 1247,
      defaultSort: 304,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Libre Franklin",
      displayName: null,
      category: "Sans Serif",
      size: 108354,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 49,
      trending: 1295,
      defaultSort: 49,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Licorice",
      displayName: null,
      category: "Handwriting",
      size: 154512,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-18",
      popularity: 1159,
      trending: 1727,
      defaultSort: 1130,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Life Savers",
      displayName: null,
      category: "Display",
      size: 194130,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 7,
          lineHeight: 1.222
        },
        "700": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.222
        },
        "800": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.222
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-13",
      popularity: 859,
      trending: 326,
      defaultSort: 858,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lilita One",
      displayName: null,
      category: "Display",
      size: 15298,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.143
        }
      },
      axes: [],
      designers: ["Juan Montoreano"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 131,
      trending: 748,
      defaultSort: 125,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lily Script One",
      displayName: null,
      category: "Display",
      size: 20248,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.376
        }
      },
      axes: [],
      designers: ["Julia Petretta"],
      lastModified: "2022-09-21",
      dateAdded: "2013-06-05",
      popularity: 936,
      trending: 1758,
      defaultSort: 925,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Limelight",
      displayName: null,
      category: "Display",
      size: 132292,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.21728515625
        }
      },
      axes: [],
      designers: ["Nicole Fally", "Sorkin Type"],
      lastModified: "2023-04-27",
      dateAdded: "2011-05-25",
      popularity: 597,
      trending: 1090,
      defaultSort: 612,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Linden Hill",
      displayName: null,
      category: "Serif",
      size: 54717,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.347900390625
        },
        "400i": {
          thickness: 4,
          slant: 2,
          width: 5,
          lineHeight: 1.347900390625
        }
      },
      axes: [],
      designers: ["Barry Schwartz"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-19",
      popularity: 1175,
      trending: 1580,
      defaultSort: 1143,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Literata",
      displayName: null,
      category: "Serif",
      size: 928930,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 7,
          max: 72,
          defaultValue: 14
        },
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["TypeTogether"],
      lastModified: "2023-06-07",
      dateAdded: "2018-12-06",
      popularity: 263,
      trending: 146,
      defaultSort: 275,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Liu Jian Mao Cao",
      displayName: null,
      category: "Handwriting",
      size: 4951804,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Liu Zhengjiang", "Kimberly Geswein", "ZhongQi"],
      lastModified: "2022-09-27",
      dateAdded: "2019-03-17",
      popularity: 1194,
      trending: 118,
      defaultSort: 1160,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Livvic",
      displayName: null,
      category: "Sans Serif",
      size: 105588,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        }
      },
      axes: [],
      designers: ["LV=", "Jacques Le Bailly"],
      lastModified: "2023-05-02",
      dateAdded: "2019-06-21",
      popularity: 483,
      trending: 284,
      defaultSort: 502,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lobster",
      displayName: null,
      category: "Display",
      size: 406076,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 5,
          width: 6,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type", "Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-17",
      popularity: 85,
      trending: 1375,
      defaultSort: 81,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lobster Two",
      displayName: null,
      category: "Display",
      size: 90834,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.25
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.25
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.25
        },
        "700i": {
          thickness: 5,
          slant: 5,
          width: 6,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-21",
      popularity: 176,
      trending: 1251,
      defaultSort: 177,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Londrina Outline",
      displayName: null,
      category: "Display",
      size: 167112,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 1,
          slant: 1,
          width: 6,
          lineHeight: 1.183
        }
      },
      axes: [],
      designers: ["Marcelo Magalh\xE3es"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 989,
      trending: 572,
      defaultSort: 970,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Londrina Shadow",
      displayName: null,
      category: "Display",
      size: 179844,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.183
        }
      },
      axes: [],
      designers: ["Marcelo Magalh\xE3es"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 943,
      trending: 580,
      defaultSort: 932,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Londrina Sketch",
      displayName: null,
      category: "Display",
      size: 332856,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.183
        }
      },
      axes: [],
      designers: ["Marcelo Magalh\xE3es"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 1338,
      trending: 1429,
      defaultSort: 1284,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Londrina Solid",
      displayName: null,
      category: "Display",
      size: 88050,
      subsets: ["menu", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.183
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.183
        },
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.183
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.183
        }
      },
      axes: [],
      designers: ["Marcelo Magalh\xE3es"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 365,
      trending: 1357,
      defaultSort: 385,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Long Cang",
      displayName: null,
      category: "Handwriting",
      size: 5162508,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Chen Xiaomin"],
      lastModified: "2022-09-27",
      dateAdded: "2019-03-17",
      popularity: 1190,
      trending: 130,
      defaultSort: 1156,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lora",
      displayName: null,
      category: "Serif",
      size: 217674,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.28
        },
        "400i": {
          thickness: 4,
          slant: 2,
          width: 7,
          lineHeight: 1.28
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.28
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.28
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Cyreal"],
      lastModified: "2023-02-22",
      dateAdded: "2011-07-06",
      popularity: 33,
      trending: 855,
      defaultSort: 34,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Love Light",
      displayName: null,
      category: "Handwriting",
      size: 168004,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-12-02",
      popularity: 1503,
      trending: 1628,
      defaultSort: 1400,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Love Ya Like A Sister",
      displayName: null,
      category: "Display",
      size: 135536,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2451171875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-06",
      popularity: 664,
      trending: 627,
      defaultSort: 670,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Loved by the King",
      displayName: null,
      category: "Handwriting",
      size: 18417,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 5,
          lineHeight: 1.72607421875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-06",
      popularity: 662,
      trending: 22,
      defaultSort: 181,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lovers Quarrel",
      displayName: null,
      category: "Handwriting",
      size: 110424,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 5,
          width: 3,
          lineHeight: 1.127
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-29",
      popularity: 1001,
      trending: 1641,
      defaultSort: 981,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Luckiest Guy",
      displayName: null,
      category: "Display",
      size: 73320,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 259,
      trending: 1172,
      defaultSort: 271,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lusitana",
      displayName: null,
      category: "Serif",
      size: 16635,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.297
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.297
        }
      },
      axes: [],
      designers: ["Ana Paula Megda"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 332,
      trending: 851,
      defaultSort: 350,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Lustria",
      displayName: null,
      category: "Serif",
      size: 18375,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.282
        }
      },
      axes: [],
      designers: ["MADType"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 520,
      trending: 1723,
      defaultSort: 537,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Luxurious Roman",
      displayName: null,
      category: "Display",
      size: 143608,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-11-18",
      popularity: 1448,
      trending: 100,
      defaultSort: 1368,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Luxurious Script",
      displayName: null,
      category: "Handwriting",
      size: 387952,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-02",
      popularity: 1344,
      trending: 1678,
      defaultSort: 1290,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "M PLUS 1",
      displayName: null,
      category: "Sans Serif",
      size: 4133100,
      subsets: ["menu", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Coji Morishita"],
      lastModified: "2022-09-27",
      dateAdded: "2021-08-25",
      popularity: 553,
      trending: 1174,
      defaultSort: 571,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "M PLUS 1 Code",
      displayName: null,
      category: "Sans Serif",
      size: 3926772,
      subsets: ["menu", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Coji Morishita"],
      lastModified: "2022-09-27",
      dateAdded: "2021-09-21",
      popularity: 1183,
      trending: 1684,
      defaultSort: 1150,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "M PLUS 1p",
      displayName: null,
      category: "Sans Serif",
      size: 1767323,
      subsets: [
        "menu",
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "hebrew",
        "japanese",
        "latin",
        "latin-ext",
        "vietnamese"
      ],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        }
      },
      axes: [],
      designers: ["Coji Morishita", "M+ Fonts Project"],
      lastModified: "2023-05-02",
      dateAdded: "2017-06-12",
      popularity: 132,
      trending: 653,
      defaultSort: 126,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "M PLUS 2",
      displayName: null,
      category: "Sans Serif",
      size: 4141232,
      subsets: ["menu", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Coji Morishita"],
      lastModified: "2022-09-27",
      dateAdded: "2021-08-25",
      popularity: 656,
      trending: 99,
      defaultSort: 663,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "M PLUS Code Latin",
      displayName: null,
      category: "Sans Serif",
      size: 158492,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.235
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 100,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Coji Morishita"],
      lastModified: "2023-03-09",
      dateAdded: "2021-09-21",
      popularity: 1527,
      trending: 693,
      defaultSort: 1417,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "M PLUS Rounded 1c",
      displayName: null,
      category: "Sans Serif",
      size: 3404494,
      subsets: [
        "menu",
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "hebrew",
        "japanese",
        "latin",
        "latin-ext",
        "vietnamese"
      ],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.485
        }
      },
      axes: [],
      designers: ["Coji Morishita", "M+ Fonts Project"],
      lastModified: "2022-09-27",
      dateAdded: "2018-05-17",
      popularity: 98,
      trending: 480,
      defaultSort: 93,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ma Shan Zheng",
      displayName: null,
      category: "Handwriting",
      size: 5867444,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Ma ShanZheng"],
      lastModified: "2022-09-27",
      dateAdded: "2019-03-17",
      popularity: 781,
      trending: 1673,
      defaultSort: 782,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Macondo",
      displayName: null,
      category: "Display",
      size: 22083,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.18
        }
      },
      axes: [],
      designers: ["John Vargas Beltr\xE1n"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 389,
      trending: 1709,
      defaultSort: 409,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Macondo Swash Caps",
      displayName: null,
      category: "Display",
      size: 17700,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.18
        }
      },
      axes: [],
      designers: ["John Vargas Beltr\xE1n"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 1072,
      trending: 1096,
      defaultSort: 1056,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mada",
      displayName: null,
      category: "Sans Serif",
      size: 181408,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Khaled Hosny", "Paul D. Hunt"],
      lastModified: "2023-05-23",
      dateAdded: "2017-07-26",
      popularity: 327,
      trending: 1277,
      defaultSort: 346,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Magra",
      displayName: null,
      category: "Sans Serif",
      size: 23060,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.215
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.215
        }
      },
      axes: [],
      designers: ["FontFuror"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 584,
      trending: 1284,
      defaultSort: 600,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Maiden Orange",
      displayName: null,
      category: "Display",
      size: 60688,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-20",
      popularity: 1224,
      trending: 1347,
      defaultSort: 1185,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Maitree",
      displayName: null,
      category: "Serif",
      size: 189768,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 548,
      trending: 624,
      defaultSort: 565,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Major Mono Display",
      displayName: null,
      category: "Monospace",
      size: 126788,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Emre Parlak"],
      lastModified: "2023-05-02",
      dateAdded: "2018-12-11",
      popularity: 881,
      trending: 221,
      defaultSort: 876,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mako",
      displayName: null,
      category: "Sans Serif",
      size: 47759,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.30810546875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-11",
      popularity: 806,
      trending: 174,
      defaultSort: 808,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mali",
      displayName: null,
      category: "Handwriting",
      size: 114265,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2018-09-10",
      popularity: 457,
      trending: 178,
      defaultSort: 474,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mallanna",
      displayName: null,
      category: "Sans Serif",
      size: 235173,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.849425287356322
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-04-26",
      dateAdded: "2014-12-10",
      popularity: 626,
      trending: 327,
      defaultSort: 637,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mandali",
      displayName: null,
      category: "Sans Serif",
      size: 231346,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.9772151898734178
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-04-26",
      dateAdded: "2014-12-10",
      popularity: 325,
      trending: 1035,
      defaultSort: 344,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Manjari",
      displayName: null,
      category: "Sans Serif",
      size: 151750,
      subsets: ["menu", "latin", "latin-ext", "malayalam"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.07421875
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.0986328125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171875
        }
      },
      axes: [],
      designers: ["Santhosh Thottingal"],
      lastModified: "2022-04-26",
      dateAdded: "2018-11-21",
      popularity: 559,
      trending: 1273,
      defaultSort: 577,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Manrope",
      displayName: null,
      category: "Sans Serif",
      size: 165420,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.366
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.366
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.366
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.366
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.366
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.366
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.366
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Mikhail Sharanda"],
      lastModified: "2023-05-02",
      dateAdded: "2019-10-02",
      popularity: 47,
      trending: 522,
      defaultSort: 46,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mansalva",
      displayName: null,
      category: "Handwriting",
      size: 355776,
      subsets: ["menu", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.578
        }
      },
      axes: [],
      designers: ["Carolina Short"],
      lastModified: "2022-11-09",
      dateAdded: "2019-08-29",
      popularity: 672,
      trending: 1497,
      defaultSort: 678,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Manuale",
      displayName: null,
      category: "Serif",
      size: 194526,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-03-21",
      dateAdded: "2017-07-31",
      popularity: 995,
      trending: 505,
      defaultSort: 976,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Marcellus",
      displayName: null,
      category: "Serif",
      size: 24460,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25390625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-05-09",
      popularity: 209,
      trending: 767,
      defaultSort: 212,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Marcellus SC",
      displayName: null,
      category: "Serif",
      size: 24844,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25390625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-05-09",
      popularity: 522,
      trending: 1455,
      defaultSort: 539,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Marck Script",
      displayName: null,
      category: "Handwriting",
      size: 39169,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 7,
          width: 7,
          lineHeight: 1.249
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2023-05-02",
      dateAdded: "2011-10-12",
      popularity: 255,
      trending: 1176,
      defaultSort: 268,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Margarine",
      displayName: null,
      category: "Display",
      size: 83505,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.34423828125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-16",
      popularity: 1127,
      trending: 368,
      defaultSort: 1105,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Marhey",
      displayName: null,
      category: "Display",
      size: 198704,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.74
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.74
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.74
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.74
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.74
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Nur Syamsi", "Bustanul Arifin"],
      lastModified: "2023-03-09",
      dateAdded: "2022-10-06",
      popularity: 1447,
      trending: 1651,
      defaultSort: 1136,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Markazi Text",
      displayName: null,
      category: "Serif",
      size: 296896,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2001953125
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Borna Izadpanah", "Florian Runge", "Fiona Ross"],
      lastModified: "2022-09-21",
      dateAdded: "2018-06-05",
      popularity: 410,
      trending: 24,
      defaultSort: 215,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Marko One",
      displayName: null,
      category: "Serif",
      size: 21411,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.3408203125
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-26",
      dateAdded: "2011-12-13",
      popularity: 1220,
      trending: 1098,
      defaultSort: 1181,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Marmelad",
      displayName: null,
      category: "Sans Serif",
      size: 142764,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.193
        }
      },
      axes: [],
      designers: ["Cyreal", "Manvel Shmavonyan"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-07",
      popularity: 572,
      trending: 148,
      defaultSort: 588,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Martel",
      displayName: null,
      category: "Serif",
      size: 89593,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.687
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.687
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.687
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.687
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.687
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.687
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 4,
          lineHeight: 1.687
        }
      },
      axes: [],
      designers: ["Dan Reynolds"],
      lastModified: "2022-09-21",
      dateAdded: "2015-04-20",
      popularity: 173,
      trending: 1046,
      defaultSort: 174,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Martel Sans",
      displayName: null,
      category: "Sans Serif",
      size: 152885,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 4,
          lineHeight: 1.824
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.824
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 4,
          lineHeight: 1.824
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 4,
          lineHeight: 1.824
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 4,
          lineHeight: 1.824
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.824
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 4,
          lineHeight: 1.824
        }
      },
      axes: [],
      designers: ["Dan Reynolds", "Mathieu R\xE9guer"],
      lastModified: "2022-09-21",
      dateAdded: "2015-03-04",
      popularity: 390,
      trending: 1702,
      defaultSort: 410,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Martian Mono",
      displayName: null,
      category: "Monospace",
      size: 148460,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 112.5,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Roman Shamin", "Evil Martians"],
      lastModified: "2023-02-23",
      dateAdded: "2022-11-25",
      popularity: 1200,
      trending: 17,
      defaultSort: 104,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Marvel",
      displayName: null,
      category: "Sans Serif",
      size: 21269,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.21
        },
        "400i": {
          thickness: 3,
          slant: 4,
          width: 6,
          lineHeight: 1.21
        },
        "700": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.21
        },
        "700i": {
          thickness: 4,
          slant: 4,
          width: 6,
          lineHeight: 1.21
        }
      },
      axes: [],
      designers: ["Carolina Trebol"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-03",
      popularity: 684,
      trending: 659,
      defaultSort: 690,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mate",
      displayName: null,
      category: "Serif",
      size: 63380,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.22
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 6,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-04-04",
      dateAdded: "2011-11-02",
      popularity: 232,
      trending: 263,
      defaultSort: 244,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mate SC",
      displayName: null,
      category: "Serif",
      size: 71092,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-04-27",
      dateAdded: "2011-11-02",
      popularity: 247,
      trending: 199,
      defaultSort: 260,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Maven Pro",
      displayName: null,
      category: "Sans Serif",
      size: 90712,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.175
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.175
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.175
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.175
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Joe Prince"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-25",
      popularity: 74,
      trending: 474,
      defaultSort: 70,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "McLaren",
      displayName: null,
      category: "Display",
      size: 31885,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.4345703125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2012-08-13",
      popularity: 840,
      trending: 1268,
      defaultSort: 841,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mea Culpa",
      displayName: null,
      category: "Handwriting",
      size: 162232,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-12-02",
      popularity: 1350,
      trending: 124,
      defaultSort: 1296,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Meddon",
      displayName: null,
      category: "Handwriting",
      size: 85171,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 5,
          width: 4,
          lineHeight: 2.10791015625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-02-02",
      popularity: 751,
      trending: 1647,
      defaultSort: 753,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "MedievalSharp",
      displayName: null,
      category: "Display",
      size: 75332,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.1298828125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-02",
      popularity: 1133,
      trending: 1555,
      defaultSort: 1110,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Medula One",
      displayName: null,
      category: "Display",
      size: 16364,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 1,
          lineHeight: 1.008
        }
      },
      axes: [],
      designers: ["LatinoType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1005,
      trending: 1016,
      defaultSort: 984,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Meera Inimai",
      displayName: null,
      category: "Sans Serif",
      size: 72272,
      subsets: ["menu", "latin", "tamil"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6455078125
        }
      },
      axes: [],
      designers: ["SMC"],
      lastModified: "2022-04-26",
      dateAdded: "2016-05-31",
      popularity: 666,
      trending: 1761,
      defaultSort: 672,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Megrim",
      displayName: null,
      category: "Display",
      size: 27044,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 7,
          lineHeight: 1.17
        }
      },
      axes: [],
      designers: ["Daniel Johnson"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-04",
      popularity: 743,
      trending: 684,
      defaultSort: 746,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Meie Script",
      displayName: null,
      category: "Handwriting",
      size: 128428,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 9,
          width: 6,
          lineHeight: 1.2666015625
        }
      },
      axes: [],
      designers: ["Johan Kallas", "Mihkel Virkus"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-21",
      popularity: 1123,
      trending: 717,
      defaultSort: 1102,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Meow Script",
      displayName: null,
      category: "Handwriting",
      size: 601304,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-02",
      popularity: 1260,
      trending: 804,
      defaultSort: 1219,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Merienda",
      displayName: null,
      category: "Handwriting",
      size: 226360,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.444
        },
        "400": {
          thickness: 5,
          slant: 3,
          width: 8,
          lineHeight: 1.444
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.444
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.444
        },
        "700": {
          thickness: 6,
          slant: 3,
          width: 8,
          lineHeight: 1.444
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.444
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.444
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2012-10-31",
      popularity: 310,
      trending: 300,
      defaultSort: 326,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Merriweather",
      displayName: null,
      category: "Serif",
      size: 150902,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "300i": {
          thickness: 4,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "900i": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-11",
      popularity: 26,
      trending: 1132,
      defaultSort: 27,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Merriweather Sans",
      displayName: null,
      category: "Sans Serif",
      size: 251640,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "300i": {
          thickness: 4,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "800i": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.257
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Sorkin Type"],
      lastModified: "2023-04-27",
      dateAdded: "2013-03-06",
      popularity: 110,
      trending: 1351,
      defaultSort: 106,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Metal",
      displayName: null,
      category: "Display",
      size: 142428,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05078125
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-26",
      dateAdded: "2011-03-02",
      popularity: 1298,
      trending: 1790,
      defaultSort: 1255,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Metal Mania",
      displayName: null,
      category: "Display",
      size: 123068,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.23828125
        }
      },
      axes: [],
      designers: ["Open Window"],
      lastModified: "2022-09-21",
      dateAdded: "2012-07-11",
      popularity: 1167,
      trending: 254,
      defaultSort: 1135,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Metamorphous",
      displayName: null,
      category: "Display",
      size: 27161,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["James Grieshaber"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 785,
      trending: 1011,
      defaultSort: 786,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Metrophobic",
      displayName: null,
      category: "Sans Serif",
      size: 79772,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.23291015625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2011-05-11",
      popularity: 646,
      trending: 191,
      defaultSort: 654,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Michroma",
      displayName: null,
      category: "Sans Serif",
      size: 64344,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.421875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-06-07",
      dateAdded: "2011-03-30",
      popularity: 449,
      trending: 1153,
      defaultSort: 470,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Milonga",
      displayName: null,
      category: "Display",
      size: 69301,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-30",
      popularity: 1128,
      trending: 1451,
      defaultSort: 1106,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Miltonian",
      displayName: null,
      category: "Display",
      size: 126804,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.192
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-06",
      popularity: 1423,
      trending: 1393,
      defaultSort: 1356,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Miltonian Tattoo",
      displayName: null,
      category: "Display",
      size: 107880,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.192
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-06",
      popularity: 1429,
      trending: 1519,
      defaultSort: 1359,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mina",
      displayName: null,
      category: "Sans Serif",
      size: 151922,
      subsets: ["menu", "bengali", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        }
      },
      axes: [],
      designers: ["Suman Bhandary", "Natanael Gama", "Mooniak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-28",
      popularity: 1017,
      trending: 1631,
      defaultSort: 998,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mingzat",
      displayName: null,
      category: "Sans Serif",
      size: 191316,
      subsets: ["menu", "latin", "latin-ext", "lepcha"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.097
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-31",
      dateAdded: "2022-05-25",
      popularity: 1571,
      trending: 215,
      defaultSort: 1373,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Lepc",
      primaryLanguage: ""
    },
    {
      family: "Miniver",
      displayName: null,
      category: "Display",
      size: 29283,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 5,
          width: 7,
          lineHeight: 1.4580078125
        }
      },
      axes: [],
      designers: ["Open Window"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1006,
      trending: 704,
      defaultSort: 985,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Miriam Libre",
      displayName: null,
      category: "Sans Serif",
      size: 74702,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 3,
          lineHeight: 1.313
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 3,
          lineHeight: 1.313
        }
      },
      axes: [],
      designers: ["Michal Sahar"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-20",
      popularity: 621,
      trending: 1084,
      defaultSort: 633,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mirza",
      displayName: null,
      category: "Display",
      size: 177353,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["KB Studio"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 712,
      trending: 893,
      defaultSort: 717,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Miss Fajardose",
      displayName: null,
      category: "Handwriting",
      size: 30209,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 9,
          width: 3,
          lineHeight: 1.248
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-30",
      popularity: 1326,
      trending: 617,
      defaultSort: 1276,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mitr",
      displayName: null,
      category: "Sans Serif",
      size: 217766,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.57
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.57
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.57
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.57
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.57
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.57
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 242,
      trending: 491,
      defaultSort: 255,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mochiy Pop One",
      displayName: null,
      category: "Sans Serif",
      size: 5163948,
      subsets: ["menu", "japanese", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["FONTDASU"],
      lastModified: "2022-09-27",
      dateAdded: "2021-04-14",
      popularity: 652,
      trending: 65,
      defaultSort: 659,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mochiy Pop P One",
      displayName: null,
      category: "Sans Serif",
      size: 5164140,
      subsets: ["menu", "japanese", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["FONTDASU"],
      lastModified: "2022-09-27",
      dateAdded: "2021-04-14",
      popularity: 1118,
      trending: 671,
      defaultSort: 1097,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Modak",
      displayName: null,
      category: "Display",
      size: 271464,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 10,
          slant: 1,
          width: 4,
          lineHeight: 1.505859375
        }
      },
      axes: [],
      designers: ["Ek Type"],
      lastModified: "2022-09-21",
      dateAdded: "2015-02-18",
      popularity: 842,
      trending: 269,
      defaultSort: 843,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Modern Antiqua",
      displayName: null,
      category: "Display",
      size: 26792,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.13427734375
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-13",
      popularity: 1176,
      trending: 1324,
      defaultSort: 1144,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mogra",
      displayName: null,
      category: "Display",
      size: 323028,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Lipi Raval"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 860,
      trending: 1133,
      defaultSort: 859,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mohave",
      displayName: null,
      category: "Sans Serif",
      size: 66806,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Gumpita Rahayu"],
      lastModified: "2022-09-21",
      dateAdded: "2020-01-23",
      popularity: 1085,
      trending: 513,
      defaultSort: 1068,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Moirai One",
      displayName: null,
      category: "Display",
      size: 2102128,
      subsets: ["menu", "korean", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Jiyeon Park", "JAMO"],
      lastModified: "2023-06-07",
      dateAdded: "2023-06-05",
      popularity: 1388,
      trending: 1816,
      defaultSort: 160,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Kore",
      primaryLanguage: ""
    },
    {
      family: "Molengo",
      displayName: null,
      category: "Sans Serif",
      size: 33658,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.1962890625
        }
      },
      axes: [],
      designers: ["Denis Jacquerye"],
      lastModified: "2022-09-21",
      dateAdded: "2010-04-19",
      popularity: 636,
      trending: 372,
      defaultSort: 647,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Molle",
      displayName: null,
      category: "Handwriting",
      size: 34080,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400i": {
          thickness: 6,
          slant: 8,
          width: 7,
          lineHeight: 1.24658203125
        }
      },
      axes: [],
      designers: ["Elena Albertoni"],
      lastModified: "2022-04-26",
      dateAdded: "2012-09-18",
      popularity: 1109,
      trending: 329,
      defaultSort: 1089,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Monda",
      displayName: null,
      category: "Sans Serif",
      size: 159436,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.62890625
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.62890625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-30",
      popularity: 348,
      trending: 1612,
      defaultSort: 366,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Monofett",
      displayName: null,
      category: "Monospace",
      size: 72328,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 10,
          slant: 1,
          width: 7,
          lineHeight: 1.130859375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-23",
      dateAdded: "2011-05-04",
      popularity: 1026,
      trending: 127,
      defaultSort: 1014,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Monomaniac One",
      displayName: null,
      category: "Sans Serif",
      size: 122056,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Maniackers Design"],
      lastModified: "2023-05-23",
      dateAdded: "2023-05-23",
      popularity: 1409,
      trending: 1793,
      defaultSort: 238,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Monoton",
      displayName: null,
      category: "Display",
      size: 26536,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.556640625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-24",
      popularity: 320,
      trending: 427,
      defaultSort: 337,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Monsieur La Doulaise",
      displayName: null,
      category: "Handwriting",
      size: 26472,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 10,
          width: 5,
          lineHeight: 1.561
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-30",
      popularity: 586,
      trending: 520,
      defaultSort: 602,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Montaga",
      displayName: null,
      category: "Serif",
      size: 17847,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        }
      },
      axes: [],
      designers: ["Alejandra Rodriguez"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 809,
      trending: 416,
      defaultSort: 811,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Montagu Slab",
      displayName: null,
      category: "Serif",
      size: 529316,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.282
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.282
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.282
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.282
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.282
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.282
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.282
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 16,
          max: 144,
          defaultValue: 144
        },
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Florian Karsten"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-20",
      popularity: 1023,
      trending: 1109,
      defaultSort: 1009,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "MonteCarlo",
      displayName: null,
      category: "Handwriting",
      size: 393456,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.7
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-05-14",
      popularity: 1069,
      trending: 1060,
      defaultSort: 1053,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Montez",
      displayName: null,
      category: "Handwriting",
      size: 77132,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 5,
          lineHeight: 1.30810546875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-17",
      popularity: 741,
      trending: 1073,
      defaultSort: 744,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Montserrat",
      displayName: null,
      category: "Sans Serif",
      size: 423806,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1.219
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Julieta Ulanovsky", "Sol Matas", "Juan Pablo del Peral", "Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 7,
      trending: 535,
      defaultSort: 8,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Montserrat Alternates",
      displayName: null,
      category: "Sans Serif",
      size: 215384,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.219
        }
      },
      axes: [],
      designers: ["Julieta Ulanovsky", "Sol Matas", "Juan Pablo del Peral", "Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-01",
      popularity: 169,
      trending: 212,
      defaultSort: 170,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Montserrat Subrayada",
      displayName: null,
      category: "Sans Serif",
      size: 11521,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.219
        }
      },
      axes: [],
      designers: ["Julieta Ulanovsky"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-01",
      popularity: 715,
      trending: 441,
      defaultSort: 720,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Moo Lah Lah",
      displayName: null,
      category: "Display",
      size: 316228,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-26",
      popularity: 1521,
      trending: 493,
      defaultSort: 1413,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Moon Dance",
      displayName: null,
      category: "Handwriting",
      size: 276360,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-18",
      popularity: 1056,
      trending: 639,
      defaultSort: 1041,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Moul",
      displayName: null,
      category: "Display",
      size: 166200,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-26",
      dateAdded: "2011-03-02",
      popularity: 1047,
      trending: 287,
      defaultSort: 1032,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Moulpali",
      displayName: null,
      category: "Display",
      size: 100364,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.197265625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-26",
      dateAdded: "2011-03-02",
      popularity: 1425,
      trending: 1487,
      defaultSort: 1357,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mountains of Christmas",
      displayName: null,
      category: "Display",
      size: 122774,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.38671875
        },
        "700": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.38671875
        }
      },
      axes: [],
      designers: ["Tart Workshop"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-14",
      popularity: 908,
      trending: 1350,
      defaultSort: 900,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mouse Memoirs",
      displayName: null,
      category: "Sans Serif",
      size: 32696,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 2,
          lineHeight: 1.14501953125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2012-11-02",
      popularity: 760,
      trending: 252,
      defaultSort: 761,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mr Bedfort",
      displayName: null,
      category: "Handwriting",
      size: 21797,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.676
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2023-05-02",
      dateAdded: "2012-01-11",
      popularity: 1342,
      trending: 691,
      defaultSort: 1288,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mr Dafoe",
      displayName: null,
      category: "Handwriting",
      size: 24726,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 10,
          width: 6,
          lineHeight: 1.397
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-30",
      popularity: 250,
      trending: 877,
      defaultSort: 263,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mr De Haviland",
      displayName: null,
      category: "Handwriting",
      size: 23988,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 9,
          width: 4,
          lineHeight: 1.317
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-30",
      popularity: 754,
      trending: 579,
      defaultSort: 755,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mrs Saint Delafield",
      displayName: null,
      category: "Handwriting",
      size: 26511,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 9,
          width: 4,
          lineHeight: 1.525
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 486,
      trending: 1221,
      defaultSort: 505,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mrs Sheppards",
      displayName: null,
      category: "Handwriting",
      size: 22988,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 10,
          width: 5,
          lineHeight: 1.337
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-30",
      popularity: 1180,
      trending: 419,
      defaultSort: 1147,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ms Madi",
      displayName: null,
      category: "Handwriting",
      size: 144208,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-23",
      popularity: 750,
      trending: 223,
      defaultSort: 752,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mukta",
      displayName: null,
      category: "Sans Serif",
      size: 417222,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        }
      },
      axes: [],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2017-01-26",
      popularity: 34,
      trending: 1575,
      defaultSort: 35,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mukta Mahee",
      displayName: null,
      category: "Sans Serif",
      size: 211430,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        }
      },
      axes: [],
      designers: ["Ek Type"],
      lastModified: "2023-05-02",
      dateAdded: "2017-05-19",
      popularity: 838,
      trending: 730,
      defaultSort: 839,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mukta Malar",
      displayName: null,
      category: "Sans Serif",
      size: 246319,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        }
      },
      axes: [],
      designers: ["Ek Type"],
      lastModified: "2022-09-21",
      dateAdded: "2017-02-13",
      popularity: 291,
      trending: 1548,
      defaultSort: 305,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mukta Vaani",
      displayName: null,
      category: "Sans Serif",
      size: 469868,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.662
        }
      },
      axes: [],
      designers: ["Ek Type"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 731,
      trending: 922,
      defaultSort: 736,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mulish",
      displayName: null,
      category: "Sans Serif",
      size: 215768,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.255
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams", "Cyreal", "Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-25",
      popularity: 41,
      trending: 1191,
      defaultSort: 40,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Murecho",
      displayName: null,
      category: "Sans Serif",
      size: 1430664,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "japanese", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Neil Summerour"],
      lastModified: "2023-06-29",
      dateAdded: "2021-10-27",
      popularity: 1068,
      trending: 1770,
      defaultSort: 1052,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: "en_Latn"
    },
    {
      family: "MuseoModerno",
      displayName: null,
      category: "Display",
      size: 203500,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.59
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2020-05-17",
      popularity: 978,
      trending: 1504,
      defaultSort: 960,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "My Soul",
      displayName: null,
      category: "Handwriting",
      size: 145468,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-23",
      popularity: 1471,
      trending: 1269,
      defaultSort: 1386,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mynerve",
      displayName: null,
      category: "Handwriting",
      size: 279224,
      subsets: ["menu", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31
        }
      },
      axes: [],
      designers: ["Carolina Short"],
      lastModified: "2023-05-02",
      dateAdded: "2023-01-03",
      popularity: 1297,
      trending: 76,
      defaultSort: 879,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Mystery Quest",
      displayName: null,
      category: "Display",
      size: 27518,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.365234375
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 973,
      trending: 194,
      defaultSort: 955,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "NTR",
      displayName: null,
      category: "Sans Serif",
      size: 147346,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 2.1201171875
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-09-21",
      dateAdded: "2014-12-10",
      popularity: 581,
      trending: 908,
      defaultSort: 597,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nabla",
      displayName: null,
      category: "Display",
      size: 1643616,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "math", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.643
        }
      },
      axes: [
        {
          tag: "EDPT",
          min: 0,
          max: 200,
          defaultValue: 100
        },
        {
          tag: "EHLT",
          min: 0,
          max: 24,
          defaultValue: 12
        }
      ],
      designers: ["Arthur Reinders Folmer", "Just van Rossum"],
      lastModified: "2023-06-07",
      dateAdded: "2022-08-15",
      popularity: 1379,
      trending: 293,
      defaultSort: 1254,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV1", "OTSVG"],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nanum Brush Script",
      displayName: null,
      category: "Handwriting",
      size: 3745376,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Sandoll"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-05",
      popularity: 476,
      trending: 1215,
      defaultSort: 495,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nanum Gothic",
      displayName: null,
      category: "Sans Serif",
      size: 2341766,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Sandoll"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-05",
      popularity: 54,
      trending: 1287,
      defaultSort: 53,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nanum Gothic Coding",
      displayName: null,
      category: "Monospace",
      size: 2281082,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Sandoll"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-05",
      popularity: 297,
      trending: 1074,
      defaultSort: 311,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nanum Myeongjo",
      displayName: null,
      category: "Serif",
      size: 4227980,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.150390625
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.150390625
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.150390625
        }
      },
      axes: [],
      designers: ["Fontrix", "Sandoll"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-05",
      popularity: 121,
      trending: 820,
      defaultSort: 115,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nanum Pen Script",
      displayName: null,
      category: "Handwriting",
      size: 3789752,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.15
        }
      },
      axes: [],
      designers: ["Sandoll"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-05",
      popularity: 335,
      trending: 832,
      defaultSort: 353,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Narnoor",
      displayName: null,
      category: "Serif",
      size: 88492,
      subsets: ["menu", "gunjala-gondi", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.551
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-06-29",
      dateAdded: "2023-06-27",
      popularity: 880,
      trending: 1,
      defaultSort: 2,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Gong",
      primaryLanguage: ""
    },
    {
      family: "Neonderthaw",
      displayName: null,
      category: "Handwriting",
      size: 276228,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.35
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-18",
      popularity: 1280,
      trending: 274,
      defaultSort: 1237,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nerko One",
      displayName: null,
      category: "Handwriting",
      size: 102416,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.211
        }
      },
      axes: [],
      designers: ["Nermin Kahrimanovic"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-06",
      popularity: 853,
      trending: 451,
      defaultSort: 852,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Neucha",
      displayName: null,
      category: "Handwriting",
      size: 67476,
      subsets: ["menu", "cyrillic", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.1015625
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2010-09-21",
      popularity: 276,
      trending: 1299,
      defaultSort: 288,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Neuton",
      displayName: null,
      category: "Serif",
      size: 59692,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.26513671875
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.26513671875
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.26513671875
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.26513671875
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.26513671875
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.26513671875
        }
      },
      axes: [],
      designers: ["Brian Zick"],
      lastModified: "2023-05-02",
      dateAdded: "2011-02-09",
      popularity: 253,
      trending: 463,
      defaultSort: 266,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "New Rocker",
      displayName: null,
      category: "Display",
      size: 64235,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.229
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-30",
      popularity: 1112,
      trending: 1183,
      defaultSort: 1092,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "New Tegomin",
      displayName: null,
      category: "Serif",
      size: 7450688,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Kousuke Nagai"],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-13",
      popularity: 1232,
      trending: 696,
      defaultSort: 1194,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "News Cycle",
      displayName: null,
      category: "Sans Serif",
      size: 79988,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 1.64453125
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.64453125
        }
      },
      axes: [],
      designers: ["Nathan Willis"],
      lastModified: "2023-05-02",
      dateAdded: "2011-04-27",
      popularity: 261,
      trending: 1286,
      defaultSort: 273,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Newsreader",
      displayName: null,
      category: "Serif",
      size: 473674,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 6,
          max: 72,
          defaultValue: 16
        },
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Production Type"],
      lastModified: "2022-09-21",
      dateAdded: "2020-07-01",
      popularity: 440,
      trending: 1341,
      defaultSort: 462,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Niconne",
      displayName: null,
      category: "Handwriting",
      size: 24707,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 6,
          width: 5,
          lineHeight: 1.21240234375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 528,
      trending: 585,
      defaultSort: 546,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Niramit",
      displayName: null,
      category: "Sans Serif",
      size: 111950,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 285,
      trending: 86,
      defaultSort: 299,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nixie One",
      displayName: null,
      category: "Display",
      size: 40924,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 8,
          lineHeight: 1.136
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-21",
      popularity: 632,
      trending: 1194,
      defaultSort: 643,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nobile",
      displayName: null,
      category: "Sans Serif",
      size: 77044,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.12744140625
        },
        "400i": {
          thickness: 4,
          slant: 3,
          width: 7,
          lineHeight: 1.4150390625
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.12744140625
        },
        "500i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.4150390625
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.12744140625
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.4150390625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-10",
      popularity: 582,
      trending: 840,
      defaultSort: 598,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nokora",
      displayName: null,
      category: "Sans Serif",
      size: 58633,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32177734375
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32177734375
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32177734375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32177734375
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32177734375
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-05-10",
      dateAdded: "2011-11-09",
      popularity: 907,
      trending: 294,
      defaultSort: 898,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Norican",
      displayName: null,
      category: "Handwriting",
      size: 27728,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 5,
          width: 6,
          lineHeight: 1.4091796875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-08",
      popularity: 555,
      trending: 749,
      defaultSort: 573,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nosifer",
      displayName: null,
      category: "Display",
      size: 22458,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 9,
          lineHeight: 1.740234375
        }
      },
      axes: [],
      designers: ["Typomondo"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1210,
      trending: 1453,
      defaultSort: 1174,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Notable",
      displayName: null,
      category: "Sans Serif",
      size: 38216,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Eli Block", "Hana Tanimura", "Noemie Le Coz"],
      lastModified: "2022-09-21",
      dateAdded: "2018-08-02",
      popularity: 729,
      trending: 1240,
      defaultSort: 734,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nothing You Could Do",
      displayName: null,
      category: "Handwriting",
      size: 22002,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 8,
          width: 8,
          lineHeight: 1.333984375
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-11",
      popularity: 381,
      trending: 1177,
      defaultSort: 402,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noticia Text",
      displayName: null,
      category: "Serif",
      size: 60942,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.36474609375
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.36474609375
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.36474609375
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 8,
          lineHeight: 1.36474609375
        }
      },
      axes: [],
      designers: ["JM Sol\xE9"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-08",
      popularity: 175,
      trending: 1186,
      defaultSort: 176,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Color Emoji",
      displayName: null,
      category: "Sans Serif",
      size: 24066744,
      subsets: ["menu", "emoji"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171875
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-31",
      dateAdded: "2021-02-16",
      popularity: 58,
      trending: 890,
      defaultSort: 1492,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: ["COLRV1", "OTSVG"],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Emoji",
      displayName: null,
      category: "Sans Serif",
      size: 1966648,
      subsets: ["menu", "emoji"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171875
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171875
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171875
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171875
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171875
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2022-04-29",
      popularity: 1079,
      trending: 270,
      defaultSort: 1499,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Kufi Arabic",
      displayName: null,
      category: "Sans Serif",
      size: 367488,
      subsets: ["menu", "arabic"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.897
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-19",
      popularity: 186,
      trending: 1412,
      defaultSort: 1494,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Music",
      displayName: null,
      category: "Sans Serif",
      size: 178928,
      subsets: ["menu", "latin", "latin-ext", "music"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.787
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1508,
      trending: 1796,
      defaultSort: 1405,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Naskh Arabic",
      displayName: null,
      category: "Serif",
      size: 311212,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.703
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.703
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.703
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.703
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 309,
      trending: 183,
      defaultSort: 324,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Noto Nastaliq Urdu",
      displayName: null,
      category: "Serif",
      size: 690188,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.5
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.5
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.5
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-19",
      popularity: 587,
      trending: 1594,
      defaultSort: 603,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Noto Rashi Hebrew",
      displayName: null,
      category: "Serif",
      size: 102208,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1500,
      trending: 434,
      defaultSort: 1399,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Hebr",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans",
      displayName: null,
      category: "Sans Serif",
      size: 486534,
      subsets: [
        "menu",
        "cyrillic",
        "cyrillic-ext",
        "devanagari",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "vietnamese"
      ],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.362
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.362
        },
        "700i": {
          thickness: 7,
          slant: 5,
          width: 7,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2013-02-27",
      popularity: 17,
      trending: 1201,
      defaultSort: 17,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Adlam",
      displayName: null,
      category: "Sans Serif",
      size: 136472,
      subsets: ["menu", "adlam", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-22",
      dateAdded: "2020-11-19",
      popularity: 1490,
      trending: 1363,
      defaultSort: 1393,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Adlam Unjoined",
      displayName: null,
      category: "Sans Serif",
      size: 74148,
      subsets: ["menu", "adlam", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1506,
      trending: 613,
      defaultSort: 1403,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Adlm",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Anatolian Hieroglyphs",
      displayName: null,
      category: "Sans Serif",
      size: 228424,
      subsets: ["menu", "anatolian-hieroglyphs"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.406
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1171,
      trending: 1675,
      defaultSort: 1501,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Arabic",
      displayName: null,
      category: "Sans Serif",
      size: 771644,
      subsets: ["menu", "arabic"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.112
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-06-01",
      dateAdded: "2020-11-19",
      popularity: 112,
      trending: 1511,
      defaultSort: 1493,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Armenian",
      displayName: null,
      category: "Sans Serif",
      size: 221724,
      subsets: ["menu", "armenian", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-19",
      popularity: 1015,
      trending: 1729,
      defaultSort: 996,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Armn",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Avestan",
      displayName: null,
      category: "Sans Serif",
      size: 60532,
      subsets: ["menu", "avestan", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-19",
      popularity: 1475,
      trending: 83,
      defaultSort: 1388,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Avst",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Balinese",
      displayName: null,
      category: "Sans Serif",
      size: 194288,
      subsets: ["menu", "balinese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.201
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.201
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.201
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.201
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1546,
      trending: 318,
      defaultSort: 1427,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Bali",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Bamum",
      displayName: null,
      category: "Sans Serif",
      size: 204724,
      subsets: ["menu", "bamum", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1565,
      trending: 1738,
      defaultSort: 1433,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Bassa Vah",
      displayName: null,
      category: "Sans Serif",
      size: 61308,
      subsets: ["menu", "bassa-vah", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1591,
      trending: 1722,
      defaultSort: 1447,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Batak",
      displayName: null,
      category: "Sans Serif",
      size: 72040,
      subsets: ["menu", "batak", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-22",
      dateAdded: "2020-11-19",
      popularity: 1630,
      trending: 1809,
      defaultSort: 1471,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Bengali",
      displayName: null,
      category: "Sans Serif",
      size: 624604,
      subsets: ["menu", "bengali", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-21",
      dateAdded: "2020-11-19",
      popularity: 674,
      trending: 73,
      defaultSort: 681,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Bhaiksuki",
      displayName: null,
      category: "Sans Serif",
      size: 247792,
      subsets: ["menu", "bhaiksuki"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1623,
      trending: 308,
      defaultSort: 1523,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Brahmi",
      displayName: null,
      category: "Sans Serif",
      size: 41916,
      subsets: ["menu", "brahmi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.375
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1587,
      trending: 1057,
      defaultSort: 1516,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Buginese",
      displayName: null,
      category: "Sans Serif",
      size: 51976,
      subsets: ["menu", "buginese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1586,
      trending: 484,
      defaultSort: 1443,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Buhid",
      displayName: null,
      category: "Sans Serif",
      size: 30844,
      subsets: ["menu", "buhid", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1589,
      trending: 387,
      defaultSort: 1445,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Canadian Aboriginal",
      displayName: null,
      category: "Sans Serif",
      size: 260700,
      subsets: ["menu", "canadian-aboriginal", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1523,
      trending: 155,
      defaultSort: 1414,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Carian",
      displayName: null,
      category: "Sans Serif",
      size: 12848,
      subsets: ["menu", "carian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1563,
      trending: 1537,
      defaultSort: 1510,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Caucasian Albanian",
      displayName: null,
      category: "Sans Serif",
      size: 26852,
      subsets: ["menu", "caucasian-albanian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1641,
      trending: 1538,
      defaultSort: 1525,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Chakma",
      displayName: null,
      category: "Sans Serif",
      size: 126960,
      subsets: ["menu", "chakma", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1615,
      trending: 1627,
      defaultSort: 1463,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Cham",
      displayName: null,
      category: "Sans Serif",
      size: 158448,
      subsets: ["menu", "cham", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.468
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1574,
      trending: 509,
      defaultSort: 1438,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Cham",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Cherokee",
      displayName: null,
      category: "Sans Serif",
      size: 224360,
      subsets: ["menu", "cherokee", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1537,
      trending: 1765,
      defaultSort: 1422,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Chorasmian",
      displayName: null,
      category: "Sans Serif",
      size: 68808,
      subsets: ["menu", "chorasmian", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-23",
      dateAdded: "2023-05-23",
      popularity: 1489,
      trending: 1788,
      defaultSort: 240,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Chrs",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Coptic",
      displayName: null,
      category: "Sans Serif",
      size: 91108,
      subsets: ["menu", "coptic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1496,
      trending: 1614,
      defaultSort: 1398,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Cuneiform",
      displayName: null,
      category: "Sans Serif",
      size: 820248,
      subsets: ["menu", "cuneiform"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.286
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1583,
      trending: 1315,
      defaultSort: 1514,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Cypriot",
      displayName: null,
      category: "Sans Serif",
      size: 15080,
      subsets: ["menu", "cypriot"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1501,
      trending: 1553,
      defaultSort: 1503,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Deseret",
      displayName: null,
      category: "Sans Serif",
      size: 19928,
      subsets: ["menu", "deseret"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1541,
      trending: 1379,
      defaultSort: 1505,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Devanagari",
      displayName: null,
      category: "Sans Serif",
      size: 934280,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 379,
      trending: 533,
      defaultSort: 399,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Display",
      displayName: null,
      category: "Sans Serif",
      size: 1621940,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-21",
      dateAdded: "2020-11-19",
      popularity: 217,
      trending: 663,
      defaultSort: 222,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Duployan",
      displayName: null,
      category: "Sans Serif",
      size: 1823534,
      subsets: ["menu", "duployan", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1648,
      trending: 241,
      defaultSort: 1483,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Dupl",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Egyptian Hieroglyphs",
      displayName: null,
      category: "Sans Serif",
      size: 585400,
      subsets: ["menu", "egyptian-hieroglyphs"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.65
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1540,
      trending: 317,
      defaultSort: 1504,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Elbasan",
      displayName: null,
      category: "Sans Serif",
      size: 60084,
      subsets: ["menu", "elbasan", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.117
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-23",
      dateAdded: "2020-11-19",
      popularity: 1645,
      trending: 276,
      defaultSort: 1480,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Elba",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Elymaic",
      displayName: null,
      category: "Sans Serif",
      size: 9024,
      subsets: ["menu", "elymaic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1671,
      trending: 697,
      defaultSort: 1539,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Ethiopic",
      displayName: null,
      category: "Sans Serif",
      size: 1143168,
      subsets: ["menu", "ethiopic", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2016-04-15",
      popularity: 1316,
      trending: 1682,
      defaultSort: 1267,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Ethi",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Georgian",
      displayName: null,
      category: "Sans Serif",
      size: 311728,
      subsets: ["menu", "georgian", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 854,
      trending: 464,
      defaultSort: 853,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Geor",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Glagolitic",
      displayName: null,
      category: "Sans Serif",
      size: 39832,
      subsets: ["menu", "glagolitic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1575,
      trending: 1432,
      defaultSort: 1512,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Gothic",
      displayName: null,
      category: "Sans Serif",
      size: 11660,
      subsets: ["menu", "gothic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1305,
      trending: 507,
      defaultSort: 1502,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Grantha",
      displayName: null,
      category: "Sans Serif",
      size: 407456,
      subsets: ["menu", "grantha", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.824
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1620,
      trending: 1304,
      defaultSort: 1467,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Gujarati",
      displayName: null,
      category: "Sans Serif",
      size: 688976,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1134,
      trending: 25,
      defaultSort: 236,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Gujr",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Gunjala Gondi",
      displayName: null,
      category: "Sans Serif",
      size: 62592,
      subsets: ["menu", "gunjala-gondi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1669,
      trending: 1303,
      defaultSort: 1537,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Gurmukhi",
      displayName: null,
      category: "Sans Serif",
      size: 268608,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1416,
      trending: 67,
      defaultSort: 1140,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Guru",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans HK",
      displayName: "Noto Sans Hong Kong",
      category: "Sans Serif",
      size: 5802264,
      subsets: ["menu", "chinese-hongkong", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2019-03-12",
      popularity: 133,
      trending: 92,
      defaultSort: 127,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Hanifi Rohingya",
      displayName: null,
      category: "Sans Serif",
      size: 108308,
      subsets: ["menu", "hanifi-rohingya", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-01",
      dateAdded: "2020-11-19",
      popularity: 1647,
      trending: 1080,
      defaultSort: 1482,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Rohg",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Hanunoo",
      displayName: null,
      category: "Sans Serif",
      size: 52188,
      subsets: ["menu", "hanunoo", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1612,
      trending: 700,
      defaultSort: 1462,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Hatran",
      displayName: null,
      category: "Sans Serif",
      size: 5044,
      subsets: ["menu", "hatran"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1539,
      trending: 43,
      defaultSort: 1496,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Hebrew",
      displayName: null,
      category: "Sans Serif",
      size: 183076,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 529,
      trending: 436,
      defaultSort: 547,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Hebr",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Imperial Aramaic",
      displayName: null,
      category: "Sans Serif",
      size: 6432,
      subsets: ["menu", "imperial-aramaic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1561,
      trending: 791,
      defaultSort: 1508,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Indic Siyaq Numbers",
      displayName: null,
      category: "Sans Serif",
      size: 32660,
      subsets: ["menu", "indic-siyaq-numbers"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.562
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1644,
      trending: 1280,
      defaultSort: 1527,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Inscriptional Pahlavi",
      displayName: null,
      category: "Sans Serif",
      size: 5988,
      subsets: ["menu", "inscriptional-pahlavi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.421
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1564,
      trending: 886,
      defaultSort: 1511,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Inscriptional Parthian",
      displayName: null,
      category: "Sans Serif",
      size: 52504,
      subsets: ["menu", "inscriptional-parthian", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.37
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-23",
      dateAdded: "2020-11-19",
      popularity: 1633,
      trending: 1213,
      defaultSort: 1474,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Prti",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans JP",
      displayName: "Noto Sans Japanese",
      category: "Sans Serif",
      size: 9589900,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2015-01-29",
      popularity: 5,
      trending: 1223,
      defaultSort: 6,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Javanese",
      displayName: null,
      category: "Sans Serif",
      size: 250440,
      subsets: ["menu", "javanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.036
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.036
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.036
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.036
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1438,
      trending: 1334,
      defaultSort: 1361,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Java",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans KR",
      displayName: "Noto Sans Korean",
      category: "Sans Serif",
      size: 4779948,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-05",
      popularity: 29,
      trending: 1116,
      defaultSort: 30,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Kaithi",
      displayName: null,
      category: "Sans Serif",
      size: 91276,
      subsets: ["menu", "kaithi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.502
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1657,
      trending: 707,
      defaultSort: 1532,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Kannada",
      displayName: null,
      category: "Sans Serif",
      size: 668232,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.349
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 753,
      trending: 37,
      defaultSort: 484,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Knda",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Kayah Li",
      displayName: null,
      category: "Sans Serif",
      size: 52440,
      subsets: ["menu", "kayah-li", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1578,
      trending: 489,
      defaultSort: 1440,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Kharoshthi",
      displayName: null,
      category: "Sans Serif",
      size: 91472,
      subsets: ["menu", "kharoshthi", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.37
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1649,
      trending: 1352,
      defaultSort: 1484,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Khar",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Khmer",
      displayName: null,
      category: "Sans Serif",
      size: 344568,
      subsets: ["menu", "khmer", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-19",
      popularity: 1207,
      trending: 517,
      defaultSort: 1171,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Khmr",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Khojki",
      displayName: null,
      category: "Sans Serif",
      size: 110252,
      subsets: ["menu", "khojki", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.856
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1663,
      trending: 1332,
      defaultSort: 1491,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Khudawadi",
      displayName: null,
      category: "Sans Serif",
      size: 19056,
      subsets: ["menu", "khudawadi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.317
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1598,
      trending: 407,
      defaultSort: 1517,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Lao",
      displayName: null,
      category: "Sans Serif",
      size: 153520,
      subsets: ["menu", "lao", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.645
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-21",
      dateAdded: "2020-11-19",
      popularity: 1100,
      trending: 603,
      defaultSort: 1081,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Lao Looped",
      displayName: null,
      category: "Sans Serif",
      size: 231172,
      subsets: ["menu", "lao", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2022-09-05",
      popularity: 1518,
      trending: 84,
      defaultSort: 1176,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Laoo",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Lepcha",
      displayName: null,
      category: "Sans Serif",
      size: 76440,
      subsets: ["menu", "latin", "latin-ext", "lepcha"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.519
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1513,
      trending: 277,
      defaultSort: 1409,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Limbu",
      displayName: null,
      category: "Sans Serif",
      size: 60820,
      subsets: ["menu", "latin", "latin-ext", "limbu"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1582,
      trending: 503,
      defaultSort: 1442,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Linear A",
      displayName: null,
      category: "Sans Serif",
      size: 58168,
      subsets: ["menu", "linear-a"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1651,
      trending: 1206,
      defaultSort: 1529,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Linear B",
      displayName: null,
      category: "Sans Serif",
      size: 62892,
      subsets: ["menu", "linear-b"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1665,
      trending: 596,
      defaultSort: 1534,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Lisu",
      displayName: null,
      category: "Sans Serif",
      size: 56240,
      subsets: ["menu", "latin", "latin-ext", "lisu"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1631,
      trending: 1726,
      defaultSort: 1472,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Lisu",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Lycian",
      displayName: null,
      category: "Sans Serif",
      size: 4488,
      subsets: ["menu", "lycian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1597,
      trending: 45,
      defaultSort: 1497,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Lydian",
      displayName: null,
      category: "Sans Serif",
      size: 4524,
      subsets: ["menu", "lydian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1614,
      trending: 1623,
      defaultSort: 1520,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Mahajani",
      displayName: null,
      category: "Sans Serif",
      size: 22852,
      subsets: ["menu", "mahajani"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1674,
      trending: 1677,
      defaultSort: 1541,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Malayalam",
      displayName: null,
      category: "Sans Serif",
      size: 504204,
      subsets: ["menu", "latin", "latin-ext", "malayalam"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 432,
      trending: 369,
      defaultSort: 454,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Mlym",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Mandaic",
      displayName: null,
      category: "Sans Serif",
      size: 29068,
      subsets: ["menu", "mandaic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.147
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1655,
      trending: 227,
      defaultSort: 1531,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Manichaean",
      displayName: null,
      category: "Sans Serif",
      size: 50256,
      subsets: ["menu", "manichaean"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1672,
      trending: 1094,
      defaultSort: 1540,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Marchen",
      displayName: null,
      category: "Sans Serif",
      size: 131248,
      subsets: ["menu", "marchen"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.641
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-02",
      dateAdded: "2020-11-19",
      popularity: 1576,
      trending: 1425,
      defaultSort: 1513,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Masaram Gondi",
      displayName: null,
      category: "Sans Serif",
      size: 86204,
      subsets: ["menu", "latin", "latin-ext", "masaram-gondi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1602,
      trending: 515,
      defaultSort: 1454,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Math",
      displayName: null,
      category: "Sans Serif",
      size: 590896,
      subsets: ["menu", "math"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.492
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1098,
      trending: 470,
      defaultSort: 1500,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Mayan Numerals",
      displayName: null,
      category: "Sans Serif",
      size: 4716,
      subsets: ["menu", "mayan-numerals"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1608,
      trending: 433,
      defaultSort: 1518,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Medefaidrin",
      displayName: null,
      category: "Sans Serif",
      size: 112788,
      subsets: ["menu", "latin", "latin-ext", "medefaidrin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1588,
      trending: 1464,
      defaultSort: 1444,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Meetei Mayek",
      displayName: null,
      category: "Sans Serif",
      size: 95616,
      subsets: ["menu", "latin", "latin-ext", "meetei-mayek"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1512,
      trending: 400,
      defaultSort: 1408,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Mende Kikakui",
      displayName: null,
      category: "Sans Serif",
      size: 94212,
      subsets: ["menu", "latin", "latin-ext", "mende-kikakui"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.267
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1606,
      trending: 821,
      defaultSort: 1458,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Meroitic",
      displayName: null,
      category: "Sans Serif",
      size: 87636,
      subsets: ["menu", "latin", "latin-ext", "meroitic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1652,
      trending: 299,
      defaultSort: 1485,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Mero",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Miao",
      displayName: null,
      category: "Sans Serif",
      size: 100188,
      subsets: ["menu", "latin", "latin-ext", "miao"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.492
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1543,
      trending: 544,
      defaultSort: 1424,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Modi",
      displayName: null,
      category: "Sans Serif",
      size: 107020,
      subsets: ["menu", "latin", "latin-ext", "modi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.354
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1604,
      trending: 238,
      defaultSort: 1456,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Mongolian",
      displayName: null,
      category: "Sans Serif",
      size: 285152,
      subsets: ["menu", "latin", "latin-ext", "mongolian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.75
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1463,
      trending: 109,
      defaultSort: 1378,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Mono",
      displayName: null,
      category: "Monospace",
      size: 1692740,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-23",
      dateAdded: "2020-11-19",
      popularity: 420,
      trending: 1488,
      defaultSort: 443,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Mro",
      displayName: null,
      category: "Sans Serif",
      size: 54272,
      subsets: ["menu", "latin", "latin-ext", "mro"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-12-07",
      dateAdded: "2020-11-19",
      popularity: 1599,
      trending: 1330,
      defaultSort: 1451,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Multani",
      displayName: null,
      category: "Sans Serif",
      size: 57728,
      subsets: ["menu", "latin", "latin-ext", "multani"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1609,
      trending: 301,
      defaultSort: 1460,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Myanmar",
      displayName: null,
      category: "Sans Serif",
      size: 203725,
      subsets: ["menu", "myanmar"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.184
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1002,
      trending: 1043,
      defaultSort: 1498,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans NKo",
      displayName: "Noto Sans N'Ko",
      category: "Sans Serif",
      size: 76892,
      subsets: ["menu", "latin", "latin-ext", "nko"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-01-24",
      dateAdded: "2020-11-19",
      popularity: 1635,
      trending: 732,
      defaultSort: 1475,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Nabataean",
      displayName: null,
      category: "Sans Serif",
      size: 55600,
      subsets: ["menu", "latin", "latin-ext", "nabataean"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1660,
      trending: 334,
      defaultSort: 1488,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Nbat",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Nag Mundari",
      displayName: null,
      category: "Sans Serif",
      size: 59644,
      subsets: ["menu", "latin", "latin-ext", "nag-mundari"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-09",
      dateAdded: "2023-05-08",
      popularity: 1487,
      trending: 1757,
      defaultSort: 290,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Nagm",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Nandinagari",
      displayName: null,
      category: "Sans Serif",
      size: 261380,
      subsets: ["menu", "latin", "latin-ext", "nandinagari"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.46
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-09",
      dateAdded: "2023-05-08",
      popularity: 1124,
      trending: 504,
      defaultSort: 312,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Nand",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans New Tai Lue",
      displayName: null,
      category: "Sans Serif",
      size: 76064,
      subsets: ["menu", "latin", "latin-ext", "new-tai-lue"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1639,
      trending: 1399,
      defaultSort: 1479,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Talu",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Newa",
      displayName: null,
      category: "Sans Serif",
      size: 259668,
      subsets: ["menu", "latin", "latin-ext", "newa"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.432
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1600,
      trending: 393,
      defaultSort: 1452,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Nushu",
      displayName: "Noto Sans N\xFCshu",
      category: "Sans Serif",
      size: 187204,
      subsets: ["menu", "latin", "latin-ext", "nushu"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1654,
      trending: 1422,
      defaultSort: 1486,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Ogham",
      displayName: null,
      category: "Sans Serif",
      size: 4684,
      subsets: ["menu", "ogham"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1659,
      trending: 719,
      defaultSort: 1533,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Ol Chiki",
      displayName: null,
      category: "Sans Serif",
      size: 91152,
      subsets: ["menu", "latin", "latin-ext", "ol-chiki"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1554,
      trending: 50,
      defaultSort: 769,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old Hungarian",
      displayName: null,
      category: "Sans Serif",
      size: 54112,
      subsets: ["menu", "old-hungarian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.036
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1562,
      trending: 1789,
      defaultSort: 1509,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old Italic",
      displayName: null,
      category: "Sans Serif",
      size: 7596,
      subsets: ["menu", "old-italic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1550,
      trending: 1155,
      defaultSort: 1507,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old North Arabian",
      displayName: null,
      category: "Sans Serif",
      size: 7228,
      subsets: ["menu", "old-north-arabian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1640,
      trending: 1275,
      defaultSort: 1524,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old Permic",
      displayName: null,
      category: "Sans Serif",
      size: 10008,
      subsets: ["menu", "old-permic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1670,
      trending: 1077,
      defaultSort: 1538,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old Persian",
      displayName: null,
      category: "Sans Serif",
      size: 12764,
      subsets: ["menu", "old-persian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1585,
      trending: 399,
      defaultSort: 1515,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old Sogdian",
      displayName: null,
      category: "Sans Serif",
      size: 66184,
      subsets: ["menu", "latin", "latin-ext", "old-sogdian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1661,
      trending: 771,
      defaultSort: 1489,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Sogo",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old South Arabian",
      displayName: null,
      category: "Sans Serif",
      size: 5276,
      subsets: ["menu", "old-south-arabian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1643,
      trending: 901,
      defaultSort: 1526,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Old Turkic",
      displayName: null,
      category: "Sans Serif",
      size: 15160,
      subsets: ["menu", "old-turkic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1613,
      trending: 1646,
      defaultSort: 1519,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Oriya",
      displayName: null,
      category: "Sans Serif",
      size: 467912,
      subsets: ["menu", "latin", "latin-ext", "oriya"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1114,
      trending: 52,
      defaultSort: 818,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Orya",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Osage",
      displayName: null,
      category: "Sans Serif",
      size: 60076,
      subsets: ["menu", "latin", "latin-ext", "osage"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1605,
      trending: 1785,
      defaultSort: 1457,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Osmanya",
      displayName: null,
      category: "Sans Serif",
      size: 57652,
      subsets: ["menu", "latin", "latin-ext", "osmanya"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1646,
      trending: 808,
      defaultSort: 1481,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Pahawh Hmong",
      displayName: null,
      category: "Sans Serif",
      size: 73820,
      subsets: ["menu", "latin", "latin-ext", "pahawh-hmong"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1601,
      trending: 432,
      defaultSort: 1453,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Palmyrene",
      displayName: null,
      category: "Sans Serif",
      size: 64084,
      subsets: ["menu", "latin", "latin-ext", "palmyrene"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1619,
      trending: 439,
      defaultSort: 1466,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Palm",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Pau Cin Hau",
      displayName: null,
      category: "Sans Serif",
      size: 56924,
      subsets: ["menu", "latin", "latin-ext", "pau-cin-hau"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1658,
      trending: 925,
      defaultSort: 1487,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Phags Pa",
      displayName: null,
      category: "Sans Serif",
      size: 39292,
      subsets: ["menu", "phags-pa"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1675,
      trending: 676,
      defaultSort: 1542,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Phoenician",
      displayName: null,
      category: "Sans Serif",
      size: 6192,
      subsets: ["menu", "phoenician"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1650,
      trending: 381,
      defaultSort: 1528,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Psalter Pahlavi",
      displayName: null,
      category: "Sans Serif",
      size: 76400,
      subsets: ["menu", "latin", "latin-ext", "psalter-pahlavi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1607,
      trending: 161,
      defaultSort: 1459,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Phlp",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Rejang",
      displayName: null,
      category: "Sans Serif",
      size: 54216,
      subsets: ["menu", "latin", "latin-ext", "rejang"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1636,
      trending: 465,
      defaultSort: 1476,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Runic",
      displayName: null,
      category: "Sans Serif",
      size: 9044,
      subsets: ["menu", "runic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1653,
      trending: 699,
      defaultSort: 1530,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans SC",
      displayName: "Noto Sans Simplified Chinese",
      category: "Sans Serif",
      size: 8495844,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2018-10-22",
      popularity: 84,
      trending: 586,
      defaultSort: 80,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Samaritan",
      displayName: null,
      category: "Sans Serif",
      size: 51740,
      subsets: ["menu", "latin", "latin-ext", "samaritan"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1335,
      trending: 62,
      defaultSort: 1040,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Samr",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Saurashtra",
      displayName: null,
      category: "Sans Serif",
      size: 74668,
      subsets: ["menu", "latin", "latin-ext", "saurashtra"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1595,
      trending: 207,
      defaultSort: 1449,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Sharada",
      displayName: null,
      category: "Sans Serif",
      size: 122368,
      subsets: ["menu", "latin", "latin-ext", "sharada"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.38
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-17",
      dateAdded: "2020-11-19",
      popularity: 1577,
      trending: 1795,
      defaultSort: 1439,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Shavian",
      displayName: null,
      category: "Sans Serif",
      size: 13420,
      subsets: ["menu", "shavian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1668,
      trending: 167,
      defaultSort: 1536,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Siddham",
      displayName: null,
      category: "Sans Serif",
      size: 235216,
      subsets: ["menu", "latin", "latin-ext", "siddham"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.03
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1626,
      trending: 1545,
      defaultSort: 1470,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans SignWriting",
      displayName: null,
      category: "Sans Serif",
      size: 7880504,
      subsets: ["menu", "latin", "latin-ext", "signwriting"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.002
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-01-06",
      dateAdded: "2022-10-30",
      popularity: 1627,
      trending: 1424,
      defaultSort: 1108,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Sinhala",
      displayName: null,
      category: "Sans Serif",
      size: 1181956,
      subsets: ["menu", "latin", "latin-ext", "sinhala"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 747,
      trending: 884,
      defaultSort: 750,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Sogdian",
      displayName: null,
      category: "Sans Serif",
      size: 141656,
      subsets: ["menu", "latin", "latin-ext", "sogdian"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.382
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2020-11-19",
      popularity: 1662,
      trending: 449,
      defaultSort: 1490,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Sogd",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Sora Sompeng",
      displayName: null,
      category: "Sans Serif",
      size: 60240,
      subsets: ["menu", "latin", "latin-ext", "sora-sompeng"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1505,
      trending: 291,
      defaultSort: 1402,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Sora",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Soyombo",
      displayName: null,
      category: "Sans Serif",
      size: 66968,
      subsets: ["menu", "soyombo"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.596
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1666,
      trending: 641,
      defaultSort: 1535,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Sundanese",
      displayName: null,
      category: "Sans Serif",
      size: 60620,
      subsets: ["menu", "latin", "latin-ext", "sundanese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-01",
      dateAdded: "2020-11-19",
      popularity: 1569,
      trending: 51,
      defaultSort: 793,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Sund",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Syloti Nagri",
      displayName: null,
      category: "Sans Serif",
      size: 66364,
      subsets: ["menu", "latin", "latin-ext", "syloti-nagri"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1467,
      trending: 531,
      defaultSort: 1383,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Symbols",
      displayName: null,
      category: "Sans Serif",
      size: 402416,
      subsets: ["menu", "latin", "latin-ext", "symbols"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.05
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-19",
      popularity: 956,
      trending: 1698,
      defaultSort: 942,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Symbols 2",
      displayName: null,
      category: "Sans Serif",
      size: 1218916,
      subsets: ["menu", "latin", "latin-ext", "symbols"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.699
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-09",
      dateAdded: "2020-11-19",
      popularity: 1275,
      trending: 668,
      defaultSort: 1232,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Syriac",
      displayName: null,
      category: "Sans Serif",
      size: 171996,
      subsets: ["menu", "latin", "latin-ext", "syriac"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.412
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1632,
      trending: 1289,
      defaultSort: 1473,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Syrc",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans TC",
      displayName: "Noto Sans Traditional Chinese",
      category: "Sans Serif",
      size: 5804584,
      subsets: ["menu", "chinese-traditional", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2018-10-22",
      popularity: 32,
      trending: 343,
      defaultSort: 33,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tagalog",
      displayName: null,
      category: "Sans Serif",
      size: 52676,
      subsets: ["menu", "latin", "latin-ext", "tagalog"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1547,
      trending: 1143,
      defaultSort: 1428,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tagbanwa",
      displayName: null,
      category: "Sans Serif",
      size: 46212,
      subsets: ["menu", "latin", "latin-ext", "tagbanwa"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1596,
      trending: 1598,
      defaultSort: 1450,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tai Le",
      displayName: null,
      category: "Sans Serif",
      size: 57620,
      subsets: ["menu", "latin", "latin-ext", "tai-le"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1618,
      trending: 1430,
      defaultSort: 1465,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tai Tham",
      displayName: null,
      category: "Sans Serif",
      size: 172864,
      subsets: ["menu", "latin", "latin-ext", "tai-tham"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.589
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.589
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.589
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.589
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1572,
      trending: 1356,
      defaultSort: 1437,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tai Viet",
      displayName: null,
      category: "Sans Serif",
      size: 68872,
      subsets: ["menu", "latin", "latin-ext", "tai-viet"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1526,
      trending: 1102,
      defaultSort: 1416,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Takri",
      displayName: null,
      category: "Sans Serif",
      size: 67144,
      subsets: ["menu", "latin", "latin-ext", "takri"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.262
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1560,
      trending: 669,
      defaultSort: 1432,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tamil",
      displayName: null,
      category: "Sans Serif",
      size: 340668,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 377,
      trending: 188,
      defaultSort: 397,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Taml",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tamil Supplement",
      displayName: null,
      category: "Sans Serif",
      size: 67716,
      subsets: ["menu", "latin", "latin-ext", "tamil-supplement"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-29",
      dateAdded: "2020-11-19",
      popularity: 1638,
      trending: 828,
      defaultSort: 1478,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Taml",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tangsa",
      displayName: null,
      category: "Sans Serif",
      size: 92040,
      subsets: ["menu", "latin", "latin-ext", "tangsa"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2022-09-11",
      popularity: 1493,
      trending: 1792,
      defaultSort: 1199,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Tnsa",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Telugu",
      displayName: null,
      category: "Sans Serif",
      size: 902620,
      subsets: ["menu", "latin", "latin-ext", "telugu"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-04",
      dateAdded: "2020-11-19",
      popularity: 788,
      trending: 1484,
      defaultSort: 789,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Telu",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Thaana",
      displayName: null,
      category: "Sans Serif",
      size: 112776,
      subsets: ["menu", "latin", "latin-ext", "thaana"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.493
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1557,
      trending: 1666,
      defaultSort: 1431,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Thaa",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Thai",
      displayName: null,
      category: "Sans Serif",
      size: 218404,
      subsets: ["menu", "latin", "latin-ext", "thai"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.511
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-21",
      dateAdded: "2020-11-19",
      popularity: 244,
      trending: 417,
      defaultSort: 257,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Thai Looped",
      displayName: null,
      category: "Sans Serif",
      size: 104587,
      subsets: ["menu", "latin", "latin-ext", "thai"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1340,
      trending: 249,
      defaultSort: 1286,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Thai",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tifinagh",
      displayName: null,
      category: "Sans Serif",
      size: 114056,
      subsets: ["menu", "latin", "latin-ext", "tifinagh"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-12-07",
      dateAdded: "2020-11-19",
      popularity: 1566,
      trending: 915,
      defaultSort: 1434,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Tirhuta",
      displayName: null,
      category: "Sans Serif",
      size: 96864,
      subsets: ["menu", "tirhuta"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.545
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-05-10",
      dateAdded: "2020-11-19",
      popularity: 1617,
      trending: 394,
      defaultSort: 1521,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Ugaritic",
      displayName: null,
      category: "Sans Serif",
      size: 53244,
      subsets: ["menu", "latin", "latin-ext", "ugaritic"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.124
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-23",
      dateAdded: "2020-11-19",
      popularity: 1622,
      trending: 1397,
      defaultSort: 1468,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Ugar",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Vai",
      displayName: null,
      category: "Sans Serif",
      size: 128852,
      subsets: ["menu", "latin", "latin-ext", "vai"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1603,
      trending: 1591,
      defaultSort: 1455,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Wancho",
      displayName: null,
      category: "Sans Serif",
      size: 64880,
      subsets: ["menu", "latin", "latin-ext", "wancho"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1637,
      trending: 1417,
      defaultSort: 1477,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Warang Citi",
      displayName: null,
      category: "Sans Serif",
      size: 86880,
      subsets: ["menu", "latin", "latin-ext", "warang-citi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.142
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1611,
      trending: 709,
      defaultSort: 1461,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Yi",
      displayName: null,
      category: "Sans Serif",
      size: 331328,
      subsets: ["menu", "latin", "latin-ext", "yi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1590,
      trending: 1445,
      defaultSort: 1446,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Sans Zanabazar Square",
      displayName: null,
      category: "Sans Serif",
      size: 69432,
      subsets: ["menu", "latin", "latin-ext", "zanabazar-square"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.442
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1625,
      trending: 1200,
      defaultSort: 1469,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif",
      displayName: null,
      category: "Serif",
      size: 2415170,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.362
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.362
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 8,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-31",
      dateAdded: "2013-02-27",
      popularity: 48,
      trending: 845,
      defaultSort: 47,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Ahom",
      displayName: null,
      category: "Serif",
      size: 84780,
      subsets: ["menu", "ahom", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.655
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1538,
      trending: 610,
      defaultSort: 1423,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Ahom",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Armenian",
      displayName: null,
      category: "Serif",
      size: 288484,
      subsets: ["menu", "armenian", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1317,
      trending: 875,
      defaultSort: 1268,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Armn",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Balinese",
      displayName: null,
      category: "Serif",
      size: 125940,
      subsets: ["menu", "balinese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.795
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-09",
      dateAdded: "2020-11-19",
      popularity: 1593,
      trending: 355,
      defaultSort: 1448,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Bali",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Bengali",
      displayName: null,
      category: "Serif",
      size: 1055548,
      subsets: ["menu", "bengali", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.594
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-21",
      dateAdded: "2020-11-19",
      popularity: 324,
      trending: 1609,
      defaultSort: 343,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Devanagari",
      displayName: null,
      category: "Serif",
      size: 860548,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.555
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 563,
      trending: 279,
      defaultSort: 581,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Display",
      displayName: null,
      category: "Serif",
      size: 1917960,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 473,
      trending: 711,
      defaultSort: 492,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Dogra",
      displayName: null,
      category: "Serif",
      size: 28056,
      subsets: ["menu", "dogra"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.494
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-11-09",
      dateAdded: "2020-11-19",
      popularity: 1559,
      trending: 34,
      defaultSort: 1495,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Ethiopic",
      displayName: null,
      category: "Serif",
      size: 1057996,
      subsets: ["menu", "ethiopic", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1504,
      trending: 600,
      defaultSort: 1401,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Georgian",
      displayName: null,
      category: "Serif",
      size: 383484,
      subsets: ["menu", "georgian", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1211,
      trending: 42,
      defaultSort: 595,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Geor",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Grantha",
      displayName: null,
      category: "Serif",
      size: 428384,
      subsets: ["menu", "grantha", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.824
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1616,
      trending: 1313,
      defaultSort: 1464,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Gujarati",
      displayName: null,
      category: "Serif",
      size: 377904,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.447
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1376,
      trending: 1563,
      defaultSort: 1316,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Gujr",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Gurmukhi",
      displayName: null,
      category: "Serif",
      size: 144664,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.434
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1567,
      trending: 240,
      defaultSort: 1435,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Guru",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif HK",
      displayName: "Noto Serif Hong Kong",
      category: "Serif",
      size: 59915920,
      subsets: ["menu", "chinese-hongkong", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2022-05-11",
      popularity: 1345,
      trending: 1640,
      defaultSort: 1291,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Hebrew",
      displayName: null,
      category: "Serif",
      size: 175792,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.186
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 967,
      trending: 722,
      defaultSort: 952,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Hebr",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif JP",
      displayName: "Noto Serif Japanese",
      category: "Serif",
      size: 6178404,
      subsets: ["menu", "japanese", "latin"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2018-08-22",
      popularity: 82,
      trending: 1326,
      defaultSort: 78,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif KR",
      displayName: "Noto Serif Korean",
      category: "Serif",
      size: 7149412,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2018-08-22",
      popularity: 195,
      trending: 894,
      defaultSort: 196,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Kannada",
      displayName: null,
      category: "Serif",
      size: 491276,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.62
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1230,
      trending: 1733,
      defaultSort: 1191,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Knda",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Khmer",
      displayName: null,
      category: "Serif",
      size: 479080,
      subsets: ["menu", "khmer", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1393,
      trending: 1558,
      defaultSort: 1330,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Khmr",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Khojki",
      displayName: null,
      category: "Serif",
      size: 234228,
      subsets: ["menu", "khojki", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.856
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.856
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.856
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.856
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2022-08-29",
      popularity: 1536,
      trending: 896,
      defaultSort: 1227,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Khoj",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Lao",
      displayName: null,
      category: "Serif",
      size: 193024,
      subsets: ["menu", "lao", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.656
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-21",
      dateAdded: "2020-11-19",
      popularity: 1221,
      trending: 1527,
      defaultSort: 1182,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Laoo",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Makasar",
      displayName: null,
      category: "Serif",
      size: 57888,
      subsets: ["menu", "latin", "latin-ext", "makasar"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.362
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-29",
      dateAdded: "2023-06-27",
      popularity: 888,
      trending: 2,
      defaultSort: 3,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Maka",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Malayalam",
      displayName: null,
      category: "Serif",
      size: 242048,
      subsets: ["menu", "latin", "latin-ext", "malayalam"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.247
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 801,
      trending: 1782,
      defaultSort: 803,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Mlym",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Myanmar",
      displayName: null,
      category: "Serif",
      size: 250640,
      subsets: ["menu", "myanmar"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.499
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2020-11-19",
      popularity: 1549,
      trending: 1499,
      defaultSort: 1506,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif NP Hmong",
      displayName: "Noto Serif Nyiakeng Puachue Hmong",
      category: "Serif",
      size: 133168,
      subsets: ["menu", "latin", "nyiakeng-puachue-hmong"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-12-07",
      dateAdded: "2020-11-19",
      popularity: 1581,
      trending: 1115,
      defaultSort: 1441,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Oriya",
      displayName: null,
      category: "Serif",
      size: 241144,
      subsets: ["menu", "latin", "latin-ext", "oriya"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.409
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.409
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.409
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.409
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2022-07-04",
      popularity: 1584,
      trending: 285,
      defaultSort: 1319,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Orya",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Ottoman Siyaq",
      displayName: null,
      category: "Serif",
      size: 70964,
      subsets: ["menu", "latin", "latin-ext", "ottoman-siyaq-numbers"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.703
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 1296,
      trending: 12,
      defaultSort: 54,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif SC",
      displayName: "Noto Serif Simplified Chinese",
      category: "Serif",
      size: 11217064,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2018-12-03",
      popularity: 283,
      trending: 556,
      defaultSort: 297,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Sinhala",
      displayName: null,
      category: "Serif",
      size: 1026928,
      subsets: ["menu", "latin", "latin-ext", "sinhala"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.304
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-02",
      dateAdded: "2020-11-19",
      popularity: 1327,
      trending: 1539,
      defaultSort: 1277,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Sinh",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif TC",
      displayName: "Noto Serif Traditional Chinese",
      category: "Serif",
      size: 5832886,
      subsets: ["menu", "chinese-traditional", "latin"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.437
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2022-09-27",
      dateAdded: "2018-12-03",
      popularity: 192,
      trending: 426,
      defaultSort: 193,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Tamil",
      displayName: null,
      category: "Serif",
      size: 421226,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.561
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-27",
      dateAdded: "2020-11-19",
      popularity: 1519,
      trending: 1013,
      defaultSort: 1411,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Taml",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Tangut",
      displayName: null,
      category: "Serif",
      size: 5726004,
      subsets: ["menu", "latin", "latin-ext", "tangut"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.006
        }
      },
      axes: [],
      designers: ["Google"],
      lastModified: "2023-05-23",
      dateAdded: "2020-11-19",
      popularity: 1400,
      trending: 208,
      defaultSort: 1336,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Tang",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Telugu",
      displayName: null,
      category: "Serif",
      size: 550624,
      subsets: ["menu", "latin", "latin-ext", "telugu"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.352
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-04-04",
      dateAdded: "2020-11-19",
      popularity: 1476,
      trending: 1814,
      defaultSort: 1389,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Telu",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Thai",
      displayName: null,
      category: "Serif",
      size: 281076,
      subsets: ["menu", "latin", "latin-ext", "thai"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.598
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 62.5,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-09-21",
      dateAdded: "2020-11-19",
      popularity: 925,
      trending: 140,
      defaultSort: 914,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Tibetan",
      displayName: null,
      category: "Serif",
      size: 2063504,
      subsets: ["menu", "latin", "latin-ext", "tibetan"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.815
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2020-11-19",
      popularity: 1460,
      trending: 1505,
      defaultSort: 1376,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Tibt",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Toto",
      displayName: null,
      category: "Serif",
      size: 68452,
      subsets: ["menu", "latin", "latin-ext", "toto"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.303
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-03-09",
      dateAdded: "2022-09-04",
      popularity: 1548,
      trending: 1751,
      defaultSort: 1214,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "Toto",
      primaryLanguage: ""
    },
    {
      family: "Noto Serif Yezidi",
      displayName: null,
      category: "Serif",
      size: 23760,
      subsets: ["menu", "yezidi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2022-07-19",
      dateAdded: "2020-11-19",
      popularity: 1621,
      trending: 734,
      defaultSort: 1522,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Noto Traditional Nushu",
      displayName: "Noto Traditional N\xFCshu",
      category: "Sans Serif",
      size: 292524,
      subsets: ["menu", "latin", "latin-ext", "nushu"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.172
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.172
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.172
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.172
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.172
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Google"],
      lastModified: "2023-05-23",
      dateAdded: "2020-11-19",
      popularity: 1552,
      trending: 566,
      defaultSort: 1430,
      androidFragment: null,
      isNoto: true,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Cut",
      displayName: null,
      category: "Display",
      size: 40359,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.20703125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 1331,
      trending: 1798,
      defaultSort: 1280,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Flat",
      displayName: null,
      category: "Display",
      size: 39835,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.20703125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 1173,
      trending: 1754,
      defaultSort: 1142,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Mono",
      displayName: null,
      category: "Monospace",
      size: 148642,
      subsets: ["menu", "greek", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.3935546875
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 745,
      trending: 437,
      defaultSort: 748,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Oval",
      displayName: null,
      category: "Display",
      size: 41727,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.20703125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 1337,
      trending: 33,
      defaultSort: 401,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Round",
      displayName: null,
      category: "Display",
      size: 41309,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.20703125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 808,
      trending: 104,
      defaultSort: 810,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Script",
      displayName: null,
      category: "Display",
      size: 117388,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.20703125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 1415,
      trending: 1595,
      defaultSort: 1350,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Slim",
      displayName: null,
      category: "Display",
      size: 39969,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.20703125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-23",
      popularity: 1197,
      trending: 116,
      defaultSort: 1163,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nova Square",
      displayName: null,
      category: "Display",
      size: 36395,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.20703125
        }
      },
      axes: [],
      designers: ["Wojciech Kalinowski"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-14",
      popularity: 1057,
      trending: 1763,
      defaultSort: 1042,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Numans",
      displayName: null,
      category: "Sans Serif",
      size: 19302,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.1748046875
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-17",
      popularity: 824,
      trending: 303,
      defaultSort: 827,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nunito",
      displayName: null,
      category: "Sans Serif",
      size: 279382,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "300": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.364
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.364
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.364
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams", "Cyreal", "Jacques Le Bailly"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-12",
      popularity: 23,
      trending: 1168,
      defaultSort: 22,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nunito Sans",
      displayName: null,
      category: "Sans Serif",
      size: 564826,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.364
        }
      },
      axes: [
        {
          tag: "YTLC",
          min: 440,
          max: 540,
          defaultValue: 500
        },
        {
          tag: "opsz",
          min: 6,
          max: 12,
          defaultValue: 12
        },
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 200,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams", "Jacques Le Bailly", "Manvel Shmavonyan", "Alexei Vanyashin"],
      lastModified: "2023-04-27",
      dateAdded: "2016-12-07",
      popularity: 20,
      trending: 1050,
      defaultSort: 20,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Nuosu SIL",
      displayName: null,
      category: "Serif",
      size: 261232,
      subsets: ["menu", "latin", "latin-ext", "yi"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.318359375
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-31",
      dateAdded: "2022-04-28",
      popularity: 1218,
      trending: 1779,
      defaultSort: 1179,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Yiii",
      primaryLanguage: ""
    },
    {
      family: "Odibee Sans",
      displayName: null,
      category: "Display",
      size: 46220,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.108
        }
      },
      axes: [],
      designers: ["James Barnard"],
      lastModified: "2022-09-21",
      dateAdded: "2019-11-08",
      popularity: 655,
      trending: 341,
      defaultSort: 662,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Odor Mean Chey",
      displayName: null,
      category: "Serif",
      size: 103900,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-05-10",
      dateAdded: "2011-03-02",
      popularity: 899,
      trending: 115,
      defaultSort: 890,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Offside",
      displayName: null,
      category: "Display",
      size: 61824,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.261
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2012-10-26",
      popularity: 1113,
      trending: 1150,
      defaultSort: 1093,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oi",
      displayName: null,
      category: "Display",
      size: 345584,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "tamil", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.58
        }
      },
      axes: [],
      designers: ["Kostas Bartsokas"],
      lastModified: "2023-05-02",
      dateAdded: "2021-02-03",
      popularity: 1442,
      trending: 667,
      defaultSort: 1366,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Old Standard TT",
      displayName: null,
      category: "Serif",
      size: 263162,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.236
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 7,
          lineHeight: 1.236
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.236
        }
      },
      axes: [],
      designers: ["Alexey Kryukov"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-18",
      popularity: 216,
      trending: 1107,
      defaultSort: 220,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oldenburg",
      displayName: null,
      category: "Display",
      size: 27438,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.25439453125
        }
      },
      axes: [],
      designers: ["Nicole Fally"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1281,
      trending: 1482,
      defaultSort: 1238,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ole",
      displayName: null,
      category: "Handwriting",
      size: 194772,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-12-02",
      popularity: 1510,
      trending: 87,
      defaultSort: 1407,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oleo Script",
      displayName: null,
      category: "Display",
      size: 18710,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 4,
          width: 6,
          lineHeight: 1.383
        },
        "700": {
          thickness: 7,
          slant: 4,
          width: 6,
          lineHeight: 1.383
        }
      },
      axes: [],
      designers: ["soytutype fonts"],
      lastModified: "2022-05-10",
      dateAdded: "2012-03-29",
      popularity: 395,
      trending: 833,
      defaultSort: 417,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oleo Script Swash Caps",
      displayName: null,
      category: "Display",
      size: 18710,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 4,
          width: 6,
          lineHeight: 1.383
        },
        "700": {
          thickness: 8,
          slant: 4,
          width: 6,
          lineHeight: 1.383
        }
      },
      axes: [],
      designers: ["soytutype fonts"],
      lastModified: "2022-05-10",
      dateAdded: "2012-11-12",
      popularity: 692,
      trending: 342,
      defaultSort: 698,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oooh Baby",
      displayName: null,
      category: "Handwriting",
      size: 135104,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-11-26",
      popularity: 736,
      trending: 574,
      defaultSort: 741,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Open Sans",
      displayName: null,
      category: "Sans Serif",
      size: 558374,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.36181640625
        },
        "300i": {
          thickness: 3,
          slant: 5,
          width: 7,
          lineHeight: 1.36181640625
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.36181640625
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 7,
          lineHeight: 1.36181640625
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36181640625
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36181640625
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.36181640625
        },
        "600i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.36181640625
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.36181640625
        },
        "700i": {
          thickness: 7,
          slant: 5,
          width: 7,
          lineHeight: 1.36181640625
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.36181640625
        },
        "800i": {
          thickness: 8,
          slant: 5,
          width: 8,
          lineHeight: 1.36181640625
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 300,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Steve Matteson"],
      lastModified: "2023-05-02",
      dateAdded: "2011-02-02",
      popularity: 4,
      trending: 1027,
      defaultSort: 5,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oranienbaum",
      displayName: null,
      category: "Serif",
      size: 141220,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.155
        }
      },
      axes: [],
      designers: ["Oleg Pospelov", "Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-20",
      popularity: 436,
      trending: 383,
      defaultSort: 458,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Orbit",
      displayName: null,
      category: "Sans Serif",
      size: 784480,
      subsets: ["menu", "korean", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Sooun Cho", "JAMO"],
      lastModified: "2023-06-07",
      dateAdded: "2023-06-05",
      popularity: 1434,
      trending: 1818,
      defaultSort: 162,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Kore",
      primaryLanguage: ""
    },
    {
      family: "Orbitron",
      displayName: null,
      category: "Sans Serif",
      size: 38576,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.254
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.254
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.254
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.254
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.254
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.254
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Matt McInerney"],
      lastModified: "2023-03-21",
      dateAdded: "2010-12-15",
      popularity: 152,
      trending: 708,
      defaultSort: 146,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oregano",
      displayName: null,
      category: "Display",
      size: 44071,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.291015625
        },
        "400i": {
          thickness: 5,
          slant: 9,
          width: 6,
          lineHeight: 1.2900390625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-13",
      popularity: 793,
      trending: 788,
      defaultSort: 795,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Orelega One",
      displayName: null,
      category: "Display",
      size: 133732,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.09033203125
        }
      },
      axes: [],
      designers: ["Haruki Wakamatsu"],
      lastModified: "2022-09-21",
      dateAdded: "2021-03-11",
      popularity: 980,
      trending: 905,
      defaultSort: 962,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Orienta",
      displayName: null,
      category: "Sans Serif",
      size: 55176,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.195
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2012-09-07",
      popularity: 862,
      trending: 1458,
      defaultSort: 861,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Original Surfer",
      displayName: null,
      category: "Display",
      size: 34318,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2509765625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 786,
      trending: 1112,
      defaultSort: 787,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oswald",
      displayName: null,
      category: "Sans Serif",
      size: 129452,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.482
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.482
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.482
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.482
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.482
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.482
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams", "Kalapi Gajjar", "Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 16,
      trending: 1398,
      defaultSort: 16,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Outfit",
      displayName: null,
      category: "Sans Serif",
      size: 110884,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Smartsheet Inc", "Rodrigo Fuenzalida"],
      lastModified: "2023-04-27",
      dateAdded: "2021-09-27",
      popularity: 109,
      trending: 361,
      defaultSort: 105,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Over the Rainbow",
      displayName: null,
      category: "Handwriting",
      size: 28103,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 2.0400390625
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-27",
      popularity: 816,
      trending: 388,
      defaultSort: 817,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Overlock",
      displayName: null,
      category: "Display",
      size: 44762,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.22
        },
        "400i": {
          thickness: 4,
          slant: 3,
          width: 6,
          lineHeight: 1.22
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.22
        },
        "700i": {
          thickness: 5,
          slant: 3,
          width: 6,
          lineHeight: 1.22
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.22
        },
        "900i": {
          thickness: 7,
          slant: 3,
          width: 7,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Dario Manuel Muhafara"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 503,
      trending: 412,
      defaultSort: 519,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Overlock SC",
      displayName: null,
      category: "Display",
      size: 18592,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Dario Manuel Muhafara"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1013,
      trending: 198,
      defaultSort: 994,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Overpass",
      displayName: null,
      category: "Sans Serif",
      size: 304014,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Delve Withrington", "Dave Bailey", "Thomas Jockin"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-02",
      popularity: 104,
      trending: 523,
      defaultSort: 99,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Overpass Mono",
      displayName: null,
      category: "Monospace",
      size: 258800,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.266
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Delve Withrington", "Dave Bailey", "Thomas Jockin"],
      lastModified: "2022-09-21",
      dateAdded: "2016-12-02",
      popularity: 516,
      trending: 1377,
      defaultSort: 532,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ovo",
      displayName: null,
      category: "Serif",
      size: 23887,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.125
        }
      },
      axes: [],
      designers: ["Nicole Fally"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-20",
      popularity: 566,
      trending: 560,
      defaultSort: 584,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oxanium",
      displayName: null,
      category: "Display",
      size: 43536,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Severin Meyer"],
      lastModified: "2022-09-21",
      dateAdded: "2020-01-30",
      popularity: 328,
      trending: 105,
      defaultSort: 347,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oxygen",
      displayName: null,
      category: "Sans Serif",
      size: 46828,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2626953125
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2626953125
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.2626953125
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-29",
      popularity: 69,
      trending: 1032,
      defaultSort: 65,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Oxygen Mono",
      displayName: null,
      category: "Monospace",
      size: 34272,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.31201171875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2012-09-08",
      popularity: 627,
      trending: 1316,
      defaultSort: 638,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "PT Mono",
      displayName: null,
      category: "Monospace",
      size: 100999,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.12
        }
      },
      axes: [],
      designers: ["ParaType"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 289,
      trending: 258,
      defaultSort: 303,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "PT Sans",
      displayName: null,
      category: "Sans Serif",
      size: 229341,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.294
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.294
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.294
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 6,
          lineHeight: 1.294
        }
      },
      axes: [],
      designers: ["ParaType"],
      lastModified: "2022-09-21",
      dateAdded: "2010-09-21",
      popularity: 28,
      trending: 878,
      defaultSort: 29,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "PT Sans Caption",
      displayName: null,
      category: "Sans Serif",
      size: 197494,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.294
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.294
        }
      },
      axes: [],
      designers: ["ParaType"],
      lastModified: "2023-05-02",
      dateAdded: "2010-09-21",
      popularity: 180,
      trending: 1283,
      defaultSort: 182,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "PT Sans Narrow",
      displayName: null,
      category: "Sans Serif",
      size: 198698,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.294
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.294
        }
      },
      axes: [],
      designers: ["ParaType"],
      lastModified: "2023-05-02",
      dateAdded: "2010-09-21",
      popularity: 62,
      trending: 887,
      defaultSort: 59,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "PT Serif",
      displayName: null,
      category: "Serif",
      size: 180768,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.325
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.325
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.325
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.325
        }
      },
      axes: [],
      designers: ["ParaType"],
      lastModified: "2023-05-02",
      dateAdded: "2011-02-09",
      popularity: 43,
      trending: 876,
      defaultSort: 42,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "PT Serif Caption",
      displayName: null,
      category: "Serif",
      size: 204576,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.325
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.325
        }
      },
      axes: [],
      designers: ["ParaType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-02-09",
      popularity: 431,
      trending: 440,
      defaultSort: 453,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pacifico",
      displayName: null,
      category: "Handwriting",
      size: 329380,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.756
        }
      },
      axes: [],
      designers: ["Vernon Adams", "Jacques Le Bailly", "Botjo Nikoltchev", "Ani Petrova"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-09",
      popularity: 87,
      trending: 1447,
      defaultSort: 84,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Padauk",
      displayName: null,
      category: "Sans Serif",
      size: 499082,
      subsets: ["menu", "latin", "latin-ext", "myanmar"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.474609375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.474609375
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2022-11-09",
      dateAdded: "2016-11-08",
      popularity: 451,
      trending: 337,
      defaultSort: 472,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Mymr",
      primaryLanguage: ""
    },
    {
      family: "Padyakke Expanded One",
      displayName: null,
      category: "Display",
      size: 390600,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.441
        }
      },
      axes: [],
      designers: ["James Puckett"],
      lastModified: "2023-05-02",
      dateAdded: "2022-12-05",
      popularity: 1592,
      trending: 1642,
      defaultSort: 992,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Knda",
      primaryLanguage: ""
    },
    {
      family: "Palanquin",
      displayName: null,
      category: "Sans Serif",
      size: 478114,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.811
        },
        "200": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.811
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.811
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.811
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.811
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.811
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.811
        }
      },
      axes: [],
      designers: ["Pria Ravichandran"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-28",
      popularity: 408,
      trending: 1530,
      defaultSort: 430,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Palanquin Dark",
      displayName: null,
      category: "Sans Serif",
      size: 511753,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.811
        },
        "500": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.811
        },
        "600": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.811
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.811
        }
      },
      axes: [],
      designers: ["Pria Ravichandran"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-28",
      popularity: 459,
      trending: 733,
      defaultSort: 476,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Palette Mosaic",
      displayName: null,
      category: "Display",
      size: 142520,
      subsets: ["menu", "japanese", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Shibuya Font"],
      lastModified: "2023-05-31",
      dateAdded: "2021-04-13",
      popularity: 1456,
      trending: 1817,
      defaultSort: 1374,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Pangolin",
      displayName: null,
      category: "Handwriting",
      size: 592688,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        }
      },
      axes: [],
      designers: ["Kevin Burke"],
      lastModified: "2022-09-21",
      dateAdded: "2017-01-11",
      popularity: 361,
      trending: 1348,
      defaultSort: 381,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Paprika",
      displayName: null,
      category: "Display",
      size: 90580,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 3,
          width: 8,
          lineHeight: 1.419
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-26",
      popularity: 1063,
      trending: 1353,
      defaultSort: 1047,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Parisienne",
      displayName: null,
      category: "Handwriting",
      size: 34951,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 8,
          width: 6,
          lineHeight: 1.3623046875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-25",
      popularity: 288,
      trending: 792,
      defaultSort: 302,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Passero One",
      displayName: null,
      category: "Display",
      size: 19856,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.1904296875
        }
      },
      axes: [],
      designers: ["Viktoriya Grabowska"],
      lastModified: "2022-05-10",
      dateAdded: "2011-08-31",
      popularity: 1293,
      trending: 476,
      defaultSort: 1251,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Passion One",
      displayName: null,
      category: "Display",
      size: 24648,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 6,
          lineHeight: 1.101
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.101
        },
        "900": {
          thickness: 9,
          slant: 1,
          width: 7,
          lineHeight: 1.101
        }
      },
      axes: [],
      designers: ["Fontstage"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 196,
      trending: 1226,
      defaultSort: 198,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Passions Conflict",
      displayName: null,
      category: "Handwriting",
      size: 149128,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-07",
      popularity: 1138,
      trending: 1536,
      defaultSort: 1113,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pathway Extreme",
      displayName: null,
      category: "Sans Serif",
      size: 265264,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.356
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 8,
          max: 144,
          defaultValue: 12
        },
        {
          tag: "wdth",
          min: 75,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-04-20",
      dateAdded: "2023-04-19",
      popularity: 611,
      trending: 20,
      defaultSort: 143,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pathway Gothic One",
      displayName: null,
      category: "Sans Serif",
      size: 49944,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.152
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-04-27",
      dateAdded: "2013-06-05",
      popularity: 200,
      trending: 1323,
      defaultSort: 202,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Patrick Hand",
      displayName: null,
      category: "Handwriting",
      size: 54194,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.354
        }
      },
      axes: [],
      designers: ["Patrick Wagesreiter"],
      lastModified: "2023-05-02",
      dateAdded: "2011-07-06",
      popularity: 295,
      trending: 1510,
      defaultSort: 309,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Patrick Hand SC",
      displayName: null,
      category: "Handwriting",
      size: 54194,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.354
        }
      },
      axes: [],
      designers: ["Patrick Wagesreiter"],
      lastModified: "2022-09-21",
      dateAdded: "2013-02-27",
      popularity: 653,
      trending: 1602,
      defaultSort: 660,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pattaya",
      displayName: null,
      category: "Sans Serif",
      size: 420092,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3876953125
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2016-05-31",
      popularity: 500,
      trending: 123,
      defaultSort: 517,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Patua One",
      displayName: null,
      category: "Display",
      size: 19690,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.219
        }
      },
      axes: [],
      designers: ["LatinoType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 168,
      trending: 1369,
      defaultSort: 169,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pavanam",
      displayName: null,
      category: "Sans Serif",
      size: 63100,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.291
        }
      },
      axes: [],
      designers: ["Tharique Azeez"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 850,
      trending: 1149,
      defaultSort: 850,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Paytone One",
      displayName: null,
      category: "Sans Serif",
      size: 114648,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.396
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2011-05-04",
      popularity: 269,
      trending: 1540,
      defaultSort: 282,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Peddana",
      displayName: null,
      category: "Serif",
      size: 281364,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.628
        }
      },
      axes: [],
      designers: ["Appaji Ambarisha Darbha"],
      lastModified: "2022-09-21",
      dateAdded: "2014-12-10",
      popularity: 1192,
      trending: 1588,
      defaultSort: 1157,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Peralta",
      displayName: null,
      category: "Display",
      size: 35616,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.29443359375
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-07-11",
      popularity: 928,
      trending: 1321,
      defaultSort: 917,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Permanent Marker",
      displayName: null,
      category: "Handwriting",
      size: 74632,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 6,
          width: 8,
          lineHeight: 1.45703125
        }
      },
      axes: [],
      designers: ["Font Diner"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 157,
      trending: 1526,
      defaultSort: 151,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Petemoss",
      displayName: null,
      category: "Handwriting",
      size: 143236,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-07",
      popularity: 1468,
      trending: 235,
      defaultSort: 1384,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Petit Formal Script",
      displayName: null,
      category: "Handwriting",
      size: 70282,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 7,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2023-05-02",
      dateAdded: "2012-09-07",
      popularity: 590,
      trending: 1065,
      defaultSort: 606,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Petrona",
      displayName: null,
      category: "Serif",
      size: 224374,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.128
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.128
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Ringo R. Seeber"],
      lastModified: "2023-03-21",
      dateAdded: "2020-07-14",
      popularity: 331,
      trending: 378,
      defaultSort: 349,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Philosopher",
      displayName: null,
      category: "Sans Serif",
      size: 113415,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.12
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.12
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.12
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.12
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-31",
      popularity: 181,
      trending: 638,
      defaultSort: 183,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Phudu",
      displayName: null,
      category: "Display",
      size: 129144,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.225
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["D\u01B0\u01A1ng Tr\u1EA7n"],
      lastModified: "2023-02-16",
      dateAdded: "2023-01-30",
      popularity: 1497,
      trending: 1560,
      defaultSort: 722,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Piazzolla",
      displayName: null,
      category: "Serif",
      size: 621536,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.42
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 8,
          max: 30,
          defaultValue: 14
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Juan Pablo del Peral", "Huerta Tipogr\xE1fica"],
      lastModified: "2023-03-21",
      dateAdded: "2020-08-27",
      popularity: 992,
      trending: 1685,
      defaultSort: 973,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Piedra",
      displayName: null,
      category: "Display",
      size: 36358,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.301
        }
      },
      axes: [],
      designers: ["Sudtipos"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-30",
      popularity: 1120,
      trending: 1459,
      defaultSort: 1099,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pinyon Script",
      displayName: null,
      category: "Handwriting",
      size: 146484,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 9,
          width: 6,
          lineHeight: 1.24755859375
        }
      },
      axes: [],
      designers: ["Nicole Fally"],
      lastModified: "2023-05-02",
      dateAdded: "2011-10-12",
      popularity: 406,
      trending: 872,
      defaultSort: 428,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pirata One",
      displayName: null,
      category: "Display",
      size: 56316,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.285
        }
      },
      axes: [],
      designers: ["Rodrigo Fuenzalida", "Nicolas Massi"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 574,
      trending: 144,
      defaultSort: 590,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Plaster",
      displayName: null,
      category: "Display",
      size: 18428,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 9,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Sorkin Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 1116,
      trending: 347,
      defaultSort: 1095,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Play",
      displayName: null,
      category: "Sans Serif",
      size: 204862,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.157
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.157
        }
      },
      axes: [],
      designers: ["Jonas Hecksher"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-04",
      popularity: 120,
      trending: 812,
      defaultSort: 114,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Playball",
      displayName: null,
      category: "Display",
      size: 190720,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 7,
          width: 6,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 316,
      trending: 673,
      defaultSort: 333,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Playfair",
      displayName: null,
      category: "Serif",
      size: 1144870,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 5,
          max: 1200,
          defaultValue: 14
        },
        {
          tag: "wdth",
          min: 87.5,
          max: 112.5,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Claus Eggers S\xF8rensen"],
      lastModified: "2023-06-21",
      dateAdded: "2023-04-12",
      popularity: 491,
      trending: 1615,
      defaultSort: 325,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Playfair Display",
      displayName: null,
      category: "Serif",
      size: 289706,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.333
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 7,
          lineHeight: 1.333
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.333
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.333
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.333
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.333
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.333
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1.333
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.333
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.333
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.333
        },
        "900i": {
          thickness: 7,
          slant: 5,
          width: 7,
          lineHeight: 1.333
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Claus Eggers S\xF8rensen"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-16",
      popularity: 25,
      trending: 817,
      defaultSort: 26,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Playfair Display SC",
      displayName: null,
      category: "Serif",
      size: 202728,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.333
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 8,
          lineHeight: 1.333
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.333
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 8,
          lineHeight: 1.333
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.333
        },
        "900i": {
          thickness: 7,
          slant: 5,
          width: 8,
          lineHeight: 1.333
        }
      },
      axes: [],
      designers: ["Claus Eggers S\xF8rensen"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-26",
      popularity: 287,
      trending: 1582,
      defaultSort: 301,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Plus Jakarta Sans",
      displayName: null,
      category: "Sans Serif",
      size: 179738,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Tokotype"],
      lastModified: "2023-06-22",
      dateAdded: "2022-03-23",
      popularity: 141,
      trending: 584,
      defaultSort: 134,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Podkova",
      displayName: null,
      category: "Serif",
      size: 163368,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.108
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.108
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.108
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.108
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.108
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-18",
      popularity: 570,
      trending: 1500,
      defaultSort: 586,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Poiret One",
      displayName: null,
      category: "Display",
      size: 22853,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 7,
          lineHeight: 1.17
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 223,
      trending: 379,
      defaultSort: 230,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Poller One",
      displayName: null,
      category: "Display",
      size: 16366,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.1884765625
        }
      },
      axes: [],
      designers: ["Yvonne Sch\xFCttler"],
      lastModified: "2022-09-21",
      dateAdded: "2011-09-28",
      popularity: 773,
      trending: 113,
      defaultSort: 774,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Poltawski Nowy",
      displayName: "P\xF3\u0142tawski Nowy",
      category: "Serif",
      size: 400108,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Adam P\xF3\u0142tawski", "Mateusz Machalski", "Borys Kosmynka", "Ania Wielu\u0144ska"],
      lastModified: "2023-05-31",
      dateAdded: "2023-04-19",
      popularity: 1216,
      trending: 1544,
      defaultSort: 362,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Poly",
      displayName: null,
      category: "Serif",
      size: 33294,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.188
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.188
        }
      },
      axes: [],
      designers: ["Nicol\xE1s Silva"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-02",
      popularity: 795,
      trending: 926,
      defaultSort: 797,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pompiere",
      displayName: null,
      category: "Display",
      size: 25132,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 5,
          lineHeight: 1.20166015625
        }
      },
      axes: [],
      designers: ["Karolina Lach"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-20",
      popularity: 847,
      trending: 1586,
      defaultSort: 847,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pontano Sans",
      displayName: null,
      category: "Sans Serif",
      size: 78564,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28125
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.28125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28125
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams"],
      lastModified: "2023-04-04",
      dateAdded: "2012-03-14",
      popularity: 401,
      trending: 1209,
      defaultSort: 423,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Poor Story",
      displayName: null,
      category: "Display",
      size: 3966768,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Yoon Design"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-23",
      popularity: 1142,
      trending: 760,
      defaultSort: 1117,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Poppins",
      displayName: null,
      category: "Sans Serif",
      size: 170738,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.5
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.5
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.5
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.5
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [],
      designers: ["Indian Type Foundry", "Jonny Pinhorn"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-03",
      popularity: 9,
      trending: 823,
      defaultSort: 10,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Port Lligat Sans",
      displayName: null,
      category: "Sans Serif",
      size: 18104,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.071
        }
      },
      axes: [],
      designers: ["Tipo"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 1067,
      trending: 1503,
      defaultSort: 1051,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Port Lligat Slab",
      displayName: null,
      category: "Serif",
      size: 19054,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.071
        }
      },
      axes: [],
      designers: ["Tipo"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 931,
      trending: 1734,
      defaultSort: 920,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Potta One",
      displayName: null,
      category: "Display",
      size: 4918516,
      subsets: ["menu", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Font Zone 108"],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-14",
      popularity: 933,
      trending: 453,
      defaultSort: 922,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pragati Narrow",
      displayName: null,
      category: "Sans Serif",
      size: 147822,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 1.692
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 1.692
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2015-04-22",
      popularity: 339,
      trending: 581,
      defaultSort: 357,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Praise",
      displayName: null,
      category: "Handwriting",
      size: 694316,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-12",
      popularity: 1295,
      trending: 255,
      defaultSort: 1253,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Prata",
      displayName: null,
      category: "Serif",
      size: 101284,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.355
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-09-07",
      popularity: 182,
      trending: 330,
      defaultSort: 184,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Preahvihear",
      displayName: null,
      category: "Sans Serif",
      size: 91520,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-27",
      dateAdded: "2011-03-02",
      popularity: 1358,
      trending: 1662,
      defaultSort: 1301,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Press Start 2P",
      displayName: null,
      category: "Display",
      size: 118204,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 10,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["CodeMan38"],
      lastModified: "2023-05-02",
      dateAdded: "2012-04-04",
      popularity: 222,
      trending: 552,
      defaultSort: 229,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Pridi",
      displayName: null,
      category: "Serif",
      size: 213464,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.6
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.55
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.55
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.55
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.55
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.55
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 367,
      trending: 458,
      defaultSort: 387,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Princess Sofia",
      displayName: null,
      category: "Handwriting",
      size: 130400,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 3,
          width: 6,
          lineHeight: 1.546875
        }
      },
      axes: [],
      designers: ["Tart Workshop"],
      lastModified: "2023-05-02",
      dateAdded: "2012-02-15",
      popularity: 1074,
      trending: 710,
      defaultSort: 1058,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Prociono",
      displayName: null,
      category: "Serif",
      size: 18835,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Barry Schwartz"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-31",
      popularity: 955,
      trending: 1467,
      defaultSort: 941,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Prompt",
      displayName: null,
      category: "Sans Serif",
      size: 164480,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.512
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 75,
      trending: 409,
      defaultSort: 72,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Prosto One",
      displayName: null,
      category: "Display",
      size: 96868,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.235
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad", "Pavel Emelyanov"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 837,
      trending: 234,
      defaultSort: 838,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Proza Libre",
      displayName: null,
      category: "Sans Serif",
      size: 98388,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.365234375
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.365234375
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.357421875
        }
      },
      axes: [],
      designers: ["Jasper de Waard"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 577,
      trending: 290,
      defaultSort: 593,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Public Sans",
      displayName: null,
      category: "Sans Serif",
      size: 105628,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.175
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["USWDS", "Dan Williams", "Pablo Impallari", "Rodrigo Fuenzalida"],
      lastModified: "2022-09-21",
      dateAdded: "2019-06-07",
      popularity: 97,
      trending: 420,
      defaultSort: 92,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Puppies Play",
      displayName: null,
      category: "Handwriting",
      size: 167944,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-10-12",
      popularity: 1524,
      trending: 158,
      defaultSort: 1415,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Puritan",
      displayName: null,
      category: "Sans Serif",
      size: 28730,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.1103515625
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.109375
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.125
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.125
        }
      },
      axes: [],
      designers: ["Ben Weiner"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-30",
      popularity: 856,
      trending: 824,
      defaultSort: 855,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Purple Purse",
      displayName: null,
      category: "Display",
      size: 36426,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-16",
      popularity: 1300,
      trending: 442,
      defaultSort: 1257,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Qahiri",
      displayName: null,
      category: "Sans Serif",
      size: 35996,
      subsets: ["menu", "arabic", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1333333333333333
        }
      },
      axes: [],
      designers: ["Khaled Hosny"],
      lastModified: "2022-12-07",
      dateAdded: "2021-04-03",
      popularity: 1161,
      trending: 110,
      defaultSort: 1132,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Quando",
      displayName: null,
      category: "Serif",
      size: 119688,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Joana Correia"],
      lastModified: "2022-09-21",
      dateAdded: "2012-07-10",
      popularity: 685,
      trending: 929,
      defaultSort: 691,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Quantico",
      displayName: null,
      category: "Sans Serif",
      size: 11479,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.43
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 7,
          lineHeight: 1.43
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.43
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 7,
          lineHeight: 1.43
        }
      },
      axes: [],
      designers: ["MADType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 397,
      trending: 1394,
      defaultSort: 419,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Quattrocento",
      displayName: null,
      category: "Serif",
      size: 57181,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.108
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.108
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2023-05-02",
      dateAdded: "2012-03-20",
      popularity: 248,
      trending: 917,
      defaultSort: 262,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Quattrocento Sans",
      displayName: null,
      category: "Sans Serif",
      size: 39176,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.108
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.108
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.108
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.108
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-15",
      popularity: 215,
      trending: 622,
      defaultSort: 219,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Questrial",
      displayName: null,
      category: "Sans Serif",
      size: 184176,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.03
        }
      },
      axes: [],
      designers: ["Joe Prince", "Laura Meseguer"],
      lastModified: "2023-01-06",
      dateAdded: "2011-08-10",
      popularity: 129,
      trending: 889,
      defaultSort: 123,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Quicksand",
      displayName: null,
      category: "Sans Serif",
      size: 124824,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 1,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        },
        "400": {
          thickness: 3,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Andrew Paglinawan"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-19",
      popularity: 37,
      trending: 1099,
      defaultSort: 37,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Quintessential",
      displayName: null,
      category: "Handwriting",
      size: 44312,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.533203125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-02",
      popularity: 509,
      trending: 658,
      defaultSort: 525,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Qwigley",
      displayName: null,
      category: "Handwriting",
      size: 87336,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 7,
          width: 4,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 575,
      trending: 575,
      defaultSort: 591,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Qwitcher Grypen",
      displayName: null,
      category: "Handwriting",
      size: 193576,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-26",
      popularity: 1004,
      trending: 184,
      defaultSort: 983,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Racing Sans One",
      displayName: null,
      category: "Display",
      size: 58490,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 5,
          width: 7,
          lineHeight: 1.26
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-13",
      popularity: 414,
      trending: 81,
      defaultSort: 437,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Radio Canada",
      displayName: null,
      category: "Sans Serif",
      size: 466288,
      subsets: ["menu", "canadian-aboriginal", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 100,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Charles Daoud", "Coppers and Brasses", "Alexandre Saumier Demers", "Jacques Le Bailly"],
      lastModified: "2023-05-09",
      dateAdded: "2022-04-25",
      popularity: 999,
      trending: 224,
      defaultSort: 979,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Radley",
      displayName: null,
      category: "Serif",
      size: 86712,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.263671875
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.263671875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 737,
      trending: 550,
      defaultSort: 742,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rajdhani",
      displayName: null,
      category: "Sans Serif",
      size: 387431,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 2,
          slant: 1,
          width: 6,
          lineHeight: 1.276
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.276
        },
        "500": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.276
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.276
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.276
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2014-07-09",
      popularity: 92,
      trending: 1466,
      defaultSort: 87,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rakkas",
      displayName: null,
      category: "Display",
      size: 146824,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.491
        }
      },
      axes: [],
      designers: ["Zeynep Akay"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 775,
      trending: 1625,
      defaultSort: 776,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Raleway",
      displayName: null,
      category: "Sans Serif",
      size: 315414,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "100i": {
          thickness: 1,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "200": {
          thickness: 2,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "200i": {
          thickness: 2,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "300i": {
          thickness: 3,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "500i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "600i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "800": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.174
        },
        "800i": {
          thickness: 7,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.174
        },
        "900i": {
          thickness: 8,
          slant: 4,
          width: 7,
          lineHeight: 1.174
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Matt McInerney", "Pablo Impallari", "Rodrigo Fuenzalida"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-07",
      popularity: 18,
      trending: 866,
      defaultSort: 18,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Raleway Dots",
      displayName: null,
      category: "Display",
      size: 464888,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 1,
          slant: 1,
          width: 7,
          lineHeight: 1.131
        }
      },
      axes: [],
      designers: ["Matt McInerney", "Pablo Impallari", "Rodrigo Fuenzalida", "Brenda Gallo"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-07",
      popularity: 752,
      trending: 454,
      defaultSort: 754,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ramabhadra",
      displayName: null,
      category: "Sans Serif",
      size: 251151,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.8975903614457832
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-04-27",
      dateAdded: "2014-12-10",
      popularity: 321,
      trending: 1552,
      defaultSort: 340,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ramaraja",
      displayName: null,
      category: "Serif",
      size: 272499,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.7133333333333334
        }
      },
      axes: [],
      designers: ["Appaji Ambarisha Darbha"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-08",
      popularity: 874,
      trending: 403,
      defaultSort: 871,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rambla",
      displayName: null,
      category: "Sans Serif",
      size: 16956,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.224
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.224
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.224
        },
        "700i": {
          thickness: 7,
          slant: 4,
          width: 7,
          lineHeight: 1.224
        }
      },
      axes: [],
      designers: ["Martin Sommaruga"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 554,
      trending: 1574,
      defaultSort: 572,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rammetto One",
      displayName: null,
      category: "Display",
      size: 19117,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.68896484375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-02",
      popularity: 471,
      trending: 1020,
      defaultSort: 490,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rampart One",
      displayName: null,
      category: "Display",
      size: 3722352,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Fontworks Inc."],
      lastModified: "2022-09-27",
      dateAdded: "2021-06-08",
      popularity: 757,
      trending: 1465,
      defaultSort: 758,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ranchers",
      displayName: null,
      category: "Display",
      size: 68762,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Impallari Type"],
      lastModified: "2023-05-02",
      dateAdded: "2012-09-07",
      popularity: 974,
      trending: 1695,
      defaultSort: 956,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rancho",
      displayName: null,
      category: "Handwriting",
      size: 44832,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.2421875
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 474,
      trending: 1567,
      defaultSort: 493,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ranga",
      displayName: null,
      category: "Display",
      size: 123208,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 5,
          width: 5,
          lineHeight: 1.463029756537421
        },
        "700": {
          thickness: 6,
          slant: 5,
          width: 5,
          lineHeight: 1.463029756537421
        }
      },
      axes: [],
      designers: ["TipTopTyp"],
      lastModified: "2023-05-02",
      dateAdded: "2015-01-28",
      popularity: 1010,
      trending: 71,
      defaultSort: 990,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rasa",
      displayName: null,
      category: "Serif",
      size: 382116,
      subsets: ["menu", "gujarati", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Rosetta", "Anna Giedry\u015B", "David B\u0159ezina"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 598,
      trending: 1059,
      defaultSort: 613,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rationale",
      displayName: null,
      category: "Sans Serif",
      size: 28190,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.153
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-27",
      dateAdded: "2011-08-03",
      popularity: 1038,
      trending: 798,
      defaultSort: 1024,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ravi Prakash",
      displayName: null,
      category: "Display",
      size: 128642,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.583984375
        }
      },
      axes: [],
      designers: ["Appaji Ambarisha Darbha"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-12",
      popularity: 1160,
      trending: 1630,
      defaultSort: 1131,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Readex Pro",
      displayName: null,
      category: "Sans Serif",
      size: 286208,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "HEXP",
          min: 0,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 160,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Thomas Jockin", "Nadine Chahine", "Bonnie Shaver-Troup", "Santiago Orozco", "H\xE9ctor G\xF3mez"],
      lastModified: "2023-04-27",
      dateAdded: "2021-09-16",
      popularity: 271,
      trending: 364,
      defaultSort: 283,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Recursive",
      displayName: null,
      category: "Sans Serif",
      size: 2379132,
      subsets: ["menu", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "CASL",
          min: 0,
          max: 1,
          defaultValue: 0
        },
        {
          tag: "CRSV",
          min: 0,
          max: 1,
          defaultValue: 0.5
        },
        {
          tag: "MONO",
          min: 0,
          max: 1,
          defaultValue: 0
        },
        {
          tag: "slnt",
          min: -15,
          max: 0,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 300,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Arrow Type", "Stephen Nixon"],
      lastModified: "2023-01-06",
      dateAdded: "2019-06-28",
      popularity: 784,
      trending: 203,
      defaultSort: 785,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Red Hat Display",
      displayName: null,
      category: "Sans Serif",
      size: 99692,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["MCKL"],
      lastModified: "2022-09-21",
      dateAdded: "2019-04-09",
      popularity: 116,
      trending: 768,
      defaultSort: 110,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Red Hat Mono",
      displayName: null,
      category: "Monospace",
      size: 71012,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["MCKL"],
      lastModified: "2022-09-21",
      dateAdded: "2021-06-10",
      popularity: 1048,
      trending: 576,
      defaultSort: 1033,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Red Hat Text",
      displayName: null,
      category: "Sans Serif",
      size: 98324,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.323
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["MCKL"],
      lastModified: "2022-09-21",
      dateAdded: "2019-04-09",
      popularity: 280,
      trending: 120,
      defaultSort: 293,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Red Rose",
      displayName: null,
      category: "Display",
      size: 114928,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Jaikishan Patel"],
      lastModified: "2023-03-21",
      dateAdded: "2020-07-02",
      popularity: 948,
      trending: 189,
      defaultSort: 935,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Redacted",
      displayName: null,
      category: "Display",
      size: 15920,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Christian Naths"],
      lastModified: "2023-01-06",
      dateAdded: "2013-09-18",
      popularity: 1153,
      trending: 14,
      defaultSort: 71,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Redacted Script",
      displayName: null,
      category: "Display",
      size: 84900,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Christian Naths"],
      lastModified: "2023-05-02",
      dateAdded: "2013-09-18",
      popularity: 1450,
      trending: 187,
      defaultSort: 1369,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Redressed",
      displayName: null,
      category: "Handwriting",
      size: 79220,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.17236328125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-21",
      popularity: 1062,
      trending: 921,
      defaultSort: 1046,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Reem Kufi",
      displayName: null,
      category: "Sans Serif",
      size: 130976,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Khaled Hosny", "Santiago Orozco"],
      lastModified: "2022-12-07",
      dateAdded: "2016-05-31",
      popularity: 398,
      trending: 1308,
      defaultSort: 420,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Reem Kufi Fun",
      displayName: null,
      category: "Sans Serif",
      size: 142736,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Khaled Hosny", "Santiago Orozco"],
      lastModified: "2023-03-09",
      dateAdded: "2021-11-01",
      popularity: 1408,
      trending: 60,
      defaultSort: 988,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV0"],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Reem Kufi Ink",
      displayName: null,
      category: "Sans Serif",
      size: 242992,
      subsets: ["menu", "arabic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5
        }
      },
      axes: [],
      designers: ["Khaled Hosny", "Santiago Orozco"],
      lastModified: "2023-05-31",
      dateAdded: "2021-11-01",
      popularity: 1507,
      trending: 245,
      defaultSort: 1404,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: ["COLRV1", "OTSVG"],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Reenie Beanie",
      displayName: null,
      category: "Handwriting",
      size: 64386,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["James Grieshaber"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-10",
      popularity: 425,
      trending: 941,
      defaultSort: 448,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Reggae One",
      displayName: null,
      category: "Display",
      size: 2153256,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Fontworks Inc."],
      lastModified: "2023-05-02",
      dateAdded: "2020-12-15",
      popularity: 728,
      trending: 55,
      defaultSort: 733,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Revalia",
      displayName: null,
      category: "Display",
      size: 61436,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 9,
          lineHeight: 1.234375
        }
      },
      axes: [],
      designers: ["Johan Kallas", "Mihkel Virkus"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-14",
      popularity: 1294,
      trending: 1741,
      defaultSort: 1252,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rhodium Libre",
      displayName: null,
      category: "Serif",
      size: 106902,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.71
        }
      },
      axes: [],
      designers: ["James Puckett"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-03",
      popularity: 1075,
      trending: 316,
      defaultSort: 1059,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ribeye",
      displayName: null,
      category: "Display",
      size: 44724,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.3662109375
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-23",
      popularity: 993,
      trending: 1243,
      defaultSort: 974,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ribeye Marrow",
      displayName: null,
      category: "Display",
      size: 45571,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.3662109375
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 1256,
      trending: 1639,
      defaultSort: 1215,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Righteous",
      displayName: null,
      category: "Display",
      size: 23485,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.24169921875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2023-05-02",
      dateAdded: "2011-11-23",
      popularity: 165,
      trending: 1797,
      defaultSort: 166,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Risque",
      displayName: null,
      category: "Display",
      size: 33784,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 2,
          width: 7,
          lineHeight: 1.15576171875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-11",
      popularity: 1204,
      trending: 1385,
      defaultSort: 1168,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Road Rage",
      displayName: null,
      category: "Display",
      size: 427472,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-21",
      popularity: 1042,
      trending: 1406,
      defaultSort: 1027,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Roboto",
      displayName: null,
      category: "Sans Serif",
      size: 173710,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 2,
          slant: 1,
          width: 7,
          lineHeight: 1.171875
        },
        "100i": {
          thickness: 2,
          slant: 4,
          width: 7,
          lineHeight: 1.171875
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.171875
        },
        "300i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.171875
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.171875
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.171875
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.171875
        },
        "500i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.171875
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.171875
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.171875
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.171875
        },
        "900i": {
          thickness: 7,
          slant: 4,
          width: 7,
          lineHeight: 1.171875
        }
      },
      axes: [],
      designers: ["Christian Robertson"],
      lastModified: "2022-09-21",
      dateAdded: "2013-01-09",
      popularity: 2,
      trending: 1138,
      defaultSort: 1,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Roboto Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 172424,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.171875
        },
        "300i": {
          thickness: 4,
          slant: 4,
          width: 6,
          lineHeight: 1.171875
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.171875
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.171875
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.171875
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 6,
          lineHeight: 1.171875
        }
      },
      axes: [],
      designers: ["Christian Robertson"],
      lastModified: "2022-09-21",
      dateAdded: "2012-06-26",
      popularity: 11,
      trending: 1244,
      defaultSort: 12,
      androidFragment: "name=Roboto&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Roboto Flex",
      displayName: null,
      category: "Sans Serif",
      size: 1755856,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [
        {
          tag: "GRAD",
          min: -200,
          max: 150,
          defaultValue: 0
        },
        {
          tag: "XTRA",
          min: 323,
          max: 603,
          defaultValue: 468
        },
        {
          tag: "YOPQ",
          min: 25,
          max: 135,
          defaultValue: 79
        },
        {
          tag: "YTAS",
          min: 649,
          max: 854,
          defaultValue: 750
        },
        {
          tag: "YTDE",
          min: -305,
          max: -98,
          defaultValue: -203
        },
        {
          tag: "YTFI",
          min: 560,
          max: 788,
          defaultValue: 738
        },
        {
          tag: "YTLC",
          min: 416,
          max: 570,
          defaultValue: 514
        },
        {
          tag: "YTUC",
          min: 528,
          max: 760,
          defaultValue: 712
        },
        {
          tag: "opsz",
          min: 8,
          max: 144,
          defaultValue: 14
        },
        {
          tag: "slnt",
          min: -10,
          max: 0,
          defaultValue: 0
        },
        {
          tag: "wdth",
          min: 25,
          max: 151,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: [
        "Font Bureau",
        "David Berlow",
        "Santiago Orozco",
        "Irene Vlachou",
        "Ilya Ruderman",
        "Yury Ostromentsky",
        "Mikhail Strukov"
      ],
      lastModified: "2023-01-06",
      dateAdded: "2022-05-02",
      popularity: 202,
      trending: 1042,
      defaultSort: 204,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Roboto Mono",
      displayName: null,
      category: "Monospace",
      size: 191258,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Christian Robertson"],
      lastModified: "2022-09-21",
      dateAdded: "2015-05-13",
      popularity: 15,
      trending: 705,
      defaultSort: 15,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Roboto Serif",
      displayName: null,
      category: "Serif",
      size: 4312646,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.171
        }
      },
      axes: [
        {
          tag: "GRAD",
          min: -50,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "opsz",
          min: 8,
          max: 144,
          defaultValue: 14
        },
        {
          tag: "wdth",
          min: 50,
          max: 150,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Commercial Type", "Greg Gazdowicz"],
      lastModified: "2023-04-04",
      dateAdded: "2022-02-10",
      popularity: 273,
      trending: 557,
      defaultSort: 285,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Roboto Slab",
      displayName: null,
      category: "Serif",
      size: 251688,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 2,
          slant: 1,
          width: 7,
          lineHeight: 1.31884765625
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.31884765625
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.31884765625
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.31884765625
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.31884765625
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Christian Robertson"],
      lastModified: "2023-05-02",
      dateAdded: "2013-04-10",
      popularity: 22,
      trending: 1159,
      defaultSort: 21,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rochester",
      displayName: null,
      category: "Handwriting",
      size: 37144,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.28759765625
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-03",
      popularity: 576,
      trending: 605,
      defaultSort: 592,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rock 3D",
      displayName: null,
      category: "Display",
      size: 444468,
      subsets: ["menu", "japanese", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Shibuya Font"],
      lastModified: "2023-05-31",
      dateAdded: "2020-12-14",
      popularity: 1480,
      trending: 1776,
      defaultSort: 1390,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Rock Salt",
      displayName: null,
      category: "Handwriting",
      size: 124372,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 2,
          width: 8,
          lineHeight: 2.3857421875
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 336,
      trending: 665,
      defaultSort: 354,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "RocknRoll One",
      displayName: null,
      category: "Sans Serif",
      size: 2682824,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Fontworks Inc."],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-15",
      popularity: 738,
      trending: 1252,
      defaultSort: 743,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rokkitt",
      displayName: null,
      category: "Serif",
      size: 134592,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.137
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.137
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.137
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.137
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Vernon Adams"],
      lastModified: "2023-03-21",
      dateAdded: "2011-07-27",
      popularity: 204,
      trending: 1100,
      defaultSort: 206,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Romanesco",
      displayName: null,
      category: "Handwriting",
      size: 28547,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 6,
          width: 1,
          lineHeight: 1.14697265625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-13",
      popularity: 1146,
      trending: 1274,
      defaultSort: 1119,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ropa Sans",
      displayName: null,
      category: "Sans Serif",
      size: 57920,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.072
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.072
        }
      },
      axes: [],
      designers: ["Botjo Nikoltchev"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-25",
      popularity: 274,
      trending: 912,
      defaultSort: 286,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rosario",
      displayName: null,
      category: "Sans Serif",
      size: 150196,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.212
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 6,
          lineHeight: 1.212
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.212
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.212
        },
        "700i": {
          thickness: 6,
          slant: 3,
          width: 6,
          lineHeight: 1.212
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-03-21",
      dateAdded: "2011-09-07",
      popularity: 639,
      trending: 1367,
      defaultSort: 649,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rosarivo",
      displayName: null,
      category: "Serif",
      size: 21410,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.403
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.403
        }
      },
      axes: [],
      designers: ["Pablo Ugerman"],
      lastModified: "2022-09-21",
      dateAdded: "2012-03-29",
      popularity: 1061,
      trending: 910,
      defaultSort: 1045,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rouge Script",
      displayName: null,
      category: "Handwriting",
      size: 22140,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 4,
          width: 5,
          lineHeight: 1.1752
        }
      },
      axes: [],
      designers: ["Sabrina Mariela Lopez"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 735,
      trending: 626,
      defaultSort: 740,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rowdies",
      displayName: null,
      category: "Display",
      size: 76261,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.242
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.242
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.242
        }
      },
      axes: [],
      designers: ["Jaikishan Patel"],
      lastModified: "2022-09-21",
      dateAdded: "2019-10-10",
      popularity: 146,
      trending: 724,
      defaultSort: 139,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rozha One",
      displayName: null,
      category: "Serif",
      size: 322828,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.42
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2014-08-13",
      popularity: 510,
      trending: 328,
      defaultSort: 526,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik",
      displayName: null,
      category: "Sans Serif",
      size: 357394,
      subsets: ["menu", "arabic", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Hubert and Fischer", "Meir Sadan", "Cyreal", "Daniel Grumer", "Omaima Dajani"],
      lastModified: "2023-06-29",
      dateAdded: "2015-07-22",
      popularity: 27,
      trending: 1114,
      defaultSort: 28,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik 80s Fade",
      displayName: null,
      category: "Display",
      size: 3448044,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2023-05-02",
      dateAdded: "2022-11-24",
      popularity: 1478,
      trending: 1747,
      defaultSort: 1006,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Beastly",
      displayName: null,
      category: "Display",
      size: 512684,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2021-09-02",
      popularity: 1359,
      trending: 213,
      defaultSort: 1302,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Bubbles",
      displayName: null,
      category: "Display",
      size: 219564,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2023-05-02",
      dateAdded: "2022-02-17",
      popularity: 1380,
      trending: 1780,
      defaultSort: 1320,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Burned",
      displayName: null,
      category: "Display",
      size: 605348,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-06-15",
      popularity: 1544,
      trending: 1470,
      defaultSort: 1342,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Dirt",
      displayName: null,
      category: "Display",
      size: 1492292,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2023-05-02",
      dateAdded: "2022-06-15",
      popularity: 640,
      trending: 30,
      defaultSort: 338,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Distressed",
      displayName: null,
      category: "Display",
      size: 892544,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-06-15",
      popularity: 1365,
      trending: 637,
      defaultSort: 1308,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Gemstones",
      displayName: null,
      category: "Display",
      size: 265004,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-12-07",
      dateAdded: "2022-11-24",
      popularity: 1531,
      trending: 1314,
      defaultSort: 1008,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Glitch",
      displayName: null,
      category: "Display",
      size: 407304,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-17",
      popularity: 1386,
      trending: 443,
      defaultSort: 1326,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Iso",
      displayName: null,
      category: "Display",
      size: 132376,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2023-05-02",
      dateAdded: "2022-06-15",
      popularity: 1511,
      trending: 1811,
      defaultSort: 1340,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Marker Hatch",
      displayName: null,
      category: "Display",
      size: 363876,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-06-15",
      popularity: 1522,
      trending: 702,
      defaultSort: 1341,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Maze",
      displayName: null,
      category: "Display",
      size: 459040,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2023-05-02",
      dateAdded: "2022-06-15",
      popularity: 1573,
      trending: 1122,
      defaultSort: 1343,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Microbe",
      displayName: null,
      category: "Display",
      size: 1444176,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-17",
      popularity: 1491,
      trending: 1256,
      defaultSort: 1395,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Mono One",
      displayName: null,
      category: "Sans Serif",
      size: 22893,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 9,
          lineHeight: 1.238
        }
      },
      axes: [],
      designers: ["Hubert and Fischer"],
      lastModified: "2023-05-02",
      dateAdded: "2014-05-05",
      popularity: 314,
      trending: 1596,
      defaultSort: 330,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Moonrocks",
      displayName: null,
      category: "Display",
      size: 403712,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-17",
      popularity: 532,
      trending: 755,
      defaultSort: 550,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Pixels",
      displayName: null,
      category: "Display",
      size: 5627648,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2023-04-04",
      dateAdded: "2023-03-31",
      popularity: 1483,
      trending: 1378,
      defaultSort: 482,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Puddles",
      displayName: null,
      category: "Display",
      size: 404956,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-17",
      popularity: 1364,
      trending: 1730,
      defaultSort: 1307,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Spray Paint",
      displayName: null,
      category: "Display",
      size: 941576,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-12-07",
      dateAdded: "2022-11-24",
      popularity: 1446,
      trending: 103,
      defaultSort: 1004,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Storm",
      displayName: null,
      category: "Display",
      size: 795704,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-12-07",
      dateAdded: "2022-11-24",
      popularity: 1502,
      trending: 895,
      defaultSort: 1007,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Vinyl",
      displayName: null,
      category: "Display",
      size: 414752,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-12-07",
      dateAdded: "2022-11-24",
      popularity: 1449,
      trending: 633,
      defaultSort: 1005,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rubik Wet Paint",
      displayName: null,
      category: "Display",
      size: 442628,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.185
        }
      },
      axes: [],
      designers: ["NaN", "Luke Prowse"],
      lastModified: "2022-09-21",
      dateAdded: "2022-02-17",
      popularity: 1370,
      trending: 273,
      defaultSort: 1312,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ruda",
      displayName: null,
      category: "Sans Serif",
      size: 84420,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.217
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.217
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.217
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.217
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.217
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.217
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Mariela Monsalve", "Angelina Sanchez"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 298,
      trending: 1180,
      defaultSort: 313,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rufina",
      displayName: null,
      category: "Serif",
      size: 19127,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.235
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.235
        }
      },
      axes: [],
      designers: ["Martin Sommaruga"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 376,
      trending: 913,
      defaultSort: 396,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ruge Boogie",
      displayName: null,
      category: "Handwriting",
      size: 329956,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2011-12-19",
      popularity: 1375,
      trending: 527,
      defaultSort: 1315,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ruluko",
      displayName: null,
      category: "Sans Serif",
      size: 27436,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.155
        }
      },
      axes: [],
      designers: ["Ana Sanfelippo", "Ang\xE9lica D\xEDaz", "Meme Hern\xE1ndez"],
      lastModified: "2022-04-27",
      dateAdded: "2012-01-11",
      popularity: 1198,
      trending: 1014,
      defaultSort: 1164,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rum Raisin",
      displayName: null,
      category: "Sans Serif",
      size: 35175,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.2900390625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-02",
      popularity: 986,
      trending: 1067,
      defaultSort: 968,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ruslan Display",
      displayName: null,
      category: "Display",
      size: 20086,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.085
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-18",
      popularity: 889,
      trending: 1632,
      defaultSort: 882,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Russo One",
      displayName: null,
      category: "Sans Serif",
      size: 19428,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.205
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2012-04-04",
      popularity: 135,
      trending: 370,
      defaultSort: 128,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ruthie",
      displayName: null,
      category: "Handwriting",
      size: 71856,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 7,
          width: 4,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1066,
      trending: 1433,
      defaultSort: 1050,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Rye",
      displayName: null,
      category: "Display",
      size: 66252,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Nicole Fally"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-21",
      popularity: 531,
      trending: 1391,
      defaultSort: 549,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "STIX Two Text",
      displayName: null,
      category: "Serif",
      size: 436662,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Tiro Typeworks", "Ross Mills", "John Hudson", "Paul Hanslow"],
      lastModified: "2023-05-02",
      dateAdded: "2021-04-15",
      popularity: 478,
      trending: 186,
      defaultSort: 497,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sacramento",
      displayName: null,
      category: "Handwriting",
      size: 41985,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.45947265625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-01",
      popularity: 205,
      trending: 874,
      defaultSort: 208,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sahitya",
      displayName: null,
      category: "Serif",
      size: 125026,
      subsets: ["menu", "devanagari", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.553
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 4,
          lineHeight: 1.553
        }
      },
      axes: [],
      designers: ["Juan Pablo del Peral"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-17",
      popularity: 1028,
      trending: 559,
      defaultSort: 1015,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sail",
      displayName: null,
      category: "Display",
      size: 32656,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.154
        }
      },
      axes: [],
      designers: ["Miguel Hernandez"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 755,
      trending: 122,
      defaultSort: 756,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Saira",
      displayName: null,
      category: "Sans Serif",
      size: 509206,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 50,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2017-07-31",
      popularity: 235,
      trending: 499,
      defaultSort: 247,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Saira Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 95279,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2017-07-31",
      popularity: 210,
      trending: 1778,
      defaultSort: 213,
      androidFragment: "name=Saira&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Saira Extra Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 95178,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2017-07-31",
      popularity: 415,
      trending: 346,
      defaultSort: 438,
      androidFragment: "name=Saira&width=62.5",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Saira Semi Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 95503,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2017-07-31",
      popularity: 308,
      trending: 1124,
      defaultSort: 323,
      androidFragment: "name=Saira&width=87.5",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Saira Stencil One",
      displayName: null,
      category: "Display",
      size: 109944,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.574
        }
      },
      axes: [],
      designers: ["Hector Gatti", "Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2019-06-18",
      popularity: 828,
      trending: 195,
      defaultSort: 830,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Salsa",
      displayName: null,
      category: "Display",
      size: 24609,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.226
        }
      },
      axes: [],
      designers: ["John Vargas Beltr\xE1n"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 909,
      trending: 546,
      defaultSort: 901,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sanchez",
      displayName: null,
      category: "Serif",
      size: 26775,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.278
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 8,
          lineHeight: 1.278
        }
      },
      axes: [],
      designers: ["Daniel Hernandez"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 267,
      trending: 1106,
      defaultSort: 280,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sancreek",
      displayName: null,
      category: "Display",
      size: 32131,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.3876953125
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 1052,
      trending: 1512,
      defaultSort: 1037,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sansita",
      displayName: null,
      category: "Sans Serif",
      size: 114156,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2016-12-04",
      popularity: 402,
      trending: 682,
      defaultSort: 424,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sansita Swashed",
      displayName: null,
      category: "Display",
      size: 234096,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2020-08-31",
      popularity: 645,
      trending: 858,
      defaultSort: 653,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sarabun",
      displayName: null,
      category: "Sans Serif",
      size: 91764,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400": {
          thickness: 3,
          slant: 1,
          width: 5,
          lineHeight: 1.3
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 5,
          lineHeight: 1.3
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.3
        },
        "700i": {
          thickness: 5,
          slant: 5,
          width: 5,
          lineHeight: 1.3
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Suppakit Chalermlarp"],
      lastModified: "2022-09-21",
      dateAdded: "2013-10-28",
      popularity: 128,
      trending: 692,
      defaultSort: 122,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sarala",
      displayName: null,
      category: "Sans Serif",
      size: 90435,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 1.63037109375
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 5,
          lineHeight: 1.63037109375
        }
      },
      axes: [],
      designers: ["Andres Torresi"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-17",
      popularity: 372,
      trending: 662,
      defaultSort: 392,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sarina",
      displayName: null,
      category: "Display",
      size: 42939,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 7,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["James Grieshaber"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 1150,
      trending: 1607,
      defaultSort: 1123,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sarpanch",
      displayName: null,
      category: "Sans Serif",
      size: 294382,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.4
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.4
        },
        "600": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.4
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.4
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.4
        },
        "900": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.4
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2014-09-03",
      popularity: 937,
      trending: 799,
      defaultSort: 927,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sassy Frass",
      displayName: null,
      category: "Handwriting",
      size: 162820,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-12",
      popularity: 1278,
      trending: 153,
      defaultSort: 1235,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Satisfy",
      displayName: null,
      category: "Handwriting",
      size: 47928,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.4404296875
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 125,
      trending: 220,
      defaultSort: 119,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sawarabi Gothic",
      displayName: null,
      category: "Sans Serif",
      size: 1902848,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.472
        }
      },
      axes: [],
      designers: ["mshio"],
      lastModified: "2022-09-27",
      dateAdded: "2018-05-17",
      popularity: 221,
      trending: 687,
      defaultSort: 228,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sawarabi Mincho",
      displayName: null,
      category: "Serif",
      size: 1084300,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.479
        }
      },
      axes: [],
      designers: ["mshio"],
      lastModified: "2022-09-27",
      dateAdded: "2018-05-17",
      popularity: 199,
      trending: 492,
      defaultSort: 201,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Scada",
      displayName: null,
      category: "Sans Serif",
      size: 92999,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.244
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 7,
          lineHeight: 1.244
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.244
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.244
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2023-05-02",
      dateAdded: "2012-07-30",
      popularity: 498,
      trending: 456,
      defaultSort: 515,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Scheherazade New",
      displayName: null,
      category: "Serif",
      size: 517996,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.03955078125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.03955078125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.03955078125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.03955078125
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-23",
      dateAdded: "2021-05-12",
      popularity: 1040,
      trending: 93,
      defaultSort: 1026,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Arab",
      primaryLanguage: ""
    },
    {
      family: "Schibsted Grotesk",
      displayName: null,
      category: "Sans Serif",
      size: 178754,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.234375
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Bakken & B\xE6ck", "Henrik Kongsvoll"],
      lastModified: "2023-05-02",
      dateAdded: "2023-03-31",
      popularity: 1322,
      trending: 64,
      defaultSort: 444,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Schoolbell",
      displayName: null,
      category: "Handwriting",
      size: 48904,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.392578125
        }
      },
      axes: [],
      designers: ["Font Diner"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 595,
      trending: 625,
      defaultSort: 610,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Scope One",
      displayName: null,
      category: "Serif",
      size: 93144,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 5,
          lineHeight: 1.383
        }
      },
      axes: [],
      designers: ["Dalton Maag"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 861,
      trending: 909,
      defaultSort: 860,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Seaweed Script",
      displayName: null,
      category: "Display",
      size: 58115,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 7,
          width: 6,
          lineHeight: 1.357421875
        }
      },
      axes: [],
      designers: ["Neapolitan"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-29",
      popularity: 540,
      trending: 1579,
      defaultSort: 558,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Secular One",
      displayName: null,
      category: "Sans Serif",
      size: 83916,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 5,
          lineHeight: 1.455
        }
      },
      axes: [],
      designers: ["Michal Sahar"],
      lastModified: "2023-06-22",
      dateAdded: "2016-03-31",
      popularity: 208,
      trending: 1800,
      defaultSort: 211,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sedgwick Ave",
      displayName: null,
      category: "Handwriting",
      size: 145332,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        }
      },
      axes: [],
      designers: ["Pedro Vergani", "Kevin Burke"],
      lastModified: "2022-09-21",
      dateAdded: "2017-08-01",
      popularity: 688,
      trending: 1648,
      defaultSort: 694,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sedgwick Ave Display",
      displayName: null,
      category: "Handwriting",
      size: 140148,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.249
        }
      },
      axes: [],
      designers: ["Pedro Vergani", "Kevin Burke"],
      lastModified: "2022-09-21",
      dateAdded: "2017-08-01",
      popularity: 1292,
      trending: 1440,
      defaultSort: 1249,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sen",
      displayName: null,
      category: "Sans Serif",
      size: 47724,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.203125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.203125
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.203125
        }
      },
      axes: [],
      designers: ["Kosal Sen"],
      lastModified: "2022-09-21",
      dateAdded: "2020-01-17",
      popularity: 190,
      trending: 919,
      defaultSort: 191,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Send Flowers",
      displayName: null,
      category: "Handwriting",
      size: 127692,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.325
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-11",
      popularity: 1443,
      trending: 173,
      defaultSort: 1367,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sevillana",
      displayName: null,
      category: "Display",
      size: 79591,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.35693359375
        }
      },
      axes: [],
      designers: ["Brownfox"],
      lastModified: "2022-04-27",
      dateAdded: "2012-02-22",
      popularity: 1411,
      trending: 528,
      defaultSort: 1347,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Seymour One",
      displayName: null,
      category: "Sans Serif",
      size: 42662,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 10,
          slant: 1,
          width: 9,
          lineHeight: 1.2568359375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-24",
      popularity: 1270,
      trending: 1328,
      defaultSort: 1228,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shadows Into Light",
      displayName: null,
      category: "Handwriting",
      size: 28654,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.6064453125
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-08",
      popularity: 108,
      trending: 1278,
      defaultSort: 103,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shadows Into Light Two",
      displayName: null,
      category: "Handwriting",
      size: 25609,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.451171875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2023-05-02",
      dateAdded: "2012-02-22",
      popularity: 485,
      trending: 1564,
      defaultSort: 504,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shalimar",
      displayName: null,
      category: "Handwriting",
      size: 220724,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.22
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-10-14",
      popularity: 938,
      trending: 128,
      defaultSort: 928,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shantell Sans",
      displayName: null,
      category: "Display",
      size: 1380826,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.34
        }
      },
      axes: [
        {
          tag: "BNCE",
          min: -100,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "INFM",
          min: 0,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "SPAC",
          min: 0,
          max: 100,
          defaultValue: 0
        },
        {
          tag: "wght",
          min: 300,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Shantell Martin", "Arrow Type", "Anya Danilova"],
      lastModified: "2023-04-27",
      dateAdded: "2023-01-16",
      popularity: 923,
      trending: 314,
      defaultSort: 723,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shanti",
      displayName: null,
      category: "Sans Serif",
      size: 49755,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.27490234375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-11",
      popularity: 1030,
      trending: 1717,
      defaultSort: 1017,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Share",
      displayName: null,
      category: "Display",
      size: 83900,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.127
        },
        "400i": {
          thickness: 5,
          slant: 3,
          width: 6,
          lineHeight: 1.127
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.127
        },
        "700i": {
          thickness: 6,
          slant: 2,
          width: 7,
          lineHeight: 1.127
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-08",
      popularity: 512,
      trending: 168,
      defaultSort: 528,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Share Tech",
      displayName: null,
      category: "Sans Serif",
      size: 53096,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.127
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 782,
      trending: 389,
      defaultSort: 783,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Share Tech Mono",
      displayName: null,
      category: "Monospace",
      size: 12544,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.127
        }
      },
      axes: [],
      designers: ["Carrois Apostrophe"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-31",
      popularity: 369,
      trending: 1302,
      defaultSort: 389,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shippori Antique",
      displayName: null,
      category: "Sans Serif",
      size: 7404988,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["FONTDASU"],
      lastModified: "2022-09-27",
      dateAdded: "2021-04-14",
      popularity: 1119,
      trending: 1421,
      defaultSort: 1098,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shippori Antique B1",
      displayName: null,
      category: "Sans Serif",
      size: 13095332,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["FONTDASU"],
      lastModified: "2022-09-27",
      dateAdded: "2021-04-14",
      popularity: 1250,
      trending: 365,
      defaultSort: 1209,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shippori Mincho",
      displayName: null,
      category: "Serif",
      size: 8626632,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["FONTDASU"],
      lastModified: "2022-09-27",
      dateAdded: "2021-01-04",
      popularity: 371,
      trending: 244,
      defaultSort: 391,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shippori Mincho B1",
      displayName: null,
      category: "Serif",
      size: 15150545,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["FONTDASU"],
      lastModified: "2022-09-27",
      dateAdded: "2021-01-04",
      popularity: 665,
      trending: 564,
      defaultSort: 671,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shizuru",
      displayName: null,
      category: "Display",
      size: 251244,
      subsets: ["menu", "japanese", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Shibuya Font"],
      lastModified: "2023-05-31",
      dateAdded: "2020-12-08",
      popularity: 1509,
      trending: 1097,
      defaultSort: 1406,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Shojumaru",
      displayName: null,
      category: "Display",
      size: 41714,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 9,
          lineHeight: 1.32421875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-25",
      popularity: 825,
      trending: 835,
      defaultSort: 828,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Short Stack",
      displayName: null,
      category: "Handwriting",
      size: 35460,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.2314453125
        }
      },
      axes: [],
      designers: ["James Grieshaber"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-17",
      popularity: 492,
      trending: 1130,
      defaultSort: 511,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Shrikhand",
      displayName: null,
      category: "Display",
      size: 220804,
      subsets: ["menu", "gujarati", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.458
        }
      },
      axes: [],
      designers: ["Jonny Pinhorn"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 300,
      trending: 1532,
      defaultSort: 315,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Siemreap",
      displayName: null,
      category: "Display",
      size: 61459,
      subsets: ["menu", "khmer"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.83935546875
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-20",
      popularity: 1268,
      trending: 1264,
      defaultSort: 1225,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sigmar",
      displayName: null,
      category: "Display",
      size: 209084,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.638
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-05-02",
      dateAdded: "2023-04-19",
      popularity: 1404,
      trending: 1799,
      defaultSort: 415,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sigmar One",
      displayName: null,
      category: "Display",
      size: 172512,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 10,
          slant: 1,
          width: 8,
          lineHeight: 1.638
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-04",
      popularity: 670,
      trending: 1728,
      defaultSort: 676,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Signika",
      displayName: null,
      category: "Sans Serif",
      size: 439512,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.232
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Anna Giedry\u015B"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 139,
      trending: 859,
      defaultSort: 132,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Signika Negative",
      displayName: null,
      category: "Sans Serif",
      size: 428416,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.232
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.232
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Anna Giedry\u015B"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 89,
      trending: 525,
      defaultSort: 85,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Silkscreen",
      displayName: null,
      category: "Display",
      size: 31426,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        }
      },
      axes: [],
      designers: ["Jason Kottke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-06-22",
      popularity: 680,
      trending: 49,
      defaultSort: 686,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Simonetta",
      displayName: null,
      category: "Display",
      size: 109959,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.251953125
        },
        "400i": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.251953125
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.251953125
        },
        "900i": {
          thickness: 7,
          slant: 2,
          width: 7,
          lineHeight: 1.251953125
        }
      },
      axes: [],
      designers: ["Brownfox"],
      lastModified: "2023-05-02",
      dateAdded: "2012-04-04",
      popularity: 1181,
      trending: 590,
      defaultSort: 1148,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Single Day",
      displayName: null,
      category: "Display",
      size: 816524,
      subsets: ["menu", "korean"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["DXKorea Inc"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-22",
      popularity: 1263,
      trending: 911,
      defaultSort: 1222,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sintony",
      displayName: null,
      category: "Sans Serif",
      size: 14794,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.303
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.303
        }
      },
      axes: [],
      designers: ["Eduardo Rodriguez Tunni"],
      lastModified: "2022-09-21",
      dateAdded: "2013-01-30",
      popularity: 418,
      trending: 1297,
      defaultSort: 441,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sirin Stencil",
      displayName: null,
      category: "Display",
      size: 40210,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.45703125
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-27",
      dateAdded: "2012-01-18",
      popularity: 1108,
      trending: 57,
      defaultSort: 926,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Six Caps",
      displayName: null,
      category: "Sans Serif",
      size: 26034,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 1,
          lineHeight: 1.31591796875
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-02-16",
      popularity: 357,
      trending: 402,
      defaultSort: 374,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Skranji",
      displayName: null,
      category: "Display",
      size: 97076,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.3583984375
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.3583984375
        }
      },
      axes: [],
      designers: ["Neapolitan"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-21",
      popularity: 807,
      trending: 1748,
      defaultSort: 809,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Slabo 13px",
      displayName: null,
      category: "Serif",
      size: 25599,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2307692307692308
        }
      },
      axes: [],
      designers: ["John Hudson"],
      lastModified: "2022-09-21",
      dateAdded: "2014-05-30",
      popularity: 650,
      trending: 680,
      defaultSort: 658,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Slabo 27px",
      displayName: null,
      category: "Serif",
      size: 26993,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.2222222222222223
        }
      },
      axes: [],
      designers: ["John Hudson"],
      lastModified: "2022-09-21",
      dateAdded: "2014-05-30",
      popularity: 115,
      trending: 1592,
      defaultSort: 109,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Slackey",
      displayName: null,
      category: "Display",
      size: 37896,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.4228515625
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 932,
      trending: 646,
      defaultSort: 921,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Slackside One",
      displayName: null,
      category: "Handwriting",
      size: 171736,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Maniackers Design"],
      lastModified: "2023-05-23",
      dateAdded: "2023-05-23",
      popularity: 1440,
      trending: 1767,
      defaultSort: 239,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Smokum",
      displayName: null,
      category: "Display",
      size: 63080,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 5,
          lineHeight: 1.2197265625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-03",
      popularity: 515,
      trending: 1669,
      defaultSort: 531,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Smooch",
      displayName: null,
      category: "Handwriting",
      size: 364436,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-02",
      popularity: 1132,
      trending: 21,
      defaultSort: 165,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Smooch Sans",
      displayName: null,
      category: "Sans Serif",
      size: 92880,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-12-17",
      popularity: 1107,
      trending: 418,
      defaultSort: 1088,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Smythe",
      displayName: null,
      category: "Display",
      size: 47182,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 5,
          lineHeight: 1.15380859375
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-20",
      popularity: 1261,
      trending: 473,
      defaultSort: 1220,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sniglet",
      displayName: null,
      category: "Display",
      size: 33431,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.245
        },
        "800": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.245
        }
      },
      axes: [],
      designers: ["Haley Fiege"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-15",
      popularity: 635,
      trending: 1599,
      defaultSort: 646,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Snippet",
      displayName: null,
      category: "Sans Serif",
      size: 19466,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.151
        }
      },
      axes: [],
      designers: ["Gesine Todt"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-20",
      popularity: 1222,
      trending: 181,
      defaultSort: 1183,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Snowburst One",
      displayName: null,
      category: "Display",
      size: 46962,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 8,
          lineHeight: 1.263671875
        }
      },
      axes: [],
      designers: ["Annet Stirling"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-26",
      popularity: 1391,
      trending: 1618,
      defaultSort: 1329,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sofadi One",
      displayName: null,
      category: "Display",
      size: 52712,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.166
        }
      },
      axes: [],
      designers: ["Botjo Nikoltchev"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-30",
      popularity: 1354,
      trending: 1218,
      defaultSort: 1299,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sofia",
      displayName: null,
      category: "Handwriting",
      size: 16989,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.576
        }
      },
      axes: [],
      designers: ["LatinoType"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 544,
      trending: 1707,
      defaultSort: 562,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sofia Sans",
      displayName: null,
      category: "Sans Serif",
      size: 328500,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Lettersoup", "Botio Nikoltchev", "Ani Petrova"],
      lastModified: "2023-03-21",
      dateAdded: "2021-01-13",
      popularity: 763,
      trending: 735,
      defaultSort: 764,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sofia Sans Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 329458,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Lettersoup", "Botio Nikoltchev", "Ani Petrova"],
      lastModified: "2023-02-02",
      dateAdded: "2022-11-16",
      popularity: 746,
      trending: 1688,
      defaultSort: 749,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sofia Sans Extra Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 327244,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Lettersoup", "Botio Nikoltchev", "Ani Petrova"],
      lastModified: "2023-02-02",
      dateAdded: "2022-11-16",
      popularity: 985,
      trending: 1687,
      defaultSort: 892,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sofia Sans Semi Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 331860,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "1i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Lettersoup", "Botio Nikoltchev", "Ani Petrova"],
      lastModified: "2023-03-21",
      dateAdded: "2022-11-16",
      popularity: 851,
      trending: 26,
      defaultSort: 259,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Solitreo",
      displayName: null,
      category: "Handwriting",
      size: 96968,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.43
        }
      },
      axes: [],
      designers: ["Nathan Gross", "Bryan Kirschen"],
      lastModified: "2023-05-02",
      dateAdded: "2022-12-14",
      popularity: 1309,
      trending: 703,
      defaultSort: 965,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hebr",
      primaryLanguage: ""
    },
    {
      family: "Solway",
      displayName: null,
      category: "Serif",
      size: 56588,
      subsets: ["menu", "latin"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Mariya Lish", "The Northern Block"],
      lastModified: "2023-02-16",
      dateAdded: "2018-08-06",
      popularity: 839,
      trending: 228,
      defaultSort: 840,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Song Myung",
      displayName: null,
      category: "Serif",
      size: 2035300,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["JIKJI"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-23",
      popularity: 960,
      trending: 672,
      defaultSort: 945,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sono",
      displayName: null,
      category: "Sans Serif",
      size: 154620,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "MONO",
          min: 0,
          max: 1,
          defaultValue: 1
        },
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck"],
      lastModified: "2023-03-21",
      dateAdded: "2022-07-29",
      popularity: 857,
      trending: 302,
      defaultSort: 856,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sonsie One",
      displayName: null,
      category: "Display",
      size: 35123,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 6,
          width: 9,
          lineHeight: 1.2939453125
        }
      },
      axes: [],
      designers: ["Riccardo De Franceschi"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 910,
      trending: 518,
      defaultSort: 902,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sora",
      displayName: null,
      category: "Sans Serif",
      size: 111400,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Jonathan Barnbrook", "Juli\xE1n Moncada"],
      lastModified: "2022-09-21",
      dateAdded: "2020-06-10",
      popularity: 167,
      trending: 325,
      defaultSort: 168,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sorts Mill Goudy",
      displayName: null,
      category: "Serif",
      size: 48655,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.438
        },
        "400i": {
          thickness: 4,
          slant: 4,
          width: 6,
          lineHeight: 1.438
        }
      },
      axes: [],
      designers: ["Barry Schwartz"],
      lastModified: "2022-09-21",
      dateAdded: "2011-09-07",
      popularity: 396,
      trending: 1322,
      defaultSort: 418,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Source Code Pro",
      displayName: null,
      category: "Monospace",
      size: 183396,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        },
        "900": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.257
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.257
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Paul D. Hunt"],
      lastModified: "2022-09-21",
      dateAdded: "2012-09-20",
      popularity: 78,
      trending: 1250,
      defaultSort: 74,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Source Sans 3",
      displayName: null,
      category: "Sans Serif",
      size: 518112,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.424
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Paul D. Hunt"],
      lastModified: "2023-05-02",
      dateAdded: "2021-09-17",
      popularity: 260,
      trending: 35,
      defaultSort: 272,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Source Serif 4",
      displayName: null,
      category: "Serif",
      size: 1032470,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.371
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 8,
          max: 60,
          defaultValue: 14
        },
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Frank Grie\xDFhammer"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-16",
      popularity: 197,
      trending: 40,
      defaultSort: 199,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Space Grotesk",
      displayName: null,
      category: "Sans Serif",
      size: 136676,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.276
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.276
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.276
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.276
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.276
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Florian Karsten"],
      lastModified: "2023-01-06",
      dateAdded: "2020-10-06",
      popularity: 81,
      trending: 1310,
      defaultSort: 77,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Space Mono",
      displayName: null,
      category: "Monospace",
      size: 96329,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.481
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.481
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.481
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.481
        }
      },
      axes: [],
      designers: ["Colophon Foundry"],
      lastModified: "2023-06-22",
      dateAdded: "2016-06-15",
      popularity: 183,
      trending: 1587,
      defaultSort: 185,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Special Elite",
      displayName: null,
      category: "Display",
      size: 166180,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-20",
      popularity: 251,
      trending: 1066,
      defaultSort: 264,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Spectral",
      displayName: null,
      category: "Serif",
      size: 286544,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        }
      },
      axes: [],
      designers: ["Production Type"],
      lastModified: "2023-01-06",
      dateAdded: "2017-06-12",
      popularity: 188,
      trending: 1605,
      defaultSort: 189,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Spectral SC",
      displayName: null,
      category: "Serif",
      size: 286580,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.522
        }
      },
      axes: [],
      designers: ["Production Type"],
      lastModified: "2023-05-02",
      dateAdded: "2017-10-10",
      popularity: 663,
      trending: 834,
      defaultSort: 669,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Spicy Rice",
      displayName: null,
      category: "Display",
      size: 38719,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 6,
          lineHeight: 1.37890625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-13",
      popularity: 915,
      trending: 154,
      defaultSort: 908,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Spinnaker",
      displayName: null,
      category: "Sans Serif",
      size: 15865,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.17529296875
        }
      },
      axes: [],
      designers: ["Elena Albertoni"],
      lastModified: "2022-04-27",
      dateAdded: "2011-09-28",
      popularity: 562,
      trending: 1306,
      defaultSort: 580,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Spirax",
      displayName: null,
      category: "Display",
      size: 22525,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.235
        }
      },
      axes: [],
      designers: ["Brenda Gallo"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-23",
      popularity: 1185,
      trending: 1524,
      defaultSort: 1152,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Splash",
      displayName: null,
      category: "Handwriting",
      size: 1473200,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.63
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2022-05-18",
      popularity: 1484,
      trending: 1362,
      defaultSort: 1379,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Spline Sans",
      displayName: null,
      category: "Sans Serif",
      size: 146896,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Eben Sorkin", "Mirko Velimirovi\u0107"],
      lastModified: "2023-05-02",
      dateAdded: "2021-11-22",
      popularity: 924,
      trending: 91,
      defaultSort: 913,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Spline Sans Mono",
      displayName: null,
      category: "Monospace",
      size: 125448,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Eben Sorkin", "Mirko Velimirovi\u0107"],
      lastModified: "2023-03-21",
      dateAdded: "2022-03-27",
      popularity: 1129,
      trending: 41,
      defaultSort: 574,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Squada One",
      displayName: null,
      category: "Display",
      size: 9319,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.057
        }
      },
      axes: [],
      designers: ["Joe Prince"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-15",
      popularity: 412,
      trending: 1381,
      defaultSort: 435,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Square Peg",
      displayName: null,
      category: "Handwriting",
      size: 130916,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.32
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-23",
      popularity: 1055,
      trending: 253,
      defaultSort: 1039,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sree Krushnadevaraya",
      displayName: null,
      category: "Serif",
      size: 612636,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 2.0597222222222222
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-12",
      popularity: 882,
      trending: 551,
      defaultSort: 877,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sriracha",
      displayName: null,
      category: "Handwriting",
      size: 319896,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.77
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2015-07-01",
      popularity: 340,
      trending: 774,
      defaultSort: 358,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Srisakdi",
      displayName: null,
      category: "Display",
      size: 102214,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 1117,
      trending: 618,
      defaultSort: 1096,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Staatliches",
      displayName: null,
      category: "Display",
      size: 63316,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Brian LaRossa", "Erica Carras"],
      lastModified: "2022-09-21",
      dateAdded: "2018-12-09",
      popularity: 213,
      trending: 1713,
      defaultSort: 217,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stalemate",
      displayName: null,
      category: "Handwriting",
      size: 39920,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 3,
          lineHeight: 1.4658203125
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-11-03",
      popularity: 1094,
      trending: 1409,
      defaultSort: 1076,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stalinist One",
      displayName: null,
      category: "Display",
      size: 48808,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 7,
          width: 10,
          lineHeight: 1.476
        }
      },
      axes: [],
      designers: ["Alexey Maslov", "Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-20",
      popularity: 1058,
      trending: 264,
      defaultSort: 1043,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stardos Stencil",
      displayName: null,
      category: "Display",
      size: 37834,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.37939453125
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.37939453125
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-06",
      popularity: 657,
      trending: 352,
      defaultSort: 664,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stick",
      displayName: null,
      category: "Sans Serif",
      size: 2215036,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Fontworks Inc."],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-15",
      popularity: 984,
      trending: 1136,
      defaultSort: 967,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stick No Bills",
      displayName: null,
      category: "Sans Serif",
      size: 279212,
      subsets: ["menu", "latin", "latin-ext", "sinhala"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.252
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.252
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.252
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.252
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.252
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.252
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.252
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Mooniak"],
      lastModified: "2023-05-02",
      dateAdded: "2021-06-29",
      popularity: 1244,
      trending: 920,
      defaultSort: 1204,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stint Ultra Condensed",
      displayName: null,
      category: "Display",
      size: 21994,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 1,
          lineHeight: 1.12890625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 612,
      trending: 1735,
      defaultSort: 625,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stint Ultra Expanded",
      displayName: null,
      category: "Display",
      size: 23145,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 8,
          lineHeight: 1.140625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-15",
      popularity: 1099,
      trending: 1279,
      defaultSort: 1080,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stoke",
      displayName: null,
      category: "Serif",
      size: 57922,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Nicole Fally"],
      lastModified: "2022-09-21",
      dateAdded: "2012-08-03",
      popularity: 1011,
      trending: 739,
      defaultSort: 991,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Strait",
      displayName: null,
      category: "Sans Serif",
      size: 58448,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.095
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2012-10-26",
      popularity: 1019,
      trending: 537,
      defaultSort: 1e3,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Style Script",
      displayName: null,
      category: "Handwriting",
      size: 603164,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.52
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-05-14",
      popularity: 643,
      trending: 616,
      defaultSort: 651,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Stylish",
      displayName: null,
      category: "Sans Serif",
      size: 10854004,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["AsiaSoft Inc"],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-27",
      popularity: 964,
      trending: 715,
      defaultSort: 949,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sue Ellen Francisco",
      displayName: null,
      category: "Handwriting",
      size: 28154,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 4,
          lineHeight: 1.94921875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-14",
      popularity: 802,
      trending: 1645,
      defaultSort: 804,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Suez One",
      displayName: null,
      category: "Serif",
      size: 70884,
      subsets: ["menu", "hebrew", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 5,
          lineHeight: 1.306
        }
      },
      axes: [],
      designers: ["Michal Sahar"],
      lastModified: "2022-09-21",
      dateAdded: "2016-03-31",
      popularity: 615,
      trending: 1554,
      defaultSort: 627,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sulphur Point",
      displayName: null,
      category: "Sans Serif",
      size: 55693,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Dale Sattler"],
      lastModified: "2023-05-02",
      dateAdded: "2019-09-25",
      popularity: 776,
      trending: 136,
      defaultSort: 777,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sumana",
      displayName: null,
      category: "Serif",
      size: 94523,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 2.927
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 2.927
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2015-04-29",
      popularity: 930,
      trending: 272,
      defaultSort: 919,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sunflower",
      displayName: null,
      category: "Sans Serif",
      size: 758389,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["JIKJISOFT"],
      lastModified: "2022-09-21",
      dateAdded: "2018-02-27",
      popularity: 603,
      trending: 773,
      defaultSort: 618,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sunshiney",
      displayName: null,
      category: "Handwriting",
      size: 160208,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.3203125
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 1290,
      trending: 219,
      defaultSort: 1247,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Supermercado One",
      displayName: null,
      category: "Display",
      size: 19460,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.197265625
        }
      },
      axes: [],
      designers: ["James Grieshaber"],
      lastModified: "2022-09-21",
      dateAdded: "2011-11-02",
      popularity: 777,
      trending: 825,
      defaultSort: 778,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Sura",
      displayName: null,
      category: "Serif",
      size: 70117,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 1.57763671875
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 1.57763671875
        }
      },
      axes: [],
      designers: ["Carolina Giovagnoli"],
      lastModified: "2023-05-02",
      dateAdded: "2015-06-17",
      popularity: 1096,
      trending: 286,
      defaultSort: 1078,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Suranna",
      displayName: null,
      category: "Serif",
      size: 124163,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 2.18974358974359
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-04-27",
      dateAdded: "2015-01-12",
      popularity: 633,
      trending: 360,
      defaultSort: 644,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Suravaram",
      displayName: null,
      category: "Serif",
      size: 119552,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 2.1316326530612244
        }
      },
      axes: [],
      designers: ["Purushoth Kumar Guttula"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-12",
      popularity: 1382,
      trending: 1613,
      defaultSort: 1322,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Suwannaphum",
      displayName: null,
      category: "Serif",
      size: 101123,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-27",
      dateAdded: "2011-03-02",
      popularity: 1053,
      trending: 39,
      defaultSort: 527,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Swanky and Moo Moo",
      displayName: null,
      category: "Handwriting",
      size: 31290,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.466796875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-27",
      popularity: 1208,
      trending: 716,
      defaultSort: 1172,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Syncopate",
      displayName: null,
      category: "Sans Serif",
      size: 119048,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 9,
          lineHeight: 1.041015625
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 9,
          lineHeight: 1.041015625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-27",
      popularity: 444,
      trending: 483,
      defaultSort: 466,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Syne",
      displayName: null,
      category: "Sans Serif",
      size: 146980,
      subsets: ["menu", "greek", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Bonjour Monde", "Lucas Descroix", "George Triantafyllakos"],
      lastModified: "2023-05-02",
      dateAdded: "2020-08-25",
      popularity: 393,
      trending: 514,
      defaultSort: 413,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Syne Mono",
      displayName: null,
      category: "Monospace",
      size: 72240,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Bonjour Monde", "Lucas Descroix"],
      lastModified: "2022-09-21",
      dateAdded: "2020-08-25",
      popularity: 707,
      trending: 701,
      defaultSort: 712,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Syne Tactile",
      displayName: null,
      category: "Display",
      size: 129820,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Bonjour Monde", "Lucas Descroix"],
      lastModified: "2022-09-21",
      dateAdded: "2020-08-25",
      popularity: 1461,
      trending: 843,
      defaultSort: 1377,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tai Heritage Pro",
      displayName: null,
      category: "Serif",
      size: 288692,
      subsets: ["menu", "latin", "latin-ext", "tai-viet", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.099609375
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 2.099609375
        }
      },
      axes: [],
      designers: ["SIL International"],
      lastModified: "2023-05-31",
      dateAdded: "2022-05-12",
      popularity: 1369,
      trending: 236,
      defaultSort: 1311,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Tavt",
      primaryLanguage: ""
    },
    {
      family: "Tajawal",
      displayName: null,
      category: "Sans Serif",
      size: 59850,
      subsets: ["menu", "arabic", "latin"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Boutros Fonts", "Mourad Boutros", "Soulaf Khalifeh"],
      lastModified: "2022-09-21",
      dateAdded: "2018-04-04",
      popularity: 114,
      trending: 1652,
      defaultSort: 108,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tangerine",
      displayName: null,
      category: "Handwriting",
      size: 63056,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 10,
          width: 3,
          lineHeight: 1
        },
        "700": {
          thickness: 4,
          slant: 8,
          width: 4,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Toshi Omagari"],
      lastModified: "2022-09-21",
      dateAdded: "2010-06-08",
      popularity: 279,
      trending: 744,
      defaultSort: 292,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tapestry",
      displayName: null,
      category: "Handwriting",
      size: 137716,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-04-07",
      popularity: 1486,
      trending: 1128,
      defaultSort: 1391,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Taprom",
      displayName: null,
      category: "Display",
      size: 203652,
      subsets: ["menu", "khmer", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.806640625
        }
      },
      axes: [],
      designers: ["Danh Hong"],
      lastModified: "2022-04-27",
      dateAdded: "2011-03-02",
      popularity: 1402,
      trending: 1636,
      defaultSort: 1338,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tauri",
      displayName: null,
      category: "Sans Serif",
      size: 22825,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Yvonne Sch\xFCttler"],
      lastModified: "2022-09-21",
      dateAdded: "2013-02-27",
      popularity: 900,
      trending: 1161,
      defaultSort: 891,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Taviraj",
      displayName: null,
      category: "Serif",
      size: 226637,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.706
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 281,
      trending: 275,
      defaultSort: 294,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Teko",
      displayName: null,
      category: "Sans Serif",
      size: 309228,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 1,
          lineHeight: 1.433
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 2,
          lineHeight: 1.433
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 5,
          lineHeight: 1.433
        },
        "600": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.433
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 6,
          lineHeight: 1.433
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2023-05-02",
      dateAdded: "2014-06-25",
      popularity: 93,
      trending: 1271,
      defaultSort: 88,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Telex",
      displayName: null,
      category: "Sans Serif",
      size: 38940,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.205
        }
      },
      axes: [],
      designers: ["Huerta Tipogr\xE1fica"],
      lastModified: "2022-12-07",
      dateAdded: "2012-01-18",
      popularity: 550,
      trending: 1655,
      defaultSort: 567,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tenali Ramakrishna",
      displayName: null,
      category: "Sans Serif",
      size: 278474,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.564
        }
      },
      axes: [],
      designers: ["Appaji Ambarisha Darbha"],
      lastModified: "2022-09-21",
      dateAdded: "2014-12-10",
      popularity: 701,
      trending: 251,
      defaultSort: 708,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tenor Sans",
      displayName: null,
      category: "Sans Serif",
      size: 52475,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.17
        }
      },
      axes: [],
      designers: ["Denis Masharov"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-25",
      popularity: 252,
      trending: 1188,
      defaultSort: 265,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Text Me One",
      displayName: null,
      category: "Sans Serif",
      size: 17323,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.221
        }
      },
      axes: [],
      designers: ["Julia Petretta"],
      lastModified: "2023-05-02",
      dateAdded: "2012-10-31",
      popularity: 1163,
      trending: 1072,
      defaultSort: 1133,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Texturina",
      displayName: null,
      category: "Serif",
      size: 290320,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.56
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 12,
          max: 72,
          defaultValue: 12
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Guillermo Torres", "Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2020-10-23",
      popularity: 1312,
      trending: 1171,
      defaultSort: 1263,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Thasadith",
      displayName: null,
      category: "Sans Serif",
      size: 97012,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2022-09-21",
      dateAdded: "2018-09-10",
      popularity: 594,
      trending: 1175,
      defaultSort: 609,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "The Girl Next Door",
      displayName: null,
      category: "Handwriting",
      size: 32768,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 7,
          lineHeight: 1.8427734375
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-20",
      popularity: 990,
      trending: 1134,
      defaultSort: 971,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "The Nautigal",
      displayName: null,
      category: "Handwriting",
      size: 158298,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-18",
      popularity: 1282,
      trending: 404,
      defaultSort: 1239,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tienne",
      displayName: null,
      category: "Serif",
      size: 72984,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.3447265625
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.3447265625
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.3447265625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-27",
      popularity: 871,
      trending: 461,
      defaultSort: 869,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tillana",
      displayName: null,
      category: "Handwriting",
      size: 313587,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 4,
          width: 7,
          lineHeight: 1.642
        },
        "500": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.642
        },
        "600": {
          thickness: 6,
          slant: 4,
          width: 8,
          lineHeight: 1.642
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.642
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.642
        }
      },
      axes: [],
      designers: ["Indian Type Foundry"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-03",
      popularity: 618,
      trending: 345,
      defaultSort: 630,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tilt Neon",
      displayName: null,
      category: "Display",
      size: 583288,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.262
        }
      },
      axes: [
        {
          tag: "XROT",
          min: -45,
          max: 45,
          defaultValue: 0
        },
        {
          tag: "YROT",
          min: -45,
          max: 45,
          defaultValue: 0
        }
      ],
      designers: ["Andy Clymer"],
      lastModified: "2023-05-31",
      dateAdded: "2022-12-01",
      popularity: 1351,
      trending: 593,
      defaultSort: 1012,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tilt Prism",
      displayName: null,
      category: "Display",
      size: 1049672,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.262
        }
      },
      axes: [
        {
          tag: "XROT",
          min: -45,
          max: 45,
          defaultValue: 0
        },
        {
          tag: "YROT",
          min: -45,
          max: 45,
          defaultValue: 0
        }
      ],
      designers: ["Andy Clymer"],
      lastModified: "2023-05-31",
      dateAdded: "2022-12-01",
      popularity: 1405,
      trending: 1813,
      defaultSort: 1013,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tilt Warp",
      displayName: null,
      category: "Display",
      size: 256812,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.262
        }
      },
      axes: [
        {
          tag: "XROT",
          min: -45,
          max: 45,
          defaultValue: 0
        },
        {
          tag: "YROT",
          min: -45,
          max: 45,
          defaultValue: 0
        }
      ],
      designers: ["Andy Clymer"],
      lastModified: "2023-05-31",
      dateAdded: "2022-12-01",
      popularity: 1016,
      trending: 830,
      defaultSort: 997,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Timmana",
      displayName: null,
      category: "Sans Serif",
      size: 372715,
      subsets: ["menu", "latin", "telugu"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 3,
          width: 6,
          lineHeight: 1.6293333333333333
        }
      },
      axes: [],
      designers: ["Appaji Ambarisha Darbha"],
      lastModified: "2022-09-21",
      dateAdded: "2015-01-12",
      popularity: 870,
      trending: 541,
      defaultSort: 868,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tinos",
      displayName: null,
      category: "Serif",
      size: 459699,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.14990234375
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.14990234375
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.14990234375
        },
        "700i": {
          thickness: 6,
          slant: 4,
          width: 7,
          lineHeight: 1.14990234375
        }
      },
      axes: [],
      designers: ["Steve Matteson"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-18",
      popularity: 161,
      trending: 802,
      defaultSort: 155,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tiro Bangla",
      displayName: null,
      category: "Serif",
      size: 326676,
      subsets: ["menu", "bengali", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Fiona Ross", "Neelakash Kshetrimayum"],
      lastModified: "2023-01-06",
      dateAdded: "2022-05-25",
      popularity: 1202,
      trending: 1664,
      defaultSort: 1167,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Beng",
      primaryLanguage: ""
    },
    {
      family: "Tiro Devanagari Hindi",
      displayName: null,
      category: "Serif",
      size: 424430,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Fiona Ross", "Paul Hanslow"],
      lastModified: "2023-01-06",
      dateAdded: "2022-05-25",
      popularity: 826,
      trending: 401,
      defaultSort: 829,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "Tiro Devanagari Marathi",
      displayName: null,
      category: "Serif",
      size: 440720,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Fiona Ross", "Paul Hanslow"],
      lastModified: "2023-01-06",
      dateAdded: "2022-05-25",
      popularity: 1363,
      trending: 243,
      defaultSort: 1306,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "Tiro Devanagari Sanskrit",
      displayName: null,
      category: "Serif",
      size: 763452,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.33
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Fiona Ross", "Paul Hanslow"],
      lastModified: "2023-01-06",
      dateAdded: "2022-05-25",
      popularity: 1332,
      trending: 106,
      defaultSort: 1281,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Deva",
      primaryLanguage: ""
    },
    {
      family: "Tiro Gurmukhi",
      displayName: null,
      category: "Serif",
      size: 152316,
      subsets: ["menu", "gurmukhi", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Fiona Ross", "Paul Hanslow"],
      lastModified: "2023-01-06",
      dateAdded: "2022-05-25",
      popularity: 1241,
      trending: 558,
      defaultSort: 1201,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Guru",
      primaryLanguage: ""
    },
    {
      family: "Tiro Kannada",
      displayName: null,
      category: "Serif",
      size: 482926,
      subsets: ["menu", "kannada", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.794
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.794
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Fiona Ross", "Kaja S\u0142ojewska"],
      lastModified: "2023-01-06",
      dateAdded: "2022-05-25",
      popularity: 1081,
      trending: 411,
      defaultSort: 1064,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Knda",
      primaryLanguage: ""
    },
    {
      family: "Tiro Tamil",
      displayName: null,
      category: "Serif",
      size: 198008,
      subsets: ["menu", "latin", "latin-ext", "tamil"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.436
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.436
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "Fernando Mello", "Fiona Ross", "Kaja S\u0142ojewska"],
      lastModified: "2023-05-09",
      dateAdded: "2022-05-25",
      popularity: 1482,
      trending: 822,
      defaultSort: 1371,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Taml",
      primaryLanguage: ""
    },
    {
      family: "Tiro Telugu",
      displayName: null,
      category: "Serif",
      size: 635216,
      subsets: ["menu", "latin", "latin-ext", "telugu"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.794
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.794
        }
      },
      axes: [],
      designers: ["Tiro Typeworks", "John Hudson", "Fiona Ross", "Kaja S\u0142ojewska"],
      lastModified: "2023-02-02",
      dateAdded: "2022-05-25",
      popularity: 1470,
      trending: 1807,
      defaultSort: 1370,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Telu",
      primaryLanguage: ""
    },
    {
      family: "Titan One",
      displayName: null,
      category: "Display",
      size: 25523,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 8,
          lineHeight: 1.145
        }
      },
      axes: [],
      designers: ["Rodrigo Fuenzalida"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 317,
      trending: 1589,
      defaultSort: 334,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Titillium Web",
      displayName: null,
      category: "Sans Serif",
      size: 65144,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: 2,
          slant: 1,
          width: 6,
          lineHeight: 1.521
        },
        "200i": {
          thickness: 2,
          slant: 5,
          width: 6,
          lineHeight: 1.521
        },
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.521
        },
        "300i": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.521
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.521
        },
        "400i": {
          thickness: 4,
          slant: 5,
          width: 6,
          lineHeight: 1.521
        },
        "600": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.521
        },
        "600i": {
          thickness: 6,
          slant: 5,
          width: 6,
          lineHeight: 1.521
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.521
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 6,
          lineHeight: 1.521
        },
        "900": {
          thickness: 9,
          slant: 1,
          width: 7,
          lineHeight: 1.521
        }
      },
      axes: [],
      designers: ["Accademia di Belle Arti di Urbino"],
      lastModified: "2022-09-21",
      dateAdded: "2012-10-01",
      popularity: 45,
      trending: 1056,
      defaultSort: 44,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tomorrow",
      displayName: null,
      category: "Sans Serif",
      size: 60378,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Tony de Marco", "Monica Rizzolli"],
      lastModified: "2022-09-21",
      dateAdded: "2019-10-02",
      popularity: 822,
      trending: 1541,
      defaultSort: 825,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tourney",
      displayName: null,
      category: "Display",
      size: 166830,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.1
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck", "ETC"],
      lastModified: "2023-03-09",
      dateAdded: "2021-04-29",
      popularity: 1381,
      trending: 90,
      defaultSort: 1321,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Trade Winds",
      displayName: null,
      category: "Display",
      size: 85380,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 5,
          width: 8,
          lineHeight: 1.453125
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 976,
      trending: 1616,
      defaultSort: 958,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Train One",
      displayName: null,
      category: "Display",
      size: 2152516,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Fontworks Inc."],
      lastModified: "2022-09-27",
      dateAdded: "2020-12-15",
      popularity: 1090,
      trending: 485,
      defaultSort: 1072,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Trirong",
      displayName: null,
      category: "Serif",
      size: 208121,
      subsets: ["menu", "latin", "latin-ext", "thai", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.734
        }
      },
      axes: [],
      designers: ["Cadson Demak"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 461,
      trending: 338,
      defaultSort: 478,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Trispace",
      displayName: null,
      category: "Sans Serif",
      size: 303532,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.13
        }
      },
      axes: [
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Tyler Finck", "ETC"],
      lastModified: "2023-03-21",
      dateAdded: "2020-09-25",
      popularity: 1095,
      trending: 380,
      defaultSort: 1077,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Trocchi",
      displayName: null,
      category: "Serif",
      size: 68840,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.29931640625
        }
      },
      axes: [],
      designers: ["Vernon Adams"],
      lastModified: "2023-04-27",
      dateAdded: "2012-04-04",
      popularity: 533,
      trending: 598,
      defaultSort: 551,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Trochut",
      displayName: null,
      category: "Display",
      size: 12742,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.177
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 6,
          lineHeight: 1.177
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 6,
          lineHeight: 1.177
        }
      },
      axes: [],
      designers: ["Andreu Balius"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-18",
      popularity: 1299,
      trending: 827,
      defaultSort: 1256,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Truculenta",
      displayName: null,
      category: "Sans Serif",
      size: 1052128,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.39
        }
      },
      axes: [
        {
          tag: "opsz",
          min: 12,
          max: 72,
          defaultValue: 14
        },
        {
          tag: "wdth",
          min: 75,
          max: 125,
          defaultValue: 100
        },
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Omnibus-Type"],
      lastModified: "2023-05-02",
      dateAdded: "2020-12-16",
      popularity: 1360,
      trending: 1622,
      defaultSort: 1303,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Trykker",
      displayName: null,
      category: "Serif",
      size: 23643,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Magnus Gaarde"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 719,
      trending: 47,
      defaultSort: 702,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Tsukimi Rounded",
      displayName: null,
      category: "Sans Serif",
      size: 109196,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Takashi Funayama"],
      lastModified: "2023-05-23",
      dateAdded: "2023-05-23",
      popularity: 1431,
      trending: 1774,
      defaultSort: 207,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Tulpen One",
      displayName: null,
      category: "Display",
      size: 19409,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 1,
          lineHeight: 1.08984375
        }
      },
      axes: [],
      designers: ["Naima Ben Ayed"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-03",
      popularity: 1126,
      trending: 1773,
      defaultSort: 1104,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Turret Road",
      displayName: null,
      category: "Display",
      size: 51972,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.093
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.093
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.093
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.093
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.093
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.093
        }
      },
      axes: [],
      designers: ["Dale Sattler"],
      lastModified: "2022-09-21",
      dateAdded: "2019-09-03",
      popularity: 648,
      trending: 1113,
      defaultSort: 656,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Twinkle Star",
      displayName: null,
      category: "Handwriting",
      size: 310488,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-26",
      popularity: 1520,
      trending: 620,
      defaultSort: 1412,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ubuntu",
      displayName: null,
      category: "Sans Serif",
      size: 368578,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.149
        },
        "300i": {
          thickness: 4,
          slant: 5,
          width: 7,
          lineHeight: 1.149
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.149
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.149
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.149
        },
        "500i": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1.149
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 7,
          lineHeight: 1.149
        },
        "700i": {
          thickness: 7,
          slant: 5,
          width: 7,
          lineHeight: 1.149
        }
      },
      axes: [],
      designers: ["Dalton Maag"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-15",
      popularity: 24,
      trending: 1463,
      defaultSort: 24,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ubuntu Condensed",
      displayName: null,
      category: "Sans Serif",
      size: 168405,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.149
        }
      },
      axes: [],
      designers: ["Dalton Maag"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-05",
      popularity: 179,
      trending: 1355,
      defaultSort: 180,
      androidFragment: "name=Ubuntu&width=75.0",
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ubuntu Mono",
      displayName: null,
      category: "Monospace",
      size: 112445,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "greek-ext", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Dalton Maag"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-05",
      popularity: 229,
      trending: 839,
      defaultSort: 241,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Uchen",
      displayName: null,
      category: "Serif",
      size: 859156,
      subsets: ["menu", "latin", "tibetan"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.86328125
        }
      },
      axes: [],
      designers: ["Christopher J. Fynn"],
      lastModified: "2022-09-21",
      dateAdded: "2019-12-07",
      popularity: 1406,
      trending: 731,
      defaultSort: 1344,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ultra",
      displayName: null,
      category: "Serif",
      size: 52472,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 9,
          lineHeight: 1.28271484375
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-09",
      popularity: 268,
      trending: 846,
      defaultSort: 281,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Unbounded",
      displayName: null,
      category: "Display",
      size: 778272,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.24
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["NaN"],
      lastModified: "2023-04-27",
      dateAdded: "2022-11-07",
      popularity: 278,
      trending: 1472,
      defaultSort: 291,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Uncial Antiqua",
      displayName: null,
      category: "Display",
      size: 34018,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.31591796875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 968,
      trending: 1496,
      defaultSort: 953,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Underdog",
      displayName: null,
      category: "Display",
      size: 101480,
      subsets: ["menu", "cyrillic", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.156
        }
      },
      axes: [],
      designers: ["Sergey Steblina", "Jovanny Lemonad"],
      lastModified: "2023-05-02",
      dateAdded: "2012-09-23",
      popularity: 1156,
      trending: 1603,
      defaultSort: 1127,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Unica One",
      displayName: null,
      category: "Display",
      size: 71872,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.182
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-05-02",
      dateAdded: "2012-10-26",
      popularity: 344,
      trending: 1570,
      defaultSort: 363,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "UnifrakturCook",
      displayName: null,
      category: "Display",
      size: 27928,
      subsets: ["menu", "latin"],
      fonts: {
        "700": {
          thickness: 8,
          slant: 1,
          width: 6,
          lineHeight: 1.30859375
        }
      },
      axes: [],
      designers: ["j. 'mach' wust"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-07",
      popularity: 983,
      trending: 1135,
      defaultSort: 966,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "UnifrakturMaguntia",
      displayName: null,
      category: "Display",
      size: 45486,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 6,
          lineHeight: 1.03515625
        }
      },
      axes: [],
      designers: ["j. 'mach' wust"],
      lastModified: "2022-09-21",
      dateAdded: "2010-11-30",
      popularity: 717,
      trending: 902,
      defaultSort: 721,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Unkempt",
      displayName: null,
      category: "Display",
      size: 191692,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 7,
          lineHeight: 1.2216796875
        },
        "700": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.1943359375
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-05",
      popularity: 1033,
      trending: 765,
      defaultSort: 1020,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Unlock",
      displayName: null,
      category: "Display",
      size: 57640,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.068
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-03-21",
      dateAdded: "2011-11-30",
      popularity: 996,
      trending: 350,
      defaultSort: 977,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Unna",
      displayName: null,
      category: "Serif",
      size: 78989,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1.152
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.152
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.152
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.152
        }
      },
      axes: [],
      designers: ["Omnibus-Type"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-20",
      popularity: 214,
      trending: 363,
      defaultSort: 218,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Updock",
      displayName: null,
      category: "Handwriting",
      size: 120868,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-23",
      popularity: 1420,
      trending: 385,
      defaultSort: 1353,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Urbanist",
      displayName: null,
      category: "Sans Serif",
      size: 86174,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Corey Hu"],
      lastModified: "2023-01-06",
      dateAdded: "2021-06-02",
      popularity: 162,
      trending: 1706,
      defaultSort: 156,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "VT323",
      displayName: null,
      category: "Monospace",
      size: 153116,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 6,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Peter Hull"],
      lastModified: "2022-09-21",
      dateAdded: "2011-03-02",
      popularity: 387,
      trending: 1118,
      defaultSort: 407,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vampiro One",
      displayName: null,
      category: "Display",
      size: 19133,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 8,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Riccardo De Franceschi"],
      lastModified: "2022-04-27",
      dateAdded: "2012-11-26",
      popularity: 1103,
      trending: 689,
      defaultSort: 1084,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Varela",
      displayName: null,
      category: "Sans Serif",
      size: 79136,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.3
        }
      },
      axes: [],
      designers: ["Joe Prince"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-29",
      popularity: 380,
      trending: 1282,
      defaultSort: 400,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Varela Round",
      displayName: null,
      category: "Sans Serif",
      size: 132748,
      subsets: ["menu", "hebrew", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.204
        }
      },
      axes: [],
      designers: ["Joe Prince"],
      lastModified: "2023-02-16",
      dateAdded: "2011-07-13",
      popularity: 96,
      trending: 1087,
      defaultSort: 91,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Varta",
      displayName: null,
      category: "Sans Serif",
      size: 112072,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4501953125
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4501953125
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4501953125
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4501953125
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.4501953125
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Joana Correia", "Viktoriya Grabowska", "Eben Sorkin"],
      lastModified: "2023-03-21",
      dateAdded: "2020-06-11",
      popularity: 896,
      trending: 233,
      defaultSort: 888,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vast Shadow",
      displayName: null,
      category: "Display",
      size: 32235,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 9,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Nicole Fally"],
      lastModified: "2022-09-21",
      dateAdded: "2011-10-12",
      popularity: 803,
      trending: 891,
      defaultSort: 805,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vazirmatn",
      displayName: null,
      category: "Sans Serif",
      size: 241328,
      subsets: ["menu", "arabic", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.5625
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Saber Rastikerdar"],
      lastModified: "2023-05-02",
      dateAdded: "2022-03-16",
      popularity: 700,
      trending: 861,
      defaultSort: 707,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vesper Libre",
      displayName: null,
      category: "Serif",
      size: 84789,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 1.89453125
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 3,
          lineHeight: 1.89453125
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 1.89453125
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 3,
          lineHeight: 1.89453125
        }
      },
      axes: [],
      designers: ["Mota Italic"],
      lastModified: "2022-09-21",
      dateAdded: "2014-07-14",
      popularity: 723,
      trending: 1626,
      defaultSort: 728,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Viaoda Libre",
      displayName: null,
      category: "Display",
      size: 196944,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.411
        }
      },
      axes: [],
      designers: ["Gydient", "Vi\u1EC7tAnh Nguy\u1EC5n"],
      lastModified: "2023-06-07",
      dateAdded: "2019-11-05",
      popularity: 1101,
      trending: 259,
      defaultSort: 1082,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vibes",
      displayName: null,
      category: "Display",
      size: 78412,
      subsets: ["menu", "arabic", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.785
        }
      },
      axes: [],
      designers: ["AbdElmomen Kadhim (blueMix)"],
      lastModified: "2022-09-21",
      dateAdded: "2019-04-23",
      popularity: 1349,
      trending: 1531,
      defaultSort: 1295,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vibur",
      displayName: null,
      category: "Handwriting",
      size: 91454,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 3,
          width: 6,
          lineHeight: 1.43359375
        }
      },
      axes: [],
      designers: ["Johan Kallas"],
      lastModified: "2022-09-21",
      dateAdded: "2010-12-15",
      popularity: 901,
      trending: 85,
      defaultSort: 893,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vidaloka",
      displayName: null,
      category: "Serif",
      size: 67261,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.21435546875
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-08-17",
      popularity: 256,
      trending: 1141,
      defaultSort: 269,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Viga",
      displayName: null,
      category: "Sans Serif",
      size: 15882,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 7,
          lineHeight: 1.344
        }
      },
      axes: [],
      designers: ["Fontstage"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-07",
      popularity: 272,
      trending: 1360,
      defaultSort: 284,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vina Sans",
      displayName: null,
      category: "Display",
      size: 93328,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.215
        }
      },
      axes: [],
      designers: ["Nguyen Type"],
      lastModified: "2023-06-07",
      dateAdded: "2023-04-19",
      popularity: 1481,
      trending: 1387,
      defaultSort: 416,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Voces",
      displayName: null,
      category: "Display",
      size: 123756,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.349
        }
      },
      axes: [],
      designers: ["Ana Paula Megda", "Pablo Ugerman"],
      lastModified: "2022-09-21",
      dateAdded: "2012-02-22",
      popularity: 952,
      trending: 529,
      defaultSort: 938,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Volkhov",
      displayName: null,
      category: "Serif",
      size: 55281,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 1,
          width: 8,
          lineHeight: 1.29
        },
        "400i": {
          thickness: 5,
          slant: 5,
          width: 7,
          lineHeight: 1.29
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.29
        },
        "700i": {
          thickness: 6,
          slant: 5,
          width: 7,
          lineHeight: 1.29
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-04-27",
      dateAdded: "2011-08-17",
      popularity: 305,
      trending: 1276,
      defaultSort: 321,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vollkorn",
      displayName: null,
      category: "Serif",
      size: 509564,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.393
        },
        "400i": {
          thickness: 5,
          slant: 4,
          width: 6,
          lineHeight: 1.393
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "700": {
          thickness: 8,
          slant: 1,
          width: 8,
          lineHeight: 1.393
        },
        "700i": {
          thickness: 8,
          slant: 4,
          width: 7,
          lineHeight: 1.393
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Friedrich Althausen"],
      lastModified: "2023-05-02",
      dateAdded: "2010-09-08",
      popularity: 142,
      trending: 860,
      defaultSort: 135,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vollkorn SC",
      displayName: null,
      category: "Serif",
      size: 203058,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.393
        }
      },
      axes: [],
      designers: ["Friedrich Althausen"],
      lastModified: "2022-09-21",
      dateAdded: "2017-09-08",
      popularity: 608,
      trending: 292,
      defaultSort: 623,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Voltaire",
      displayName: null,
      category: "Sans Serif",
      size: 262432,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 4,
          slant: 1,
          width: 6,
          lineHeight: 1.24560546875
        }
      },
      axes: [],
      designers: ["Yvonne Sch\xFCttler"],
      lastModified: "2023-03-21",
      dateAdded: "2011-08-17",
      popularity: 342,
      trending: 1597,
      defaultSort: 360,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Vujahday Script",
      displayName: null,
      category: "Handwriting",
      size: 333472,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.36
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-11-18",
      popularity: 1105,
      trending: 554,
      defaultSort: 1086,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Waiting for the Sunrise",
      displayName: null,
      category: "Handwriting",
      size: 31788,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 2,
          slant: 1,
          width: 6,
          lineHeight: 1.6533203125
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-14",
      popularity: 671,
      trending: 185,
      defaultSort: 677,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Wallpoet",
      displayName: null,
      category: "Display",
      size: 20124,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.002
        }
      },
      axes: [],
      designers: ["Lars Berggren"],
      lastModified: "2022-09-21",
      dateAdded: "2011-04-27",
      popularity: 465,
      trending: 358,
      defaultSort: 483,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Walter Turncoat",
      displayName: null,
      category: "Handwriting",
      size: 153836,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 7,
          lineHeight: 1.396484375
        }
      },
      axes: [],
      designers: ["Sideshow"],
      lastModified: "2022-09-21",
      dateAdded: "2011-01-06",
      popularity: 834,
      trending: 1270,
      defaultSort: 835,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Warnes",
      displayName: null,
      category: "Display",
      size: 70272,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.304
        }
      },
      axes: [],
      designers: ["Eduardo Tunni"],
      lastModified: "2023-05-02",
      dateAdded: "2012-09-07",
      popularity: 1465,
      trending: 193,
      defaultSort: 1381,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Water Brush",
      displayName: null,
      category: "Handwriting",
      size: 332028,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.45
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-04-07",
      popularity: 1302,
      trending: 736,
      defaultSort: 1259,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Waterfall",
      displayName: null,
      category: "Handwriting",
      size: 521348,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.16
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2021-11-18",
      popularity: 1093,
      trending: 101,
      defaultSort: 1075,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Wellfleet",
      displayName: null,
      category: "Display",
      size: 34556,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 5,
          slant: 1,
          width: 8,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Riccardo De Franceschi"],
      lastModified: "2022-09-21",
      dateAdded: "2012-01-11",
      popularity: 1154,
      trending: 706,
      defaultSort: 1126,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Wendy One",
      displayName: null,
      category: "Sans Serif",
      size: 12651,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: 9,
          slant: 1,
          width: 7,
          lineHeight: 1.055
        }
      },
      axes: [],
      designers: ["Alejandro Inler"],
      lastModified: "2023-05-02",
      dateAdded: "2012-12-13",
      popularity: 848,
      trending: 543,
      defaultSort: 848,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Whisper",
      displayName: null,
      category: "Handwriting",
      size: 134852,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.28
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2022-09-21",
      dateAdded: "2022-03-23",
      popularity: 1255,
      trending: 108,
      defaultSort: 1213,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "WindSong",
      displayName: null,
      category: "Handwriting",
      size: 271924,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.405
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.405
        }
      },
      axes: [],
      designers: ["Robert Leuschke"],
      lastModified: "2023-05-02",
      dateAdded: "2021-05-28",
      popularity: 1130,
      trending: 1317,
      defaultSort: 1107,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Wire One",
      displayName: null,
      category: "Sans Serif",
      size: 48420,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 1,
          slant: 1,
          width: 1,
          lineHeight: 1.1
        }
      },
      axes: [],
      designers: ["Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2011-05-18",
      popularity: 1009,
      trending: 1475,
      defaultSort: 989,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Wix Madefor Display",
      displayName: null,
      category: "Sans Serif",
      size: 159788,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Dalton Maag"],
      lastModified: "2023-05-09",
      dateAdded: "2023-05-08",
      popularity: 863,
      trending: 526,
      defaultSort: 261,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Wix Madefor Text",
      displayName: null,
      category: "Sans Serif",
      size: 122524,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.26
        }
      },
      axes: [
        {
          tag: "wght",
          min: 400,
          max: 800,
          defaultValue: 400
        }
      ],
      designers: ["Dalton Maag"],
      lastModified: "2023-05-09",
      dateAdded: "2023-05-08",
      popularity: 1267,
      trending: 864,
      defaultSort: 221,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Work Sans",
      displayName: null,
      category: "Sans Serif",
      size: 348914,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "200": {
          thickness: 2,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "500": {
          thickness: 5,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "600": {
          thickness: 6,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "800": {
          thickness: 8,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        },
        "900": {
          thickness: 9,
          slant: 1,
          width: 3,
          lineHeight: 1.173
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.173
        }
      },
      axes: [
        {
          tag: "wght",
          min: 100,
          max: 900,
          defaultValue: 400
        }
      ],
      designers: ["Wei Huang"],
      lastModified: "2022-09-21",
      dateAdded: "2015-07-08",
      popularity: 31,
      trending: 1163,
      defaultSort: 32,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Xanh Mono",
      displayName: null,
      category: "Monospace",
      size: 61880,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.19
        }
      },
      axes: [],
      designers: ["Yellow Type", "L\xE2m B\u1EA3o", "Duy Dao"],
      lastModified: "2023-06-07",
      dateAdded: "2020-08-10",
      popularity: 905,
      trending: 685,
      defaultSort: 896,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yaldevi",
      displayName: null,
      category: "Sans Serif",
      size: 469216,
      subsets: ["menu", "latin", "latin-ext", "sinhala"],
      fonts: {
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.316
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.316
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.316
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.316
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.316
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.316
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Mooniak"],
      lastModified: "2023-03-21",
      dateAdded: "2021-06-28",
      popularity: 1169,
      trending: 295,
      defaultSort: 1138,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yanone Kaffeesatz",
      displayName: null,
      category: "Sans Serif",
      size: 122256,
      subsets: ["menu", "cyrillic", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "200": {
          thickness: 1,
          slant: 1,
          width: 5,
          lineHeight: 0.992
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 5,
          lineHeight: 0.992
        },
        "400": {
          thickness: 4,
          slant: 1,
          width: 5,
          lineHeight: 0.992
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.992
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 0.992
        },
        "700": {
          thickness: 6,
          slant: 1,
          width: 2,
          lineHeight: 0.992
        }
      },
      axes: [
        {
          tag: "wght",
          min: 200,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Yanone", "Cyreal"],
      lastModified: "2022-09-21",
      dateAdded: "2010-05-11",
      popularity: 117,
      trending: 803,
      defaultSort: 111,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yantramanav",
      displayName: null,
      category: "Sans Serif",
      size: 157838,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "100": {
          thickness: 1,
          slant: 1,
          width: 3,
          lineHeight: 1.296875
        },
        "300": {
          thickness: 3,
          slant: 1,
          width: 3,
          lineHeight: 1.296875
        },
        "400": {
          thickness: 5,
          slant: 1,
          width: 3,
          lineHeight: 1.296875
        },
        "500": {
          thickness: 6,
          slant: 1,
          width: 3,
          lineHeight: 1.296875
        },
        "700": {
          thickness: 7,
          slant: 1,
          width: 3,
          lineHeight: 1.296875
        },
        "900": {
          thickness: 8,
          slant: 1,
          width: 3,
          lineHeight: 1.296875
        }
      },
      axes: [],
      designers: ["Erin McLaughlin"],
      lastModified: "2022-09-21",
      dateAdded: "2015-06-03",
      popularity: 166,
      trending: 916,
      defaultSort: 167,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yatra One",
      displayName: null,
      category: "Display",
      size: 276324,
      subsets: ["menu", "devanagari", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.478
        }
      },
      axes: [],
      designers: ["Catherine Leigh Schmidt"],
      lastModified: "2022-09-21",
      dateAdded: "2016-06-15",
      popularity: 306,
      trending: 510,
      defaultSort: 322,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yellowtail",
      displayName: null,
      category: "Handwriting",
      size: 62216,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 8,
          width: 5,
          lineHeight: 1.36279296875
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-20",
      popularity: 194,
      trending: 793,
      defaultSort: 195,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yeon Sung",
      displayName: null,
      category: "Display",
      size: 2495400,
      subsets: ["menu", "korean", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.25
        }
      },
      axes: [],
      designers: ["Woowahan brothers"],
      lastModified: "2022-09-27",
      dateAdded: "2018-02-23",
      popularity: 1195,
      trending: 1371,
      defaultSort: 1161,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yeseva One",
      displayName: null,
      category: "Display",
      size: 108016,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: 7,
          slant: 1,
          width: 8,
          lineHeight: 1.155
        }
      },
      axes: [],
      designers: ["Jovanny Lemonad"],
      lastModified: "2022-09-21",
      dateAdded: "2011-07-13",
      popularity: 265,
      trending: 1111,
      defaultSort: 278,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yesteryear",
      displayName: null,
      category: "Handwriting",
      size: 37158,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 6,
          slant: 7,
          width: 5,
          lineHeight: 1.46728515625
        }
      },
      axes: [],
      designers: ["Astigmatic"],
      lastModified: "2022-09-21",
      dateAdded: "2011-12-19",
      popularity: 534,
      trending: 880,
      defaultSort: 552,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yomogi",
      displayName: null,
      category: "Handwriting",
      size: 4039220,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Satsuyako"],
      lastModified: "2022-09-27",
      dateAdded: "2021-04-14",
      popularity: 1070,
      trending: 164,
      defaultSort: 1054,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yrsa",
      displayName: null,
      category: "Serif",
      size: 255796,
      subsets: ["menu", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.218
        }
      },
      axes: [
        {
          tag: "wght",
          min: 300,
          max: 700,
          defaultValue: 400
        }
      ],
      designers: ["Rosetta", "Anna Giedry\u015B", "David B\u0159ezina"],
      lastModified: "2023-05-02",
      dateAdded: "2016-06-15",
      popularity: 490,
      trending: 1083,
      defaultSort: 510,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ysabeau",
      displayName: null,
      category: "Sans Serif",
      size: 382778,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "1i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Christian Thalmann"],
      lastModified: "2023-04-20",
      dateAdded: "2023-04-19",
      popularity: 1308,
      trending: 754,
      defaultSort: 252,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ysabeau Infant",
      displayName: null,
      category: "Sans Serif",
      size: 338604,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "1i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Christian Thalmann"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 1179,
      trending: 8,
      defaultSort: 23,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ysabeau Office",
      displayName: null,
      category: "Sans Serif",
      size: 352262,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "1000i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "1i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "200i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "800i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "900i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Christian Thalmann"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 1187,
      trending: 9,
      defaultSort: 25,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Ysabeau SC",
      displayName: null,
      category: "Sans Serif",
      size: 223380,
      subsets: ["menu", "cyrillic", "cyrillic-ext", "greek", "latin", "latin-ext", "vietnamese"],
      fonts: {
        "1": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "100": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "1000": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        },
        "200": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "800": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.343
        }
      },
      axes: [
        {
          tag: "wght",
          min: 1,
          max: 1e3,
          defaultValue: 400
        }
      ],
      designers: ["Christian Thalmann"],
      lastModified: "2023-06-22",
      dateAdded: "2023-06-21",
      popularity: 1248,
      trending: 13,
      defaultSort: 48,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yuji Boku",
      displayName: null,
      category: "Serif",
      size: 8525588,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Kinuta Font Factory"],
      lastModified: "2022-09-27",
      dateAdded: "2021-09-26",
      popularity: 1366,
      trending: 48,
      defaultSort: 724,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yuji Hentaigana Akari",
      displayName: null,
      category: "Handwriting",
      size: 93496,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Kinuta Font Factory"],
      lastModified: "2023-05-31",
      dateAdded: "2021-06-10",
      popularity: 1545,
      trending: 1822,
      defaultSort: 1426,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Yuji Hentaigana Akebono",
      displayName: null,
      category: "Handwriting",
      size: 99100,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Kinuta Font Factory"],
      lastModified: "2023-05-31",
      dateAdded: "2021-06-10",
      popularity: 1568,
      trending: 1823,
      defaultSort: 1436,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hira",
      primaryLanguage: ""
    },
    {
      family: "Yuji Mai",
      displayName: null,
      category: "Serif",
      size: 8496292,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Kinuta Font Factory"],
      lastModified: "2022-09-27",
      dateAdded: "2021-09-26",
      popularity: 1466,
      trending: 413,
      defaultSort: 1382,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yuji Syuku",
      displayName: null,
      category: "Serif",
      size: 8430348,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Kinuta Font Factory"],
      lastModified: "2022-09-27",
      dateAdded: "2021-09-26",
      popularity: 1073,
      trending: 686,
      defaultSort: 1057,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Yusei Magic",
      displayName: null,
      category: "Sans Serif",
      size: 3134968,
      subsets: ["menu", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Tanukizamurai"],
      lastModified: "2023-05-02",
      dateAdded: "2020-12-14",
      popularity: 799,
      trending: 683,
      defaultSort: 801,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "ZCOOL KuaiLe",
      displayName: null,
      category: "Sans Serif",
      size: 3275404,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Liu Bingke", "Yang Kang", "Wu Shaojie"],
      lastModified: "2022-11-09",
      dateAdded: "2018-12-10",
      popularity: 893,
      trending: 171,
      defaultSort: 886,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hans",
      primaryLanguage: ""
    },
    {
      family: "ZCOOL QingKe HuangYou",
      displayName: null,
      category: "Sans Serif",
      size: 8328684,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Zheng Qingke"],
      lastModified: "2022-11-09",
      dateAdded: "2018-12-10",
      popularity: 616,
      trending: 1760,
      defaultSort: 628,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hans",
      primaryLanguage: ""
    },
    {
      family: "ZCOOL XiaoWei",
      displayName: null,
      category: "Sans Serif",
      size: 6313808,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Li Dawei"],
      lastModified: "2022-11-09",
      dateAdded: "2018-12-10",
      popularity: 634,
      trending: 1413,
      defaultSort: 645,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Hans",
      primaryLanguage: ""
    },
    {
      family: "Zen Antique",
      displayName: null,
      category: "Serif",
      size: 5507920,
      subsets: ["menu", "cyrillic", "greek", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-08-31",
      popularity: 677,
      trending: 1670,
      defaultSort: 684,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Zen Antique Soft",
      displayName: null,
      category: "Serif",
      size: 7095608,
      subsets: ["menu", "cyrillic", "greek", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-08-31",
      popularity: 1141,
      trending: 601,
      defaultSort: 1116,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Zen Dots",
      displayName: null,
      category: "Display",
      size: 37112,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-03-11",
      popularity: 1172,
      trending: 655,
      defaultSort: 1141,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Zen Kaku Gothic Antique",
      displayName: null,
      category: "Sans Serif",
      size: 2305184,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-08-31",
      popularity: 686,
      trending: 53,
      defaultSort: 692,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Zen Kaku Gothic New",
      displayName: null,
      category: "Sans Serif",
      size: 2296893,
      subsets: ["menu", "cyrillic", "japanese", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-08-31",
      popularity: 318,
      trending: 410,
      defaultSort: 335,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Zen Kurenaido",
      displayName: null,
      category: "Sans Serif",
      size: 4303112,
      subsets: ["menu", "cyrillic", "greek", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-05-02",
      dateAdded: "2021-08-31",
      popularity: 742,
      trending: 1170,
      defaultSort: 745,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Zen Loop",
      displayName: null,
      category: "Display",
      size: 44240,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.125
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.125
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-03-10",
      popularity: 1469,
      trending: 1333,
      defaultSort: 1385,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Zen Maru Gothic",
      displayName: null,
      category: "Sans Serif",
      size: 3771293,
      subsets: ["menu", "cyrillic", "greek", "japanese", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-06-07",
      dateAdded: "2021-08-31",
      popularity: 388,
      trending: 494,
      defaultSort: 408,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Zen Old Mincho",
      displayName: null,
      category: "Serif",
      size: 5463908,
      subsets: ["menu", "cyrillic", "greek", "japanese", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        },
        "900": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.448
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-08-31",
      popularity: 644,
      trending: 770,
      defaultSort: 652,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "Jpan",
      primaryLanguage: ""
    },
    {
      family: "Zen Tokyo Zoo",
      displayName: null,
      category: "Display",
      size: 92176,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Yoshimichi Ohira"],
      lastModified: "2023-01-06",
      dateAdded: "2021-04-30",
      popularity: 1143,
      trending: 38,
      defaultSort: 507,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Zeyada",
      displayName: null,
      category: "Handwriting",
      size: 33532,
      subsets: ["menu", "latin"],
      fonts: {
        "400": {
          thickness: 3,
          slant: 1,
          width: 6,
          lineHeight: 1.576171875
        }
      },
      axes: [],
      designers: ["Kimberly Geswein"],
      lastModified: "2022-09-21",
      dateAdded: "2011-06-08",
      popularity: 184,
      trending: 883,
      defaultSort: 186,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Zhi Mang Xing",
      displayName: null,
      category: "Handwriting",
      size: 4063532,
      subsets: ["menu", "chinese-simplified", "latin"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1
        }
      },
      axes: [],
      designers: ["Wei Zhimang"],
      lastModified: "2022-09-27",
      dateAdded: "2019-03-17",
      popularity: 1045,
      trending: 141,
      defaultSort: 1030,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Zilla Slab",
      displayName: null,
      category: "Serif",
      size: 272912,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "300": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "300i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "400i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "500i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "600i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700i": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Typotheque"],
      lastModified: "2022-09-21",
      dateAdded: "2017-06-28",
      popularity: 119,
      trending: 1624,
      defaultSort: 113,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    },
    {
      family: "Zilla Slab Highlight",
      displayName: null,
      category: "Display",
      size: 273594,
      subsets: ["menu", "latin", "latin-ext"],
      fonts: {
        "400": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        },
        "700": {
          thickness: null,
          slant: null,
          width: null,
          lineHeight: 1.2
        }
      },
      axes: [],
      designers: ["Typotheque"],
      lastModified: "2022-09-21",
      dateAdded: "2017-07-26",
      popularity: 1018,
      trending: 488,
      defaultSort: 999,
      androidFragment: null,
      isNoto: false,
      colorCapabilities: [],
      primaryScript: "",
      primaryLanguage: ""
    }
  ],
  promotedScript: null
};

// src/runtime-utilities/props.ts
import { expand } from "inline-style-expand-shorthand";
var { PropTypes: PropTypes2 } = __CARTA_RUNTIME;
var fonts = googleFonts.familyMetadataList.map((font) => ({
  label: font.family,
  value: font.family
}));
var color = {
  section: "Text",
  label: "Color",
  schema: PropTypes2.string().optional(),
  type: "color"
};
var fontFamily = {
  section: "Text",
  label: "Family",
  schema: PropTypes2.string().optional(),
  type: "select",
  search: true,
  options: fonts
};
var fontSize = {
  section: "Text",
  label: "Size",
  schema: PropTypes2.number().optional(),
  type: "number",
  min: 10,
  max: 100
};
var fontWeight = {
  section: "Text",
  label: "Weight",
  schema: PropTypes2.string().optional(),
  type: "select",
  options: [
    { label: "Light", value: "300" },
    { label: "Normal", value: "400" },
    // { label: 'Medium', value: '500' },
    // { label: 'Semi-Bold', value: '600' },
    { label: "Bold", value: "700" }
  ]
};
var textTransform = {
  section: "Text",
  label: "Transform",
  schema: PropTypes2.string().optional(),
  type: "select",
  options: [
    { label: "None", value: "none" },
    { label: "Capitalize", value: "capitalize" },
    { label: "Uppercase", value: "uppercase" },
    { label: "Lowercase", value: "lowercase" }
  ]
};
var textAlign = {
  section: "Text",
  label: "Align",
  schema: PropTypes2.enum(["left", "center", "right"]).optional(),
  type: "toggle",
  options: [
    { label: "Left", value: "left", icon: "format_align_left" },
    { label: "Center", value: "center", icon: "format_align_center" },
    { label: "Right", value: "right", icon: "format_align_right" }
  ]
};
var textDecoration = {
  section: "Text",
  label: "Decoration",
  schema: PropTypes2.string().optional(),
  type: "select",
  options: [
    { label: "None", value: "none", icon: "format_clear" },
    { label: "Underline", value: "underline", icon: "format_underlined" },
    { label: "Line Through", value: "line-through", icon: "format_strikethrough" }
  ]
};
var padding = {
  section: "Layout",
  label: "Padding",
  schema: PropTypes2.string().optional(),
  type: "box",
  core: true
};
var margin = {
  section: "Layout",
  label: "Margin",
  schema: PropTypes2.string().optional(),
  type: "box",
  core: true
};
var align = {
  section: "Layout",
  label: "Alignment",
  schema: PropTypes2.enum(["left", "center", "right"]).optional(),
  type: "toggle",
  options: [
    { label: "Left", value: "left", icon: "align_horizontal_left" },
    { label: "Center", value: "center", icon: "align_horizontal_center" },
    { label: "Right", value: "right", icon: "align_horizontal_right" }
  ]
};
var opacity = {
  section: "Styles",
  label: "Opacity",
  schema: PropTypes2.number().optional(),
  type: "slider",
  min: 0,
  max: 1,
  step: 0.1,
  defaultValue: 1
};
var backgroundColor = {
  section: "Styles",
  label: "Fill",
  schema: PropTypes2.string().optional(),
  type: "color"
};
var borderRadius = {
  section: "Styles",
  label: "Radius",
  schema: PropTypes2.string().optional(),
  type: "radius",
  defaultValue: "0"
};
var boxShadow = {
  section: "Styles",
  label: "Shadow",
  schema: PropTypes2.string().optional(),
  type: "shadow"
};
var role = {
  section: "Accessibility",
  label: "Role",
  schema: PropTypes2.enum(["article", "region", "navigation"]).optional(),
  options: [
    { label: "Article", value: "article" },
    { label: "Region", value: "region" },
    { label: "Navigation", value: "navigation" },
    { label: "None", value: "" }
  ]
};
var lang = {
  section: "Accessibility",
  label: "Language",
  schema: PropTypes2.string().optional()
};
var dir = {
  section: "Accessibility",
  label: "Text Direction",
  schema: PropTypes2.enum(["ltr", "rtl", "auto"]).optional(),
  options: [
    { label: "Left to Right", value: "ltr" },
    { label: "Right to Left", value: "rtl" },
    { label: "Auto", value: "auto" }
  ]
};
var label = {
  section: "Accessibility",
  label: "Label",
  schema: PropTypes2.string().optional()
};
var className = {
  section: "Advanced",
  label: "CSS Class",
  schema: PropTypes2.string().optional()
};
var style = {
  section: "Advanced",
  label: "CSS Style",
  schema: PropTypes2.string().optional()
};
var commonProps = {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  textTransform,
  textAlign,
  textDecoration,
  padding,
  margin,
  align,
  opacity,
  backgroundColor,
  borderRadius,
  boxShadow,
  role,
  lang,
  dir,
  label,
  class: className,
  style
};
function getStylesValue(selector, cssProperty, serialize2) {
  const serializeName = serialize2?.name;
  const isNativeCode = serialize2 ? serialize2.toString().includes("[native code]") : false;
  const serializeStringified = serialize2 ? isNativeCode ? serializeName : `(${serialize2.toString()})` : "(value) => value";
  return `(rootElement) => {
    const element = ${selector === "&" ? `rootElement` : `rootElement.querySelector("${selector}")`};

    if (!element) {
      return null;
    }

    const computedStyle = window.getComputedStyle(element);

    if (!computedStyle) {
      return null;
    }
    const serialize = ${serializeStringified}

    return serialize(computedStyle.getPropertyValue("${cssProperty}"));
  };`;
}
var commonGroups = {
  /**
   * Group for all prose components
   */
  prose: {
    color: {
      core: true,
      ...commonProps.color,
      getComputedValue: getStylesValue("&", "color")
    },
    "font-family": {
      ...commonProps.fontFamily,
      getComputedValue: getStylesValue("&", "font-family", (value) => value.split(",")[0])
    },
    "font-size": {
      ...commonProps.fontSize,
      getComputedValue: getStylesValue("&", "font-size", parseInt)
    },
    "font-weight": {
      core: true,
      ...commonProps.fontWeight,
      getComputedValue: getStylesValue("&", "font-weight")
    },
    "line-height": {
      section: "Text",
      label: "Line Height",
      schema: PropTypes2.number().optional(),
      type: "number",
      min: 0.1,
      step: 0.1,
      getComputedValue: (rootElement) => {
        const computedStyles = window.getComputedStyle(rootElement);
        if (!computedStyles) {
          return null;
        }
        const fontSize2 = parseFloat(computedStyles.getPropertyValue("font-size"));
        const lineHeight = computedStyles.getPropertyValue("line-height");
        if (lineHeight === "normal") {
          return null;
        }
        return parseFloat((parseFloat(lineHeight) / fontSize2).toFixed(2));
      }
    },
    "text-align": {
      core: true,
      ...commonProps.textAlign,
      getComputedValue: getStylesValue("&", "text-align", (value) => {
        if (value === "start") {
          return "left";
        }
        if (value === "end") {
          return "right";
        }
        return value;
      })
    },
    "text-transform": {
      section: "Text",
      label: "Transform",
      schema: PropTypes2.string().optional(),
      type: "select",
      options: [
        { label: "None", value: "none" },
        { label: "Capitalize", value: "capitalize" },
        { label: "Uppercase", value: "uppercase" },
        { label: "Lowercase", value: "lowercase" }
      ],
      getComputedValue: getStylesValue("&", "text-transform")
    },
    "text-decoration": {
      section: "Text",
      label: "Decoration",
      schema: PropTypes2.string().optional(),
      type: "select",
      options: [
        { label: "None", value: "none", icon: "format_clear" },
        { label: "Underline", value: "underline", icon: "format_underlined" },
        { label: "Line Through", value: "line-through", icon: "format_strikethrough" }
      ],
      getComputedValue: getStylesValue("&", "text-decoration")
    },
    padding: {
      core: true,
      section: "Layout",
      label: "Padding",
      schema: PropTypes2.string().optional().default(""),
      type: "box",
      getComputedValue: getStylesValue("&", "padding")
    },
    margin: {
      core: true,
      section: "Layout",
      label: "Margin",
      schema: PropTypes2.string().optional().default(""),
      type: "box",
      getComputedValue: getStylesValue("&", "margin")
    },
    lang: {
      section: "Accessibility",
      label: "Language",
      schema: PropTypes2.string().optional()
    },
    dir: {
      section: "Accessibility",
      label: "Text Direction",
      schema: PropTypes2.enum(["ltr", "rtl", "auto"]).optional(),
      options: [
        { label: "Left to Right", value: "ltr" },
        { label: "Right to Left", value: "rtl" },
        { label: "Auto", value: "auto" }
      ]
    },
    class: {
      section: "Advanced",
      label: "CSS Class",
      schema: PropTypes2.string().optional()
    },
    style: {
      section: "Advanced",
      label: "CSS Style",
      schema: PropTypes2.string().optional().default(""),
      type: "code"
    }
  },
  /**
   * Shared props for all media components
   *
   * includes everything except for the media content itself
   * and the action
   */
  media: {
    alt: {
      core: true,
      label: "Alt Text",
      schema: PropTypes2.string().optional(),
      helpText: "Describe the media for screen readers"
    },
    width: {
      core: true,
      section: "Layout",
      label: "Width",
      schema: PropTypes2.string().optional(),
      type: "size",
      defaultValue: "auto",
      icon: "width",
      resizable: true
    },
    outlookWidth: {
      section: "Layout",
      label: "Outlook Width",
      schema: PropTypes2.number().optional(),
      type: "hidden"
    },
    margin: {
      ...commonProps.margin,
      schema: commonProps.margin.schema.default("16px 0px")
    },
    align: {
      core: true,
      ...commonProps.align
    },
    opacity: commonProps.opacity,
    "border-radius": {
      ...commonProps.borderRadius
    },
    "box-shadow": {
      ...commonProps.boxShadow
    },
    "background-color": {
      ...commonProps.backgroundColor,
      section: "Alt Text"
    },
    color: {
      ...commonProps.color,
      section: "Alt Text"
    },
    "font-family": {
      ...commonProps.fontFamily,
      section: "Alt Text"
    },
    "font-size": {
      ...commonProps.fontSize,
      section: "Alt Text"
    },
    "font-weight": {
      ...commonProps.fontWeight,
      section: "Alt Text"
    },
    "letter-spacing": {
      section: "Alt Text",
      label: "Letter Spacing",
      schema: PropTypes2.number().optional(),
      type: "slider",
      min: 0,
      max: 1,
      step: 0.1
    },
    "line-height": {
      section: "Alt Text",
      label: "Line Height",
      schema: PropTypes2.number().optional(),
      type: "slider",
      min: 0.1,
      step: 0.1
    },
    "text-align": {
      section: "Alt Text",
      label: "Align",
      schema: PropTypes2.enum(["left", "center", "right"]).optional(),
      type: "toggle",
      options: [
        { label: "Left", value: "left", icon: "format_align_left" },
        { label: "Center", value: "center", icon: "format_align_center" },
        { label: "Right", value: "right", icon: "format_align_right" }
      ]
    },
    "text-transform": {
      ...commonProps.textTransform,
      section: "Alt Text"
    },
    "text-decoration": {
      ...commonProps.textDecoration,
      section: "Alt Text"
    },
    "hover-box-shadow": {
      ...commonProps.boxShadow,
      section: "Effects",
      set: "Hover"
    },
    "hover-opacity": {
      ...commonProps.opacity,
      section: "Effects",
      set: "Hover"
    },
    "hover-border-radius": {
      ...commonProps.borderRadius,
      section: "Effects",
      set: "Hover"
    },
    class: commonProps.class,
    style: commonProps.style
  }
};

// src/runtime-utilities/cache.ts
var cache_exports = {};
__export(cache_exports, {
  getCache: () => getCache,
  setCache: () => setCache
});
var cache = /* @__PURE__ */ new Map();
function getCache(key) {
  return cache.get(key);
}
function setCache(key, value) {
  cache.set(key, value);
}

// src/runtime-utilities/style.ts
var style_exports = {};
__export(style_exports, {
  createCSSCompiler: () => createCSSCompiler,
  finish: () => finish,
  fontFamily: () => fontFamily2,
  getStyles: () => getStyles,
  globalStyle: () => globalStyle,
  start: () => start,
  style: () => style2
});
import generateHash from "string-hash";
import { compile as compile2, serialize, stringify, middleware } from "stylis";
var { style: style2, globalStyle, getStyles, start, finish } = createCSSCompiler();
function fontFamily2(fontFamily3) {
  if (fonts.find((f) => f.value === fontFamily3)) {
    globalStyle(`@import url('https://fonts.googleapis.com/css2?family=${fontFamily3}&display=swap');`);
  }
}
function createCSSCompiler() {
  const cssCache = /* @__PURE__ */ new Map();
  function style3(css) {
    const hash = generateHash(css).toString(36);
    if (cssCache.has(hash)) {
      return hashToClassName(hash);
    }
    const className2 = hashToClassName(hash);
    const compiledCss = compileCSS(`.${className2} {${css}}`);
    cssCache.set(hash, { css: compiledCss });
    return className2;
  }
  function globalStyle2(css) {
    const hash = generateHash(css).toString(36);
    if (!cssCache.has(hash)) {
      cssCache.set(hash, { css: compileCSS(css) });
    }
  }
  function getStyles2() {
    const css = [...cssCache.values()].map(({ css: css2 }) => css2).join("\n\n");
    if (css) {
      return `<style>${css}</style>`;
    }
    return "";
  }
  function start2() {
    cssCache.clear();
  }
  function finish2() {
    cssCache.clear();
  }
  return {
    style: style3,
    globalStyle: globalStyle2,
    getStyles: getStyles2,
    start: start2,
    finish: finish2
  };
}
function hashToClassName(hash) {
  return `c${hash}`;
}
function compileCSS(css) {
  return serialize(compile2(css), middleware([stringify]));
}

// src/message-compiler.ts
function messageCompile(source, options = {}) {
  options.nativeTags = options.nativeTags || nativeTags;
  const { script, style: style3, templates } = parse(source, options);
  if (script.value !== "") {
    throw new Error("Message components cannot have a <script> tag");
  }
  if (style3.value.length > 0) {
    throw new Error("Message components cannot have a <style> tag");
  }
  if (templates.length !== 1) {
    throw new Error("Message components must have exactly one <template> tag");
  }
  return {
    code: `"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _internals = require("carta/internals")
var __CARTA_RUNTIME = _internals.__CARTA_RUNTIME;
async function _default(__CARTA_INPUT) {
  var __CARTA_CURRENT_DEPTH = __CARTA_INPUT.__internals.track.depth;
  var __CONTEXT = __CARTA_INPUT.context;

  var __CARTA_STYLES = [];
  var __CARTA_RESULT = ${templateNodesToJavaScript(templates[0].value, options)}

  return {
    result: __CARTA_RESULT,
    styles: __CARTA_STYLES
  };
}`
  };
}

// src/components/x-base.html
var x_base_default = `<script>
  import { commonProps } from "carta/props";

  export const config = {
    componentType: "structure",
    label: "Base",
  };

  export const props = defineProps({
    lang: {
      ...commonProps.lang,
      schema: commonProps.lang.schema.default("und"),
    },
    dir: {
      ...commonProps.dir,
      schema: commonProps.dir.schema.default("auto"),
    },
    title: PropTypes.string().default(""),
    colorScheme: PropTypes.enum([
      "normal",
      "light",
      "only light",
      "light dark",
      "dark light",
      "dark",
      "only dark",
      "only light dark",
    ]).default("normal"),
    preheader: PropTypes.string().default(""),
    style: commonProps.style,
    class: commonProps.class,
  });

  export const slots = defineSlots({
    default: SlotTypes.children(["x-section", "x-columns"]),
  });

  // commented out since props.preheader is consumed and injected on the backend
  // const DEFAULT_PREHEADER_SPACING = 100;
  // const PREHEADER_MINIMUM_SPACING = 50;
  // const spacingCount = Math.max(PREHEADER_MINIMUM_SPACING, DEFAULT_PREHEADER_SPACING - props.preheader.length);
  // const preheaderSpaces = " &#8199;&#847;".repeat(spacingCount) + " &shy;".repeat(spacingCount) + \`&nbsp;\`;
  // usage: <div #if="props.preheader" style="display: none">\${props.preheader}{preheaderSpaces}</div>
</script>
<template>
  <!DOCTYPE html>
  <html
    :lang="props.lang"
    :dir="props.dir"
    xmlns:v="urn:schemas-microsoft-com:vml"
    xmlns:o="urn:schemas-microsoft-com:office:office"
  >
    <head>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=yes" />
      <meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no" />
      <meta name="x-apple-disable-message-reformatting" />
      <meta name="color-scheme" :content="props.colorScheme" />
      <meta name="supported-color-schemes" :content="props.colorScheme" />
      <title>\${props.title}</title>
      <!--[if mso]>
        <noscript>
          <xml>
            <o:OfficeDocumentSettings>
              <o:PixelsPerInch>96</o:PixelsPerInch>
            </o:OfficeDocumentSettings>
          </xml>
        </noscript>
      <![endif]-->
      <style>
        :root {
          color-scheme: \${props.colorScheme};
          supported-color-schemes: \${props.colorScheme};
        }
      </style>
      <style>
        .x-wrapper {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
      </style>
      <style>
        body {
          margin: 0;
        }
        table.mso {
          mso-cellspacing: 0;
          padding: 0;
          font-size: medium;
          /* add default style here for MSO */
        }
      </style>
    </head>
    <body class="body" :xml:lang="props.lang" #root>
      <div
        role="article"
        aria-roledescription="email"
        :aria-label="props.title"
        :lang="props.lang"
        :dir="props.dir"
        :style="[
          {
          'font-size':'medium',
          'font-size':'max(16px, 1rem)',
          'font-family': 'Helvetica, sans-serif',
          }, props.style
        ]"
        :class="[props.class, 'x-wrapper']"
      >
        <slot />
      </div>
      <div #if="process.env.CARTA_ENV === 'development'" style="height: 40px"></div>
    </body>
  </html>
</template>
`;

// src/components/x-box.html
var x_box_default = `<script>
  /**
   * Box is a email-safe div replacement.
   *
   * There several possible outputs:
   * 1. A simple div
   *    This happens if we have need no fallback table or border box div
   * 2. A div with a fallback table
   *   This happens if we have a width, background color, or padding
   * 3. A div with a border box div
   *   This happens if we have a width with padding or a margin with alignment
   * 4. A div with a fallback table and a border box div
   *
   *
   * All of this work is to support basic div functionality while
   * giving the same affect as box-sizing: border-box on all
   * email clients.
   */

  import { commonProps } from "carta/props";
  import { fontFamily } from "carta/style";

  export const config = {
    componentType: "structure",
    label: "Box",
    presets: [
      {
        icon: "select",
        section: "Layout",
        label: "Box",
        content: "<x-box></x-box>",
      },
      {
        icon: "select",
        label: "Box",
        content: "<x-box></x-box>",
      },
    ],
  };

  export const props = defineProps({
    color: commonProps.color,
    "font-family": commonProps.fontFamily,
    "font-size": commonProps.fontSize,
    "font-weight": commonProps.fontWeight,
    "text-transform": commonProps.textTransform,
    width: {
      core: true,
      section: "Layout",
      label: "Width",
      schema: PropTypes.string().optional(),
      type: "size",
    },
    height: {
      core: true,
      section: "Layout",
      label: "height",
      schema: PropTypes.string().optional(),
      type: "size",
      units: ["auto", "px"],
    },
    padding: {
      core: true,
      ...commonProps.padding,
    },
    margin: {
      core: true,
      ...commonProps.margin,
    },
    align: {
      core: true,
      ...commonProps.align,
    },
    opacity: {
      core: true,
      ...commonProps.opacity,
    },
    "background-color": {
      core: true,
      ...commonProps.backgroundColor,
    },
    "border-radius": {
      core: true,
      ...commonProps.borderRadius,
    },
    "box-shadow": {
      core: true,
      ...commonProps.boxShadow,
    },
    role: commonProps.role,
    lang: commonProps.lang,
    dir: commonProps.dir,
    label: commonProps.label,
    class: commonProps.class,
    style: commonProps.style,
  });

  export const slots = defineSlots({
    default: SlotTypes.children([
      "x-paragraph",
      "x-box",
      "x-heading-1",
      "x-heading-2",
      "x-heading-3",
      "x-heading-4",
      "x-heading-5",
      "x-heading-6",
      "x-image",
      "x-video",
      "x-cta",
      "x-hr",
      "x-columns",
      "x-spacer",
    ]),
  });

  fontFamily(props["font-family"]);

  /**
   * Handle alignment
   *
   * if we are centered and have a width, we need to add margin:0 auto;
   * if we are right aligned and have a width, we need to add margin-left:auto;
   * if we are left aligned and have a width, we need to add margin-right:auto;
   */
  let alignMargin;
  // if we have a width of 100%, no margin
  if (props.width !== "100%") {
    if (props.align == "center" && props.width) {
      alignMargin = { "margin-left": "auto", "margin-right": "auto" };
    } else if (props.align == "right" && props.width) {
      alignMargin = { "margin-left": "auto" };
    } else if (props.align == "left" && props.width) {
      alignMargin = { "margin-right": "auto" };
    }
  }

  /**
   * Handle fallback table
   *
   * If we have a width, height, background, or padding we need to add a fallback table
   * around the div to ensure Outlook renders correctly
   */
  const addFallbackTable = props.width || props.height || props["background-color"] || props.padding || props.margin;
  const addLeftTableCell = addFallbackTable && (props.align == "right" || props.align == "center");
  const addRightTableCell = addFallbackTable && (props.align == "left" || props.align == "center");

  /**
   * Handle border box
   *
   * We want to simulate the box-sizing: border-box behavior in Outlook
   *
   * To do this we need to add the set the width and margin on an extra
   * div
   */
  const addBorderBox = (!!props.width && !!props.padding) || (!!alignMargin && !!props.margin);
  // add props.border this when we support border

  /**
   * Building styles
   */
  const tableStyles = {
    width: "100%",
    "mso-para-margin": props.margin,
  };
  const tdStyles = {
    width: props.width,
    height: props.height,
    "background-color": props["background-color"],
    color: props.color,
    padding: props.padding,
  };
  const borderBoxStyles = addBorderBox
    ? {
        "max-width": props.width,
        "min-height": props.height,
        margin: props.margin,
        opacity: props.opacity,
        "background-color": props["background-color"],
        "border-radius": props["border-radius"],
        "box-shadow": props["box-shadow"],
        ...(alignMargin ? alignMargin : {}),
      }
    : undefined;
  const boxStyles = {
    color: props.color,
    "font-family": props["font-family"],
    "font-size": props["font-size"],
    "font-weight": props["font-weight"],
    "text-transform": props["text-transform"],
    padding: props.padding ? props.padding : "0.1px",
    ...(addBorderBox
      ? {}
      : {
          "max-width": props.width,
          "min-height": props.height,
          margin: props.margin,
          opacity: props.opacity,
          "background-color": props["background-color"],
          "border-radius": props["border-radius"],
          "box-shadow": props["box-shadow"],
        }),
    ...(alignMargin && !addBorderBox ? alignMargin : {}),
  };

  /**
   * Building accessibility attributes
   */
  const lang = props.lang ?? false;
  const dir = props.dir ?? false;
  const role = props.role && props.label ? props.role : false;
  const ariaLabel = props.role && props.label ? props.label : false;
</script>
<template>
  <x-conditional condition="true" tags="open"></x-conditional>
  <fragment :is="addFallbackTable ? 'table' : 'fragment'" role="none" class="mso" align="left" :style="tableStyles">
    <fragment :is="addFallbackTable ? 'tr' : 'fragment'">
      <td #if="addLeftTableCell"></td>
      <fragment :is="addFallbackTable ? 'td' : 'fragment'" :style="tdStyles" valign="top">
        <x-conditional condition="true" tags="close"></x-conditional>
        <x-conditional #if="addBorderBox" condition="!true" tags="open"></x-conditional>
        <fragment :is="addBorderBox ? 'div' : 'fragment'" :style="borderBoxStyles" :class="props.class">
          <x-conditional #if="addBorderBox" condition="!true" tags="close"></x-conditional>
          <div :lang="lang" :dir="dir" :role="role" :aria-label="ariaLabel" :style="boxStyles" :class="addBorderBox ? false : props.class">
            <slot />
          </div>
          <x-conditional #if="addBorderBox" condition="!true" tags="open"></x-conditional>
        </fragment>
        <x-conditional #if="addBorderBox" condition="!true" tags="close"></x-conditional>
        <x-conditional condition="true" tags="open"></x-conditional>
      </fragment>
      <td #if="addRightTableCell"></td>
    </fragment>
  </fragment>
  <x-conditional condition="true" tags="close"></x-conditional>
</template>
`;

// src/components/x-column.html
var x_column_default = '<script>\n  import { commonProps } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "structure",\n    label: "Column",\n    presets: [\n      {\n        section: "Layout",\n        label: "Column",\n        content: "<x-column><x-paragraph></x-paragraph></x-column>",\n      },\n    ],\n  };\n\n  export const props = defineProps({\n    color: commonProps.color,\n    "font-family": commonProps.fontFamily,\n    "font-size": commonProps.fontSize,\n    "font-weight": commonProps.fontWeight,\n    "text-transform": commonProps.textTransform,\n    width: {\n      section: "Layout",\n      label: "Width",\n      schema: PropTypes.string().optional(),\n      type: "size",\n    },\n    padding: commonProps.padding,\n    opacity: commonProps.opacity,\n    "background-color": {\n      core: true,\n      ...commonProps.backgroundColor,\n    },\n    "border-radius": commonProps.borderRadius,\n    "box-shadow": commonProps.boxShadow,\n    class: commonProps.class,\n    style: commonProps.style,\n  });\n\n  export const slots = defineSlots({\n    default: SlotTypes.children([\n      "x-paragraph",\n      "x-box",\n      "x-heading-1",\n      "x-heading-2",\n      "x-heading-3",\n      "x-heading-4",\n      "x-heading-5",\n      "x-heading-6",\n      "x-image",\n      "x-video",\n      "x-cta",\n      "x-hr",\n      "x-spacer",\n    ]),\n  });\n\n  fontFamily(props["font-family"]);\n\n  const rowContext = getContext("row-context");\n  rowContext.currentColumn += 1;\n\n  const { layout, currentColumn } = rowContext;\n  const width = props.width\n    ? props.width\n    : (layout?.length ?? 0) > currentColumn\n    ? `${layout[currentColumn]}%`\n    : undefined;\n\n  const styleInline = {\n    display: "table-cell",\n    color: props.color,\n    "font-family": props["font-family"],\n    "font-size": props["font-size"],\n    "font-weight": props["font-weight"],\n    "text-transform": props["text-transform"],\n    width: width,\n    padding: props.padding,\n    opacity: props.opacity,\n    "background-color": props["background-color"],\n    "border-radius": props["border-radius"],\n    "box-shadow": props["box-shadow"],\n  };\n\n  const styleInlineMSO = {\n    width: width,\n    padding: props.padding,\n    "background-color": props["background-color"],\n  };\n\n  // reset the row context so that the children can\'t access it\n  setContext("row-context", undefined);\n</script>\n<template>\n  <!--[if true]>\n  <td :style="styleInlineMSO">\n  <![endif]-->\n  <div :style="[styleInline, props.style]" :class="props.class">\n    <slot><x-empty-state /></slot>\n  </div>\n  <!--[if true]>\n  </td>\n  <![endif]-->\n</template>\n';

// src/components/x-columns.html
var x_columns_default = `<script>
  import { commonProps } from "carta/props";
  import { fontFamily } from "carta/style";

  export const config = {
    componentType: "structure",
    label: "Columns",
    presets: [
      {
        icon: "view_column_2",
        section: "Layout",
        label: "2 Columns",
        content:
          "<x-columns :layout='[50,50]'><x-column><x-paragraph></x-paragraph></x-column><x-column><x-paragraph></x-paragraph></x-column></x-columns>",
      },
      {
        icon: "view_column_2",
        section: "Layout",
        label: "3 Columns",
        content:
          "<x-columns :layout='[33,33,34]'><x-column><x-paragraph></x-paragraph></x-column><x-column><x-paragraph></x-paragraph></x-column><x-column><x-paragraph></x-paragraph></x-column></x-columns>",
      },
      {
        icon: "view_column_2",
        section: "Layout",
        label: "4 Columns",
        content:
          "<x-columns :layout='[25,25,25,25]'><x-column><x-paragraph></x-paragraph></x-column><x-column><x-paragraph></x-paragraph></x-column><x-column><x-paragraph></x-paragraph></x-column><x-column><x-paragraph></x-paragraph></x-column></x-columns>",
      },
    ],
  };

  export const slots = defineSlots({
    default: {
      schema: SlotTypes.children(["x-column"]),
      direction: "horizontal",
    },
  });

  fontFamily(props["font-family"]);

  export const props = defineProps({
    color: commonProps.color,
    "font-family": commonProps.fontFamily,
    "font-size": commonProps.fontSize,
    "font-weight": commonProps.fontWeight,
    "text-transform": commonProps.textTransform,
    width: {
      section: "Layout",
      label: "Width",
      schema: PropTypes.string().optional(),
      type: "size",
    },
    layout: {
      core: true,
      section: "Layout",
      label: "Layout",
      schema: PropTypes.array(PropTypes.number()).optional(),
    },
    gap: {
      core: true,
      section: "Layout",
      label: "Gap",
      schema: PropTypes.number().optional(),
      getComputedValue(rootElement) {
        return parseInt(rootElement.style["border-spacing"] || 0);
      },
    },
    margin: commonProps.margin,
    padding: commonProps.padding,
    align: commonProps.align,
    opacity: commonProps.opacity,
    "background-color": commonProps.backgroundColor,
    "border-radius": commonProps.borderRadius,
    "box-shadow": commonProps.boxShadow,
    class: commonProps.class,
    style: commonProps.style,
  });

  const divStyle = {
    display: "table",
    width: "100%",
    "max-width": props["width"] === "auto" || props["width"] === "100%" ? undefined : props["width"],
    "border-spacing": props["gap"],
    "background-color": props["background-color"],
    color: props["color"],
    "font-family": props["font-family"],
    "font-size": props["font-size"],
    "font-weight": props["font-weight"],

    "text-transform": props["text-transform"],
    "border-radius": props["border-radius"],
    "box-shadow": props["box-shadow"],
    opacity: props["opacity"],
    padding: props["padding"],
  };
  const tableStyle = {
    width: props["width"] === "auto" || !props["width"] ? "100%" : props["width"],
    "mso-cellspacing": props["gap"],
    "background-color": props["background-color"],
    color: props["color"],
    "font-family": props["font-family"],
    "font-size": props["font-size"],
    "font-weight": props["font-weight"],

    "text-transform": props["text-transform"],
  };

  const hasWidth = props.width && props.width !== "auto" && props.width !== "100%";

  if (props.align == "center" && hasWidth) {
    divStyle.margin = "0 auto";
  } else if (props.align == "right" && hasWidth) {
    divStyle.margin = "0 0 0 auto";
  } else if (props.align == "left" && hasWidth) {
    divStyle.margin = "0 auto 0 0";
  }

  setContext("row-context", {
    layout: props["layout"],
    currentColumn: -1,
  });
</script>
<template>
  <fragment #set:is="props.margin ? 'div': 'fragment'" :style="{margin: props.margin}">
    <div :style="[divStyle, props.style]" :class="props.class" #root>
      <!--[if true]>
    <table role="none" class="mso" :align="props.align" :style="[tableStyle, props.style]" hidden>
    <![endif]-->
      <!--[if tonline]></table><![endif]-->
      <!--[if true]><tr><![endif]-->
      <div style="display: table-row">
        <slot />
      </div>
      <!--[if true]></tr><![endif]-->
      <!--[if tonline]><table><![endif]-->
      <!--[if true]>
    </table>
    <![endif]-->
    </div>
  </fragment>
</template>
`;

// src/components/x-conditional.html
var x_conditional_default = '<script>\n  export const props = defineProps({\n    condition: PropTypes.string(),\n    tags: PropTypes.enum(["open", "close", ""]).default(""),\n  });\n  let openTag = "";\n  let closeTag = "";\n  let notTag = "";\n  if (props.tags !== "close") {\n    openTag = "<!--[if " + props.condition + "]>";\n    if (props.condition.startsWith("!")) {\n      openTag = openTag + "<!-->";\n    }\n  }\n  if (props.tags !== "open") {\n    closeTag = "<![endif]-->";\n    if (props.condition.startsWith("!")) {\n      closeTag = "<!--" + closeTag;\n    }\n  }\n</script>\n<template> <fragment #set:html="openTag" /><slot /><fragment #set:html="closeTag" /> </template>\n';

// src/components/x-cta.html
var x_cta_default = `<script>
  import { commonProps, expandShorthand } from "carta/props";
  import { fontFamily } from "carta/style";

  export const config = {
    componentType: "content",
    label: "Button",
    presets: [
      {
        icon: "smart_button",
        label: "Button",
        content: "<x-cta>Click Me</x-cta>",
      },
      // {
      //   section: "Content",
      //   icon: "smart_button",
      //   label: "Button",
      //   content:
      //     '<x-cta font-weight="600" href="https://www.customer.io" :font-size="14" margin="8px 0" align="center" background-color="#000000" color="#FFFFFF" padding="10px 20px" border-radius="4px 4px 4px 4px">Click Me</x-cta>',
      // },
    ],
  };

  export const props = defineProps({
    href: {
      core: true,
      section: "Action",
      label: "Link",
      schema: PropTypes.string().optional(),
      icon: "link",
    },
    color: {
      ...commonProps.color,
      schema: commonProps.color.schema.default("#FFFFFF"),
      core: true,
    },
    "font-family": {
      ...commonProps.fontFamily,
    },
    "font-size": {
      ...commonProps.fontSize,
      schema: commonProps.fontSize.schema.default(14),
    },
    "font-weight": {
      ...commonProps.fontWeight,
    },
    "text-align": {
      ...commonProps.textAlign,
    },
    "text-transform": commonProps.textTransform,
    opacity: commonProps.opacity,
    "background-color": {
      ...commonProps.backgroundColor,
      schema: commonProps.backgroundColor.schema.default("#000000"),
      core: true,
    },
    "border-radius": {
      ...commonProps.borderRadius,
      schema: commonProps.borderRadius.schema.default("4px"),
    },
    "box-shadow": {
      ...commonProps.boxShadow,
    },
    "full-width": {
      section: "Layout",
      label: "Full Width",
      schema: PropTypes.boolean().optional().default(false),
    },
    width: {
      section: "Layout",
      label: "Width",
      schema: PropTypes.string().optional().default('auto'),
      type: "size",
    },
    height: {
      section: "Layout",
      label: "height",
      schema: PropTypes.string().optional().default('auto'),
      type: "size",
      units: ["auto", "px"],
    },
    padding: {
      ...commonProps.padding,
      schema: commonProps.padding.schema.default("10px 20px"),
    },
    margin: {
      ...commonProps.margin,
      schema: commonProps.margin.schema.default("8px 0"),
    },
    align: {
      core: true,
      ...commonProps.align,
      schema: commonProps.align.schema.default("center"),
    },
    "hover-color": {
      ...commonProps.color,
      section: "Effects",
      set: "Hover",
    },
    "hover-background-color": {
      ...commonProps.backgroundColor,
      section: "Effects",
      set: "Hover",
    },
    "hover-box-shadow": {
      ...commonProps.boxShadow,
      section: "Effects",
      set: "Hover",
    },
    "hover-opacity": {
      ...commonProps.opacity,
      section: "Effects",
      set: "Hover",
    },
    "hover-border-radius": {
      ...commonProps.borderRadius,
      section: "Effects",
      set: "Hover",
    },
    class: commonProps.class,
    style: commonProps.style,
  });

  export const slots = defineSlots({
    default: {
      schema: SlotTypes.text(),
      marks: ["bold", "italic", "underline", "strikethrough"],
    },
  });

  fontFamily(props["font-family"]);

  const hasPadding = props.padding !== "";
  let ghostTableOpen = '';
  let ghostTableClose = '';
  if (props["full-width"] || props["width"] !== 'auto' || props["height"] !== 'auto'){
    ghostTableOpen = \`<table role="presentation" border="0" cellpadding="0" cellspacing="0" align="\${props["align"]}" style="width:\${props["full-width"] ? '100%' : props["width"]};background:\${props["background-color"]}"><tr><td valign="top" style="height:\${props["height"]};text-align: \${props["text-align"] ? props["text-align"] : "center"}">\`;
    ghostTableClose = \`</td></tr></table>\`;
  }
  if (props.width === 'auto' || props["full-width"]){
    props.width = undefined;
  }
  const styleObject = {
    display: props["full-width"] ? "block" : "inline-block",
    width: props["width"],
    "max-width":  props["width"] ? "100%" : undefined,
    "min-height": props["height"] == 'auto' ? undefined : props["height"],
    "text-decoration": "none",
    "mso-padding-alt": hasPadding ? "0" : "",
    color: props["color"],
    "font-family": props["font-family"],
    "font-size": props["font-size"],
    "font-weight": props["font-weight"],
    "text-transform": props["text-transform"],
    "text-align": props["text-align"] ?? "center",
    padding: props["padding"],
    opacity: props["opacity"],
    "background-color": props["background-color"],
    "text-underline-color": props["background-color"],
    "border-radius": props["border-radius"],
    "box-shadow": props["box-shadow"],
  };
  const wrapperStyle = {
    "text-align": props["align"],
    margin: props["margin"],
  };

  function getPxValue(value) {
    if (!value.endsWith("px")) {
      return null;
    }

    return value.replace("px", "");
  }

  function getEmOrRemValue(value) {
    if (!value.endsWith("em") && !value.endsWith("rem")) {
      return null;
    }

    return value.replace("em", "").replace("rem", "");
  }

  function round(value) {
    return Number(value.toFixed(2));
  }

  const expanded = expandShorthand({ padding: props["padding"] });

  let paddingLeft = 0;
  let paddingRight = 0;
  let paddingTop = 0;
  let paddingBottom = 0;

  if (getPxValue(expanded.paddingLeft)) {
    paddingLeft = round((getPxValue(expanded.paddingLeft) / props["font-size"]) * 100);
  } else if (getEmOrRemValue(expanded.paddingLeft)) {
    paddingLeft = round(getEmOrRemValue(expanded.paddingLeft) * 100);
  }

  if (getPxValue(expanded.paddingRight)) {
    paddingRight = round((getPxValue(expanded.paddingRight) / props["font-size"]) * 100);
  } else if (getEmOrRemValue(expanded.paddingRight)) {
    paddingRight = round(getEmOrRemValue(expanded.paddingRight) * 100);
  }

  if (getPxValue(expanded.paddingBottom)) {
    paddingBottom = round((getPxValue(expanded.paddingBottom) / props["font-size"]) * 100);
  } else if (getEmOrRemValue(expanded.paddingBottom)) {
    paddingBottom = round(getEmOrRemValue(expanded.paddingBottom) * 100);
  }

  if (getPxValue(expanded.paddingTop)) {
    paddingTop = round((getPxValue(expanded.paddingTop) / props["font-size"]) * 100);
  } else if (getEmOrRemValue(expanded.paddingTop)) {
    paddingTop = round(getEmOrRemValue(expanded.paddingTop) * 100);
  }

  const inline = getContext("inline");
  const layout = "block";

</script>
<template> 
  <fragment :is="layout == 'block' ? 'div' : 'fragment'" :style="wrapperStyle">
    <x-conditional #if="ghostTableOpen" condition="true" tags="open"></x-conditional><fragment :html="ghostTableOpen"/><x-conditional #if="ghostTableOpen" condition="true" tags="close"></x-conditional>
    <a
      :href="props.href"
      :style="[styleObject, props.style]"
      :class="props.class"
      :draggable="process.env.CARTA_ENV === 'development' ? 'false' : undefined"
      ><x-conditional condition="mso" #if="paddingLeft !== 0 || paddingTop !== 0"
        ><i hidden :style="{'mso-font-width': \`\${paddingLeft}%\`, 'mso-text-raise': \`\${paddingTop + paddingBottom}%\`}"
          >&#8203;&emsp;</i
        ></x-conditional
      ><fragment
        #set:is="paddingBottom !== 0 ? 'span' : 'fragment'"
        :style="{
      'mso-text-raise': \`\${paddingBottom}%\`,
    }"
        ><slot></slot></fragment
      ><x-conditional #if="paddingRight !== 0" condition="mso"
        ><i hidden :style="{'mso-font-width': \`\${paddingRight}%\`}">&emsp;&#8203;</i></x-conditional
      ></a
    ><x-conditional #if="ghostTableClose" condition="true" tags="open"></x-conditional><fragment :html="ghostTableClose"/><x-conditional #if="ghostTableClose" condition="true" tags="close"></x-conditional></fragment
  >
</template>
`;

// src/components/x-empty-state.html
var x_empty_state_default = `<template
  ><fragment #if="process.env.CARTA_ENV === 'development'"
    ><div
      style="
        min-height: 100px;
        min-width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        background-color: #e9f2fc;
        border: 1px solid #0652BB;
        box-sizing: border-box;
        font-weight: bold;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
          'Open Sans', 'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      "
    >
      <div style="text-align: center">
        <slot>Drag in a component</slot>
      </div>
    </div></fragment
  ></template
>
`;

// src/components/x-heading-1.html
var x_heading_1_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "content",\n    label: "Heading 1",\n    prose: true,\n    presets: [\n      // {\n      //   icon: "title",\n      //   section: "Content",\n      //   label: "Heading 1",\n      //   content: "<x-heading-1></x-heading-1>",\n      // },\n      {\n        icon: "title",\n        label: "Heading 1",\n        content: "<x-heading-1></x-heading-1>",\n      },\n    ],\n  };\n\n  export const props = defineProps({ ...commonGroups.prose });\n\n  export const slots = defineSlots({\n    default: {\n      schema: SlotTypes.text(),\n      placeholder: "Heading 1",\n    },\n  });\n\n  fontFamily(props["font-family"]);\n\n  const DEFAULT_PADDING = "0";\n  const DEFAULT_MARGIN = "0.67em 0";\n  const DEFAULT_FONT_SIZE = "2em";\n\n  const styleObject = {\n    color: props["color"],\n    "font-size": props["font-size"] ?? DEFAULT_FONT_SIZE,\n    "line-height": props["line-height"] ?? "1.2",\n    "font-family": props["font-family"],\n    "font-weight": props["font-weight"],\n    "text-align": props["text-align"],\n    "text-decoration": props["text-decoration"],\n    "text-transform": props["text-transform"],\n\n    padding: props.padding || DEFAULT_PADDING,\n    margin: props.margin || DEFAULT_MARGIN,\n  };\n</script>\n<template>\n  <h1 :lang="props.lang" :dir="props.dir" :style="[styleObject, props.style]" :class="props.class"><slot /></h1>\n</template>\n';

// src/components/x-heading-2.html
var x_heading_2_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "content",\n    label: "Heading 2",\n    prose: true,\n    presets: [\n      {\n        icon: "title",\n        // section: "Content",\n        label: "Heading 2",\n        content: "<x-heading-2></x-heading-2>",\n      },\n    ],\n  };\n\n  export const props = defineProps({ ...commonGroups.prose });\n\n  export const slots = defineSlots({\n    default: {\n      schema: SlotTypes.text(),\n      placeholder: "Heading 2",\n    },\n  });\n\n  fontFamily(props["font-family"]);\n\n  const DEFAULT_PADDING = "0";\n  const DEFAULT_MARGIN = "0.83em 0";\n  const DEFAULT_FONT_SIZE = "1.5em";\n\n  const styleObject = {\n    color: props["color"],\n    "font-size": props["font-size"] ?? DEFAULT_FONT_SIZE,\n    "line-height": props["line-height"] ?? "1.2",\n    "font-family": props["font-family"],\n    "font-weight": props["font-weight"],\n    "text-align": props["text-align"],\n    "text-decoration": props["text-decoration"],\n    "text-transform": props["text-transform"],\n\n    padding: props.padding || DEFAULT_PADDING,\n    margin: props.margin || DEFAULT_MARGIN,\n  };\n</script>\n<template>\n  <h2 :lang="props.lang" :dir="props.dir" :style="[styleObject, props.style]" :class="props.class"><slot /></h2>\n</template>\n';

// src/components/x-heading-3.html
var x_heading_3_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "content",\n    label: "Heading 3",\n    prose: true,\n    presets: [\n      {\n        icon: "title",\n        // section: "Content",\n        label: "Heading 3",\n        content: "<x-heading-3></x-heading-3>",\n      },\n    ],\n  };\n\n  export const props = defineProps({ ...commonGroups.prose });\n\n  export const slots = defineSlots({\n    default: {\n      schema: SlotTypes.text(),\n      placeholder: "Heading 3",\n    },\n  });\n\n  fontFamily(props["font-family"]);\n\n  const DEFAULT_PADDING = "0";\n  const DEFAULT_MARGIN = "1em 0";\n  const DEFAULT_FONT_SIZE = "1.17em";\n\n  const styleObject = {\n    color: props["color"],\n    "font-size": props["font-size"] ?? DEFAULT_FONT_SIZE,\n    "line-height": props["line-height"] ?? "1.2",\n    "font-family": props["font-family"],\n    "font-weight": props["font-weight"],\n    "text-align": props["text-align"],\n    "text-decoration": props["text-decoration"],\n    "text-transform": props["text-transform"],\n\n    padding: props.padding || DEFAULT_PADDING,\n    margin: props.margin || DEFAULT_MARGIN,\n  };\n</script>\n<template>\n  <h3 :lang="props.lang" :dir="props.dir" :style="[styleObject, props.style]" :class="props.class"><slot /></h3>\n</template>\n';

// src/components/x-heading-4.html
var x_heading_4_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "content",\n    label: "Heading 4",\n    prose: true,\n    presets: [\n      {\n        icon: "title",\n        // section: "Content",\n        label: "Heading 4",\n        content: "<x-heading-4></x-heading-4>",\n      },\n    ],\n  };\n\n  export const props = defineProps({ ...commonGroups.prose });\n\n  export const slots = defineSlots({\n    default: {\n      schema: SlotTypes.text(),\n      placeholder: "Heading 4",\n    },\n  });\n\n  fontFamily(props["font-family"]);\n\n  const DEFAULT_PADDING = "0";\n  const DEFAULT_MARGIN = "1.33em 0";\n  const DEFAULT_FONT_SIZE = "1em";\n\n  const styleObject = {\n    color: props["color"],\n    "font-size": props["font-size"] ?? DEFAULT_FONT_SIZE,\n    "line-height": props["line-height"] ?? "1.2",\n    "font-family": props["font-family"],\n    "font-weight": props["font-weight"],\n    "text-align": props["text-align"],\n    "text-decoration": props["text-decoration"],\n    "text-transform": props["text-transform"],\n\n    padding: props.padding || DEFAULT_PADDING,\n    margin: props.margin || DEFAULT_MARGIN,\n  };\n</script>\n<template>\n  <h4 :lang="props.lang" :dir="props.dir" :style="[styleObject, props.style]" :class="props.class"><slot /></h4>\n</template>\n';

// src/components/x-heading-5.html
var x_heading_5_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "content",\n    label: "Heading 5",\n    prose: true,\n    presets: [\n      {\n        icon: "title",\n        // section: "Content",\n        label: "Heading 5",\n        content: "<x-heading-5></x-heading-5>",\n      },\n    ],\n  };\n\n  export const props = defineProps({ ...commonGroups.prose });\n\n  export const slots = defineSlots({\n    default: {\n      schema: SlotTypes.text(),\n      placeholder: "Heading 5",\n    },\n  });\n\n  fontFamily(props["font-family"]);\n\n  const DEFAULT_PADDING = "0";\n  const DEFAULT_MARGIN = "1.67em 0";\n  const DEFAULT_FONT_SIZE = "0.83em";\n\n  const styleObject = {\n    color: props["color"],\n    "font-size": props["font-size"] ?? DEFAULT_FONT_SIZE,\n    "line-height": props["line-height"] ?? "1.2",\n    "font-family": props["font-family"],\n    "font-weight": props["font-weight"],\n    "text-align": props["text-align"],\n    "text-decoration": props["text-decoration"],\n    "text-transform": props["text-transform"],\n\n    padding: props.padding || DEFAULT_PADDING,\n    margin: props.margin || DEFAULT_MARGIN,\n  };\n</script>\n<template>\n  <h5 :lang="props.lang" :dir="props.dir" :style="[styleObject, props.style]" :class="props.class"><slot /></h5>\n</template>\n';

// src/components/x-heading-6.html
var x_heading_6_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "content",\n    label: "Heading 6",\n    prose: true,\n    presets: [\n      {\n        icon: "title",\n        // section: "Content",\n        label: "Heading 6",\n        content: "<x-heading-6></x-heading-6>",\n      },\n    ],\n  };\n\n  export const props = defineProps({ ...commonGroups.prose });\n\n  export const slots = defineSlots({\n    default: {\n      schema: SlotTypes.text(),\n      placeholder: "Heading 6",\n    },\n  });\n\n  fontFamily(props["font-family"]);\n\n  const DEFAULT_PADDING = "0";\n  const DEFAULT_MARGIN = "2.33em 0";\n  const DEFAULT_FONT_SIZE = "0.67em";\n\n  const styleObject = {\n    color: props["color"],\n    "font-size": props["font-size"] ?? DEFAULT_FONT_SIZE,\n    "line-height": props["line-height"] ?? "1.2",\n    "font-family": props["font-family"],\n    "font-weight": props["font-weight"],\n    "text-align": props["text-align"],\n    "text-decoration": props["text-decoration"],\n    "text-transform": props["text-transform"],\n\n    padding: props.padding || DEFAULT_PADDING,\n    margin: props.margin || DEFAULT_MARGIN,\n  };\n</script>\n<template>\n  <h6 :lang="props.lang" :dir="props.dir" :style="[styleObject, props.style]" :class="props.class"><slot /></h6>\n</template>\n';

// src/components/x-hidden-text.html
var x_hidden_text_default = '<script>\n  export const config = {\n    componentType: "content",\n    label: "Hidden Text",\n  };\n\n  export const slots = defineSlots({\n    default: SlotTypes.text(),\n  });\n</script>\n<template>\n  <span\n    style="\n      display: inline-block;\n      max-height: 0;\n      max-width: 0;\n      mso-font-width: 0%;\n      mso-style-textfill-type: none;\n      white-space: nowrap;\n    "\n  >\n    <span\n      style="\n        max-height: 1px;\n        max-width: 1px;\n        display: inline-block;\n        overflow: hidden;\n        font-size: 1px;\n        color: rgba(0, 0, 0, 0);\n        text-indent: 9px;\n      "\n    >\n      <slot />\n    </span>\n  </span>\n</template>\n';

// src/components/x-hr.html
var x_hr_default = '<script>\n  import { commonProps, expandShorthand } from "carta/props";\n  export const config = {\n    componentType: "content",\n    label: "Divider",\n    presets: [\n      {\n        icon: "horizontal_rule",\n        // section: "Layout",\n        label: "Divider",\n        content: "<x-hr />",\n      },\n    ],\n  };\n\n  export const props = defineProps({\n    height: {\n      section: "Layout",\n      label: "Height",\n      schema: PropTypes.string().default("1px"),\n      type: "size",\n    },\n    width: {\n      section: "Layout",\n      label: "Width",\n      schema: PropTypes.string().default("auto"),\n      type: "size",\n    },\n    align: {\n      ...commonProps.align,\n      schema: commonProps.align.schema.default("center"),\n    },\n    margin: {\n      ...commonProps.margin,\n      schema: commonProps.margin.schema.default("10px 0px"),\n    },\n    "background-color": {\n      core: true,\n      ...commonProps.backgroundColor,\n      schema: commonProps.backgroundColor.schema.default("#D9D9D9"),\n    },\n    class: commonProps.class,\n    style: commonProps.style,\n  });\n\n  let height = "1.5px";\n  // if height is less than 1.5px Outlook 2016 won\'t show it.\n  if (props.height && props.height.endsWith("px")) {\n    height = Math.max(1.5, Number(props.height.slice(0, -2))) + "px";\n  }\n\n  const expanded = expandShorthand({ margin: props.margin });\n\n  let msoMarginRight = "";\n  let msoMarginLeft = "";\n  if (expanded.marginRight) {\n    msoMarginRight = `mso-para-margin-right:${expanded.marginRight};`;\n  }\n  if (expanded.marginLeft) {\n    msoMarginLeft = `mso-para-margin-left:${expanded.marginLeft};`;\n  }\n\n  // if no background-color is set outlook will show the borders so we need a default color #888\n  const styleObject = {\n    marginTop: 0,\n    marginBottom: 0,\n    "border-width": 0,\n    color: props["background-color"],\n    "background-color": props["background-color"],\n    height,\n    width: props.width === "auto" ? null : props.width,\n  };\n</script>\n<template>\n  <fragment\n    #set:is="props.margin ? \'div\' : \'fragment\'"\n    :class="props.class"\n    :style="[{padding: props.margin},msoMarginRight,msoMarginLeft]"\n  >\n    <hr :style="[styleObject, props.style]" :align="props.align" />\n  </fragment>\n</template>\n';

// src/components/x-image.html
var x_image_default = `<script>
  import { commonGroups } from "carta/props";
  import { fontFamily } from "carta/style";

  export const config = {
    componentType: "content",
    label: "Image",
    presets: [
      // {
      //   icon: "image",
      //   section: "Media",
      //   label: "Image",
      //   content: "<x-image />",
      // },
      {
        icon: "image",
        label: "Image",
        content: "<x-image />",
      },
    ],
  };

  export const props = defineProps({
    src: {
      core: true,
      label: "Source",
      schema: PropTypes.string().optional(),
      type: "media",
      accept: "image/*",
      display: ["url", "external"],
      placeholder: "Paste the image url here...",
    },
    href: {
      core: true,
      section: "Action",
      label: "Link",
      schema: PropTypes.string().optional(),
      icon: "link",
    },
    ...commonGroups.media,
    srcset: {
      section: "Advanced",
      label: "\`srcset\`",
      set: "Image Set",
      schema: PropTypes.string().optional(),
    },
    sizes: {
      section: "Advanced",
      label: "\`sizes\`",
      set: "Image Set",
      schema: PropTypes.string().optional(),
    },
  });

  fontFamily(props["font-family"]);

  const imageStyle = {
    "vertical-align": "middle",
    "max-width": "100%",
    width: props["width"],
    opacity: props["opacity"],
    "border-radius": props["border-radius"],
    "box-shadow": props["box-shadow"],
    "background-color": props["background-color"],
    color: props["color"],
    "font-family": props["font-family"],
    "font-size": props["font-size"],
    "font-weight": props["font-weight"],

    "line-height": props["line-height"],
    "text-align": props["text-align"],
    "text-transform": props["text-transform"],
    "text-decoration": props["text-decoration"],
  };
  const layout = "block";
  const addContainer = props["margin"] || layout === "block";
  const containerStyle = {
    margin: props.margin,
    display: layout === "block" ? undefined : "inline-block",
    "text-align": props.align,
  };
</script>
<template>
  <fragment :is="addContainer ? 'div' : 'fragment'" :style="containerStyle" :class="props.class">
    <fragment :is="props.href ? 'a' : 'fragment'" :href="props.href">
      <div
        #root
        #if="process.env.CARTA_ENV === 'development' && !props.src"
        data-carta-visualized-media-drop-target="src"
        :style="[
          \`background: #f7f8fa;
          padding: 32px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
            'Open Sans', 'Helvetica Neue', sans-serif;
          border: 1px solid #ebecf2;
          color: #6f7488;
          text-align: center;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          font-size: 14px;
          font-weight: 500;
          max-width: 100%;
          aspect-ratio: 4.5 / 2;
          box-sizing: border-box;
          \`,
          {width: props.width},
          ]
        "
      >
        <img src="https://assets.customer.io/assets/image.svg" alt="" />
        <div style="margin: 12px 12px 20px">Drop your image</div>
        <div
          style="
            background: #fff;
            display: inline-block;
            padding: 6px 16px;
            border-radius: 6px;
            border: 1px solid #c7c7d4;
            text-align: center;
            box-shadow: 1px 2px 2px 0px rgba(52, 52, 70, 0.04), 2px 2px 4px 0px rgba(52, 52, 70, 0.01);
            font-size: 13px;
            cursor: pointer;
          "
          data-carta-visualized-media-trigger="src"
        >
          Choose
        </div>
      </div>
      <fragment #else>
        <img
          #root
          :src="props.src"
          :srcset="props.srcset"
          :sizes="props.sizes"
          :alt="props.alt"
          :width="props.outlookWidth"
          :style="[imageStyle, props.style]"
          :class="addContainer ? '' : props.class"
        />
      </fragment>
    </fragment>
  </fragment>
</template>
`;

// src/components/x-link.html
var x_link_default = '<script>\n  import { expandShorthand } from "carta/props";\n\n  export const slots = defineSlots({\n    default: SlotTypes.children(["x-hidden-text", "x-image"]),\n  });\n  export const props = defineProps({\n    href: PropTypes.string(),\n    style: PropTypes.string().optional(),\n    lang: PropTypes.string().optional(),\n    lang: PropTypes.array().optional(),\n  });\n  let styleInline = "";\n  if (props.style) {\n    const keyValue = props.style\n      .trim()\n      .split(";")\n      .map((pair) => pair.trim().split(/:(.*)/s, 2));\n    const style = Object.fromEntries(keyValue);\n    const expandedStyle = expandShorthand(Object.fromEntries(keyValue));\n\n    const styleObject = {\n      color: style.color,\n      "font-size": style["font-size"],\n      "line-height": style["line-height"],\n      "font-family": style["font-family"],\n      "font-weight": style["font-weight"],\n      "text-align": style["text-align"],\n      "text-decoration": style["text-decoration"],\n      "text-transform": style["text-transform"],\n      "letter-spacing": style["letter-spacing"],\n      "word-spacing": style["word-spacing"],\n    };\n    for (const [key, value] of Object.entries(styleObject)) {\n      if (value) {\n        styleInline += `${key}:${value};`;\n      }\n    }\n  }\n</script>\n<template>\n  <a :href="props.href" :lang="props.lang" :style="styleInline"><slot /></a>\n</template>\n';

// src/components/x-list.html
var x_list_default = '<script>\n  import { expandShorthand } from "carta/props";\n\n  export const slots = defineSlots({\n    default: SlotTypes.children(["x-listitem"]),\n  });\n  export const props = defineProps({\n    element: PropTypes.enum(["ul", "ol"]).optional().default("ul"),\n    style: PropTypes.string().optional(),\n  });\n  let styleInline = "";\n  let marginFix = false;\n\n  const keyValue = props.style\n    .trim()\n    .split(";")\n    .map((pair) => pair.trim().split(/:(.*)/s, 2));\n  const style = Object.fromEntries(keyValue);\n  const expandedStyle = expandShorthand(Object.fromEntries(keyValue));\n  // ISSUE: this is just looking at margin, it doesn\'t account for long hand values\n  if (style.margin) {\n    marginFix = true;\n  }\n  const styleObject = {\n    color: style.color,\n    "font-size": style["font-size"],\n    "line-height": style["line-height"],\n    "font-family": style["font-family"],\n    "font-weight": style["font-weight"],\n    "text-align": style["text-align"],\n    "text-decoration": style["text-decoration"],\n    "text-transform": style["text-transform"],\n    "letter-spacing": style["letter-spacing"],\n    "word-spacing": style["word-spacing"],\n    "list-style": style["list-style"],\n    margin: style.margin ? "0" : "",\n    padding: style.margin ? "0" : "",\n  };\n  for (const [key, value] of Object.entries(styleObject)) {\n    if (value) {\n      styleInline += `${key}:${value};`;\n    }\n  }\n</script>\n<template>\n  <fragment #set:is="marginFix ? \'div\' : \'fragment\'" :style="`margin:${style.margin}`">\n    <ul #set:is="props.element" :style="styleInline">\n      <slot />\n    </ul>\n  </fragment>\n</template>\n';

// src/components/x-listitem.html
var x_listitem_default = '<script>\n  import { expandShorthand } from "carta/props";\n\n  export const props = defineProps({\n    style: PropTypes.string().optional(),\n  });\n  let styleInline = "";\n  if (props.style) {\n    const keyValue = props.style\n      .trim()\n      .split(";")\n      .map((pair) => pair.trim().split(/:(.*)/s, 2));\n    const style = Object.fromEntries(keyValue);\n    const expandedStyle = expandShorthand(Object.fromEntries(keyValue));\n    const styleObject = {\n      color: style.color,\n      "font-size": style["font-size"],\n      "line-height": style["line-height"],\n      "font-family": style["font-family"],\n      "font-weight": style["font-weight"],\n      "text-align": style["text-align"],\n      "text-decoration": style["text-decoration"],\n      "text-transform": style["text-transform"],\n      "letter-spacing": style["letter-spacing"],\n      "word-spacing": style["word-spacing"],\n      "list-style": style["list-style"],\n    };\n    for (const [key, value] of Object.entries(styleObject)) {\n      if (value) {\n        styleInline += `${key}:${value};`;\n      }\n    }\n  }\n</script>\n<template>\n  <li :style="styleInline">\n    <slot />\n  </li>\n</template>\n';

// src/components/x-paragraph.html
var x_paragraph_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { fontFamily } from "carta/style";\n\n  export const config = {\n    componentType: "content",\n    label: "Paragraph",\n    prose: true,\n    presets: [\n      // {\n      //   icon: "subject",\n      //   section: "Content",\n      //   label: "Paragraph",\n      //   content: "<x-paragraph></x-paragraph>",\n      // },\n      {\n        icon: "subject",\n        label: "Paragraph",\n        content: "<x-paragraph></x-paragraph>",\n      },\n    ],\n  };\n\n  export const props = defineProps({ ...commonGroups.prose });\n\n  export const slots = defineSlots({\n    default: SlotTypes.text(),\n  });\n\n  fontFamily(props["font-family"]);\n\n  const DEFAULT_PADDING = "0";\n  const DEFAULT_MARGIN = "1em 0";\n\n  const styleObject = {\n    color: props["color"],\n    "font-size": props["font-size"],\n    "line-height": props["line-height"] ?? "1.5",\n    "font-family": props["font-family"],\n    "font-weight": props["font-weight"],\n    "text-align": props["text-align"],\n    "text-decoration": props["text-decoration"],\n    "text-transform": props["text-transform"],\n\n    padding: props.padding || DEFAULT_PADDING,\n    margin: props.margin || DEFAULT_MARGIN,\n  };\n</script>\n<template>\n  <p :lang="props.lang" :dir="props.dir" :style="[styleObject, props.style]" :class="props.class"><slot /></p>\n</template>\n';

// src/components/x-section.html
var x_section_default = `<script>
  import { fontFamily } from "carta/style";

  export const config = {
    componentType: "structure",
    label: "Section",
    presets: [
      {
        icon: "view_agenda",
        section: "Layout",
        label: "Section",
        content: "<x-section></x-section>",
      },
    ],
  };

  export const props = defineProps({
    color: {
      section: "Text",
      label: "Color",
      schema: PropTypes.string().optional(),
      type: "color",
    },
    "font-family": {
      section: "Text",
      label: "Family",
      schema: PropTypes.string().optional(),
    },
    "font-size": {
      section: "Text",
      label: "Size",
      schema: PropTypes.number().optional(),
      type: "number",
      min: 10,
      max: 100,
    },
    "font-weight": {
      section: "Text",
      label: "Weight",
      schema: PropTypes.string().optional(),
      type: "select",
      options: [
        { label: "Light", value: "300" },
        { label: "Normal", value: "400" },
        { label: "Medium", value: "500" },
        { label: "Semi-Bold", value: "600" },
        { label: "Bold", value: "700" },
      ],
    },
    "text-transform": {
      section: "Text",
      label: "Transform",
      schema: PropTypes.string().optional(),
      type: "select",
      options: [
        { label: "None", value: "none" },
        { label: "Capitalize", value: "capitalize" },
        { label: "Uppercase", value: "uppercase" },
        { label: "Lowercase", value: "lowercase" },
      ],
    },
    width: {
      section: "Layout",
      label: "Width",
      schema: PropTypes.string().optional().default("640px"),
      type: "size",
    },
    padding: {
      section: "Layout",
      label: "Padding",
      schema: PropTypes.string().optional().default("20px"),
      type: "box",
    },
    margin: {
      section: "Layout",
      label: "Margin",
      schema: PropTypes.string().optional(),
      type: "box",
    },
    align: {
      section: "Layout",
      label: "Alignment",
      schema: PropTypes.enum(["left", "center", "right"]).optional().default("center"),
      type: "select",
      options: [
        { label: "Left", value: "left" },
        { label: "Center", value: "center" },
        { label: "Right", value: "right" },
      ],
    },
    opacity: {
      section: "Styles",
      label: "Opacity",
      schema: PropTypes.number().optional(),
      type: "slider",
      min: 0,
      max: 1,
      step: 0.1,
    },
    "outer-background-color": {
      core: true,
      section: "Styles",
      label: "Background",
      schema: PropTypes.string().optional(),
      type: "color",
    },
    "background-color": {
      core: true,
      section: "Styles",
      label: "Fill",
      schema: PropTypes.string().optional(),
      type: "color",
    },
    "border-radius": {
      section: "Styles",
      label: "Radius",
      schema: PropTypes.string().optional(),
      type: "radius",
    },
    "box-shadow": {
      section: "Styles",
      label: "Shadow",
      schema: PropTypes.string().optional(),
      type: "shadow",
    },
    role: {
      section: "Accessibility",
      label: "Role",
      schema: PropTypes.enum(["article", "region", "navigation"]).optional(),
      options: [
        { label: "Article", value: "article" },
        { label: "Region", value: "region" },
        { label: "Navigation", value: "navigation" },
        { label: "None", value: "" },
      ],
    },
    lang: {
      section: "Accessibility",
      label: "Language",
      schema: PropTypes.string().optional(),
    },
    dir: {
      section: "Accessibility",
      label: "Text Direction",
      schema: PropTypes.enum(["ltr", "rtl", "auto"]).optional(),
      options: [
        { label: "Left to Right", value: "ltr" },
        { label: "Right to Left", value: "rtl" },
        { label: "Auto", value: "auto" },
      ],
    },
    label: {
      section: "Accessibility",
      label: "Label",
      schema: PropTypes.string().optional(),
    },
    class: {
      section: "Advanced",
      label: "CSS Class",
      schema: PropTypes.string().optional(),
    },
    style: {
      section: "Advanced",
      label: "CSS Style",
      schema: PropTypes.string().optional(),
      type: "code",
    },
  });

  export const slots = defineSlots({
    default: SlotTypes.children([
      "x-paragraph",
      "x-box",
      "x-heading-1",
      "x-heading-2",
      "x-heading-3",
      "x-heading-4",
      "x-heading-5",
      "x-heading-6",
      "x-image",
      "x-video",
      "x-cta",
      "x-hr",
      "x-columns",
      "x-spacer",
    ]),
  });

  fontFamily(props);
</script>
<template>
  <div :style="{ 'background-color': props['outer-background-color'] }">
    <x-box #set="props">
      <slot><x-empty-state /></slot>
    </x-box>
  </div>
</template>
`;

// src/components/x-spacer.html
var x_spacer_default = '<script>\n  export const config = {\n    componentType: "content",\n    label: "Spacer",\n    presets: [\n      {\n        icon: "swap_vert",\n        label: "Spacer",\n        content: \'<x-spacer :size="1" direction="vertical"></x-spacer>\',\n      },\n    ],\n  };\n\n  export const props = defineProps({\n    size: {\n      core: true,\n      label: "Size",\n      schema: PropTypes.number(),\n      type: "slider",\n      min: 0,\n      max: 10,\n      step: 0.25,\n    },\n    direction: {\n      label: "Direction",\n      schema: PropTypes.enum(["vertical", "horizontal"]).default("vertical"),\n      options: [\n        {\n          label: "Vertical",\n          value: "vertical",\n        },\n        {\n          label: "Horizontal",\n          value: "horizontal",\n        },\n      ],\n      // hidden for now\n      type: "hidden",\n    },\n  });\n\n  let styles = "";\n  let element = "div";\n\n  if (props.direction === "horizontal") {\n    styles = `mso-font-width: ${Number((props.size * 100).toFixed(2))}%; display: inline-block; width: ${\n      props.size\n    }em;`;\n    element = "i";\n  } else {\n    styles = `line-height:1;height:1em;font-size:${props.size}em;`;\n  }\n</script>\n<template>\n  <fragment #set:is="element" :style="styles">&#8195;</fragment>\n</template>\n';

// src/components/x-table-caption.html
var x_table_caption_default = '<script>\n  import { expandShorthand } from "carta/props";\n\n  export const props = defineProps({\n    captionSide: PropTypes.enum(["top", "bottom", ""]).optional(),\n    style: PropTypes.string(),\n  });\n  let styleInline = "";\n  let style = [];\n  let expandedStyle = [];\n  if (props.style) {\n    const keyValue = props.style\n      .trim()\n      .split(";")\n      .map((pair) => pair.trim().split(/:(.*)/s, 2));\n    style = Object.fromEntries(keyValue);\n    expandedStyle = expandShorthand(Object.fromEntries(keyValue));\n  }\n  const styleObject = {\n    color: style.color,\n    "font-size": style["font-size"],\n    "line-height": style["line-height"],\n    "font-family": style["font-family"],\n    "font-weight": style["font-weight"],\n    "text-align": style["text-align"],\n    "text-decoration": style["text-decoration"],\n    "text-transform": style["text-transform"],\n    "letter-spacing": style["letter-spacing"],\n    "word-spacing": style["word-spacing"],\n    "text-indent": style["text-indent"],\n    margin: style.margin,\n  };\n  // we can add more styles but there are issues with MSO and mail.ru\n  for (const [key, value] of Object.entries(styleObject)) {\n    if (value) {\n      styleInline += `${key}:${value};`;\n    }\n  }\n  // ISSUE: Mail.ru removes the `<caption>` element leaving the text content hanging outside of the table, this is why the inner <span> is added. We loose the semantic meaning and the position but we can keep the styles.\n</script>\n<template>\n  <caption :align="props.captionSide" :style="`caption-side:${props.captionSide};`">\n    <span :style="styleInline"> <slot /></span>\n  </caption>\n</template>\n';

// src/components/x-table.html
var x_table_default = `<script>
  import { expandShorthand } from "carta/props";

  export const slots = defineSlots({
    default: SlotTypes.children(['x-table-caption']),
  })
  export const props = defineProps({
    'csv': PropTypes.string().url(),
    'style': PropTypes.string().optional(),
    'cellspacing': PropTypes.number().optional(),
    'cellpadding': PropTypes.number().optional(),
    'headingsPlacement': PropTypes.enum(['top', 'right', 'bottom', 'left']).or(
      PropTypes.array(
        PropTypes.enum(['top', 'right', 'bottom', 'left']),
        PropTypes.enum(['top', 'right', 'bottom', 'left']),
        PropTypes.enum(['top', 'right', 'bottom', 'left']),
        PropTypes.enum(['top', 'right', 'bottom', 'left']),
      )
    ),
  })
  // cellspacing cellpadding are defined here to make inline styles a lot easier, if these are changes via a media query we should change to border-spacing and padding
  if (typeof props.headingsPlacement === 'string'){
    props.headingsPlacement = [props.headingsPlacement]
  }
  const csv = await fetch(props.csv, {
    method: 'get',
    headers: {
        'content-type': 'text/csv;charset=UTF-8',
    }
  }).then(res => res.text());
  const table = [];
  const lines = csv.split("\\n");
  for (let i = 0; i < lines.length; i++) {
    table[i] = lines[i].split(",");
  }
  let top = props.headingsPlacement.includes('top')
  let right = props.headingsPlacement.includes('right')
  let bottom = props.headingsPlacement.includes('bottom')
  let left = props.headingsPlacement.includes('left')


  let styleInline = '';
  let style = [];
  let expandedStyle = [];
  if (props.style){
    const keyValue = props.style.trim().split(";").map(pair => pair.trim().split(/:(.*)/s, 2));
    style = Object.fromEntries(keyValue);
    expandedStyle = expandShorthand(Object.fromEntries(keyValue));
  }
  const styleObject = {
    color: style.color,
    'font-size': style['font-size'],
    border: style.border,
  }
  // we can add more styles but there are issues with MSO and mail.ru
  for (const [key, value] of Object.entries(styleObject)) {
    if (value){styleInline += \`\${key}:\${value};\`}
  }
</script>
<template>
  <div style="max-width: 100%; overflow: auto">
    <table
      :cellspacing="props.cellspacing"
      :cellpadding="props.cellpadding"
      :border="style.border ? '1' : '0'"
      :style="styleInline"
    >
      <slot></slot>
      <tr #each="(row, rowIndex) in table">
        <th
          #if="top && rowIndex == 0"
          #each="(cell, cellIndex) in row"
          :scope="left && cellIndex == 0 || right && cellIndex == row.length - 1 ? '' : 'col'"
        >
          \${cell.slice(1).slice(0, -1)}
        </th>
        <th
          #else-if="bottom && rowIndex == table.length - 1"
          #each="(cell, cellIndex) in row"
          :scope="left && cellIndex == 0 || right && cellIndex == row.length - 1 ? '' : 'col'"
        >
          \${cell.slice(1).slice(0, -1)}
        </th>
        <td
          #else
          #each="(cell, cellIndex) in row"
          :scope="left && cellIndex == 0 || right && cellIndex == row.length - 1 ? 'row' : ''"
        >
          \${cell.slice(1).slice(0, -1)}
        </td>
      </tr>
    </table>
    <!-- ISSUE: 
  I want to be able to use #is inside the above <td> however because it's using #each is wont allow a conditional 
  #set:is="left && cellIndex == 0 || right && cellIndex == row.length - 1 ? 'th' : 'td'" 
  -->
    <!-- ISSUE: 
  When the #if code matched, the above code is returning both the #if <th> and the else <td>. Same for the #else-if and #else when that matches.
  --></div>
</template>
`;

// src/components/x-video.html
var x_video_default = '<script>\n  import { commonGroups } from "carta/props";\n  import { getCache, setCache } from "carta/cache";\n\n  export const config = {\n    componentType: "content",\n    label: "Video",\n    presets: [\n      {\n        icon: "play_circle",\n        section: "Media",\n        label: "Video",\n        content:\n          \'<x-video />\',\n      },\n    ],\n  };\n\n  export const props = defineProps({\n    src: {\n      label: "Source",\n      schema: PropTypes.string().optional(),\n      type: "url",\n      core: true,\n      helpText: \'Supports YouTube, Vimeo, Wistia, and Loom.\'\n    },\n    ...commonGroups.media\n  });\n\n  function addVimeoPlay(url) {\n    return `https://i.vimeocdn.com/filter/overlay?src0=${url}&src1=https%3A%2F%2Ff.vimeocdn.com%2Fimages_v6%2Fshare%2Fplay_icon_overlay.png`;\n  }\n\n\n  let src = getCache(props.src);\n\n  if (!src) {\n    try {\n      if (props.src.startsWith("https://www.youtube.com/watch")) {\n        const videoId = props.src.split("v=")[1].split("&")[0];\n        const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;\n        src = addVimeoPlay(thumbnailUrl);\n      } else if (props.src.startsWith("https://vimeo.com/")) {\n        const videoId = props.src.split("/")[3];\n        const response = await fetch(\n          `https://vimeo.com/api/v2/video/${videoId}.json`\n        );\n        const data = await response.json();\n        const thumbnailUrl = data[0].thumbnail_large;\n        src = addVimeoPlay(thumbnailUrl);\n      } else if (props.src.includes("wistia")) {\n        const response = await fetch(\n          `https://fast.wistia.com/oembed?url=${props.src}`\n        );\n        const data = await response.json();\n        src = `${data.thumbnail_url}&image_play_button=true`;\n      } else if (props.src.includes("loom")) {\n        const response = await fetch(\n          `https://www.loom.com/v1/oembed?url=${props.src}&gif=true`\n        );\n        const data = await response.json();\n        src = addVimeoPlay(data.thumbnail_url);\n      }\n      // short youtube url\n      else if (props.src.startsWith("https://youtu.be/")) {\n        const videoId = props.src.split("/")[3];\n        const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;\n        src = addVimeoPlay(thumbnailUrl);\n      } else {\n        // generic fallbak\n        src = addVimeoPlay();\n      }\n    } catch (error) {\n      // generic fallback\n      src = addVimeoPlay();\n    }\n\n    setCache(props.src, src);\n  } else {\n  }\n\n  const DEFAULT_THUMBNAIL_URL = "https://assets.customer.io/assets/video-placeholder.svg";\n</script>\n<template>\n  <x-image\n    :href="props.src"\n    :src="props.src && src ? src : process.env.CARTA_ENV === \'development\' ? DEFAULT_THUMBNAIL_URL : \'\'"\n    #set="props"\n  />\n</template>\n';

// src/components/index.ts
var components = {
  "x-base": x_base_default,
  "x-paragraph": x_paragraph_default,
  "x-heading-1": x_heading_1_default,
  "x-heading-2": x_heading_2_default,
  "x-heading-3": x_heading_3_default,
  "x-heading-4": x_heading_4_default,
  "x-heading-5": x_heading_5_default,
  "x-heading-6": x_heading_6_default,
  "x-cta": x_cta_default,
  "x-image": x_image_default,
  "x-video": x_video_default,
  "x-columns": x_columns_default,
  "x-column": x_column_default,
  "x-box": x_box_default,
  "x-conditional": x_conditional_default,
  "x-hidden-text": x_hidden_text_default,
  "x-hr": x_hr_default,
  "x-link": x_link_default,
  "x-list": x_list_default,
  "x-listitem": x_listitem_default,
  "x-section": x_section_default,
  "x-spacer": x_spacer_default,
  "x-table-caption": x_table_caption_default,
  "x-table": x_table_default,
  "x-empty-state": x_empty_state_default
};

// src/index.ts
function createCartaInternals({
  format,
  env,
  components: components2
} = {}) {
  return {
    format: format ?? null,
    env: env ?? "production",
    components: components2 ?? {},
    styles: [],
    track: {
      components: {},
      depth: 0
    }
  };
}
var fragment = runtimeMessageCompiler(`<template><slot /></template>`).default;
function createCarta() {
  const components2 = {};
  const carta = {
    registerGlobalComponent(name, component) {
      components2[name] = component;
    },
    unregisterGlobalComponent(name) {
      delete components2[name];
    },
    async render(component, {
      context,
      format,
      env
    } = {}) {
      start();
      const __CARTA_INTERNALS = createCartaInternals({ format, components: components2, env });
      if (typeof component === "string" && !__CARTA_INTERNALS.components[component]) {
        throw new Error(`Root component "${component}" not found.`);
      }
      let result = await __PROD_CARTA_RUNTIME.renderElement(
        component,
        {},
        context ?? {},
        async () => [],
        __CARTA_INTERNALS,
        {
          openTag: "",
          closeTag: ""
        }
      );
      const injectedStyles = getStyles();
      const renderedStyles = renderStyles(__CARTA_INTERNALS.styles);
      finish();
      const joinedCSS = injectedStyles || renderedStyles ? `${injectedStyles}${renderedStyles}` : "";
      if (result.includes("</head>")) {
        result = result.replace("</head>", `${joinedCSS}</head>`);
      } else {
        result = `${joinedCSS}${result}`;
      }
      return {
        result,
        styles: __CARTA_INTERNALS.styles
      };
    }
  };
  function renderStyles(styles) {
    let renderedStyles = "<style>";
    for (const { discrete, value } of styles) {
      const trimmedValue = value.trim();
      if (discrete) {
        renderedStyles += `</style><style>${trimmedValue}</style><style>`;
      } else {
        renderedStyles += trimmedValue;
      }
    }
    renderedStyles += "</style>";
    renderedStyles = renderedStyles.replace("<style></style>", "");
    return renderedStyles;
  }
  carta.registerGlobalComponent("fragment", fragment);
  return carta;
}
function wrappedRequire(name) {
  if (name === "carta/internals") {
    return internals_exports;
  }
  if (name === "carta/props") {
    return props_exports;
  }
  if (name === "carta/cache") {
    return cache_exports;
  }
  if (name === "carta/style") {
    return style_exports;
  }
  throw new Error(`Module "${name}" not found.`);
}
function runtimeCompiler(source, options) {
  const transformedSource = Babel.transform(compile(source, options).code, {
    presets: ["es2015"]
  }).code;
  const exports = {};
  const module = { exports };
  const func = new Function("require", "module", "exports", transformedSource);
  func(wrappedRequire, module, exports);
  return module.exports;
}
function runtimeMessageCompiler(source, options) {
  const transformedSource = messageCompile(source, options).code;
  const exports = {};
  const module = { exports };
  const func = new Function("require", "module", "exports", transformedSource);
  func(wrappedRequire, module, exports);
  return module.exports;
}
export {
  compile,
  components,
  createCarta,
  createCartaInternals,
  nativeTags,
  parse,
  runtimeCompiler,
  runtimeMessageCompiler
};
